/*!
 * imagesLoaded PACKAGED v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
!(function (t, e) {
  "object" == typeof module && module.exports
    ? (module.exports = e())
    : (t.EvEmitter = e());
})("undefined" != typeof window ? window : this, function () {
  function t() {}
  let e = t.prototype;
  return (
    (e.on = function (t, e) {
      if (!t || !e) return this;
      let i = (this._events = this._events || {}),
        s = (i[t] = i[t] || []);
      return s.includes(e) || s.push(e), this;
    }),
    (e.once = function (t, e) {
      if (!t || !e) return this;
      this.on(t, e);
      let i = (this._onceEvents = this._onceEvents || {});
      return ((i[t] = i[t] || {})[e] = !0), this;
    }),
    (e.off = function (t, e) {
      let i = this._events && this._events[t];
      if (!i || !i.length) return this;
      let s = i.indexOf(e);
      return -1 != s && i.splice(s, 1), this;
    }),
    (e.emitEvent = function (t, e) {
      let i = this._events && this._events[t];
      if (!i || !i.length) return this;
      (i = i.slice(0)), (e = e || []);
      let s = this._onceEvents && this._onceEvents[t];
      for (let n of i) {
        s && s[n] && (this.off(t, n), delete s[n]), n.apply(this, e);
      }
      return this;
    }),
    (e.allOff = function () {
      return delete this._events, delete this._onceEvents, this;
    }),
    t
  );
}),
  /*!
   * imagesLoaded v5.0.0
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   */
  (function (t, e) {
    "object" == typeof module && module.exports
      ? (module.exports = e(t, require("ev-emitter")))
      : (t.imagesLoaded = e(t, t.EvEmitter));
  })("undefined" != typeof window ? window : this, function (t, e) {
    let i = t.jQuery,
      s = t.console;
    function n(t, e, o) {
      if (!(this instanceof n)) return new n(t, e, o);
      let r = t;
      var h;
      ("string" == typeof t && (r = document.querySelectorAll(t)), r)
        ? ((this.elements =
            ((h = r),
            Array.isArray(h)
              ? h
              : "object" == typeof h && "number" == typeof h.length
              ? [...h]
              : [h])),
          (this.options = {}),
          "function" == typeof e ? (o = e) : Object.assign(this.options, e),
          o && this.on("always", o),
          this.getImages(),
          i && (this.jqDeferred = new i.Deferred()),
          setTimeout(this.check.bind(this)))
        : s.error(`Bad element for imagesLoaded ${r || t}`);
    }
    (n.prototype = Object.create(e.prototype)),
      (n.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      });
    const o = [1, 9, 11];
    n.prototype.addElementImages = function (t) {
      "IMG" === t.nodeName && this.addImage(t),
        !0 === this.options.background && this.addElementBackgroundImages(t);
      let { nodeType: e } = t;
      if (!e || !o.includes(e)) return;
      let i = t.querySelectorAll("img");
      for (let t of i) this.addImage(t);
      if ("string" == typeof this.options.background) {
        let e = t.querySelectorAll(this.options.background);
        for (let t of e) this.addElementBackgroundImages(t);
      }
    };
    const r = /url\((['"])?(.*?)\1\)/gi;
    function h(t) {
      this.img = t;
    }
    function d(t, e) {
      (this.url = t), (this.element = e), (this.img = new Image());
    }
    return (
      (n.prototype.addElementBackgroundImages = function (t) {
        let e = getComputedStyle(t);
        if (!e) return;
        let i = r.exec(e.backgroundImage);
        for (; null !== i; ) {
          let s = i && i[2];
          s && this.addBackground(s, t), (i = r.exec(e.backgroundImage));
        }
      }),
      (n.prototype.addImage = function (t) {
        let e = new h(t);
        this.images.push(e);
      }),
      (n.prototype.addBackground = function (t, e) {
        let i = new d(t, e);
        this.images.push(i);
      }),
      (n.prototype.check = function () {
        if (
          ((this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          !this.images.length)
        )
          return void this.complete();
        let t = (t, e, i) => {
          setTimeout(() => {
            this.progress(t, e, i);
          });
        };
        this.images.forEach(function (e) {
          e.once("progress", t), e.check();
        });
      }),
      (n.prototype.progress = function (t, e, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
          this.emitEvent("progress", [this, t, e]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, t),
          this.progressedCount === this.images.length && this.complete(),
          this.options.debug && s && s.log(`progress: ${i}`, t, e);
      }),
      (n.prototype.complete = function () {
        let t = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(t, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          let t = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[t](this);
        }
      }),
      (h.prototype = Object.create(e.prototype)),
      (h.prototype.check = function () {
        this.getIsImageComplete()
          ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.img.crossOrigin &&
              (this.proxyImage.crossOrigin = this.img.crossOrigin),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            (this.proxyImage.src = this.img.currentSrc || this.img.src));
      }),
      (h.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
      }),
      (h.prototype.confirm = function (t, e) {
        this.isLoaded = t;
        let { parentNode: i } = this.img,
          s = "PICTURE" === i.nodeName ? i : this.img;
        this.emitEvent("progress", [this, s, e]);
      }),
      (h.prototype.handleEvent = function (t) {
        let e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (h.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (h.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (h.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (d.prototype = Object.create(h.prototype)),
      (d.prototype.check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url),
          this.getIsImageComplete() &&
            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents());
      }),
      (d.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (d.prototype.confirm = function (t, e) {
        (this.isLoaded = t),
          this.emitEvent("progress", [this, this.element, e]);
      }),
      (n.makeJQueryPlugin = function (e) {
        (e = e || t.jQuery) &&
          ((i = e),
          (i.fn.imagesLoaded = function (t, e) {
            return new n(this, t, e).jqDeferred.promise(i(this));
          }));
      }),
      n.makeJQueryPlugin(),
      n
    );
  });
/*! GSAP 3.11.4
 * https://greensock.com
 * @license Copyright 2022, GreenSock. All rights reserved. */
!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? e(exports)
    : "function" == typeof define && define.amd
    ? define(["exports"], e)
    : e(((t = t || self).window = t.window || {}));
})(this, function (e) {
  "use strict";
  function _inheritsLoose(t, e) {
    (t.prototype = Object.create(e.prototype)),
      ((t.prototype.constructor = t).__proto__ = e);
  }
  function _assertThisInitialized(t) {
    if (void 0 === t)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return t;
  }
  function r(t) {
    return "string" == typeof t;
  }
  function s(t) {
    return "function" == typeof t;
  }
  function t(t) {
    return "number" == typeof t;
  }
  function u(t) {
    return void 0 === t;
  }
  function v(t) {
    return "object" == typeof t;
  }
  function w(t) {
    return !1 !== t;
  }
  function x() {
    return "undefined" != typeof window;
  }
  function y(t) {
    return s(t) || r(t);
  }
  function P(t) {
    return (i = yt(t, ot)) && Ce;
  }
  function Q(t, e) {
    return console.warn(
      "Invalid property",
      t,
      "set to",
      e,
      "Missing plugin? gsap.registerPlugin()"
    );
  }
  function R(t, e) {
    return !e && console.warn(t);
  }
  function S(t, e) {
    return (t && (ot[t] = e) && i && (i[t] = e)) || ot;
  }
  function T() {
    return 0;
  }
  function ea(t) {
    var e,
      r,
      i = t[0];
    if ((v(i) || s(i) || (t = [t]), !(e = (i._gsap || {}).harness))) {
      for (r = gt.length; r-- && !gt[r].targetTest(i); );
      e = gt[r];
    }
    for (r = t.length; r--; )
      (t[r] && (t[r]._gsap || (t[r]._gsap = new jt(t[r], e)))) ||
        t.splice(r, 1);
    return t;
  }
  function fa(t) {
    return t._gsap || ea(Ot(t))[0]._gsap;
  }
  function ga(t, e, r) {
    return (r = t[e]) && s(r)
      ? t[e]()
      : (u(r) && t.getAttribute && t.getAttribute(e)) || r;
  }
  function ha(t, e) {
    return (t = t.split(",")).forEach(e) || t;
  }
  function ia(t) {
    return Math.round(1e5 * t) / 1e5 || 0;
  }
  function ja(t) {
    return Math.round(1e7 * t) / 1e7 || 0;
  }
  function ka(t, e) {
    var r = e.charAt(0),
      i = parseFloat(e.substr(2));
    return (
      (t = parseFloat(t)),
      "+" === r ? t + i : "-" === r ? t - i : "*" === r ? t * i : t / i
    );
  }
  function la(t, e) {
    for (var r = e.length, i = 0; t.indexOf(e[i]) < 0 && ++i < r; );
    return i < r;
  }
  function ma() {
    var t,
      e,
      r = ct.length,
      i = ct.slice(0);
    for (dt = {}, t = ct.length = 0; t < r; t++)
      (e = i[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
  }
  function na(t, e, r, i) {
    ct.length && !B && ma(),
      t.render(e, r, i || (B && e < 0 && (t._initted || t._startAt))),
      ct.length && !B && ma();
  }
  function oa(t) {
    var e = parseFloat(t);
    return (e || 0 === e) && (t + "").match(at).length < 2
      ? e
      : r(t)
      ? t.trim()
      : t;
  }
  function pa(t) {
    return t;
  }
  function qa(t, e) {
    for (var r in e) r in t || (t[r] = e[r]);
    return t;
  }
  function ta(t, e) {
    for (var r in e)
      "__proto__" !== r &&
        "constructor" !== r &&
        "prototype" !== r &&
        (t[r] = v(e[r]) ? ta(t[r] || (t[r] = {}), e[r]) : e[r]);
    return t;
  }
  function ua(t, e) {
    var r,
      i = {};
    for (r in t) r in e || (i[r] = t[r]);
    return i;
  }
  function va(t) {
    var e = t.parent || L,
      r = t.keyframes
        ? (function _setKeyframeDefaults(i) {
            return function (t, e) {
              for (var r in e)
                r in t ||
                  ("duration" === r && i) ||
                  "ease" === r ||
                  (t[r] = e[r]);
            };
          })($(t.keyframes))
        : qa;
    if (w(t.inherit))
      for (; e; ) r(t, e.vars.defaults), (e = e.parent || e._dp);
    return t;
  }
  function xa(t, e, r, i, n) {
    void 0 === r && (r = "_first"), void 0 === i && (i = "_last");
    var a,
      s = t[i];
    if (n) for (a = e[n]; s && s[n] > a; ) s = s._prev;
    return (
      s ? ((e._next = s._next), (s._next = e)) : ((e._next = t[r]), (t[r] = e)),
      e._next ? (e._next._prev = e) : (t[i] = e),
      (e._prev = s),
      (e.parent = e._dp = t),
      e
    );
  }
  function ya(t, e, r, i) {
    void 0 === r && (r = "_first"), void 0 === i && (i = "_last");
    var n = e._prev,
      a = e._next;
    n ? (n._next = a) : t[r] === e && (t[r] = a),
      a ? (a._prev = n) : t[i] === e && (t[i] = n),
      (e._next = e._prev = e.parent = null);
  }
  function za(t, e) {
    !t.parent || (e && !t.parent.autoRemoveChildren) || t.parent.remove(t),
      (t._act = 0);
  }
  function Aa(t, e) {
    if (t && (!e || e._end > t._dur || e._start < 0))
      for (var r = t; r; ) (r._dirty = 1), (r = r.parent);
    return t;
  }
  function Ca(t, e, r, i) {
    return (
      t._startAt &&
      (B
        ? t._startAt.revert(ht)
        : (t.vars.immediateRender && !t.vars.autoRevert) ||
          t._startAt.render(e, !0, i))
    );
  }
  function Ea(t) {
    return t._repeat ? Tt(t._tTime, (t = t.duration() + t._rDelay)) * t : 0;
  }
  function Ga(t, e) {
    return (
      (t - e._start) * e._ts +
      (0 <= e._ts ? 0 : e._dirty ? e.totalDuration() : e._tDur)
    );
  }
  function Ha(t) {
    return (t._end = ja(
      t._start + (t._tDur / Math.abs(t._ts || t._rts || V) || 0)
    ));
  }
  function Ia(t, e) {
    var r = t._dp;
    return (
      r &&
        r.smoothChildTiming &&
        t._ts &&
        ((t._start = ja(
          r._time -
            (0 < t._ts
              ? e / t._ts
              : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)
        )),
        Ha(t),
        r._dirty || Aa(r, t)),
      t
    );
  }
  function Ja(t, e) {
    var r;
    if (
      ((e._time || (e._initted && !e._dur)) &&
        ((r = Ga(t.rawTime(), e)),
        (!e._dur || kt(0, e.totalDuration(), r) - e._tTime > V) &&
          e.render(r, !0)),
      Aa(t, e)._dp && t._initted && t._time >= t._dur && t._ts)
    ) {
      if (t._dur < t.duration())
        for (r = t; r._dp; )
          0 <= r.rawTime() && r.totalTime(r._tTime), (r = r._dp);
      t._zTime = -V;
    }
  }
  function Ka(e, r, i, n) {
    return (
      r.parent && za(r),
      (r._start = ja(
        (t(i) ? i : i || e !== L ? xt(e, i, r) : e._time) + r._delay
      )),
      (r._end = ja(
        r._start + (r.totalDuration() / Math.abs(r.timeScale()) || 0)
      )),
      xa(e, r, "_first", "_last", e._sort ? "_start" : 0),
      bt(r) || (e._recent = r),
      n || Ja(e, r),
      e._ts < 0 && Ia(e, e._tTime),
      e
    );
  }
  function La(t, e) {
    return (
      (ot.ScrollTrigger || Q("scrollTrigger", e)) &&
      ot.ScrollTrigger.create(e, t)
    );
  }
  function Ma(t, e, r, i, n) {
    return (
      Ht(t, e, n),
      t._initted
        ? !r &&
          t._pt &&
          !B &&
          ((t._dur && !1 !== t.vars.lazy) || (!t._dur && t.vars.lazy)) &&
          f !== Et.frame
          ? (ct.push(t), (t._lazy = [n, i]), 1)
          : void 0
        : 1
    );
  }
  function Ra(t, e, r, i) {
    var n = t._repeat,
      a = ja(e) || 0,
      s = t._tTime / t._tDur;
    return (
      s && !i && (t._time *= a / t._dur),
      (t._dur = a),
      (t._tDur = n ? (n < 0 ? 1e10 : ja(a * (n + 1) + t._rDelay * n)) : a),
      0 < s && !i && Ia(t, (t._tTime = t._tDur * s)),
      t.parent && Ha(t),
      r || Aa(t.parent, t),
      t
    );
  }
  function Sa(t) {
    return t instanceof Ut ? Aa(t) : Ra(t, t._dur);
  }
  function Va(e, r, i) {
    var n,
      a,
      s = t(r[1]),
      o = (s ? 2 : 1) + (e < 2 ? 0 : 1),
      u = r[o];
    if ((s && (u.duration = r[1]), (u.parent = i), e)) {
      for (n = u, a = i; a && !("immediateRender" in n); )
        (n = a.vars.defaults || {}), (a = w(a.vars.inherit) && a.parent);
      (u.immediateRender = w(n.immediateRender)),
        e < 2 ? (u.runBackwards = 1) : (u.startAt = r[o - 1]);
    }
    return new Gt(r[0], u, r[1 + o]);
  }
  function Wa(t, e) {
    return t || 0 === t ? e(t) : e;
  }
  function Ya(t, e) {
    return r(t) && (e = st.exec(t)) ? e[1] : "";
  }
  function _a(t, e) {
    return (
      t &&
      v(t) &&
      "length" in t &&
      ((!e && !t.length) || (t.length - 1 in t && v(t[0]))) &&
      !t.nodeType &&
      t !== h
    );
  }
  function cb(r) {
    return (
      (r = Ot(r)[0] || R("Invalid scope") || {}),
      function (t) {
        var e = r.current || r.nativeElement || r;
        return Ot(
          t,
          e.querySelectorAll
            ? e
            : e === r
            ? R("Invalid scope") || a.createElement("div")
            : r
        );
      }
    );
  }
  function db(t) {
    return t.sort(function () {
      return 0.5 - Math.random();
    });
  }
  function eb(t) {
    if (s(t)) return t;
    var p = v(t) ? t : { each: t },
      _ = Yt(p.ease),
      m = p.from || 0,
      g = parseFloat(p.base) || 0,
      y = {},
      e = 0 < m && m < 1,
      T = isNaN(m) || e,
      b = p.axis,
      w = m,
      x = m;
    return (
      r(m)
        ? (w = x = { center: 0.5, edges: 0.5, end: 1 }[m] || 0)
        : !e && T && ((w = m[0]), (x = m[1])),
      function (t, e, r) {
        var i,
          n,
          a,
          s,
          o,
          u,
          h,
          l,
          f,
          c = (r || p).length,
          d = y[c];
        if (!d) {
          if (!(f = "auto" === p.grid ? 0 : (p.grid || [1, U])[1])) {
            for (
              h = -U;
              h < (h = r[f++].getBoundingClientRect().left) && f < c;

            );
            f--;
          }
          for (
            d = y[c] = [],
              i = T ? Math.min(f, c) * w - 0.5 : m % f,
              n = f === U ? 0 : T ? (c * x) / f - 0.5 : (m / f) | 0,
              l = U,
              u = h = 0;
            u < c;
            u++
          )
            (a = (u % f) - i),
              (s = n - ((u / f) | 0)),
              (d[u] = o = b ? Math.abs("y" === b ? s : a) : K(a * a + s * s)),
              h < o && (h = o),
              o < l && (l = o);
          "random" === m && db(d),
            (d.max = h - l),
            (d.min = l),
            (d.v = c =
              (parseFloat(p.amount) ||
                parseFloat(p.each) *
                  (c < f
                    ? c - 1
                    : b
                    ? "y" === b
                      ? c / f
                      : f
                    : Math.max(f, c / f)) ||
                0) * ("edges" === m ? -1 : 1)),
            (d.b = c < 0 ? g - c : g),
            (d.u = Ya(p.amount || p.each) || 0),
            (_ = _ && c < 0 ? Lt(_) : _);
        }
        return (
          (c = (d[t] - d.min) / d.max || 0),
          ja(d.b + (_ ? _(c) : c) * d.v) + d.u
        );
      }
    );
  }
  function fb(i) {
    var n = Math.pow(10, ((i + "").split(".")[1] || "").length);
    return function (e) {
      var r = ja(Math.round(parseFloat(e) / i) * i * n);
      return (r - (r % 1)) / n + (t(e) ? 0 : Ya(e));
    };
  }
  function gb(h, e) {
    var l,
      f,
      r = $(h);
    return (
      !r &&
        v(h) &&
        ((l = r = h.radius || U),
        h.values
          ? ((h = Ot(h.values)), (f = !t(h[0])) && (l *= l))
          : (h = fb(h.increment))),
      Wa(
        e,
        r
          ? s(h)
            ? function (t) {
                return (f = h(t)), Math.abs(f - t) <= l ? f : t;
              }
            : function (e) {
                for (
                  var r,
                    i,
                    n = parseFloat(f ? e.x : e),
                    a = parseFloat(f ? e.y : 0),
                    s = U,
                    o = 0,
                    u = h.length;
                  u--;

                )
                  (r = f
                    ? (r = h[u].x - n) * r + (i = h[u].y - a) * i
                    : Math.abs(h[u] - n)) < s && ((s = r), (o = u));
                return (
                  (o = !l || s <= l ? h[o] : e),
                  f || o === e || t(e) ? o : o + Ya(e)
                );
              }
          : fb(h)
      )
    );
  }
  function hb(t, e, r, i) {
    return Wa($(t) ? !e : !0 === r ? !!(r = 0) : !i, function () {
      return $(t)
        ? t[~~(Math.random() * t.length)]
        : (r = r || 1e-5) &&
            (i = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) &&
            Math.floor(
              Math.round((t - r / 2 + Math.random() * (e - t + 0.99 * r)) / r) *
                r *
                i
            ) / i;
    });
  }
  function lb(e, r, t) {
    return Wa(t, function (t) {
      return e[~~r(t)];
    });
  }
  function ob(t) {
    for (var e, r, i, n, a = 0, s = ""; ~(e = t.indexOf("random(", a)); )
      (i = t.indexOf(")", e)),
        (n = "[" === t.charAt(e + 7)),
        (r = t.substr(e + 7, i - e - 7).match(n ? at : tt)),
        (s +=
          t.substr(a, e - a) + hb(n ? r : +r[0], n ? 0 : +r[1], +r[2] || 1e-5)),
        (a = i + 1);
    return s + t.substr(a, t.length - a);
  }
  function rb(t, e, r) {
    var i,
      n,
      a,
      s = t.labels,
      o = U;
    for (i in s)
      (n = s[i] - e) < 0 == !!r &&
        n &&
        o > (n = Math.abs(n)) &&
        ((a = i), (o = n));
    return a;
  }
  function tb(t) {
    return (
      za(t),
      t.scrollTrigger && t.scrollTrigger.kill(!!B),
      t.progress() < 1 && Ct(t, "onInterrupt"),
      t
    );
  }
  function yb(t, e, r) {
    return (
      ((6 * (t += t < 0 ? 1 : 1 < t ? -1 : 0) < 1
        ? e + (r - e) * t * 6
        : t < 0.5
        ? r
        : 3 * t < 2
        ? e + (r - e) * (2 / 3 - t) * 6
        : e) *
        At +
        0.5) |
      0
    );
  }
  function zb(e, r, i) {
    var n,
      a,
      s,
      o,
      u,
      h,
      l,
      f,
      c,
      d,
      p = e ? (t(e) ? [e >> 16, (e >> 8) & At, e & At] : 0) : St.black;
    if (!p) {
      if (("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), St[e]))
        p = St[e];
      else if ("#" === e.charAt(0)) {
        if (
          (e.length < 6 &&
            (e =
              "#" +
              (n = e.charAt(1)) +
              n +
              (a = e.charAt(2)) +
              a +
              (s = e.charAt(3)) +
              s +
              (5 === e.length ? e.charAt(4) + e.charAt(4) : "")),
          9 === e.length)
        )
          return [
            (p = parseInt(e.substr(1, 6), 16)) >> 16,
            (p >> 8) & At,
            p & At,
            parseInt(e.substr(7), 16) / 255,
          ];
        p = [(e = parseInt(e.substr(1), 16)) >> 16, (e >> 8) & At, e & At];
      } else if ("hsl" === e.substr(0, 3))
        if (((p = d = e.match(tt)), r)) {
          if (~e.indexOf("="))
            return (p = e.match(et)), i && p.length < 4 && (p[3] = 1), p;
        } else
          (o = (+p[0] % 360) / 360),
            (u = p[1] / 100),
            (n =
              2 * (h = p[2] / 100) -
              (a = h <= 0.5 ? h * (u + 1) : h + u - h * u)),
            3 < p.length && (p[3] *= 1),
            (p[0] = yb(o + 1 / 3, n, a)),
            (p[1] = yb(o, n, a)),
            (p[2] = yb(o - 1 / 3, n, a));
      else p = e.match(tt) || St.transparent;
      p = p.map(Number);
    }
    return (
      r &&
        !d &&
        ((n = p[0] / At),
        (a = p[1] / At),
        (s = p[2] / At),
        (h = ((l = Math.max(n, a, s)) + (f = Math.min(n, a, s))) / 2),
        l === f
          ? (o = u = 0)
          : ((c = l - f),
            (u = 0.5 < h ? c / (2 - l - f) : c / (l + f)),
            (o =
              l === n
                ? (a - s) / c + (a < s ? 6 : 0)
                : l === a
                ? (s - n) / c + 2
                : (n - a) / c + 4),
            (o *= 60)),
        (p[0] = ~~(o + 0.5)),
        (p[1] = ~~(100 * u + 0.5)),
        (p[2] = ~~(100 * h + 0.5))),
      i && p.length < 4 && (p[3] = 1),
      p
    );
  }
  function Ab(t) {
    var r = [],
      i = [],
      n = -1;
    return (
      t.split(Rt).forEach(function (t) {
        var e = t.match(rt) || [];
        r.push.apply(r, e), i.push((n += e.length + 1));
      }),
      (r.c = i),
      r
    );
  }
  function Bb(t, e, r) {
    var i,
      n,
      a,
      s,
      o = "",
      u = (t + o).match(Rt),
      h = e ? "hsla(" : "rgba(",
      l = 0;
    if (!u) return t;
    if (
      ((u = u.map(function (t) {
        return (
          (t = zb(t, e, 1)) &&
          h +
            (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) +
            ")"
        );
      })),
      r && ((a = Ab(t)), (i = r.c).join(o) !== a.c.join(o)))
    )
      for (s = (n = t.replace(Rt, "1").split(rt)).length - 1; l < s; l++)
        o +=
          n[l] +
          (~i.indexOf(l)
            ? u.shift() || h + "0,0,0,0)"
            : (a.length ? a : u.length ? u : r).shift());
    if (!n) for (s = (n = t.split(Rt)).length - 1; l < s; l++) o += n[l] + u[l];
    return o + n[s];
  }
  function Eb(t) {
    var e,
      r = t.join(" ");
    if (((Rt.lastIndex = 0), Rt.test(r)))
      return (
        (e = Dt.test(r)),
        (t[1] = Bb(t[1], e)),
        (t[0] = Bb(t[0], e, Ab(t[1]))),
        !0
      );
  }
  function Nb(t) {
    var e = (t + "").split("("),
      r = Ft[e[0]];
    return r && 1 < e.length && r.config
      ? r.config.apply(
          null,
          ~t.indexOf("{")
            ? [
                (function _parseObjectInString(t) {
                  for (
                    var e,
                      r,
                      i,
                      n = {},
                      a = t.substr(1, t.length - 3).split(":"),
                      s = a[0],
                      o = 1,
                      u = a.length;
                    o < u;
                    o++
                  )
                    (r = a[o]),
                      (e = o !== u - 1 ? r.lastIndexOf(",") : r.length),
                      (i = r.substr(0, e)),
                      (n[s] = isNaN(i) ? i.replace(Bt, "").trim() : +i),
                      (s = r.substr(e + 1).trim());
                  return n;
                })(e[1]),
              ]
            : (function _valueInParentheses(t) {
                var e = t.indexOf("(") + 1,
                  r = t.indexOf(")"),
                  i = t.indexOf("(", e);
                return t.substring(e, ~i && i < r ? t.indexOf(")", r + 1) : r);
              })(t)
                .split(",")
                .map(oa)
        )
      : Ft._CE && It.test(t)
      ? Ft._CE("", t)
      : r;
  }
  function Pb(t, e) {
    for (var r, i = t._first; i; )
      i instanceof Ut
        ? Pb(i, e)
        : !i.vars.yoyoEase ||
          (i._yoyo && i._repeat) ||
          i._yoyo === e ||
          (i.timeline
            ? Pb(i.timeline, e)
            : ((r = i._ease),
              (i._ease = i._yEase),
              (i._yEase = r),
              (i._yoyo = e))),
        (i = i._next);
  }
  function Rb(t, e, r, i) {
    void 0 === r &&
      (r = function easeOut(t) {
        return 1 - e(1 - t);
      }),
      void 0 === i &&
        (i = function easeInOut(t) {
          return t < 0.5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
        });
    var n,
      a = { easeIn: e, easeOut: r, easeInOut: i };
    return (
      ha(t, function (t) {
        for (var e in ((Ft[t] = ot[t] = a), (Ft[(n = t.toLowerCase())] = r), a))
          Ft[
            n + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")
          ] = Ft[t + "." + e] = a[e];
      }),
      a
    );
  }
  function Sb(e) {
    return function (t) {
      return t < 0.5 ? (1 - e(1 - 2 * t)) / 2 : 0.5 + e(2 * (t - 0.5)) / 2;
    };
  }
  function Tb(r, t, e) {
    function Hm(t) {
      return 1 === t ? 1 : i * Math.pow(2, -10 * t) * G((t - a) * n) + 1;
    }
    var i = 1 <= t ? t : 1,
      n = (e || (r ? 0.3 : 0.45)) / (t < 1 ? t : 1),
      a = (n / W) * (Math.asin(1 / i) || 0),
      s =
        "out" === r
          ? Hm
          : "in" === r
          ? function (t) {
              return 1 - Hm(1 - t);
            }
          : Sb(Hm);
    return (
      (n = W / n),
      (s.config = function (t, e) {
        return Tb(r, t, e);
      }),
      s
    );
  }
  function Ub(e, r) {
    function Pm(t) {
      return t ? --t * t * ((r + 1) * t + r) + 1 : 0;
    }
    void 0 === r && (r = 1.70158);
    var t =
      "out" === e
        ? Pm
        : "in" === e
        ? function (t) {
            return 1 - Pm(1 - t);
          }
        : Sb(Pm);
    return (
      (t.config = function (t) {
        return Ub(e, t);
      }),
      t
    );
  }
  var I,
    B,
    l,
    L,
    h,
    n,
    a,
    i,
    o,
    f,
    c,
    d,
    p,
    _,
    m,
    g,
    b,
    k,
    M,
    O,
    C,
    A,
    D,
    E,
    z,
    F,
    Y,
    N,
    j = {
      autoSleep: 120,
      force3D: "auto",
      nullTargetWarn: 1,
      units: { lineHeight: "" },
    },
    q = { duration: 0.5, overwrite: !1, delay: 0 },
    U = 1e8,
    V = 1 / U,
    W = 2 * Math.PI,
    X = W / 4,
    H = 0,
    K = Math.sqrt,
    Z = Math.cos,
    G = Math.sin,
    J =
      ("function" == typeof ArrayBuffer && ArrayBuffer.isView) ||
      function () {},
    $ = Array.isArray,
    tt = /(?:-?\.?\d|\.)+/gi,
    et = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    rt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    it = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    nt = /[+-]=-?[.\d]+/,
    at = /[^,'"\[\]\s]+/gi,
    st = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    ot = {},
    ut = { suppressEvents: !0, isStart: !0, kill: !1 },
    ht = { suppressEvents: !0, kill: !1 },
    lt = { suppressEvents: !0 },
    ft = {},
    ct = [],
    dt = {},
    pt = {},
    _t = {},
    mt = 30,
    gt = [],
    vt = "",
    yt = function _merge(t, e) {
      for (var r in e) t[r] = e[r];
      return t;
    },
    Tt = function _animationCycle(t, e) {
      var r = Math.floor((t /= e));
      return t && r === t ? r - 1 : r;
    },
    bt = function _isFromOrFromStart(t) {
      var e = t.data;
      return "isFromStart" === e || "isStart" === e;
    },
    wt = { _start: 0, endTime: T, totalDuration: T },
    xt = function _parsePosition(t, e, i) {
      var n,
        a,
        s,
        o = t.labels,
        u = t._recent || wt,
        h = t.duration() >= U ? u.endTime(!1) : t._dur;
      return r(e) && (isNaN(e) || e in o)
        ? ((a = e.charAt(0)),
          (s = "%" === e.substr(-1)),
          (n = e.indexOf("=")),
          "<" === a || ">" === a
            ? (0 <= n && (e = e.replace(/=/, "")),
              ("<" === a ? u._start : u.endTime(0 <= u._repeat)) +
                (parseFloat(e.substr(1)) || 0) *
                  (s ? (n < 0 ? u : i).totalDuration() / 100 : 1))
            : n < 0
            ? (e in o || (o[e] = h), o[e])
            : ((a = parseFloat(e.charAt(n - 1) + e.substr(n + 1))),
              s && i && (a = (a / 100) * ($(i) ? i[0] : i).totalDuration()),
              1 < n ? _parsePosition(t, e.substr(0, n - 1), i) + a : h + a))
        : null == e
        ? h
        : +e;
    },
    kt = function _clamp(t, e, r) {
      return r < t ? t : e < r ? e : r;
    },
    Mt = [].slice,
    Ot = function toArray(t, e, i) {
      return l && !e && l.selector
        ? l.selector(t)
        : !r(t) || i || (!n && zt())
        ? $(t)
          ? (function _flatten(t, e, i) {
              return (
                void 0 === i && (i = []),
                t.forEach(function (t) {
                  return (r(t) && !e) || _a(t, 1)
                    ? i.push.apply(i, Ot(t))
                    : i.push(t);
                }) || i
              );
            })(t, i)
          : _a(t)
          ? Mt.call(t, 0)
          : t
          ? [t]
          : []
        : Mt.call((e || a).querySelectorAll(t), 0);
    },
    Pt = function mapRange(e, t, r, i, n) {
      var a = t - e,
        s = i - r;
      return Wa(n, function (t) {
        return r + (((t - e) / a) * s || 0);
      });
    },
    Ct = function _callback(t, e, r) {
      var i,
        n,
        a,
        s = t.vars,
        o = s[e],
        u = l,
        h = t._ctx;
      if (o)
        return (
          (i = s[e + "Params"]),
          (n = s.callbackScope || t),
          r && ct.length && ma(),
          h && (l = h),
          (a = i ? o.apply(n, i) : o.call(n)),
          (l = u),
          a
        );
    },
    At = 255,
    St = {
      aqua: [0, At, At],
      lime: [0, At, 0],
      silver: [192, 192, 192],
      black: [0, 0, 0],
      maroon: [128, 0, 0],
      teal: [0, 128, 128],
      blue: [0, 0, At],
      navy: [0, 0, 128],
      white: [At, At, At],
      olive: [128, 128, 0],
      yellow: [At, At, 0],
      orange: [At, 165, 0],
      gray: [128, 128, 128],
      purple: [128, 0, 128],
      green: [0, 128, 0],
      red: [At, 0, 0],
      pink: [At, 192, 203],
      cyan: [0, At, At],
      transparent: [At, At, At, 0],
    },
    Rt = (function () {
      var t,
        e =
          "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
      for (t in St) e += "|" + t + "\\b";
      return new RegExp(e + ")", "gi");
    })(),
    Dt = /hsl[a]?\(/,
    Et =
      ((M = Date.now),
      (O = 500),
      (C = 33),
      (A = M()),
      (D = A),
      (z = E = 1e3 / 240),
      (g = {
        time: 0,
        frame: 0,
        tick: function tick() {
          wl(!0);
        },
        deltaRatio: function deltaRatio(t) {
          return b / (1e3 / (t || 60));
        },
        wake: function wake() {
          o &&
            (!n &&
              x() &&
              ((h = n = window),
              (a = h.document || {}),
              (ot.gsap = Ce),
              (h.gsapVersions || (h.gsapVersions = [])).push(Ce.version),
              P(i || h.GreenSockGlobals || (!h.gsap && h) || {}),
              (m = h.requestAnimationFrame)),
            p && g.sleep(),
            (_ =
              m ||
              function (t) {
                return setTimeout(t, (z - 1e3 * g.time + 1) | 0);
              }),
            (d = 1),
            wl(2));
        },
        sleep: function sleep() {
          (m ? h.cancelAnimationFrame : clearTimeout)(p), (d = 0), (_ = T);
        },
        lagSmoothing: function lagSmoothing(t, e) {
          (O = t || 1 / 0), (C = Math.min(e || 33, O));
        },
        fps: function fps(t) {
          (E = 1e3 / (t || 240)), (z = 1e3 * g.time + E);
        },
        add: function add(n, t, e) {
          var a = t
            ? function (t, e, r, i) {
                n(t, e, r, i), g.remove(a);
              }
            : n;
          return g.remove(n), F[e ? "unshift" : "push"](a), zt(), a;
        },
        remove: function remove(t, e) {
          ~(e = F.indexOf(t)) && F.splice(e, 1) && e <= k && k--;
        },
        _listeners: (F = []),
      })),
    zt = function _wake() {
      return !d && Et.wake();
    },
    Ft = {},
    It = /^[\d.\-M][\d.\-,\s]/,
    Bt = /["']/g,
    Lt = function _invertEase(e) {
      return function (t) {
        return 1 - e(1 - t);
      };
    },
    Yt = function _parseEase(t, e) {
      return (t && (s(t) ? t : Ft[t] || Nb(t))) || e;
    };
  function wl(t) {
    var e,
      r,
      i,
      n,
      a = M() - D,
      s = !0 === t;
    if (
      (O < a && (A += a - C),
      (0 < (e = (i = (D += a) - A) - z) || s) &&
        ((n = ++g.frame),
        (b = i - 1e3 * g.time),
        (g.time = i /= 1e3),
        (z += e + (E <= e ? 4 : E - e)),
        (r = 1)),
      s || (p = _(wl)),
      r)
    )
      for (k = 0; k < F.length; k++) F[k](i, b, n, t);
  }
  function en(t) {
    return t < N
      ? Y * t * t
      : t < 0.7272727272727273
      ? Y * Math.pow(t - 1.5 / 2.75, 2) + 0.75
      : t < 0.9090909090909092
      ? Y * (t -= 2.25 / 2.75) * t + 0.9375
      : Y * Math.pow(t - 2.625 / 2.75, 2) + 0.984375;
  }
  ha("Linear,Quad,Cubic,Quart,Quint,Strong", function (t, e) {
    var r = e < 5 ? e + 1 : e;
    Rb(
      t + ",Power" + (r - 1),
      e
        ? function (t) {
            return Math.pow(t, r);
          }
        : function (t) {
            return t;
          },
      function (t) {
        return 1 - Math.pow(1 - t, r);
      },
      function (t) {
        return t < 0.5
          ? Math.pow(2 * t, r) / 2
          : 1 - Math.pow(2 * (1 - t), r) / 2;
      }
    );
  }),
    (Ft.Linear.easeNone = Ft.none = Ft.Linear.easeIn),
    Rb("Elastic", Tb("in"), Tb("out"), Tb()),
    (Y = 7.5625),
    (N = 1 / 2.75),
    Rb(
      "Bounce",
      function (t) {
        return 1 - en(1 - t);
      },
      en
    ),
    Rb("Expo", function (t) {
      return t ? Math.pow(2, 10 * (t - 1)) : 0;
    }),
    Rb("Circ", function (t) {
      return -(K(1 - t * t) - 1);
    }),
    Rb("Sine", function (t) {
      return 1 === t ? 1 : 1 - Z(t * X);
    }),
    Rb("Back", Ub("in"), Ub("out"), Ub()),
    (Ft.SteppedEase =
      Ft.steps =
      ot.SteppedEase =
        {
          config: function config(t, e) {
            void 0 === t && (t = 1);
            var r = 1 / t,
              i = t + (e ? 0 : 1),
              n = e ? 1 : 0;
            return function (t) {
              return (((i * kt(0, 0.99999999, t)) | 0) + n) * r;
            };
          },
        }),
    (q.ease = Ft["quad.out"]),
    ha(
      "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
      function (t) {
        return (vt += t + "," + t + "Params,");
      }
    );
  var Nt,
    jt = function GSCache(t, e) {
      (this.id = H++),
        ((t._gsap = this).target = t),
        (this.harness = e),
        (this.get = e ? e.get : ga),
        (this.set = e ? e.getSetter : re);
    },
    qt =
      (((Nt = Animation.prototype).delay = function delay(t) {
        return t || 0 === t
          ? (this.parent &&
              this.parent.smoothChildTiming &&
              this.startTime(this._start + t - this._delay),
            (this._delay = t),
            this)
          : this._delay;
      }),
      (Nt.duration = function duration(t) {
        return arguments.length
          ? this.totalDuration(
              0 < this._repeat ? t + (t + this._rDelay) * this._repeat : t
            )
          : this.totalDuration() && this._dur;
      }),
      (Nt.totalDuration = function totalDuration(t) {
        return arguments.length
          ? ((this._dirty = 0),
            Ra(
              this,
              this._repeat < 0
                ? t
                : (t - this._repeat * this._rDelay) / (this._repeat + 1)
            ))
          : this._tDur;
      }),
      (Nt.totalTime = function totalTime(t, e) {
        if ((zt(), !arguments.length)) return this._tTime;
        var r = this._dp;
        if (r && r.smoothChildTiming && this._ts) {
          for (Ia(this, t), !r._dp || r.parent || Ja(r, this); r && r.parent; )
            r.parent._time !==
              r._start +
                (0 <= r._ts
                  ? r._tTime / r._ts
                  : (r.totalDuration() - r._tTime) / -r._ts) &&
              r.totalTime(r._tTime, !0),
              (r = r.parent);
          !this.parent &&
            this._dp.autoRemoveChildren &&
            ((0 < this._ts && t < this._tDur) ||
              (this._ts < 0 && 0 < t) ||
              (!this._tDur && !t)) &&
            Ka(this._dp, this, this._start - this._delay);
        }
        return (
          (this._tTime !== t ||
            (!this._dur && !e) ||
            (this._initted && Math.abs(this._zTime) === V) ||
            (!t && !this._initted && (this.add || this._ptLookup))) &&
            (this._ts || (this._pTime = t), na(this, t, e)),
          this
        );
      }),
      (Nt.time = function time(t, e) {
        return arguments.length
          ? this.totalTime(
              Math.min(this.totalDuration(), t + Ea(this)) %
                (this._dur + this._rDelay) || (t ? this._dur : 0),
              e
            )
          : this._time;
      }),
      (Nt.totalProgress = function totalProgress(t, e) {
        return arguments.length
          ? this.totalTime(this.totalDuration() * t, e)
          : this.totalDuration()
          ? Math.min(1, this._tTime / this._tDur)
          : this.ratio;
      }),
      (Nt.progress = function progress(t, e) {
        return arguments.length
          ? this.totalTime(
              this.duration() *
                (!this._yoyo || 1 & this.iteration() ? t : 1 - t) +
                Ea(this),
              e
            )
          : this.duration()
          ? Math.min(1, this._time / this._dur)
          : this.ratio;
      }),
      (Nt.iteration = function iteration(t, e) {
        var r = this.duration() + this._rDelay;
        return arguments.length
          ? this.totalTime(this._time + (t - 1) * r, e)
          : this._repeat
          ? Tt(this._tTime, r) + 1
          : 1;
      }),
      (Nt.timeScale = function timeScale(t) {
        if (!arguments.length) return this._rts === -V ? 0 : this._rts;
        if (this._rts === t) return this;
        var e =
          this.parent && this._ts ? Ga(this.parent._time, this) : this._tTime;
        return (
          (this._rts = +t || 0),
          (this._ts = this._ps || t === -V ? 0 : this._rts),
          this.totalTime(kt(-this._delay, this._tDur, e), !0),
          Ha(this),
          (function _recacheAncestors(t) {
            for (var e = t.parent; e && e.parent; )
              (e._dirty = 1), e.totalDuration(), (e = e.parent);
            return t;
          })(this)
        );
      }),
      (Nt.paused = function paused(t) {
        return arguments.length
          ? (this._ps !== t &&
              ((this._ps = t)
                ? ((this._pTime =
                    this._tTime || Math.max(-this._delay, this.rawTime())),
                  (this._ts = this._act = 0))
                : (zt(),
                  (this._ts = this._rts),
                  this.totalTime(
                    this.parent && !this.parent.smoothChildTiming
                      ? this.rawTime()
                      : this._tTime || this._pTime,
                    1 === this.progress() &&
                      Math.abs(this._zTime) !== V &&
                      (this._tTime -= V)
                  ))),
            this)
          : this._ps;
      }),
      (Nt.startTime = function startTime(t) {
        if (arguments.length) {
          this._start = t;
          var e = this.parent || this._dp;
          return (
            !e || (!e._sort && this.parent) || Ka(e, this, t - this._delay),
            this
          );
        }
        return this._start;
      }),
      (Nt.endTime = function endTime(t) {
        return (
          this._start +
          (w(t) ? this.totalDuration() : this.duration()) /
            Math.abs(this._ts || 1)
        );
      }),
      (Nt.rawTime = function rawTime(t) {
        var e = this.parent || this._dp;
        return e
          ? t &&
            (!this._ts ||
              (this._repeat && this._time && this.totalProgress() < 1))
            ? this._tTime % (this._dur + this._rDelay)
            : this._ts
            ? Ga(e.rawTime(t), this)
            : this._tTime
          : this._tTime;
      }),
      (Nt.revert = function revert(t) {
        void 0 === t && (t = lt);
        var e = B;
        return (
          (B = t),
          (this._initted || this._startAt) &&
            (this.timeline && this.timeline.revert(t),
            this.totalTime(-0.01, t.suppressEvents)),
          "nested" !== this.data && !1 !== t.kill && this.kill(),
          (B = e),
          this
        );
      }),
      (Nt.globalTime = function globalTime(t) {
        for (var e = this, r = arguments.length ? t : e.rawTime(); e; )
          (r = e._start + r / (e._ts || 1)), (e = e._dp);
        return !this.parent && this._sat
          ? this._sat.vars.immediateRender
            ? -1
            : this._sat.globalTime(t)
          : r;
      }),
      (Nt.repeat = function repeat(t) {
        return arguments.length
          ? ((this._repeat = t === 1 / 0 ? -2 : t), Sa(this))
          : -2 === this._repeat
          ? 1 / 0
          : this._repeat;
      }),
      (Nt.repeatDelay = function repeatDelay(t) {
        if (arguments.length) {
          var e = this._time;
          return (this._rDelay = t), Sa(this), e ? this.time(e) : this;
        }
        return this._rDelay;
      }),
      (Nt.yoyo = function yoyo(t) {
        return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
      }),
      (Nt.seek = function seek(t, e) {
        return this.totalTime(xt(this, t), w(e));
      }),
      (Nt.restart = function restart(t, e) {
        return this.play().totalTime(t ? -this._delay : 0, w(e));
      }),
      (Nt.play = function play(t, e) {
        return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
      }),
      (Nt.reverse = function reverse(t, e) {
        return (
          null != t && this.seek(t || this.totalDuration(), e),
          this.reversed(!0).paused(!1)
        );
      }),
      (Nt.pause = function pause(t, e) {
        return null != t && this.seek(t, e), this.paused(!0);
      }),
      (Nt.resume = function resume() {
        return this.paused(!1);
      }),
      (Nt.reversed = function reversed(t) {
        return arguments.length
          ? (!!t !== this.reversed() &&
              this.timeScale(-this._rts || (t ? -V : 0)),
            this)
          : this._rts < 0;
      }),
      (Nt.invalidate = function invalidate() {
        return (this._initted = this._act = 0), (this._zTime = -V), this;
      }),
      (Nt.isActive = function isActive() {
        var t,
          e = this.parent || this._dp,
          r = this._start;
        return !(
          e &&
          !(
            this._ts &&
            this._initted &&
            e.isActive() &&
            (t = e.rawTime(!0)) >= r &&
            t < this.endTime(!0) - V
          )
        );
      }),
      (Nt.eventCallback = function eventCallback(t, e, r) {
        var i = this.vars;
        return 1 < arguments.length
          ? (e
              ? ((i[t] = e),
                r && (i[t + "Params"] = r),
                "onUpdate" === t && (this._onUpdate = e))
              : delete i[t],
            this)
          : i[t];
      }),
      (Nt.then = function then(t) {
        var i = this;
        return new Promise(function (e) {
          function zo() {
            var t = i.then;
            (i.then = null),
              s(r) && (r = r(i)) && (r.then || r === i) && (i.then = t),
              e(r),
              (i.then = t);
          }
          var r = s(t) ? t : pa;
          (i._initted && 1 === i.totalProgress() && 0 <= i._ts) ||
          (!i._tTime && i._ts < 0)
            ? zo()
            : (i._prom = zo);
        });
      }),
      (Nt.kill = function kill() {
        tb(this);
      }),
      Animation);
  function Animation(t) {
    (this.vars = t),
      (this._delay = +t.delay || 0),
      (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) &&
        ((this._rDelay = t.repeatDelay || 0),
        (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
      (this._ts = 1),
      Ra(this, +t.duration, 1, 1),
      (this.data = t.data),
      l && (this._ctx = l).data.push(this),
      d || Et.wake();
  }
  qa(qt.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: !1,
    parent: null,
    _initted: !1,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -V,
    _prom: 0,
    _ps: !1,
    _rts: 1,
  });
  var Ut = (function (i) {
    function Timeline(t, e) {
      var r;
      return (
        void 0 === t && (t = {}),
        ((r = i.call(this, t) || this).labels = {}),
        (r.smoothChildTiming = !!t.smoothChildTiming),
        (r.autoRemoveChildren = !!t.autoRemoveChildren),
        (r._sort = w(t.sortChildren)),
        L && Ka(t.parent || L, _assertThisInitialized(r), e),
        t.reversed && r.reverse(),
        t.paused && r.paused(!0),
        t.scrollTrigger && La(_assertThisInitialized(r), t.scrollTrigger),
        r
      );
    }
    _inheritsLoose(Timeline, i);
    var e = Timeline.prototype;
    return (
      (e.to = function to(t, e, r) {
        return Va(0, arguments, this), this;
      }),
      (e.from = function from(t, e, r) {
        return Va(1, arguments, this), this;
      }),
      (e.fromTo = function fromTo(t, e, r, i) {
        return Va(2, arguments, this), this;
      }),
      (e.set = function set(t, e, r) {
        return (
          (e.duration = 0),
          (e.parent = this),
          va(e).repeatDelay || (e.repeat = 0),
          (e.immediateRender = !!e.immediateRender),
          new Gt(t, e, xt(this, r), 1),
          this
        );
      }),
      (e.call = function call(t, e, r) {
        return Ka(this, Gt.delayedCall(0, t, e), r);
      }),
      (e.staggerTo = function staggerTo(t, e, r, i, n, a, s) {
        return (
          (r.duration = e),
          (r.stagger = r.stagger || i),
          (r.onComplete = a),
          (r.onCompleteParams = s),
          (r.parent = this),
          new Gt(t, r, xt(this, n)),
          this
        );
      }),
      (e.staggerFrom = function staggerFrom(t, e, r, i, n, a, s) {
        return (
          (r.runBackwards = 1),
          (va(r).immediateRender = w(r.immediateRender)),
          this.staggerTo(t, e, r, i, n, a, s)
        );
      }),
      (e.staggerFromTo = function staggerFromTo(t, e, r, i, n, a, s, o) {
        return (
          (i.startAt = r),
          (va(i).immediateRender = w(i.immediateRender)),
          this.staggerTo(t, e, i, n, a, s, o)
        );
      }),
      (e.render = function render(t, e, r) {
        var i,
          n,
          a,
          s,
          o,
          u,
          h,
          l,
          f,
          c,
          d,
          p,
          _ = this._time,
          m = this._dirty ? this.totalDuration() : this._tDur,
          g = this._dur,
          v = t <= 0 ? 0 : ja(t),
          y = this._zTime < 0 != t < 0 && (this._initted || !g);
        if (
          (this !== L && m < v && 0 <= t && (v = m),
          v !== this._tTime || r || y)
        ) {
          if (
            (_ !== this._time &&
              g &&
              ((v += this._time - _), (t += this._time - _)),
            (i = v),
            (f = this._start),
            (u = !(l = this._ts)),
            y && (g || (_ = this._zTime), (!t && e) || (this._zTime = t)),
            this._repeat)
          ) {
            if (
              ((d = this._yoyo),
              (o = g + this._rDelay),
              this._repeat < -1 && t < 0)
            )
              return this.totalTime(100 * o + t, e, r);
            if (
              ((i = ja(v % o)),
              v === m
                ? ((s = this._repeat), (i = g))
                : ((s = ~~(v / o)) && s === v / o && ((i = g), s--),
                  g < i && (i = g)),
              (c = Tt(this._tTime, o)),
              !_ && this._tTime && c !== s && (c = s),
              d && 1 & s && ((i = g - i), (p = 1)),
              s !== c && !this._lock)
            ) {
              var T = d && 1 & c,
                b = T === (d && 1 & s);
              if (
                (s < c && (T = !T),
                (_ = T ? 0 : g),
                (this._lock = 1),
                (this.render(_ || (p ? 0 : ja(s * o)), e, !g)._lock = 0),
                (this._tTime = v),
                !e && this.parent && Ct(this, "onRepeat"),
                this.vars.repeatRefresh && !p && (this.invalidate()._lock = 1),
                (_ && _ !== this._time) ||
                  u != !this._ts ||
                  (this.vars.onRepeat && !this.parent && !this._act))
              )
                return this;
              if (
                ((g = this._dur),
                (m = this._tDur),
                b &&
                  ((this._lock = 2),
                  (_ = T ? g : -1e-4),
                  this.render(_, !0),
                  this.vars.repeatRefresh && !p && this.invalidate()),
                (this._lock = 0),
                !this._ts && !u)
              )
                return this;
              Pb(this, p);
            }
          }
          if (
            (this._hasPause &&
              !this._forcing &&
              this._lock < 2 &&
              (h = (function _findNextPauseTween(t, e, r) {
                var i;
                if (e < r)
                  for (i = t._first; i && i._start <= r; ) {
                    if ("isPause" === i.data && i._start > e) return i;
                    i = i._next;
                  }
                else
                  for (i = t._last; i && i._start >= r; ) {
                    if ("isPause" === i.data && i._start < e) return i;
                    i = i._prev;
                  }
              })(this, ja(_), ja(i))) &&
              (v -= i - (i = h._start)),
            (this._tTime = v),
            (this._time = i),
            (this._act = !l),
            this._initted ||
              ((this._onUpdate = this.vars.onUpdate),
              (this._initted = 1),
              (this._zTime = t),
              (_ = 0)),
            !_ && i && !e && (Ct(this, "onStart"), this._tTime !== v))
          )
            return this;
          if (_ <= i && 0 <= t)
            for (n = this._first; n; ) {
              if (
                ((a = n._next), (n._act || i >= n._start) && n._ts && h !== n)
              ) {
                if (n.parent !== this) return this.render(t, e, r);
                if (
                  (n.render(
                    0 < n._ts
                      ? (i - n._start) * n._ts
                      : (n._dirty ? n.totalDuration() : n._tDur) +
                          (i - n._start) * n._ts,
                    e,
                    r
                  ),
                  i !== this._time || (!this._ts && !u))
                ) {
                  (h = 0), a && (v += this._zTime = -V);
                  break;
                }
              }
              n = a;
            }
          else {
            n = this._last;
            for (var w = t < 0 ? t : i; n; ) {
              if (
                ((a = n._prev), (n._act || w <= n._end) && n._ts && h !== n)
              ) {
                if (n.parent !== this) return this.render(t, e, r);
                if (
                  (n.render(
                    0 < n._ts
                      ? (w - n._start) * n._ts
                      : (n._dirty ? n.totalDuration() : n._tDur) +
                          (w - n._start) * n._ts,
                    e,
                    r || (B && (n._initted || n._startAt))
                  ),
                  i !== this._time || (!this._ts && !u))
                ) {
                  (h = 0), a && (v += this._zTime = w ? -V : V);
                  break;
                }
              }
              n = a;
            }
          }
          if (
            h &&
            !e &&
            (this.pause(),
            (h.render(_ <= i ? 0 : -V)._zTime = _ <= i ? 1 : -1),
            this._ts)
          )
            return (this._start = f), Ha(this), this.render(t, e, r);
          this._onUpdate && !e && Ct(this, "onUpdate", !0),
            ((v === m && this._tTime >= this.totalDuration()) || (!v && _)) &&
              ((f !== this._start && Math.abs(l) === Math.abs(this._ts)) ||
                this._lock ||
                ((!t && g) ||
                  !((v === m && 0 < this._ts) || (!v && this._ts < 0)) ||
                  za(this, 1),
                e ||
                  (t < 0 && !_) ||
                  (!v && !_ && m) ||
                  (Ct(
                    this,
                    v === m && 0 <= t ? "onComplete" : "onReverseComplete",
                    !0
                  ),
                  !this._prom ||
                    (v < m && 0 < this.timeScale()) ||
                    this._prom())));
        }
        return this;
      }),
      (e.add = function add(e, i) {
        var n = this;
        if ((t(i) || (i = xt(this, i, e)), !(e instanceof qt))) {
          if ($(e))
            return (
              e.forEach(function (t) {
                return n.add(t, i);
              }),
              this
            );
          if (r(e)) return this.addLabel(e, i);
          if (!s(e)) return this;
          e = Gt.delayedCall(0, e);
        }
        return this !== e ? Ka(this, e, i) : this;
      }),
      (e.getChildren = function getChildren(t, e, r, i) {
        void 0 === t && (t = !0),
          void 0 === e && (e = !0),
          void 0 === r && (r = !0),
          void 0 === i && (i = -U);
        for (var n = [], a = this._first; a; )
          a._start >= i &&
            (a instanceof Gt
              ? e && n.push(a)
              : (r && n.push(a),
                t && n.push.apply(n, a.getChildren(!0, e, r)))),
            (a = a._next);
        return n;
      }),
      (e.getById = function getById(t) {
        for (var e = this.getChildren(1, 1, 1), r = e.length; r--; )
          if (e[r].vars.id === t) return e[r];
      }),
      (e.remove = function remove(t) {
        return r(t)
          ? this.removeLabel(t)
          : s(t)
          ? this.killTweensOf(t)
          : (ya(this, t),
            t === this._recent && (this._recent = this._last),
            Aa(this));
      }),
      (e.totalTime = function totalTime(t, e) {
        return arguments.length
          ? ((this._forcing = 1),
            !this._dp &&
              this._ts &&
              (this._start = ja(
                Et.time -
                  (0 < this._ts
                    ? t / this._ts
                    : (this.totalDuration() - t) / -this._ts)
              )),
            i.prototype.totalTime.call(this, t, e),
            (this._forcing = 0),
            this)
          : this._tTime;
      }),
      (e.addLabel = function addLabel(t, e) {
        return (this.labels[t] = xt(this, e)), this;
      }),
      (e.removeLabel = function removeLabel(t) {
        return delete this.labels[t], this;
      }),
      (e.addPause = function addPause(t, e, r) {
        var i = Gt.delayedCall(0, e || T, r);
        return (
          (i.data = "isPause"), (this._hasPause = 1), Ka(this, i, xt(this, t))
        );
      }),
      (e.removePause = function removePause(t) {
        var e = this._first;
        for (t = xt(this, t); e; )
          e._start === t && "isPause" === e.data && za(e), (e = e._next);
      }),
      (e.killTweensOf = function killTweensOf(t, e, r) {
        for (var i = this.getTweensOf(t, r), n = i.length; n--; )
          Vt !== i[n] && i[n].kill(t, e);
        return this;
      }),
      (e.getTweensOf = function getTweensOf(e, r) {
        for (var i, n = [], a = Ot(e), s = this._first, o = t(r); s; )
          s instanceof Gt
            ? la(s._targets, a) &&
              (o
                ? (!Vt || (s._initted && s._ts)) &&
                  s.globalTime(0) <= r &&
                  s.globalTime(s.totalDuration()) > r
                : !r || s.isActive()) &&
              n.push(s)
            : (i = s.getTweensOf(a, r)).length && n.push.apply(n, i),
            (s = s._next);
        return n;
      }),
      (e.tweenTo = function tweenTo(t, e) {
        e = e || {};
        var r,
          i = this,
          n = xt(i, t),
          a = e.startAt,
          s = e.onStart,
          o = e.onStartParams,
          u = e.immediateRender,
          h = Gt.to(
            i,
            qa(
              {
                ease: e.ease || "none",
                lazy: !1,
                immediateRender: !1,
                time: n,
                overwrite: "auto",
                duration:
                  e.duration ||
                  Math.abs(
                    (n - (a && "time" in a ? a.time : i._time)) / i.timeScale()
                  ) ||
                  V,
                onStart: function onStart() {
                  if ((i.pause(), !r)) {
                    var t =
                      e.duration ||
                      Math.abs(
                        (n - (a && "time" in a ? a.time : i._time)) /
                          i.timeScale()
                      );
                    h._dur !== t && Ra(h, t, 0, 1).render(h._time, !0, !0),
                      (r = 1);
                  }
                  s && s.apply(h, o || []);
                },
              },
              e
            )
          );
        return u ? h.render(0) : h;
      }),
      (e.tweenFromTo = function tweenFromTo(t, e, r) {
        return this.tweenTo(e, qa({ startAt: { time: xt(this, t) } }, r));
      }),
      (e.recent = function recent() {
        return this._recent;
      }),
      (e.nextLabel = function nextLabel(t) {
        return void 0 === t && (t = this._time), rb(this, xt(this, t));
      }),
      (e.previousLabel = function previousLabel(t) {
        return void 0 === t && (t = this._time), rb(this, xt(this, t), 1);
      }),
      (e.currentLabel = function currentLabel(t) {
        return arguments.length
          ? this.seek(t, !0)
          : this.previousLabel(this._time + V);
      }),
      (e.shiftChildren = function shiftChildren(t, e, r) {
        void 0 === r && (r = 0);
        for (var i, n = this._first, a = this.labels; n; )
          n._start >= r && ((n._start += t), (n._end += t)), (n = n._next);
        if (e) for (i in a) a[i] >= r && (a[i] += t);
        return Aa(this);
      }),
      (e.invalidate = function invalidate(t) {
        var e = this._first;
        for (this._lock = 0; e; ) e.invalidate(t), (e = e._next);
        return i.prototype.invalidate.call(this, t);
      }),
      (e.clear = function clear(t) {
        void 0 === t && (t = !0);
        for (var e, r = this._first; r; )
          (e = r._next), this.remove(r), (r = e);
        return (
          this._dp && (this._time = this._tTime = this._pTime = 0),
          t && (this.labels = {}),
          Aa(this)
        );
      }),
      (e.totalDuration = function totalDuration(t) {
        var e,
          r,
          i,
          n = 0,
          a = this,
          s = a._last,
          o = U;
        if (arguments.length)
          return a.timeScale(
            (a._repeat < 0 ? a.duration() : a.totalDuration()) /
              (a.reversed() ? -t : t)
          );
        if (a._dirty) {
          for (i = a.parent; s; )
            (e = s._prev),
              s._dirty && s.totalDuration(),
              o < (r = s._start) && a._sort && s._ts && !a._lock
                ? ((a._lock = 1), (Ka(a, s, r - s._delay, 1)._lock = 0))
                : (o = r),
              r < 0 &&
                s._ts &&
                ((n -= r),
                ((!i && !a._dp) || (i && i.smoothChildTiming)) &&
                  ((a._start += r / a._ts), (a._time -= r), (a._tTime -= r)),
                a.shiftChildren(-r, !1, -Infinity),
                (o = 0)),
              s._end > n && s._ts && (n = s._end),
              (s = e);
          Ra(a, a === L && a._time > n ? a._time : n, 1, 1), (a._dirty = 0);
        }
        return a._tDur;
      }),
      (Timeline.updateRoot = function updateRoot(t) {
        if ((L._ts && (na(L, Ga(t, L)), (f = Et.frame)), Et.frame >= mt)) {
          mt += j.autoSleep || 120;
          var e = L._first;
          if ((!e || !e._ts) && j.autoSleep && Et._listeners.length < 2) {
            for (; e && !e._ts; ) e = e._next;
            e || Et.sleep();
          }
        }
      }),
      Timeline
    );
  })(qt);
  qa(Ut.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
  function _b(t, e, i, n, a, o) {
    var u, h, l, f;
    if (
      pt[t] &&
      !1 !==
        (u = new pt[t]()).init(
          a,
          u.rawVars
            ? e[t]
            : (function _processVars(t, e, i, n, a) {
                if (
                  (s(t) && (t = Qt(t, a, e, i, n)),
                  !v(t) || (t.style && t.nodeType) || $(t) || J(t))
                )
                  return r(t) ? Qt(t, a, e, i, n) : t;
                var o,
                  u = {};
                for (o in t) u[o] = Qt(t[o], a, e, i, n);
                return u;
              })(e[t], n, a, o, i),
          i,
          n,
          o
        ) &&
      ((i._pt = h = new pe(i._pt, a, t, 0, 1, u.render, u, 0, u.priority)),
      i !== c)
    )
      for (l = i._ptLookup[i._targets.indexOf(a)], f = u._props.length; f--; )
        l[u._props[f]] = h;
    return u;
  }
  function fc(t, r, e, i) {
    var n,
      a,
      s = r.ease || i || "power1.inOut";
    if ($(r))
      (a = e[t] || (e[t] = [])),
        r.forEach(function (t, e) {
          return a.push({ t: (e / (r.length - 1)) * 100, v: t, e: s });
        });
    else
      for (n in r)
        (a = e[n] || (e[n] = [])),
          "ease" === n || a.push({ t: parseFloat(t), v: r[n], e: s });
  }
  var Vt,
    Wt,
    Xt = function _addPropTween(t, e, i, n, a, o, u, h, l, f) {
      s(n) && (n = n(a || 0, t, o));
      var c,
        d = t[e],
        p =
          "get" !== i
            ? i
            : s(d)
            ? l
              ? t[
                  e.indexOf("set") || !s(t["get" + e.substr(3)])
                    ? e
                    : "get" + e.substr(3)
                ](l)
              : t[e]()
            : d,
        _ = s(d) ? (l ? ee : $t) : Jt;
      if (
        (r(n) &&
          (~n.indexOf("random(") && (n = ob(n)),
          "=" === n.charAt(1) &&
            ((!(c = ka(p, n) + (Ya(p) || 0)) && 0 !== c) || (n = c))),
        !f || p !== n || Wt)
      )
        return isNaN(p * n) || "" === n
          ? (d || e in t || Q(e, n),
            function _addComplexStringPropTween(t, e, r, i, n, a, s) {
              var o,
                u,
                h,
                l,
                f,
                c,
                d,
                p,
                _ = new pe(this._pt, t, e, 0, 1, se, null, n),
                m = 0,
                g = 0;
              for (
                _.b = r,
                  _.e = i,
                  r += "",
                  (d = ~(i += "").indexOf("random(")) && (i = ob(i)),
                  a && (a((p = [r, i]), t, e), (r = p[0]), (i = p[1])),
                  u = r.match(it) || [];
                (o = it.exec(i));

              )
                (l = o[0]),
                  (f = i.substring(m, o.index)),
                  h ? (h = (h + 1) % 5) : "rgba(" === f.substr(-5) && (h = 1),
                  l !== u[g++] &&
                    ((c = parseFloat(u[g - 1]) || 0),
                    (_._pt = {
                      _next: _._pt,
                      p: f || 1 === g ? f : ",",
                      s: c,
                      c: "=" === l.charAt(1) ? ka(c, l) - c : parseFloat(l) - c,
                      m: h && h < 4 ? Math.round : 0,
                    }),
                    (m = it.lastIndex));
              return (
                (_.c = m < i.length ? i.substring(m, i.length) : ""),
                (_.fp = s),
                (nt.test(i) || d) && (_.e = 0),
                (this._pt = _)
              );
            }.call(this, t, e, p, n, _, h || j.stringFilter, l))
          : ((c = new pe(
              this._pt,
              t,
              e,
              +p || 0,
              n - (p || 0),
              "boolean" == typeof d ? ae : ne,
              0,
              _
            )),
            l && (c.fp = l),
            u && c.modifier(u, this, t),
            (this._pt = c));
    },
    Ht = function _initTween(t, e, r) {
      var i,
        n,
        a,
        s,
        o,
        u,
        h,
        l,
        f,
        c,
        d,
        p,
        _,
        m = t.vars,
        g = m.ease,
        v = m.startAt,
        y = m.immediateRender,
        T = m.lazy,
        b = m.onUpdate,
        x = m.onUpdateParams,
        k = m.callbackScope,
        M = m.runBackwards,
        O = m.yoyoEase,
        P = m.keyframes,
        C = m.autoRevert,
        A = t._dur,
        S = t._startAt,
        R = t._targets,
        D = t.parent,
        E = D && "nested" === D.data ? D.vars.targets : R,
        z = "auto" === t._overwrite && !I,
        F = t.timeline;
      if (
        (!F || (P && g) || (g = "none"),
        (t._ease = Yt(g, q.ease)),
        (t._yEase = O ? Lt(Yt(!0 === O ? g : O, q.ease)) : 0),
        O &&
          t._yoyo &&
          !t._repeat &&
          ((O = t._yEase), (t._yEase = t._ease), (t._ease = O)),
        (t._from = !F && !!m.runBackwards),
        !F || (P && !m.stagger))
      ) {
        if (
          ((p = (l = R[0] ? fa(R[0]).harness : 0) && m[l.prop]),
          (i = ua(m, ft)),
          S &&
            (S._zTime < 0 && S.progress(1),
            e < 0 && M && y && !C
              ? S.render(-1, !0)
              : S.revert(M && A ? ht : ut),
            (S._lazy = 0)),
          v)
        ) {
          if (
            (za(
              (t._startAt = Gt.set(
                R,
                qa(
                  {
                    data: "isStart",
                    overwrite: !1,
                    parent: D,
                    immediateRender: !0,
                    lazy: !S && w(T),
                    startAt: null,
                    delay: 0,
                    onUpdate: b,
                    onUpdateParams: x,
                    callbackScope: k,
                    stagger: 0,
                  },
                  v
                )
              ))
            ),
            (t._startAt._dp = 0),
            (t._startAt._sat = t),
            e < 0 && (B || (!y && !C)) && t._startAt.revert(ht),
            y && A && e <= 0 && r <= 0)
          )
            return void (e && (t._zTime = e));
        } else if (M && A && !S)
          if (
            (e && (y = !1),
            (a = qa(
              {
                overwrite: !1,
                data: "isFromStart",
                lazy: y && !S && w(T),
                immediateRender: y,
                stagger: 0,
                parent: D,
              },
              i
            )),
            p && (a[l.prop] = p),
            za((t._startAt = Gt.set(R, a))),
            (t._startAt._dp = 0),
            (t._startAt._sat = t),
            e < 0 && (B ? t._startAt.revert(ht) : t._startAt.render(-1, !0)),
            (t._zTime = e),
            y)
          ) {
            if (!e) return;
          } else _initTween(t._startAt, V, V);
        for (
          t._pt = t._ptCache = 0, T = (A && w(T)) || (T && !A), n = 0;
          n < R.length;
          n++
        ) {
          if (
            ((h = (o = R[n])._gsap || ea(R)[n]._gsap),
            (t._ptLookup[n] = c = {}),
            dt[h.id] && ct.length && ma(),
            (d = E === R ? n : E.indexOf(o)),
            l &&
              !1 !== (f = new l()).init(o, p || i, t, d, E) &&
              ((t._pt = s =
                new pe(t._pt, o, f.name, 0, 1, f.render, f, 0, f.priority)),
              f._props.forEach(function (t) {
                c[t] = s;
              }),
              f.priority && (u = 1)),
            !l || p)
          )
            for (a in i)
              pt[a] && (f = _b(a, i, t, d, o, E))
                ? f.priority && (u = 1)
                : (c[a] = s =
                    Xt.call(t, o, a, "get", i[a], d, E, 0, m.stringFilter));
          t._op && t._op[n] && t.kill(o, t._op[n]),
            z &&
              t._pt &&
              ((Vt = t),
              L.killTweensOf(o, c, t.globalTime(e)),
              (_ = !t.parent),
              (Vt = 0)),
            t._pt && T && (dt[h.id] = 1);
        }
        u && de(t), t._onInit && t._onInit(t);
      }
      (t._onUpdate = b),
        (t._initted = (!t._op || t._pt) && !_),
        P && e <= 0 && F.render(U, !0, !0);
    },
    Qt = function _parseFuncOrString(t, e, i, n, a) {
      return s(t)
        ? t.call(e, i, n, a)
        : r(t) && ~t.indexOf("random(")
        ? ob(t)
        : t;
    },
    Kt = vt + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
    Zt = {};
  ha(Kt + ",id,stagger,delay,duration,paused,scrollTrigger", function (t) {
    return (Zt[t] = 1);
  });
  var Gt = (function (z) {
    function Tween(e, r, i, n) {
      var a;
      "number" == typeof r && ((i.duration = r), (r = i), (i = null));
      var s,
        o,
        u,
        h,
        l,
        f,
        c,
        d,
        p = (a = z.call(this, n ? r : va(r)) || this).vars,
        _ = p.duration,
        m = p.delay,
        g = p.immediateRender,
        T = p.stagger,
        b = p.overwrite,
        x = p.keyframes,
        k = p.defaults,
        M = p.scrollTrigger,
        O = p.yoyoEase,
        P = r.parent || L,
        C = ($(e) || J(e) ? t(e[0]) : "length" in r) ? [e] : Ot(e);
      if (
        ((a._targets = C.length
          ? ea(C)
          : R(
              "GSAP target " + e + " not found. https://greensock.com",
              !j.nullTargetWarn
            ) || []),
        (a._ptLookup = []),
        (a._overwrite = b),
        x || T || y(_) || y(m))
      ) {
        if (
          ((r = a.vars),
          (s = a.timeline =
            new Ut({
              data: "nested",
              defaults: k || {},
              targets: P && "nested" === P.data ? P.vars.targets : C,
            })).kill(),
          (s.parent = s._dp = _assertThisInitialized(a)),
          (s._start = 0),
          T || y(_) || y(m))
        ) {
          if (((h = C.length), (c = T && eb(T)), v(T)))
            for (l in T) ~Kt.indexOf(l) && ((d = d || {})[l] = T[l]);
          for (o = 0; o < h; o++)
            ((u = ua(r, Zt)).stagger = 0),
              O && (u.yoyoEase = O),
              d && yt(u, d),
              (f = C[o]),
              (u.duration = +Qt(_, _assertThisInitialized(a), o, f, C)),
              (u.delay =
                (+Qt(m, _assertThisInitialized(a), o, f, C) || 0) - a._delay),
              !T &&
                1 === h &&
                u.delay &&
                ((a._delay = m = u.delay), (a._start += m), (u.delay = 0)),
              s.to(f, u, c ? c(o, f, C) : 0),
              (s._ease = Ft.none);
          s.duration() ? (_ = m = 0) : (a.timeline = 0);
        } else if (x) {
          va(qa(s.vars.defaults, { ease: "none" })),
            (s._ease = Yt(x.ease || r.ease || "none"));
          var A,
            S,
            D,
            E = 0;
          if ($(x))
            x.forEach(function (t) {
              return s.to(C, t, ">");
            }),
              s.duration();
          else {
            for (l in ((u = {}), x))
              "ease" === l || "easeEach" === l || fc(l, x[l], u, x.easeEach);
            for (l in u)
              for (
                A = u[l].sort(function (t, e) {
                  return t.t - e.t;
                }),
                  o = E = 0;
                o < A.length;
                o++
              )
                ((D = {
                  ease: (S = A[o]).e,
                  duration: ((S.t - (o ? A[o - 1].t : 0)) / 100) * _,
                })[l] = S.v),
                  s.to(C, D, E),
                  (E += D.duration);
            s.duration() < _ && s.to({}, { duration: _ - s.duration() });
          }
        }
        _ || a.duration((_ = s.duration()));
      } else a.timeline = 0;
      return (
        !0 !== b ||
          I ||
          ((Vt = _assertThisInitialized(a)), L.killTweensOf(C), (Vt = 0)),
        Ka(P, _assertThisInitialized(a), i),
        r.reversed && a.reverse(),
        r.paused && a.paused(!0),
        (g ||
          (!_ &&
            !x &&
            a._start === ja(P._time) &&
            w(g) &&
            (function _hasNoPausedAncestors(t) {
              return !t || (t._ts && _hasNoPausedAncestors(t.parent));
            })(_assertThisInitialized(a)) &&
            "nested" !== P.data)) &&
          ((a._tTime = -V), a.render(Math.max(0, -m) || 0)),
        M && La(_assertThisInitialized(a), M),
        a
      );
    }
    _inheritsLoose(Tween, z);
    var e = Tween.prototype;
    return (
      (e.render = function render(t, e, r) {
        var i,
          n,
          a,
          s,
          o,
          u,
          h,
          l,
          f,
          c = this._time,
          d = this._tDur,
          p = this._dur,
          _ = t < 0,
          m = d - V < t && !_ ? d : t < V ? 0 : t;
        if (p) {
          if (
            m !== this._tTime ||
            !t ||
            r ||
            (!this._initted && this._tTime) ||
            (this._startAt && this._zTime < 0 != _)
          ) {
            if (((i = m), (l = this.timeline), this._repeat)) {
              if (((s = p + this._rDelay), this._repeat < -1 && _))
                return this.totalTime(100 * s + t, e, r);
              if (
                ((i = ja(m % s)),
                m === d
                  ? ((a = this._repeat), (i = p))
                  : ((a = ~~(m / s)) && a === m / s && ((i = p), a--),
                    p < i && (i = p)),
                (u = this._yoyo && 1 & a) && ((f = this._yEase), (i = p - i)),
                (o = Tt(this._tTime, s)),
                i === c && !r && this._initted)
              )
                return (this._tTime = m), this;
              a !== o &&
                (l && this._yEase && Pb(l, u),
                !this.vars.repeatRefresh ||
                  u ||
                  this._lock ||
                  ((this._lock = r = 1),
                  (this.render(ja(s * a), !0).invalidate()._lock = 0)));
            }
            if (!this._initted) {
              if (Ma(this, _ ? t : i, r, e, m)) return (this._tTime = 0), this;
              if (c !== this._time) return this;
              if (p !== this._dur) return this.render(t, e, r);
            }
            if (
              ((this._tTime = m),
              (this._time = i),
              !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
              (this.ratio = h = (f || this._ease)(i / p)),
              this._from && (this.ratio = h = 1 - h),
              i && !c && !e && (Ct(this, "onStart"), this._tTime !== m))
            )
              return this;
            for (n = this._pt; n; ) n.r(h, n.d), (n = n._next);
            (l &&
              l.render(
                t < 0 ? t : !i && u ? -V : l._dur * l._ease(i / this._dur),
                e,
                r
              )) ||
              (this._startAt && (this._zTime = t)),
              this._onUpdate &&
                !e &&
                (_ && Ca(this, t, 0, r), Ct(this, "onUpdate")),
              this._repeat &&
                a !== o &&
                this.vars.onRepeat &&
                !e &&
                this.parent &&
                Ct(this, "onRepeat"),
              (m !== this._tDur && m) ||
                this._tTime !== m ||
                (_ && !this._onUpdate && Ca(this, t, 0, !0),
                (!t && p) ||
                  !(
                    (m === this._tDur && 0 < this._ts) ||
                    (!m && this._ts < 0)
                  ) ||
                  za(this, 1),
                e ||
                  (_ && !c) ||
                  !(m || c || u) ||
                  (Ct(this, m === d ? "onComplete" : "onReverseComplete", !0),
                  !this._prom ||
                    (m < d && 0 < this.timeScale()) ||
                    this._prom()));
          }
        } else
          !(function _renderZeroDurationTween(t, e, r, i) {
            var n,
              a,
              s,
              o = t.ratio,
              u =
                e < 0 ||
                (!e &&
                  ((!t._start &&
                    (function _parentPlayheadIsBeforeStart(t) {
                      var e = t.parent;
                      return (
                        e &&
                        e._ts &&
                        e._initted &&
                        !e._lock &&
                        (e.rawTime() < 0 || _parentPlayheadIsBeforeStart(e))
                      );
                    })(t) &&
                    (t._initted || !bt(t))) ||
                    ((t._ts < 0 || t._dp._ts < 0) && !bt(t))))
                  ? 0
                  : 1,
              h = t._rDelay,
              l = 0;
            if (
              (h &&
                t._repeat &&
                ((l = kt(0, t._tDur, e)),
                (a = Tt(l, h)),
                t._yoyo && 1 & a && (u = 1 - u),
                a !== Tt(t._tTime, h) &&
                  ((o = 1 - u),
                  t.vars.repeatRefresh && t._initted && t.invalidate())),
              u !== o || B || i || t._zTime === V || (!e && t._zTime))
            ) {
              if (!t._initted && Ma(t, e, i, r, l)) return;
              for (
                s = t._zTime,
                  t._zTime = e || (r ? V : 0),
                  r = r || (e && !s),
                  t.ratio = u,
                  t._from && (u = 1 - u),
                  t._time = 0,
                  t._tTime = l,
                  n = t._pt;
                n;

              )
                n.r(u, n.d), (n = n._next);
              e < 0 && Ca(t, e, 0, !0),
                t._onUpdate && !r && Ct(t, "onUpdate"),
                l && t._repeat && !r && t.parent && Ct(t, "onRepeat"),
                (e >= t._tDur || e < 0) &&
                  t.ratio === u &&
                  (u && za(t, 1),
                  r ||
                    B ||
                    (Ct(t, u ? "onComplete" : "onReverseComplete", !0),
                    t._prom && t._prom()));
            } else t._zTime || (t._zTime = e);
          })(this, t, e, r);
        return this;
      }),
      (e.targets = function targets() {
        return this._targets;
      }),
      (e.invalidate = function invalidate(t) {
        return (
          (t && this.vars.runBackwards) || (this._startAt = 0),
          (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
          (this._ptLookup = []),
          this.timeline && this.timeline.invalidate(t),
          z.prototype.invalidate.call(this, t)
        );
      }),
      (e.resetTo = function resetTo(t, e, r, i) {
        d || Et.wake(), this._ts || this.play();
        var n,
          a = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
        return (
          this._initted || Ht(this, a),
          (n = this._ease(a / this._dur)),
          (function _updatePropTweens(t, e, r, i, n, a, s) {
            var o,
              u,
              h,
              l,
              f = ((t._pt && t._ptCache) || (t._ptCache = {}))[e];
            if (!f)
              for (
                f = t._ptCache[e] = [], h = t._ptLookup, l = t._targets.length;
                l--;

              ) {
                if ((o = h[l][e]) && o.d && o.d._pt)
                  for (o = o.d._pt; o && o.p !== e && o.fp !== e; ) o = o._next;
                if (!o)
                  return (Wt = 1), (t.vars[e] = "+=0"), Ht(t, s), (Wt = 0), 1;
                f.push(o);
              }
            for (l = f.length; l--; )
              ((o = (u = f[l])._pt || u).s =
                (!i && 0 !== i) || n ? o.s + (i || 0) + a * o.c : i),
                (o.c = r - o.s),
                u.e && (u.e = ia(r) + Ya(u.e)),
                u.b && (u.b = o.s + Ya(u.b));
          })(this, t, e, r, i, n, a)
            ? this.resetTo(t, e, r, i)
            : (Ia(this, 0),
              this.parent ||
                xa(
                  this._dp,
                  this,
                  "_first",
                  "_last",
                  this._dp._sort ? "_start" : 0
                ),
              this.render(0))
        );
      }),
      (e.kill = function kill(t, e) {
        if ((void 0 === e && (e = "all"), !(t || (e && "all" !== e))))
          return (this._lazy = this._pt = 0), this.parent ? tb(this) : this;
        if (this.timeline) {
          var i = this.timeline.totalDuration();
          return (
            this.timeline.killTweensOf(t, e, Vt && !0 !== Vt.vars.overwrite)
              ._first || tb(this),
            this.parent &&
              i !== this.timeline.totalDuration() &&
              Ra(this, (this._dur * this.timeline._tDur) / i, 0, 1),
            this
          );
        }
        var n,
          a,
          s,
          o,
          u,
          h,
          l,
          f = this._targets,
          c = t ? Ot(t) : f,
          d = this._ptLookup,
          p = this._pt;
        if (
          (!e || "all" === e) &&
          (function _arraysMatch(t, e) {
            for (
              var r = t.length, i = r === e.length;
              i && r-- && t[r] === e[r];

            );
            return r < 0;
          })(f, c)
        )
          return "all" === e && (this._pt = 0), tb(this);
        for (
          n = this._op = this._op || [],
            "all" !== e &&
              (r(e) &&
                ((u = {}),
                ha(e, function (t) {
                  return (u[t] = 1);
                }),
                (e = u)),
              (e = (function _addAliasesToVars(t, e) {
                var r,
                  i,
                  n,
                  a,
                  s = t[0] ? fa(t[0]).harness : 0,
                  o = s && s.aliases;
                if (!o) return e;
                for (i in ((r = yt({}, e)), o))
                  if ((i in r))
                    for (n = (a = o[i].split(",")).length; n--; )
                      r[a[n]] = r[i];
                return r;
              })(f, e))),
            l = f.length;
          l--;

        )
          if (~c.indexOf(f[l]))
            for (u in ((a = d[l]),
            "all" === e
              ? ((n[l] = e), (o = a), (s = {}))
              : ((s = n[l] = n[l] || {}), (o = e)),
            o))
              (h = a && a[u]) &&
                (("kill" in h.d && !0 !== h.d.kill(u)) || ya(this, h, "_pt"),
                delete a[u]),
                "all" !== s && (s[u] = 1);
        return this._initted && !this._pt && p && tb(this), this;
      }),
      (Tween.to = function to(t, e, r) {
        return new Tween(t, e, r);
      }),
      (Tween.from = function from(t, e) {
        return Va(1, arguments);
      }),
      (Tween.delayedCall = function delayedCall(t, e, r, i) {
        return new Tween(e, 0, {
          immediateRender: !1,
          lazy: !1,
          overwrite: !1,
          delay: t,
          onComplete: e,
          onReverseComplete: e,
          onCompleteParams: r,
          onReverseCompleteParams: r,
          callbackScope: i,
        });
      }),
      (Tween.fromTo = function fromTo(t, e, r) {
        return Va(2, arguments);
      }),
      (Tween.set = function set(t, e) {
        return (
          (e.duration = 0), e.repeatDelay || (e.repeat = 0), new Tween(t, e)
        );
      }),
      (Tween.killTweensOf = function killTweensOf(t, e, r) {
        return L.killTweensOf(t, e, r);
      }),
      Tween
    );
  })(qt);
  qa(Gt.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
    ha("staggerTo,staggerFrom,staggerFromTo", function (r) {
      Gt[r] = function () {
        var t = new Ut(),
          e = Mt.call(arguments, 0);
        return e.splice("staggerFromTo" === r ? 5 : 4, 0, 0), t[r].apply(t, e);
      };
    });
  function nc(t, e, r) {
    return t.setAttribute(e, r);
  }
  function vc(t, e, r, i) {
    i.mSet(t, e, i.m.call(i.tween, r, i.mt), i);
  }
  var Jt = function _setterPlain(t, e, r) {
      return (t[e] = r);
    },
    $t = function _setterFunc(t, e, r) {
      return t[e](r);
    },
    ee = function _setterFuncWithParam(t, e, r, i) {
      return t[e](i.fp, r);
    },
    re = function _getSetter(t, e) {
      return s(t[e]) ? $t : u(t[e]) && t.setAttribute ? nc : Jt;
    },
    ne = function _renderPlain(t, e) {
      return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t)) / 1e6, e);
    },
    ae = function _renderBoolean(t, e) {
      return e.set(e.t, e.p, !!(e.s + e.c * t), e);
    },
    se = function _renderComplexString(t, e) {
      var r = e._pt,
        i = "";
      if (!t && e.b) i = e.b;
      else if (1 === t && e.e) i = e.e;
      else {
        for (; r; )
          (i =
            r.p +
            (r.m
              ? r.m(r.s + r.c * t)
              : Math.round(1e4 * (r.s + r.c * t)) / 1e4) +
            i),
            (r = r._next);
        i += e.c;
      }
      e.set(e.t, e.p, i, e);
    },
    oe = function _renderPropTweens(t, e) {
      for (var r = e._pt; r; ) r.r(t, r.d), (r = r._next);
    },
    le = function _addPluginModifier(t, e, r, i) {
      for (var n, a = this._pt; a; )
        (n = a._next), a.p === i && a.modifier(t, e, r), (a = n);
    },
    fe = function _killPropTweensOf(t) {
      for (var e, r, i = this._pt; i; )
        (r = i._next),
          (i.p === t && !i.op) || i.op === t
            ? ya(this, i, "_pt")
            : i.dep || (e = 1),
          (i = r);
      return !e;
    },
    de = function _sortPropTweensByPriority(t) {
      for (var e, r, i, n, a = t._pt; a; ) {
        for (e = a._next, r = i; r && r.pr > a.pr; ) r = r._next;
        (a._prev = r ? r._prev : n) ? (a._prev._next = a) : (i = a),
          (a._next = r) ? (r._prev = a) : (n = a),
          (a = e);
      }
      t._pt = i;
    },
    pe =
      ((PropTween.prototype.modifier = function modifier(t, e, r) {
        (this.mSet = this.mSet || this.set),
          (this.set = vc),
          (this.m = t),
          (this.mt = r),
          (this.tween = e);
      }),
      PropTween);
  function PropTween(t, e, r, i, n, a, s, o, u) {
    (this.t = e),
      (this.s = i),
      (this.c = n),
      (this.p = r),
      (this.r = a || ne),
      (this.d = s || this),
      (this.set = o || Jt),
      (this.pr = u || 0),
      (this._next = t) && (t._prev = this);
  }
  ha(
    vt +
      "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
    function (t) {
      return (ft[t] = 1);
    }
  ),
    (ot.TweenMax = ot.TweenLite = Gt),
    (ot.TimelineLite = ot.TimelineMax = Ut),
    (L = new Ut({
      sortChildren: !1,
      defaults: q,
      autoRemoveChildren: !0,
      id: "root",
      smoothChildTiming: !0,
    })),
    (j.stringFilter = Eb);
  function Cc(t) {
    return (Te[t] || we).map(function (t) {
      return t();
    });
  }
  function Dc() {
    var t = Date.now(),
      o = [];
    2 < t - xe &&
      (Cc("matchMediaInit"),
      ye.forEach(function (t) {
        var e,
          r,
          i,
          n,
          a = t.queries,
          s = t.conditions;
        for (r in a)
          (e = h.matchMedia(a[r]).matches) && (i = 1),
            e !== s[r] && ((s[r] = e), (n = 1));
        n && (t.revert(), i && o.push(t));
      }),
      Cc("matchMediaRevert"),
      o.forEach(function (t) {
        return t.onMatch(t);
      }),
      (xe = t),
      Cc("matchMedia"));
  }
  var _e,
    ye = [],
    Te = {},
    we = [],
    xe = 0,
    ke =
      (((_e = Context.prototype).add = function add(t, i, n) {
        function Cw() {
          var t,
            e = l,
            r = a.selector;
          return (
            e && e !== a && e.data.push(a),
            n && (a.selector = cb(n)),
            (l = a),
            (t = i.apply(a, arguments)),
            s(t) && a._r.push(t),
            (l = e),
            (a.selector = r),
            (a.isReverted = !1),
            t
          );
        }
        s(t) && ((n = i), (i = t), (t = s));
        var a = this;
        return (a.last = Cw), t === s ? Cw(a) : t ? (a[t] = Cw) : Cw;
      }),
      (_e.ignore = function ignore(t) {
        var e = l;
        (l = null), t(this), (l = e);
      }),
      (_e.getTweens = function getTweens() {
        var e = [];
        return (
          this.data.forEach(function (t) {
            return t instanceof Context
              ? e.push.apply(e, t.getTweens())
              : t instanceof Gt &&
                  !(t.parent && "nested" === t.parent.data) &&
                  e.push(t);
          }),
          e
        );
      }),
      (_e.clear = function clear() {
        this._r.length = this.data.length = 0;
      }),
      (_e.kill = function kill(e, t) {
        var r = this;
        if (e) {
          var i = this.getTweens();
          this.data.forEach(function (t) {
            "isFlip" === t.data &&
              (t.revert(),
              t.getChildren(!0, !0, !1).forEach(function (t) {
                return i.splice(i.indexOf(t), 1);
              }));
          }),
            i
              .map(function (t) {
                return { g: t.globalTime(0), t: t };
              })
              .sort(function (t, e) {
                return e.g - t.g || -1;
              })
              .forEach(function (t) {
                return t.t.revert(e);
              }),
            this.data.forEach(function (t) {
              return !(t instanceof qt) && t.revert && t.revert(e);
            }),
            this._r.forEach(function (t) {
              return t(e, r);
            }),
            (this.isReverted = !0);
        } else
          this.data.forEach(function (t) {
            return t.kill && t.kill();
          });
        if ((this.clear(), t)) {
          var n = ye.indexOf(this);
          ~n && ye.splice(n, 1);
        }
      }),
      (_e.revert = function revert(t) {
        this.kill(t || {});
      }),
      Context);
  function Context(t, e) {
    (this.selector = e && cb(e)),
      (this.data = []),
      (this._r = []),
      (this.isReverted = !1),
      t && this.add(t);
  }
  var Me,
    Oe =
      (((Me = MatchMedia.prototype).add = function add(t, e, r) {
        v(t) || (t = { matches: t });
        var i,
          n,
          a,
          s = new ke(0, r || this.scope),
          o = (s.conditions = {});
        for (n in (this.contexts.push(s),
        (e = s.add("onMatch", e)),
        (s.queries = t)))
          "all" === n
            ? (a = 1)
            : (i = h.matchMedia(t[n])) &&
              (ye.indexOf(s) < 0 && ye.push(s),
              (o[n] = i.matches) && (a = 1),
              i.addListener
                ? i.addListener(Dc)
                : i.addEventListener("change", Dc));
        return a && e(s), this;
      }),
      (Me.revert = function revert(t) {
        this.kill(t || {});
      }),
      (Me.kill = function kill(e) {
        this.contexts.forEach(function (t) {
          return t.kill(e, !0);
        });
      }),
      MatchMedia);
  function MatchMedia(t) {
    (this.contexts = []), (this.scope = t);
  }
  var Pe = {
    registerPlugin: function registerPlugin() {
      for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
        e[r] = arguments[r];
      e.forEach(function (t) {
        return (function _createPlugin(t) {
          var e = (t = (!t.name && t.default) || t).name,
            r = s(t),
            i =
              e && !r && t.init
                ? function () {
                    this._props = [];
                  }
                : t,
            n = {
              init: T,
              render: oe,
              add: Xt,
              kill: fe,
              modifier: le,
              rawVars: 0,
            },
            a = {
              targetTest: 0,
              get: 0,
              getSetter: re,
              aliases: {},
              register: 0,
            };
          if ((zt(), t !== i)) {
            if (pt[e]) return;
            qa(i, qa(ua(t, n), a)),
              yt(i.prototype, yt(n, ua(t, a))),
              (pt[(i.prop = e)] = i),
              t.targetTest && (gt.push(i), (ft[e] = 1)),
              (e =
                ("css" === e
                  ? "CSS"
                  : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin");
          }
          S(e, i), t.register && t.register(Ce, i, pe);
        })(t);
      });
    },
    timeline: function timeline(t) {
      return new Ut(t);
    },
    getTweensOf: function getTweensOf(t, e) {
      return L.getTweensOf(t, e);
    },
    getProperty: function getProperty(i, t, e, n) {
      r(i) && (i = Ot(i)[0]);
      var a = fa(i || {}).get,
        s = e ? pa : oa;
      return (
        "native" === e && (e = ""),
        i
          ? t
            ? s(((pt[t] && pt[t].get) || a)(i, t, e, n))
            : function (t, e, r) {
                return s(((pt[t] && pt[t].get) || a)(i, t, e, r));
              }
          : i
      );
    },
    quickSetter: function quickSetter(r, e, i) {
      if (1 < (r = Ot(r)).length) {
        var n = r.map(function (t) {
            return Ce.quickSetter(t, e, i);
          }),
          a = n.length;
        return function (t) {
          for (var e = a; e--; ) n[e](t);
        };
      }
      r = r[0] || {};
      var s = pt[e],
        o = fa(r),
        u = (o.harness && (o.harness.aliases || {})[e]) || e,
        h = s
          ? function (t) {
              var e = new s();
              (c._pt = 0),
                e.init(r, i ? t + i : t, c, 0, [r]),
                e.render(1, e),
                c._pt && oe(1, c);
            }
          : o.set(r, u);
      return s
        ? h
        : function (t) {
            return h(r, u, i ? t + i : t, o, 1);
          };
    },
    quickTo: function quickTo(t, i, e) {
      function Ux(t, e, r) {
        return n.resetTo(i, t, e, r);
      }
      var r,
        n = Ce.to(
          t,
          yt((((r = {})[i] = "+=0.1"), (r.paused = !0), r), e || {})
        );
      return (Ux.tween = n), Ux;
    },
    isTweening: function isTweening(t) {
      return 0 < L.getTweensOf(t, !0).length;
    },
    defaults: function defaults(t) {
      return t && t.ease && (t.ease = Yt(t.ease, q.ease)), ta(q, t || {});
    },
    config: function config(t) {
      return ta(j, t || {});
    },
    registerEffect: function registerEffect(t) {
      var i = t.name,
        n = t.effect,
        e = t.plugins,
        a = t.defaults,
        r = t.extendTimeline;
      (e || "").split(",").forEach(function (t) {
        return (
          t && !pt[t] && !ot[t] && R(i + " effect requires " + t + " plugin.")
        );
      }),
        (_t[i] = function (t, e, r) {
          return n(Ot(t), qa(e || {}, a), r);
        }),
        r &&
          (Ut.prototype[i] = function (t, e, r) {
            return this.add(_t[i](t, v(e) ? e : (r = e) && {}, this), r);
          });
    },
    registerEase: function registerEase(t, e) {
      Ft[t] = Yt(e);
    },
    parseEase: function parseEase(t, e) {
      return arguments.length ? Yt(t, e) : Ft;
    },
    getById: function getById(t) {
      return L.getById(t);
    },
    exportRoot: function exportRoot(t, e) {
      void 0 === t && (t = {});
      var r,
        i,
        n = new Ut(t);
      for (
        n.smoothChildTiming = w(t.smoothChildTiming),
          L.remove(n),
          n._dp = 0,
          n._time = n._tTime = L._time,
          r = L._first;
        r;

      )
        (i = r._next),
          (!e &&
            !r._dur &&
            r instanceof Gt &&
            r.vars.onComplete === r._targets[0]) ||
            Ka(n, r, r._start - r._delay),
          (r = i);
      return Ka(L, n, 0), n;
    },
    context: function context(t, e) {
      return t ? new ke(t, e) : l;
    },
    matchMedia: function matchMedia(t) {
      return new Oe(t);
    },
    matchMediaRefresh: function matchMediaRefresh() {
      return (
        ye.forEach(function (t) {
          var e,
            r,
            i = t.conditions;
          for (r in i) i[r] && ((i[r] = !1), (e = 1));
          e && t.revert();
        }) || Dc()
      );
    },
    addEventListener: function addEventListener(t, e) {
      var r = Te[t] || (Te[t] = []);
      ~r.indexOf(e) || r.push(e);
    },
    removeEventListener: function removeEventListener(t, e) {
      var r = Te[t],
        i = r && r.indexOf(e);
      0 <= i && r.splice(i, 1);
    },
    utils: {
      wrap: function wrap(e, t, r) {
        var i = t - e;
        return $(e)
          ? lb(e, wrap(0, e.length), t)
          : Wa(r, function (t) {
              return ((i + ((t - e) % i)) % i) + e;
            });
      },
      wrapYoyo: function wrapYoyo(e, t, r) {
        var i = t - e,
          n = 2 * i;
        return $(e)
          ? lb(e, wrapYoyo(0, e.length - 1), t)
          : Wa(r, function (t) {
              return e + (i < (t = (n + ((t - e) % n)) % n || 0) ? n - t : t);
            });
      },
      distribute: eb,
      random: hb,
      snap: gb,
      normalize: function normalize(t, e, r) {
        return Pt(t, e, 0, 1, r);
      },
      getUnit: Ya,
      clamp: function clamp(e, r, t) {
        return Wa(t, function (t) {
          return kt(e, r, t);
        });
      },
      splitColor: zb,
      toArray: Ot,
      selector: cb,
      mapRange: Pt,
      pipe: function pipe() {
        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
          e[r] = arguments[r];
        return function (t) {
          return e.reduce(function (t, e) {
            return e(t);
          }, t);
        };
      },
      unitize: function unitize(e, r) {
        return function (t) {
          return e(parseFloat(t)) + (r || Ya(t));
        };
      },
      interpolate: function interpolate(e, i, t, n) {
        var a = isNaN(e + i)
          ? 0
          : function (t) {
              return (1 - t) * e + t * i;
            };
        if (!a) {
          var s,
            o,
            u,
            h,
            l,
            f = r(e),
            c = {};
          if ((!0 === t && (n = 1) && (t = null), f))
            (e = { p: e }), (i = { p: i });
          else if ($(e) && !$(i)) {
            for (u = [], h = e.length, l = h - 2, o = 1; o < h; o++)
              u.push(interpolate(e[o - 1], e[o]));
            h--,
              (a = function func(t) {
                t *= h;
                var e = Math.min(l, ~~t);
                return u[e](t - e);
              }),
              (t = i);
          } else n || (e = yt($(e) ? [] : {}, e));
          if (!u) {
            for (s in i) Xt.call(c, e, s, "get", i[s]);
            a = function func(t) {
              return oe(t, c) || (f ? e.p : e);
            };
          }
        }
        return Wa(t, a);
      },
      shuffle: db,
    },
    install: P,
    effects: _t,
    ticker: Et,
    updateRoot: Ut.updateRoot,
    plugins: pt,
    globalTimeline: L,
    core: {
      PropTween: pe,
      globals: S,
      Tween: Gt,
      Timeline: Ut,
      Animation: qt,
      getCache: fa,
      _removeLinkedListItem: ya,
      reverting: function reverting() {
        return B;
      },
      context: function context(t) {
        return t && l && (l.data.push(t), (t._ctx = l)), l;
      },
      suppressOverwrites: function suppressOverwrites(t) {
        return (I = t);
      },
    },
  };
  ha("to,from,fromTo,delayedCall,set,killTweensOf", function (t) {
    return (Pe[t] = Gt[t]);
  }),
    Et.add(Ut.updateRoot),
    (c = Pe.to({}, { duration: 0 }));
  function Hc(t, e) {
    for (var r = t._pt; r && r.p !== e && r.op !== e && r.fp !== e; )
      r = r._next;
    return r;
  }
  function Jc(t, a) {
    return {
      name: t,
      rawVars: 1,
      init: function init(t, n, e) {
        e._onInit = function (t) {
          var e, i;
          if (
            (r(n) &&
              ((e = {}),
              ha(n, function (t) {
                return (e[t] = 1);
              }),
              (n = e)),
            a)
          ) {
            for (i in ((e = {}), n)) e[i] = a(n[i]);
            n = e;
          }
          !(function _addModifiers(t, e) {
            var r,
              i,
              n,
              a = t._targets;
            for (r in e)
              for (i = a.length; i--; )
                (n = (n = t._ptLookup[i][r]) && n.d) &&
                  (n._pt && (n = Hc(n, r)),
                  n && n.modifier && n.modifier(e[r], t, a[i], r));
          })(t, n);
        };
      },
    };
  }
  var Ce =
    Pe.registerPlugin(
      {
        name: "attr",
        init: function init(t, e, r, i, n) {
          var a, s, o;
          for (a in ((this.tween = r), e))
            (o = t.getAttribute(a) || ""),
              ((s = this.add(
                t,
                "setAttribute",
                (o || 0) + "",
                e[a],
                i,
                n,
                0,
                0,
                a
              )).op = a),
              (s.b = o),
              this._props.push(a);
        },
        render: function render(t, e) {
          for (var r = e._pt; r; )
            B ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), (r = r._next);
        },
      },
      {
        name: "endArray",
        init: function init(t, e) {
          for (var r = e.length; r--; )
            this.add(t, r, t[r] || 0, e[r], 0, 0, 0, 0, 0, 1);
        },
      },
      Jc("roundProps", fb),
      Jc("modifiers"),
      Jc("snap", gb)
    ) || Pe;
  (Gt.version = Ut.version = Ce.version = "3.11.4"), (o = 1), x() && zt();
  function td(t, e) {
    return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
  }
  function ud(t, e) {
    return e.set(
      e.t,
      e.p,
      1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u,
      e
    );
  }
  function vd(t, e) {
    return e.set(
      e.t,
      e.p,
      t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b,
      e
    );
  }
  function wd(t, e) {
    var r = e.s + e.c * t;
    e.set(e.t, e.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + e.u, e);
  }
  function xd(t, e) {
    return e.set(e.t, e.p, t ? e.e : e.b, e);
  }
  function yd(t, e) {
    return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
  }
  function zd(t, e, r) {
    return (t.style[e] = r);
  }
  function Ad(t, e, r) {
    return t.style.setProperty(e, r);
  }
  function Bd(t, e, r) {
    return (t._gsap[e] = r);
  }
  function Cd(t, e, r) {
    return (t._gsap.scaleX = t._gsap.scaleY = r);
  }
  function Dd(t, e, r, i, n) {
    var a = t._gsap;
    (a.scaleX = a.scaleY = r), a.renderTransform(n, a);
  }
  function Ed(t, e, r, i, n) {
    var a = t._gsap;
    (a[e] = r), a.renderTransform(n, a);
  }
  function Hd(t, e) {
    var r = this,
      i = this.target,
      n = i.style;
    if (t in rr) {
      if (
        ((this.tfm = this.tfm || {}),
        "transform" !== t &&
          (~(t = hr[t] || t).indexOf(",")
            ? t.split(",").forEach(function (t) {
                return (r.tfm[t] = mr(i, t));
              })
            : (this.tfm[t] = i._gsap.x ? i._gsap[t] : mr(i, t))),
        0 <= this.props.indexOf(lr))
      )
        return;
      i._gsap.svg &&
        ((this.svgo = i.getAttribute("data-svg-origin")),
        this.props.push(fr, e, "")),
        (t = lr);
    }
    (n || e) && this.props.push(t, e, n[t]);
  }
  function Id(t) {
    t.translate &&
      (t.removeProperty("translate"),
      t.removeProperty("scale"),
      t.removeProperty("rotate"));
  }
  function Jd() {
    var t,
      e,
      r = this.props,
      i = this.target,
      n = i.style,
      a = i._gsap;
    for (t = 0; t < r.length; t += 3)
      r[t + 1]
        ? (i[r[t]] = r[t + 2])
        : r[t + 2]
        ? (n[r[t]] = r[t + 2])
        : n.removeProperty(r[t].replace(sr, "-$1").toLowerCase());
    if (this.tfm) {
      for (e in this.tfm) a[e] = this.tfm[e];
      a.svg &&
        (a.renderTransform(),
        i.setAttribute("data-svg-origin", this.svgo || "")),
        !(t = Fe()) || t.isStart || n[lr] || (Id(n), (a.uncache = 1));
    }
  }
  function Kd(t, e) {
    var r = { target: t, props: [], revert: Jd, save: Hd };
    return (
      e &&
        e.split(",").forEach(function (t) {
          return r.save(t);
        }),
      r
    );
  }
  function Md(t, e) {
    var r = Se.createElementNS
      ? Se.createElementNS(
          (e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
          t
        )
      : Se.createElement(t);
    return r.style ? r : Se.createElement(t);
  }
  function Nd(t, e, r) {
    var i = getComputedStyle(t);
    return (
      i[e] ||
      i.getPropertyValue(e.replace(sr, "-$1").toLowerCase()) ||
      i.getPropertyValue(e) ||
      (!r && Nd(t, dr(e) || e, 1)) ||
      ""
    );
  }
  function Qd() {
    (function _windowExists() {
      return "undefined" != typeof window;
    })() &&
      window.document &&
      ((Ae = window),
      (Se = Ae.document),
      (Re = Se.documentElement),
      (Ee = Md("div") || { style: {} }),
      Md("div"),
      (lr = dr(lr)),
      (fr = lr + "Origin"),
      (Ee.style.cssText =
        "border-width:0;line-height:0;position:absolute;padding:0"),
      (Ie = !!dr("perspective")),
      (Fe = Ce.core.reverting),
      (De = 1));
  }
  function Rd(t) {
    var e,
      r = Md(
        "svg",
        (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) ||
          "http://www.w3.org/2000/svg"
      ),
      i = this.parentNode,
      n = this.nextSibling,
      a = this.style.cssText;
    if (
      (Re.appendChild(r),
      r.appendChild(this),
      (this.style.display = "block"),
      t)
    )
      try {
        (e = this.getBBox()),
          (this._gsapBBox = this.getBBox),
          (this.getBBox = Rd);
      } catch (t) {}
    else this._gsapBBox && (e = this._gsapBBox());
    return (
      i && (n ? i.insertBefore(this, n) : i.appendChild(this)),
      Re.removeChild(r),
      (this.style.cssText = a),
      e
    );
  }
  function Sd(t, e) {
    for (var r = e.length; r--; )
      if (t.hasAttribute(e[r])) return t.getAttribute(e[r]);
  }
  function Td(e) {
    var r;
    try {
      r = e.getBBox();
    } catch (t) {
      r = Rd.call(e, !0);
    }
    return (
      (r && (r.width || r.height)) || e.getBBox === Rd || (r = Rd.call(e, !0)),
      !r || r.width || r.x || r.y
        ? r
        : {
            x: +Sd(e, ["x", "cx", "x1"]) || 0,
            y: +Sd(e, ["y", "cy", "y1"]) || 0,
            width: 0,
            height: 0,
          }
    );
  }
  function Ud(t) {
    return !(!t.getCTM || (t.parentNode && !t.ownerSVGElement) || !Td(t));
  }
  function Vd(t, e) {
    if (e) {
      var r = t.style;
      e in rr && e !== fr && (e = lr),
        r.removeProperty
          ? (("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6)) ||
              (e = "-" + e),
            r.removeProperty(e.replace(sr, "-$1").toLowerCase()))
          : r.removeAttribute(e);
    }
  }
  function Wd(t, e, r, i, n, a) {
    var s = new pe(t._pt, e, r, 0, 1, a ? yd : xd);
    return ((t._pt = s).b = i), (s.e = n), t._props.push(r), s;
  }
  function Zd(t, e, r, i) {
    var n,
      a,
      s,
      o,
      u = parseFloat(r) || 0,
      h = (r + "").trim().substr((u + "").length) || "px",
      l = Ee.style,
      f = or.test(e),
      c = "svg" === t.tagName.toLowerCase(),
      d = (c ? "client" : "offset") + (f ? "Width" : "Height"),
      p = "px" === i,
      _ = "%" === i;
    return i === h || !u || pr[i] || pr[h]
      ? u
      : ("px" === h || p || (u = Zd(t, e, r, "px")),
        (o = t.getCTM && Ud(t)),
        (!_ && "%" !== h) || (!rr[e] && !~e.indexOf("adius"))
          ? ((l[f ? "width" : "height"] = 100 + (p ? h : i)),
            (a =
              ~e.indexOf("adius") || ("em" === i && t.appendChild && !c)
                ? t
                : t.parentNode),
            o && (a = (t.ownerSVGElement || {}).parentNode),
            (a && a !== Se && a.appendChild) || (a = Se.body),
            (s = a._gsap) &&
            _ &&
            s.width &&
            f &&
            s.time === Et.time &&
            !s.uncache
              ? ia((u / s.width) * 100)
              : ((!_ && "%" !== h) ||
                  _r[Nd(a, "display")] ||
                  (l.position = Nd(t, "position")),
                a === t && (l.position = "static"),
                a.appendChild(Ee),
                (n = Ee[d]),
                a.removeChild(Ee),
                (l.position = "absolute"),
                f && _ && (((s = fa(a)).time = Et.time), (s.width = a[d])),
                ia(p ? (n * u) / 100 : n && u ? (100 / n) * u : 0)))
          : ((n = o ? t.getBBox()[f ? "width" : "height"] : t[d]),
            ia(_ ? (u / n) * 100 : (u / 100) * n)));
  }
  function _d(t, e, r, i) {
    if (!r || "none" === r) {
      var n = dr(e, t, 1),
        a = n && Nd(t, n, 1);
      a && a !== r
        ? ((e = n), (r = a))
        : "borderColor" === e && (r = Nd(t, "borderTopColor"));
    }
    var s,
      o,
      u,
      h,
      l,
      f,
      c,
      d,
      p,
      _,
      m,
      g = new pe(this._pt, t.style, e, 0, 1, se),
      v = 0,
      y = 0;
    if (
      ((g.b = r),
      (g.e = i),
      (r += ""),
      "auto" === (i += "") &&
        ((t.style[e] = i), (i = Nd(t, e) || i), (t.style[e] = r)),
      Eb((s = [r, i])),
      (i = s[1]),
      (u = (r = s[0]).match(rt) || []),
      (i.match(rt) || []).length)
    ) {
      for (; (o = rt.exec(i)); )
        (c = o[0]),
          (p = i.substring(v, o.index)),
          l
            ? (l = (l + 1) % 5)
            : ("rgba(" !== p.substr(-5) && "hsla(" !== p.substr(-5)) || (l = 1),
          c !== (f = u[y++] || "") &&
            ((h = parseFloat(f) || 0),
            (m = f.substr((h + "").length)),
            "=" === c.charAt(1) && (c = ka(h, c) + m),
            (d = parseFloat(c)),
            (_ = c.substr((d + "").length)),
            (v = rt.lastIndex - _.length),
            _ ||
              ((_ = _ || j.units[e] || m),
              v === i.length && ((i += _), (g.e += _))),
            m !== _ && (h = Zd(t, e, f, _) || 0),
            (g._pt = {
              _next: g._pt,
              p: p || 1 === y ? p : ",",
              s: h,
              c: d - h,
              m: (l && l < 4) || "zIndex" === e ? Math.round : 0,
            }));
      g.c = v < i.length ? i.substring(v, i.length) : "";
    } else g.r = "display" === e && "none" === i ? yd : xd;
    return nt.test(i) && (g.e = 0), (this._pt = g);
  }
  function be(t) {
    var e = t.split(" "),
      r = e[0],
      i = e[1] || "50%";
    return (
      ("top" !== r && "bottom" !== r && "left" !== i && "right" !== i) ||
        ((t = r), (r = i), (i = t)),
      (e[0] = gr[r] || r),
      (e[1] = gr[i] || i),
      e.join(" ")
    );
  }
  function ce(t, e) {
    if (e.tween && e.tween._time === e.tween._dur) {
      var r,
        i,
        n,
        a = e.t,
        s = a.style,
        o = e.u,
        u = a._gsap;
      if ("all" === o || !0 === o) (s.cssText = ""), (i = 1);
      else
        for (n = (o = o.split(",")).length; -1 < --n; )
          (r = o[n]),
            rr[r] && ((i = 1), (r = "transformOrigin" === r ? fr : lr)),
            Vd(a, r);
      i &&
        (Vd(a, lr),
        u &&
          (u.svg && a.removeAttribute("transform"),
          br(a, 1),
          (u.uncache = 1),
          Id(s)));
    }
  }
  function ge(t) {
    return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t;
  }
  function he(t) {
    var e = Nd(t, lr);
    return ge(e) ? yr : e.substr(7).match(et).map(ia);
  }
  function ie(t, e) {
    var r,
      i,
      n,
      a,
      s = t._gsap || fa(t),
      o = t.style,
      u = he(t);
    return s.svg && t.getAttribute("transform")
      ? "1,0,0,1,0,0" ===
        (u = [
          (n = t.transform.baseVal.consolidate().matrix).a,
          n.b,
          n.c,
          n.d,
          n.e,
          n.f,
        ]).join(",")
        ? yr
        : u
      : (u !== yr ||
          t.offsetParent ||
          t === Re ||
          s.svg ||
          ((n = o.display),
          (o.display = "block"),
          ((r = t.parentNode) && t.offsetParent) ||
            ((a = 1), (i = t.nextElementSibling), Re.appendChild(t)),
          (u = he(t)),
          n ? (o.display = n) : Vd(t, "display"),
          a &&
            (i
              ? r.insertBefore(t, i)
              : r
              ? r.appendChild(t)
              : Re.removeChild(t))),
        e && 6 < u.length ? [u[0], u[1], u[4], u[5], u[12], u[13]] : u);
  }
  function je(t, e, r, i, n, a) {
    var s,
      o,
      u,
      h = t._gsap,
      l = n || ie(t, !0),
      f = h.xOrigin || 0,
      c = h.yOrigin || 0,
      d = h.xOffset || 0,
      p = h.yOffset || 0,
      _ = l[0],
      m = l[1],
      g = l[2],
      v = l[3],
      y = l[4],
      T = l[5],
      b = e.split(" "),
      w = parseFloat(b[0]) || 0,
      x = parseFloat(b[1]) || 0;
    r
      ? l !== yr &&
        (o = _ * v - m * g) &&
        ((u = w * (-m / o) + x * (_ / o) - (_ * T - m * y) / o),
        (w = w * (v / o) + x * (-g / o) + (g * T - v * y) / o),
        (x = u))
      : ((w = (s = Td(t)).x + (~b[0].indexOf("%") ? (w / 100) * s.width : w)),
        (x = s.y + (~(b[1] || b[0]).indexOf("%") ? (x / 100) * s.height : x))),
      i || (!1 !== i && h.smooth)
        ? ((y = w - f),
          (T = x - c),
          (h.xOffset = d + (y * _ + T * g) - y),
          (h.yOffset = p + (y * m + T * v) - T))
        : (h.xOffset = h.yOffset = 0),
      (h.xOrigin = w),
      (h.yOrigin = x),
      (h.smooth = !!i),
      (h.origin = e),
      (h.originIsAbsolute = !!r),
      (t.style[fr] = "0px 0px"),
      a &&
        (Wd(a, h, "xOrigin", f, w),
        Wd(a, h, "yOrigin", c, x),
        Wd(a, h, "xOffset", d, h.xOffset),
        Wd(a, h, "yOffset", p, h.yOffset)),
      t.setAttribute("data-svg-origin", w + " " + x);
  }
  function me(t, e, r) {
    var i = Ya(e);
    return ia(parseFloat(e) + parseFloat(Zd(t, "x", r + "px", i))) + i;
  }
  function te(t, e, i, n, a) {
    var s,
      o,
      u = 360,
      h = r(a),
      l = parseFloat(a) * (h && ~a.indexOf("rad") ? ir : 1) - n,
      f = n + l + "deg";
    return (
      h &&
        ("short" === (s = a.split("_")[1]) &&
          (l %= u) !== l % 180 &&
          (l += l < 0 ? u : -u),
        "cw" === s && l < 0
          ? (l = ((l + 36e9) % u) - ~~(l / u) * u)
          : "ccw" === s && 0 < l && (l = ((l - 36e9) % u) - ~~(l / u) * u)),
      (t._pt = o = new pe(t._pt, e, i, n, l, ud)),
      (o.e = f),
      (o.u = "deg"),
      t._props.push(i),
      o
    );
  }
  function ue(t, e) {
    for (var r in e) t[r] = e[r];
    return t;
  }
  function ve(t, e, r) {
    var i,
      n,
      a,
      s,
      o,
      u,
      h,
      l = ue({}, r._gsap),
      f = r.style;
    for (n in (l.svg
      ? ((a = r.getAttribute("transform")),
        r.setAttribute("transform", ""),
        (f[lr] = e),
        (i = br(r, 1)),
        Vd(r, lr),
        r.setAttribute("transform", a))
      : ((a = getComputedStyle(r)[lr]),
        (f[lr] = e),
        (i = br(r, 1)),
        (f[lr] = a)),
    rr))
      (a = l[n]) !== (s = i[n]) &&
        "perspective,force3D,transformOrigin,svgOrigin".indexOf(n) < 0 &&
        ((o = Ya(a) !== (h = Ya(s)) ? Zd(r, n, a, h) : parseFloat(a)),
        (u = parseFloat(s)),
        (t._pt = new pe(t._pt, i, n, o, u - o, td)),
        (t._pt.u = h || 0),
        t._props.push(n));
    ue(i, l);
  }
  var Ae,
    Se,
    Re,
    De,
    Ee,
    ze,
    Fe,
    Ie,
    Be = Ft.Power0,
    Le = Ft.Power1,
    Ye = Ft.Power2,
    Ne = Ft.Power3,
    qe = Ft.Power4,
    Ue = Ft.Linear,
    Ve = Ft.Quad,
    We = Ft.Cubic,
    Xe = Ft.Quart,
    He = Ft.Quint,
    Qe = Ft.Strong,
    Ke = Ft.Elastic,
    Ze = Ft.Back,
    Ge = Ft.SteppedEase,
    Je = Ft.Bounce,
    $e = Ft.Sine,
    tr = Ft.Expo,
    er = Ft.Circ,
    rr = {},
    ir = 180 / Math.PI,
    nr = Math.PI / 180,
    ar = Math.atan2,
    sr = /([A-Z])/g,
    or = /(left|right|width|margin|padding|x)/i,
    ur = /[\s,\(]\S/,
    hr = {
      autoAlpha: "opacity,visibility",
      scale: "scaleX,scaleY",
      alpha: "opacity",
    },
    lr = "transform",
    fr = lr + "Origin",
    cr = "O,Moz,ms,Ms,Webkit".split(","),
    dr = function _checkPropPrefix(t, e, r) {
      var i = (e || Ee).style,
        n = 5;
      if (t in i && !r) return t;
      for (
        t = t.charAt(0).toUpperCase() + t.substr(1);
        n-- && !(cr[n] + t in i);

      );
      return n < 0 ? null : (3 === n ? "ms" : 0 <= n ? cr[n] : "") + t;
    },
    pr = { deg: 1, rad: 1, turn: 1 },
    _r = { grid: 1, flex: 1 },
    mr = function _get(t, e, r, i) {
      var n;
      return (
        De || Qd(),
        e in hr &&
          "transform" !== e &&
          ~(e = hr[e]).indexOf(",") &&
          (e = e.split(",")[0]),
        rr[e] && "transform" !== e
          ? ((n = br(t, i)),
            (n =
              "transformOrigin" !== e
                ? n[e]
                : n.svg
                ? n.origin
                : wr(Nd(t, fr)) + " " + n.zOrigin + "px"))
          : ((n = t.style[e]) &&
              "auto" !== n &&
              !i &&
              !~(n + "").indexOf("calc(")) ||
            (n =
              (vr[e] && vr[e](t, e, r)) ||
              Nd(t, e) ||
              ga(t, e) ||
              ("opacity" === e ? 1 : 0)),
        r && !~(n + "").trim().indexOf(" ") ? Zd(t, e, n, r) + r : n
      );
    },
    gr = {
      top: "0%",
      bottom: "100%",
      left: "0%",
      right: "100%",
      center: "50%",
    },
    vr = {
      clearProps: function clearProps(t, e, r, i, n) {
        if ("isFromStart" !== n.data) {
          var a = (t._pt = new pe(t._pt, e, r, 0, 0, ce));
          return (a.u = i), (a.pr = -10), (a.tween = n), t._props.push(r), 1;
        }
      },
    },
    yr = [1, 0, 0, 1, 0, 0],
    Tr = {},
    br = function _parseTransform(t, e) {
      var r = t._gsap || new jt(t);
      if ("x" in r && !e && !r.uncache) return r;
      var i,
        n,
        a,
        s,
        o,
        u,
        h,
        l,
        f,
        c,
        d,
        p,
        _,
        m,
        g,
        v,
        y,
        T,
        b,
        w,
        x,
        k,
        M,
        O,
        P,
        C,
        A,
        S,
        R,
        D,
        E,
        z,
        F = t.style,
        I = r.scaleX < 0,
        B = "deg",
        L = getComputedStyle(t),
        Y = Nd(t, fr) || "0";
      return (
        (i = n = a = u = h = l = f = c = d = 0),
        (s = o = 1),
        (r.svg = !(!t.getCTM || !Ud(t))),
        L.translate &&
          (("none" === L.translate &&
            "none" === L.scale &&
            "none" === L.rotate) ||
            (F[lr] =
              ("none" !== L.translate
                ? "translate3d(" +
                  (L.translate + " 0 0").split(" ").slice(0, 3).join(", ") +
                  ") "
                : "") +
              ("none" !== L.rotate ? "rotate(" + L.rotate + ") " : "") +
              ("none" !== L.scale
                ? "scale(" + L.scale.split(" ").join(",") + ") "
                : "") +
              ("none" !== L[lr] ? L[lr] : "")),
          (F.scale = F.rotate = F.translate = "none")),
        (m = ie(t, r.svg)),
        r.svg &&
          ((O = r.uncache
            ? ((P = t.getBBox()),
              (Y = r.xOrigin - P.x + "px " + (r.yOrigin - P.y) + "px"),
              "")
            : !e && t.getAttribute("data-svg-origin")),
          je(t, O || Y, !!O || r.originIsAbsolute, !1 !== r.smooth, m)),
        (p = r.xOrigin || 0),
        (_ = r.yOrigin || 0),
        m !== yr &&
          ((T = m[0]),
          (b = m[1]),
          (w = m[2]),
          (x = m[3]),
          (i = k = m[4]),
          (n = M = m[5]),
          6 === m.length
            ? ((s = Math.sqrt(T * T + b * b)),
              (o = Math.sqrt(x * x + w * w)),
              (u = T || b ? ar(b, T) * ir : 0),
              (f = w || x ? ar(w, x) * ir + u : 0) &&
                (o *= Math.abs(Math.cos(f * nr))),
              r.svg && ((i -= p - (p * T + _ * w)), (n -= _ - (p * b + _ * x))))
            : ((z = m[6]),
              (D = m[7]),
              (A = m[8]),
              (S = m[9]),
              (R = m[10]),
              (E = m[11]),
              (i = m[12]),
              (n = m[13]),
              (a = m[14]),
              (h = (g = ar(z, R)) * ir),
              g &&
                ((O = k * (v = Math.cos(-g)) + A * (y = Math.sin(-g))),
                (P = M * v + S * y),
                (C = z * v + R * y),
                (A = k * -y + A * v),
                (S = M * -y + S * v),
                (R = z * -y + R * v),
                (E = D * -y + E * v),
                (k = O),
                (M = P),
                (z = C)),
              (l = (g = ar(-w, R)) * ir),
              g &&
                ((v = Math.cos(-g)),
                (E = x * (y = Math.sin(-g)) + E * v),
                (T = O = T * v - A * y),
                (b = P = b * v - S * y),
                (w = C = w * v - R * y)),
              (u = (g = ar(b, T)) * ir),
              g &&
                ((O = T * (v = Math.cos(g)) + b * (y = Math.sin(g))),
                (P = k * v + M * y),
                (b = b * v - T * y),
                (M = M * v - k * y),
                (T = O),
                (k = P)),
              h &&
                359.9 < Math.abs(h) + Math.abs(u) &&
                ((h = u = 0), (l = 180 - l)),
              (s = ia(Math.sqrt(T * T + b * b + w * w))),
              (o = ia(Math.sqrt(M * M + z * z))),
              (g = ar(k, M)),
              (f = 2e-4 < Math.abs(g) ? g * ir : 0),
              (d = E ? 1 / (E < 0 ? -E : E) : 0)),
          r.svg &&
            ((O = t.getAttribute("transform")),
            (r.forceCSS = t.setAttribute("transform", "") || !ge(Nd(t, lr))),
            O && t.setAttribute("transform", O))),
        90 < Math.abs(f) &&
          Math.abs(f) < 270 &&
          (I
            ? ((s *= -1),
              (f += u <= 0 ? 180 : -180),
              (u += u <= 0 ? 180 : -180))
            : ((o *= -1), (f += f <= 0 ? 180 : -180))),
        (e = e || r.uncache),
        (r.x =
          i -
          ((r.xPercent =
            i &&
            ((!e && r.xPercent) ||
              (Math.round(t.offsetWidth / 2) === Math.round(-i) ? -50 : 0)))
            ? (t.offsetWidth * r.xPercent) / 100
            : 0) +
          "px"),
        (r.y =
          n -
          ((r.yPercent =
            n &&
            ((!e && r.yPercent) ||
              (Math.round(t.offsetHeight / 2) === Math.round(-n) ? -50 : 0)))
            ? (t.offsetHeight * r.yPercent) / 100
            : 0) +
          "px"),
        (r.z = a + "px"),
        (r.scaleX = ia(s)),
        (r.scaleY = ia(o)),
        (r.rotation = ia(u) + B),
        (r.rotationX = ia(h) + B),
        (r.rotationY = ia(l) + B),
        (r.skewX = f + B),
        (r.skewY = c + B),
        (r.transformPerspective = d + "px"),
        (r.zOrigin = parseFloat(Y.split(" ")[2]) || 0) && (F[fr] = wr(Y)),
        (r.xOffset = r.yOffset = 0),
        (r.force3D = j.force3D),
        (r.renderTransform = r.svg ? Cr : Ie ? Pr : xr),
        (r.uncache = 0),
        r
      );
    },
    wr = function _firstTwoOnly(t) {
      return (t = t.split(" "))[0] + " " + t[1];
    },
    xr = function _renderNon3DTransforms(t, e) {
      (e.z = "0px"),
        (e.rotationY = e.rotationX = "0deg"),
        (e.force3D = 0),
        Pr(t, e);
    },
    kr = "0deg",
    Mr = "0px",
    Or = ") ",
    Pr = function _renderCSSTransforms(t, e) {
      var r = e || this,
        i = r.xPercent,
        n = r.yPercent,
        a = r.x,
        s = r.y,
        o = r.z,
        u = r.rotation,
        h = r.rotationY,
        l = r.rotationX,
        f = r.skewX,
        c = r.skewY,
        d = r.scaleX,
        p = r.scaleY,
        _ = r.transformPerspective,
        m = r.force3D,
        g = r.target,
        v = r.zOrigin,
        y = "",
        T = ("auto" === m && t && 1 !== t) || !0 === m;
      if (v && (l !== kr || h !== kr)) {
        var b,
          w = parseFloat(h) * nr,
          x = Math.sin(w),
          k = Math.cos(w);
        (w = parseFloat(l) * nr),
          (b = Math.cos(w)),
          (a = me(g, a, x * b * -v)),
          (s = me(g, s, -Math.sin(w) * -v)),
          (o = me(g, o, k * b * -v + v));
      }
      _ !== Mr && (y += "perspective(" + _ + Or),
        (i || n) && (y += "translate(" + i + "%, " + n + "%) "),
        (!T && a === Mr && s === Mr && o === Mr) ||
          (y +=
            o !== Mr || T
              ? "translate3d(" + a + ", " + s + ", " + o + ") "
              : "translate(" + a + ", " + s + Or),
        u !== kr && (y += "rotate(" + u + Or),
        h !== kr && (y += "rotateY(" + h + Or),
        l !== kr && (y += "rotateX(" + l + Or),
        (f === kr && c === kr) || (y += "skew(" + f + ", " + c + Or),
        (1 === d && 1 === p) || (y += "scale(" + d + ", " + p + Or),
        (g.style[lr] = y || "translate(0, 0)");
    },
    Cr = function _renderSVGTransforms(t, e) {
      var r,
        i,
        n,
        a,
        s,
        o = e || this,
        u = o.xPercent,
        h = o.yPercent,
        l = o.x,
        f = o.y,
        c = o.rotation,
        d = o.skewX,
        p = o.skewY,
        _ = o.scaleX,
        m = o.scaleY,
        g = o.target,
        v = o.xOrigin,
        y = o.yOrigin,
        T = o.xOffset,
        b = o.yOffset,
        w = o.forceCSS,
        x = parseFloat(l),
        k = parseFloat(f);
      (c = parseFloat(c)),
        (d = parseFloat(d)),
        (p = parseFloat(p)) && ((d += p = parseFloat(p)), (c += p)),
        c || d
          ? ((c *= nr),
            (d *= nr),
            (r = Math.cos(c) * _),
            (i = Math.sin(c) * _),
            (n = Math.sin(c - d) * -m),
            (a = Math.cos(c - d) * m),
            d &&
              ((p *= nr),
              (s = Math.tan(d - p)),
              (n *= s = Math.sqrt(1 + s * s)),
              (a *= s),
              p &&
                ((s = Math.tan(p)), (r *= s = Math.sqrt(1 + s * s)), (i *= s))),
            (r = ia(r)),
            (i = ia(i)),
            (n = ia(n)),
            (a = ia(a)))
          : ((r = _), (a = m), (i = n = 0)),
        ((x && !~(l + "").indexOf("px")) || (k && !~(f + "").indexOf("px"))) &&
          ((x = Zd(g, "x", l, "px")), (k = Zd(g, "y", f, "px"))),
        (v || y || T || b) &&
          ((x = ia(x + v - (v * r + y * n) + T)),
          (k = ia(k + y - (v * i + y * a) + b))),
        (u || h) &&
          ((s = g.getBBox()),
          (x = ia(x + (u / 100) * s.width)),
          (k = ia(k + (h / 100) * s.height))),
        (s =
          "matrix(" +
          r +
          "," +
          i +
          "," +
          n +
          "," +
          a +
          "," +
          x +
          "," +
          k +
          ")"),
        g.setAttribute("transform", s),
        w && (g.style[lr] = s);
    };
  ha("padding,margin,Width,Radius", function (e, r) {
    var t = "Right",
      i = "Bottom",
      n = "Left",
      o = (r < 3 ? ["Top", t, i, n] : ["Top" + n, "Top" + t, i + t, i + n]).map(
        function (t) {
          return r < 2 ? e + t : "border" + t + e;
        }
      );
    vr[1 < r ? "border" + e : e] = function (e, t, r, i, n) {
      var a, s;
      if (arguments.length < 4)
        return (
          (a = o.map(function (t) {
            return mr(e, t, r);
          })),
          5 === (s = a.join(" ")).split(a[0]).length ? a[0] : s
        );
      (a = (i + "").split(" ")),
        (s = {}),
        o.forEach(function (t, e) {
          return (s[t] = a[e] = a[e] || a[((e - 1) / 2) | 0]);
        }),
        e.init(t, s, n);
    };
  });
  var Ar,
    Sr,
    Rr,
    Dr = {
      name: "css",
      register: Qd,
      targetTest: function targetTest(t) {
        return t.style && t.nodeType;
      },
      init: function init(t, e, i, n, a) {
        var s,
          o,
          u,
          h,
          l,
          f,
          c,
          d,
          p,
          _,
          m,
          g,
          v,
          y,
          T,
          b,
          w = this._props,
          x = t.style,
          k = i.vars.startAt;
        for (c in (De || Qd(),
        (this.styles = this.styles || Kd(t)),
        (b = this.styles.props),
        (this.tween = i),
        e))
          if (
            "autoRound" !== c &&
            ((o = e[c]), !pt[c] || !_b(c, e, i, n, t, a))
          )
            if (
              ((l = typeof o),
              (f = vr[c]),
              "function" === l && (l = typeof (o = o.call(i, n, t, a))),
              "string" === l && ~o.indexOf("random(") && (o = ob(o)),
              f)
            )
              f(this, t, c, o, i) && (T = 1);
            else if ("--" === c.substr(0, 2))
              (s = (getComputedStyle(t).getPropertyValue(c) + "").trim()),
                (o += ""),
                (Rt.lastIndex = 0),
                Rt.test(s) || ((d = Ya(s)), (p = Ya(o))),
                p ? d !== p && (s = Zd(t, c, s, p) + p) : d && (o += d),
                this.add(x, "setProperty", s, o, n, a, 0, 0, c),
                w.push(c),
                b.push(c, 0, x[c]);
            else if ("undefined" !== l) {
              if (
                (k && c in k
                  ? ((s =
                      "function" == typeof k[c] ? k[c].call(i, n, t, a) : k[c]),
                    r(s) && ~s.indexOf("random(") && (s = ob(s)),
                    Ya(s + "") || (s += j.units[c] || Ya(mr(t, c)) || ""),
                    "=" === (s + "").charAt(1) && (s = mr(t, c)))
                  : (s = mr(t, c)),
                (h = parseFloat(s)),
                (_ = "string" === l && "=" === o.charAt(1) && o.substr(0, 2)) &&
                  (o = o.substr(2)),
                (u = parseFloat(o)),
                c in hr &&
                  ("autoAlpha" === c &&
                    (1 === h &&
                      "hidden" === mr(t, "visibility") &&
                      u &&
                      (h = 0),
                    b.push("visibility", 0, x.visibility),
                    Wd(
                      this,
                      x,
                      "visibility",
                      h ? "inherit" : "hidden",
                      u ? "inherit" : "hidden",
                      !u
                    )),
                  "scale" !== c &&
                    "transform" !== c &&
                    ~(c = hr[c]).indexOf(",") &&
                    (c = c.split(",")[0])),
                (m = c in rr))
              )
                if (
                  (this.styles.save(c),
                  g ||
                    (((v = t._gsap).renderTransform && !e.parseTransform) ||
                      br(t, e.parseTransform),
                    (y = !1 !== e.smoothOrigin && v.smooth),
                    ((g = this._pt =
                      new pe(
                        this._pt,
                        x,
                        lr,
                        0,
                        1,
                        v.renderTransform,
                        v,
                        0,
                        -1
                      )).dep = 1)),
                  "scale" === c)
                )
                  (this._pt = new pe(
                    this._pt,
                    v,
                    "scaleY",
                    v.scaleY,
                    (_ ? ka(v.scaleY, _ + u) : u) - v.scaleY || 0,
                    td
                  )),
                    (this._pt.u = 0),
                    w.push("scaleY", c),
                    (c += "X");
                else {
                  if ("transformOrigin" === c) {
                    b.push(fr, 0, x[fr]),
                      (o = be(o)),
                      v.svg
                        ? je(t, o, 0, y, 0, this)
                        : ((p = parseFloat(o.split(" ")[2]) || 0) !==
                            v.zOrigin && Wd(this, v, "zOrigin", v.zOrigin, p),
                          Wd(this, x, c, wr(s), wr(o)));
                    continue;
                  }
                  if ("svgOrigin" === c) {
                    je(t, o, 1, y, 0, this);
                    continue;
                  }
                  if (c in Tr) {
                    te(this, v, c, h, _ ? ka(h, _ + o) : o);
                    continue;
                  }
                  if ("smoothOrigin" === c) {
                    Wd(this, v, "smooth", v.smooth, o);
                    continue;
                  }
                  if ("force3D" === c) {
                    v[c] = o;
                    continue;
                  }
                  if ("transform" === c) {
                    ve(this, o, t);
                    continue;
                  }
                }
              else c in x || (c = dr(c) || c);
              if (
                m ||
                ((u || 0 === u) && (h || 0 === h) && !ur.test(o) && c in x)
              )
                (u = u || 0),
                  (d = (s + "").substr((h + "").length)) !==
                    (p = Ya(o) || (c in j.units ? j.units[c] : d)) &&
                    (h = Zd(t, c, s, p)),
                  (this._pt = new pe(
                    this._pt,
                    m ? v : x,
                    c,
                    h,
                    (_ ? ka(h, _ + u) : u) - h,
                    m || ("px" !== p && "zIndex" !== c) || !1 === e.autoRound
                      ? td
                      : wd
                  )),
                  (this._pt.u = p || 0),
                  d !== p && "%" !== p && ((this._pt.b = s), (this._pt.r = vd));
              else if (c in x) _d.call(this, t, c, s, _ ? _ + o : o);
              else if (c in t) this.add(t, c, s || t[c], _ ? _ + o : o, n, a);
              else if ("parseTransform" !== c) {
                Q(c, o);
                continue;
              }
              m || (c in x ? b.push(c, 0, x[c]) : b.push(c, 1, s || t[c])),
                w.push(c);
            }
        T && de(this);
      },
      render: function render(t, e) {
        if (e.tween._time || !Fe())
          for (var r = e._pt; r; ) r.r(t, r.d), (r = r._next);
        else e.styles.revert();
      },
      get: mr,
      aliases: hr,
      getSetter: function getSetter(t, e, r) {
        var i = hr[e];
        return (
          i && i.indexOf(",") < 0 && (e = i),
          e in rr && e !== fr && (t._gsap.x || mr(t, "x"))
            ? r && ze === r
              ? "scale" === e
                ? Cd
                : Bd
              : (ze = r || {}) && ("scale" === e ? Dd : Ed)
            : t.style && !u(t.style[e])
            ? zd
            : ~e.indexOf("-")
            ? Ad
            : re(t, e)
        );
      },
      core: { _removeProperty: Vd, _getMatrix: ie },
    };
  (Ce.utils.checkPrefix = dr),
    (Ce.core.getStyleSaver = Kd),
    (Rr = ha(
      (Ar = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent") +
        "," +
        (Sr = "rotation,rotationX,rotationY,skewX,skewY") +
        ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
      function (t) {
        rr[t] = 1;
      }
    )),
    ha(Sr, function (t) {
      (j.units[t] = "deg"), (Tr[t] = 1);
    }),
    (hr[Rr[13]] = Ar + "," + Sr),
    ha(
      "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
      function (t) {
        var e = t.split(":");
        hr[e[1]] = Rr[e[0]];
      }
    ),
    ha(
      "x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
      function (t) {
        j.units[t] = "px";
      }
    ),
    Ce.registerPlugin(Dr);
  var Er = Ce.registerPlugin(Dr) || Ce,
    zr = Er.core.Tween;
  (e.Back = Ze),
    (e.Bounce = Je),
    (e.CSSPlugin = Dr),
    (e.Circ = er),
    (e.Cubic = We),
    (e.Elastic = Ke),
    (e.Expo = tr),
    (e.Linear = Ue),
    (e.Power0 = Be),
    (e.Power1 = Le),
    (e.Power2 = Ye),
    (e.Power3 = Ne),
    (e.Power4 = qe),
    (e.Quad = Ve),
    (e.Quart = Xe),
    (e.Quint = He),
    (e.Sine = $e),
    (e.SteppedEase = Ge),
    (e.Strong = Qe),
    (e.TimelineLite = Ut),
    (e.TimelineMax = Ut),
    (e.TweenLite = Gt),
    (e.TweenMax = zr),
    (e.default = Er),
    (e.gsap = Er);
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
  } else {
    delete e.default;
  }
});

/*!
 * ScrollTrigger 3.11.4
 * https://greensock.com
 * @license Copyright 2022, GreenSock. All rights reserved. */
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? t(exports)
    : "function" == typeof define && define.amd
    ? define(["exports"], t)
    : t(((e = e || self).window = e.window || {}));
})(this, function (e) {
  "use strict";
  function _defineProperties(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(e, n.key, n);
    }
  }
  function r() {
    return (
      we ||
      ("undefined" != typeof window &&
        (we = window.gsap) &&
        we.registerPlugin &&
        we)
    );
  }
  function z(e, t) {
    return ~Fe.indexOf(e) && Fe[Fe.indexOf(e) + 1][t];
  }
  function A(e) {
    return !!~t.indexOf(e);
  }
  function B(e, t, r, n, o) {
    return e.addEventListener(t, r, { passive: !n, capture: !!o });
  }
  function C(e, t, r, n) {
    return e.removeEventListener(t, r, !!n);
  }
  function F() {
    return (Be && Be.isPressed) || ze.cache++;
  }
  function G(r, n) {
    function Tc(e) {
      if (e || 0 === e) {
        o && (Ce.history.scrollRestoration = "manual");
        var t = Be && Be.isPressed;
        (e = Tc.v = Math.round(e) || (Be && Be.iOS ? 1 : 0)),
          r(e),
          (Tc.cacheID = ze.cache),
          t && i("ss", e);
      } else (n || ze.cache !== Tc.cacheID || i("ref")) && ((Tc.cacheID = ze.cache), (Tc.v = r()));
      return Tc.v + Tc.offset;
    }
    return (Tc.offset = 0), r && Tc;
  }
  function J(e) {
    return (
      we.utils.toArray(e)[0] ||
      ("string" == typeof e && !1 !== we.config().nullTargetWarn
        ? console.warn("Element not found:", e)
        : null)
    );
  }
  function K(t, e) {
    var r = e.s,
      n = e.sc;
    A(t) && (t = Ee.scrollingElement || ke);
    var o = ze.indexOf(t),
      i = n === Ke.sc ? 1 : 2;
    ~o || (o = ze.push(t) - 1), ze[o + i] || t.addEventListener("scroll", F);
    var a = ze[o + i],
      s =
        a ||
        (ze[o + i] =
          G(z(t, r), !0) ||
          (A(t)
            ? n
            : G(function (e) {
                return arguments.length ? (t[r] = e) : t[r];
              })));
    return (
      (s.target = t),
      a || (s.smooth = "smooth" === we.getProperty(t, "scrollBehavior")),
      s
    );
  }
  function L(e, t, o) {
    function pd(e, t) {
      var r = Ne();
      t || n < r - s
        ? ((a = i), (i = e), (l = s), (s = r))
        : o
        ? (i += e)
        : (i = a + ((e - a) / (r - l)) * (s - l));
    }
    var i = e,
      a = e,
      s = Ne(),
      l = s,
      n = t || 50,
      c = Math.max(500, 3 * n);
    return {
      update: pd,
      reset: function reset() {
        (a = i = o ? 0 : i), (l = s = 0);
      },
      getVelocity: function getVelocity(e) {
        var t = l,
          r = a,
          n = Ne();
        return (
          (!e && 0 !== e) || e === i || pd(e),
          s === l || c < n - l
            ? 0
            : ((i + (o ? r : -r)) / ((o ? n : s) - t)) * 1e3
        );
      },
    };
  }
  function M(e, t) {
    return (
      t && !e._gsapAllow && e.preventDefault(),
      e.changedTouches ? e.changedTouches[0] : e
    );
  }
  function N(e) {
    var t = Math.max.apply(Math, e),
      r = Math.min.apply(Math, e);
    return Math.abs(t) >= Math.abs(r) ? t : r;
  }
  function O() {
    (Ae = we.core.globals().ScrollTrigger) &&
      Ae.core &&
      (function _integrate() {
        var e = Ae.core,
          r = e.bridge || {},
          t = e._scrollers,
          n = e._proxies;
        t.push.apply(t, ze),
          n.push.apply(n, Fe),
          (ze = t),
          (Fe = n),
          (i = function _bridge(e, t) {
            return r[e](t);
          });
      })();
  }
  function P(e) {
    return (
      (we = e || r()) &&
        "undefined" != typeof document &&
        document.body &&
        ((Ce = window),
        (ke = (Ee = document).documentElement),
        (Me = Ee.body),
        (t = [Ce, Ee, ke, Me]),
        we.utils.clamp,
        (Ie = we.core.context || function () {}),
        (Oe = "onpointerenter" in Me ? "pointer" : "mouse"),
        (Pe = E.isTouch =
          Ce.matchMedia &&
          Ce.matchMedia("(hover: none), (pointer: coarse)").matches
            ? 1
            : "ontouchstart" in Ce ||
              0 < navigator.maxTouchPoints ||
              0 < navigator.msMaxTouchPoints
            ? 2
            : 0),
        (De = E.eventTypes =
          (
            "ontouchstart" in ke
              ? "touchstart,touchmove,touchcancel,touchend"
              : "onpointerdown" in ke
              ? "pointerdown,pointermove,pointercancel,pointerup"
              : "mousedown,mousemove,mouseup,mouseup"
          ).split(",")),
        setTimeout(function () {
          return (o = 0);
        }, 500),
        O(),
        (Se = 1)),
      Se
    );
  }
  var we,
    Se,
    Ce,
    Ee,
    ke,
    Me,
    Pe,
    Oe,
    Ae,
    t,
    Be,
    De,
    Ie,
    o = 1,
    Le = [],
    ze = [],
    Fe = [],
    Ne = Date.now,
    i = function _bridge(e, t) {
      return t;
    },
    n = "scrollLeft",
    a = "scrollTop",
    Xe = {
      s: n,
      p: "left",
      p2: "Left",
      os: "right",
      os2: "Right",
      d: "width",
      d2: "Width",
      a: "x",
      sc: G(function (e) {
        return arguments.length
          ? Ce.scrollTo(e, Ke.sc())
          : Ce.pageXOffset || Ee[n] || ke[n] || Me[n] || 0;
      }),
    },
    Ke = {
      s: a,
      p: "top",
      p2: "Top",
      os: "bottom",
      os2: "Bottom",
      d: "height",
      d2: "Height",
      a: "y",
      op: Xe,
      sc: G(function (e) {
        return arguments.length
          ? Ce.scrollTo(Xe.sc(), e)
          : Ce.pageYOffset || Ee[a] || ke[a] || Me[a] || 0;
      }),
    };
  (Xe.op = Ke), (ze.cache = 0);
  var E =
    ((Observer.prototype.init = function init(e) {
      Se || P(we) || console.warn("Please gsap.registerPlugin(Observer)"),
        Ae || O();
      var o = e.tolerance,
        a = e.dragMinimum,
        t = e.type,
        i = e.target,
        r = e.lineHeight,
        n = e.debounce,
        s = e.preventDefault,
        l = e.onStop,
        c = e.onStopDelay,
        u = e.ignore,
        f = e.wheelSpeed,
        p = e.event,
        d = e.onDragStart,
        g = e.onDragEnd,
        h = e.onDrag,
        v = e.onPress,
        b = e.onRelease,
        m = e.onRight,
        y = e.onLeft,
        x = e.onUp,
        w = e.onDown,
        _ = e.onChangeX,
        T = e.onChangeY,
        S = e.onChange,
        E = e.onToggleX,
        k = e.onToggleY,
        D = e.onHover,
        I = e.onHoverEnd,
        R = e.onMove,
        Y = e.ignoreCheck,
        z = e.isNormalizer,
        X = e.onGestureStart,
        W = e.onGestureEnd,
        H = e.onWheel,
        U = e.onEnable,
        j = e.onDisable,
        q = e.onClick,
        V = e.scrollSpeed,
        G = e.capture,
        Z = e.allowClicks,
        $ = e.lockAxis,
        Q = e.onLockAxis;
      function Qe() {
        return (ye = Ne());
      }
      function Re(e, t) {
        return (
          ((se.event = e) && u && ~u.indexOf(e.target)) ||
          (t && ge && "touch" !== e.pointerType) ||
          (Y && Y(e, t))
        );
      }
      function Te() {
        var e = (se.deltaX = N(be)),
          t = (se.deltaY = N(me)),
          r = Math.abs(e) >= o,
          n = Math.abs(t) >= o;
        S && (r || n) && S(se, e, t, be, me),
          r &&
            (m && 0 < se.deltaX && m(se),
            y && se.deltaX < 0 && y(se),
            _ && _(se),
            E && se.deltaX < 0 != le < 0 && E(se),
            (le = se.deltaX),
            (be[0] = be[1] = be[2] = 0)),
          n &&
            (w && 0 < se.deltaY && w(se),
            x && se.deltaY < 0 && x(se),
            T && T(se),
            k && se.deltaY < 0 != ce < 0 && k(se),
            (ce = se.deltaY),
            (me[0] = me[1] = me[2] = 0)),
          (ne || re) && (R && R(se), re && (h(se), (re = !1)), (ne = !1)),
          ie && !(ie = !1) && Q && Q(se),
          oe && (H(se), (oe = !1)),
          (ee = 0);
      }
      function Ue(e, t, r) {
        (be[r] += e),
          (me[r] += t),
          se._vx.update(e),
          se._vy.update(t),
          n ? (ee = ee || requestAnimationFrame(Te)) : Te();
      }
      function Ve(e, t) {
        $ &&
          !ae &&
          ((se.axis = ae = Math.abs(e) > Math.abs(t) ? "x" : "y"), (ie = !0)),
          "y" !== ae && ((be[2] += e), se._vx.update(e, !0)),
          "x" !== ae && ((me[2] += t), se._vy.update(t, !0)),
          n ? (ee = ee || requestAnimationFrame(Te)) : Te();
      }
      function We(e) {
        if (!Re(e, 1)) {
          var t = (e = M(e, s)).clientX,
            r = e.clientY,
            n = t - se.x,
            o = r - se.y,
            i = se.isDragging;
          (se.x = t),
            (se.y = r),
            (i ||
              Math.abs(se.startX - t) >= a ||
              Math.abs(se.startY - r) >= a) &&
              (h && (re = !0),
              i || (se.isDragging = !0),
              Ve(n, o),
              i || (d && d(se)));
        }
      }
      function Ye(t) {
        if (!Re(t, 1)) {
          C(z ? i : ve, De[1], We, !0);
          var e = !isNaN(se.y - se.startY),
            r =
              se.isDragging &&
              (3 < Math.abs(se.x - se.startX) ||
                3 < Math.abs(se.y - se.startY)),
            n = M(t);
          !r &&
            e &&
            (se._vx.reset(),
            se._vy.reset(),
            s &&
              Z &&
              we.delayedCall(0.08, function () {
                if (300 < Ne() - ye && !t.defaultPrevented)
                  if (t.target.click) t.target.click();
                  else if (ve.createEvent) {
                    var e = ve.createEvent("MouseEvents");
                    e.initMouseEvent(
                      "click",
                      !0,
                      !0,
                      Ce,
                      1,
                      n.screenX,
                      n.screenY,
                      n.clientX,
                      n.clientY,
                      !1,
                      !1,
                      !1,
                      !1,
                      0,
                      null
                    ),
                      t.target.dispatchEvent(e);
                  }
              })),
            (se.isDragging = se.isGesturing = se.isPressed = !1),
            l && !z && te.restart(!0),
            g && r && g(se),
            b && b(se, r);
        }
      }
      function Ze(e) {
        return (
          e.touches &&
          1 < e.touches.length &&
          (se.isGesturing = !0) &&
          X(e, se.isDragging)
        );
      }
      function $e() {
        return (se.isGesturing = !1) || W(se);
      }
      function _e(e) {
        if (!Re(e)) {
          var t = ue(),
            r = fe();
          Ue((t - pe) * V, (r - de) * V, 1),
            (pe = t),
            (de = r),
            l && te.restart(!0);
        }
      }
      function af(e) {
        if (!Re(e)) {
          (e = M(e, s)), H && (oe = !0);
          var t =
            (1 === e.deltaMode ? r : 2 === e.deltaMode ? Ce.innerHeight : 1) *
            f;
          Ue(e.deltaX * t, e.deltaY * t, 0), l && !z && te.restart(!0);
        }
      }
      function bf(e) {
        if (!Re(e)) {
          var t = e.clientX,
            r = e.clientY,
            n = t - se.x,
            o = r - se.y;
          (se.x = t), (se.y = r), (ne = !0), (n || o) && Ve(n, o);
        }
      }
      function cf(e) {
        (se.event = e), D(se);
      }
      function df(e) {
        (se.event = e), I(se);
      }
      function ef(e) {
        return Re(e) || (M(e, s) && q(se));
      }
      (this.target = i = J(i) || ke),
        (this.vars = e),
        (u = u && we.utils.toArray(u)),
        (o = o || 1e-9),
        (a = a || 0),
        (f = f || 1),
        (V = V || 1),
        (t = t || "wheel,touch,pointer"),
        (n = !1 !== n),
        (r = r || parseFloat(Ce.getComputedStyle(Me).lineHeight) || 22);
      var ee,
        te,
        re,
        ne,
        oe,
        ie,
        ae,
        se = this,
        le = 0,
        ce = 0,
        ue = K(i, Xe),
        fe = K(i, Ke),
        pe = ue(),
        de = fe(),
        ge =
          ~t.indexOf("touch") &&
          !~t.indexOf("pointer") &&
          "pointerdown" === De[0],
        he = A(i),
        ve = i.ownerDocument || Ee,
        be = [0, 0, 0],
        me = [0, 0, 0],
        ye = 0,
        xe = (se.onPress = function (e) {
          Re(e, 1) ||
            ((se.axis = ae = null),
            te.pause(),
            (se.isPressed = !0),
            (e = M(e)),
            (le = ce = 0),
            (se.startX = se.x = e.clientX),
            (se.startY = se.y = e.clientY),
            se._vx.reset(),
            se._vy.reset(),
            B(z ? i : ve, De[1], We, s, !0),
            (se.deltaX = se.deltaY = 0),
            v && v(se));
        });
      (te = se._dc =
        we
          .delayedCall(c || 0.25, function onStopFunc() {
            se._vx.reset(), se._vy.reset(), te.pause(), l && l(se);
          })
          .pause()),
        (se.deltaX = se.deltaY = 0),
        (se._vx = L(0, 50, !0)),
        (se._vy = L(0, 50, !0)),
        (se.scrollX = ue),
        (se.scrollY = fe),
        (se.isDragging = se.isGesturing = se.isPressed = !1),
        Ie(this),
        (se.enable = function (e) {
          return (
            se.isEnabled ||
              (B(he ? ve : i, "scroll", F),
              0 <= t.indexOf("scroll") && B(he ? ve : i, "scroll", _e, s, G),
              0 <= t.indexOf("wheel") && B(i, "wheel", af, s, G),
              ((0 <= t.indexOf("touch") && Pe) || 0 <= t.indexOf("pointer")) &&
                (B(i, De[0], xe, s, G),
                B(ve, De[2], Ye),
                B(ve, De[3], Ye),
                Z && B(i, "click", Qe, !1, !0),
                q && B(i, "click", ef),
                X && B(ve, "gesturestart", Ze),
                W && B(ve, "gestureend", $e),
                D && B(i, Oe + "enter", cf),
                I && B(i, Oe + "leave", df),
                R && B(i, Oe + "move", bf)),
              (se.isEnabled = !0),
              e && e.type && xe(e),
              U && U(se)),
            se
          );
        }),
        (se.disable = function () {
          se.isEnabled &&
            (Le.filter(function (e) {
              return e !== se && A(e.target);
            }).length || C(he ? ve : i, "scroll", F),
            se.isPressed &&
              (se._vx.reset(), se._vy.reset(), C(z ? i : ve, De[1], We, !0)),
            C(he ? ve : i, "scroll", _e, G),
            C(i, "wheel", af, G),
            C(i, De[0], xe, G),
            C(ve, De[2], Ye),
            C(ve, De[3], Ye),
            C(i, "click", Qe, !0),
            C(i, "click", ef),
            C(ve, "gesturestart", Ze),
            C(ve, "gestureend", $e),
            C(i, Oe + "enter", cf),
            C(i, Oe + "leave", df),
            C(i, Oe + "move", bf),
            (se.isEnabled = se.isPressed = se.isDragging = !1),
            j && j(se));
        }),
        (se.kill = se.revert =
          function () {
            se.disable();
            var e = Le.indexOf(se);
            0 <= e && Le.splice(e, 1), Be === se && (Be = 0);
          }),
        Le.push(se),
        z && A(i) && (Be = se),
        se.enable(p);
    }),
    (function _createClass(e, t, r) {
      return (
        t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e
      );
    })(Observer, [
      {
        key: "velocityX",
        get: function get() {
          return this._vx.getVelocity();
        },
      },
      {
        key: "velocityY",
        get: function get() {
          return this._vy.getVelocity();
        },
      },
    ]),
    Observer);
  function Observer(e) {
    this.init(e);
  }
  (E.version = "3.11.4"),
    (E.create = function (e) {
      return new E(e);
    }),
    (E.register = P),
    (E.getAll = function () {
      return Le.slice();
    }),
    (E.getById = function (t) {
      return Le.filter(function (e) {
        return e.vars.id === t;
      })[0];
    }),
    r() && we.registerPlugin(E);
  function ya() {
    return (ot = 1);
  }
  function za() {
    return (ot = 0);
  }
  function Aa(e) {
    return e;
  }
  function Ba(e) {
    return Math.round(1e5 * e) / 1e5 || 0;
  }
  function Ca() {
    return "undefined" != typeof window;
  }
  function Da() {
    return He || (Ca() && (He = window.gsap) && He.registerPlugin && He);
  }
  function Ea(e) {
    return !!~l.indexOf(e);
  }
  function Fa(e) {
    return (
      z(e, "getBoundingClientRect") ||
      (Ea(e)
        ? function () {
            return (Yt.width = Je.innerWidth), (Yt.height = Je.innerHeight), Yt;
          }
        : function () {
            return Mt(e);
          })
    );
  }
  function Ia(e, t) {
    var r = t.s,
      n = t.d2,
      o = t.d,
      i = t.a;
    return (r = "scroll" + n) && (i = z(e, r))
      ? i() - Fa(e)()[o]
      : Ea(e)
      ? (qe[r] || Ge[r]) -
        (Je["inner" + n] || qe["client" + n] || Ge["client" + n])
      : e[r] - e["offset" + n];
  }
  function Ja(e, t) {
    for (var r = 0; r < g.length; r += 3)
      (t && !~t.indexOf(g[r + 1])) || e(g[r], g[r + 1], g[r + 2]);
  }
  function Ka(e) {
    return "string" == typeof e;
  }
  function La(e) {
    return "function" == typeof e;
  }
  function Ma(e) {
    return "number" == typeof e;
  }
  function Na(e) {
    return "object" == typeof e;
  }
  function Oa(e, t, r) {
    return e && e.progress(t ? 0 : 1) && r && e.pause();
  }
  function Pa(e, t) {
    if (e.enabled) {
      var r = t(e);
      r && r.totalTime && (e.callbackAnimation = r);
    }
  }
  function eb(e) {
    return Je.getComputedStyle(e);
  }
  function gb(e, t) {
    for (var r in t) r in e || (e[r] = t[r]);
    return e;
  }
  function ib(e, t) {
    var r = t.d2;
    return e["offset" + r] || e["client" + r] || 0;
  }
  function jb(e) {
    var t,
      r = [],
      n = e.labels,
      o = e.duration();
    for (t in n) r.push(n[t] / o);
    return r;
  }
  function lb(o) {
    var i = He.utils.snap(o),
      a =
        Array.isArray(o) &&
        o.slice(0).sort(function (e, t) {
          return e - t;
        });
    return a
      ? function (e, t, r) {
          var n;
          if ((void 0 === r && (r = 0.001), !t)) return i(e);
          if (0 < t) {
            for (e -= r, n = 0; n < a.length; n++) if (a[n] >= e) return a[n];
            return a[n - 1];
          }
          for (n = a.length, e += r; n--; ) if (a[n] <= e) return a[n];
          return a[0];
        }
      : function (e, t, r) {
          void 0 === r && (r = 0.001);
          var n = i(e);
          return !t || Math.abs(n - e) < r || n - e < 0 == t < 0
            ? n
            : i(t < 0 ? e - o : e + o);
        };
  }
  function nb(t, r, e, n) {
    return e.split(",").forEach(function (e) {
      return t(r, e, n);
    });
  }
  function ob(e, t, r, n, o) {
    return e.addEventListener(t, r, { passive: !n, capture: !!o });
  }
  function pb(e, t, r, n) {
    return e.removeEventListener(t, r, !!n);
  }
  function qb(e, t, r) {
    return r && r.wheelHandler && e(t, "wheel", r);
  }
  function ub(e, t) {
    if (Ka(e)) {
      var r = e.indexOf("="),
        n = ~r ? (e.charAt(r - 1) + 1) * parseFloat(e.substr(r + 1)) : 0;
      ~r && (e.indexOf("%") > r && (n *= t / 100), (e = e.substr(0, r - 1))),
        (e =
          n +
          (e in I
            ? I[e] * t
            : ~e.indexOf("%")
            ? (parseFloat(e) * t) / 100
            : parseFloat(e) || 0));
    }
    return e;
  }
  function vb(e, t, r, n, o, i, a, s) {
    var l = o.startColor,
      c = o.endColor,
      u = o.fontSize,
      f = o.indent,
      p = o.fontWeight,
      d = je.createElement("div"),
      g = Ea(r) || "fixed" === z(r, "pinType"),
      h = -1 !== e.indexOf("scroller"),
      v = g ? Ge : r,
      b = -1 !== e.indexOf("start"),
      m = b ? l : c,
      y =
        "border-color:" +
        m +
        ";font-size:" +
        u +
        ";color:" +
        m +
        ";font-weight:" +
        p +
        ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    return (
      (y += "position:" + ((h || s) && g ? "fixed;" : "absolute;")),
      (!h && !s && g) ||
        (y += (n === Ke ? T : S) + ":" + (i + parseFloat(f)) + "px;"),
      a &&
        (y +=
          "box-sizing:border-box;text-align:left;width:" +
          a.offsetWidth +
          "px;"),
      (d._isStart = b),
      d.setAttribute("class", "gsap-marker-" + e + (t ? " marker-" + t : "")),
      (d.style.cssText = y),
      (d.innerText = t || 0 === t ? e + "-" + t : e),
      v.children[0] ? v.insertBefore(d, v.children[0]) : v.appendChild(d),
      (d._offset = d["offset" + n.op.d2]),
      R(d, 0, n, b),
      d
    );
  }
  function Ab() {
    return 34 < gt() - ht && (w = w || requestAnimationFrame(j));
  }
  function Bb() {
    (v && v.isPressed && !(v.startX > Ge.clientWidth)) ||
      (ze.cache++,
      v ? (w = w || requestAnimationFrame(j)) : j(),
      ht || W("scrollStart"),
      (ht = gt()));
  }
  function Cb() {
    (y = Je.innerWidth), (m = Je.innerHeight);
  }
  function Db() {
    ze.cache++,
      nt ||
        h ||
        je.fullscreenElement ||
        je.webkitFullscreenElement ||
        (b &&
          y === Je.innerWidth &&
          !(Math.abs(Je.innerHeight - m) > 0.25 * Je.innerHeight)) ||
        c.restart(!0);
  }
  function Gb() {
    return pb(Q, "scrollEnd", Gb) || It(!0);
  }
  function Jb(e) {
    for (var t = 0; t < H.length; t += 5)
      (!e || (H[t + 4] && H[t + 4].query === e)) &&
        ((H[t].style.cssText = H[t + 1]),
        H[t].getBBox && H[t].setAttribute("transform", H[t + 2] || ""),
        (H[t + 3].uncache = 1));
  }
  function Kb(e, t) {
    var r;
    for (it = 0; it < At.length; it++)
      !(r = At[it]) ||
        (t && r._ctx !== t) ||
        (e ? r.kill(1) : r.revert(!0, !0));
    t && Jb(t), t || W("revert");
  }
  function Lb(e, t) {
    ze.cache++,
      (!t && ut) ||
        ze.forEach(function (e) {
          return La(e) && e.cacheID++ && (e.rec = 0);
        }),
      Ka(e) && (Je.history.scrollRestoration = x = e);
  }
  function Yb(e, t, r, n) {
    if (!e._gsap.swappedIn) {
      for (var o, i = q.length, a = t.style, s = e.style; i--; )
        a[(o = q[i])] = r[o];
      (a.position = "absolute" === r.position ? "absolute" : "relative"),
        "inline" === r.display && (a.display = "inline-block"),
        (s[S] = s[T] = "auto"),
        (a.flexBasis = r.flexBasis || "auto"),
        (a.overflow = "visible"),
        (a.boxSizing = "border-box"),
        (a[mt] = ib(e, Xe) + kt),
        (a[yt] = ib(e, Ke) + kt),
        (a[St] = s[Ct] = s.top = s.left = "0"),
        Rt(n),
        (s[mt] = s.maxWidth = r[mt]),
        (s[yt] = s.maxHeight = r[yt]),
        (s[St] = r[St]),
        e.parentNode !== t &&
          (e.parentNode.insertBefore(t, e), t.appendChild(e)),
        (e._gsap.swappedIn = !0);
    }
  }
  function _b(e) {
    for (var t = V.length, r = e.style, n = [], o = 0; o < t; o++)
      n.push(V[o], r[V[o]]);
    return (n.t = e), n;
  }
  function cc(e, t, r, n, o, i, a, s, l, c, u, f, p) {
    La(e) && (e = e(s)),
      Ka(e) &&
        "max" === e.substr(0, 3) &&
        (e = f + ("=" === e.charAt(4) ? ub("0" + e.substr(3), r) : 0));
    var d,
      g,
      h,
      v = p ? p.time() : 0;
    if ((p && p.seek(0), Ma(e))) a && R(a, r, n, !0);
    else {
      La(t) && (t = t(s));
      var b,
        m,
        y,
        x,
        w = (e || "0").split(" ");
      (h = J(t) || Ge),
        ((b = Mt(h) || {}) && (b.left || b.top)) ||
          "none" !== eb(h).display ||
          ((x = h.style.display),
          (h.style.display = "block"),
          (b = Mt(h)),
          x ? (h.style.display = x) : h.style.removeProperty("display")),
        (m = ub(w[0], b[n.d])),
        (y = ub(w[1] || "0", r)),
        (e = b[n.p] - l[n.p] - c + m + o - y),
        a && R(a, y, n, r - y < 20 || (a._isStart && 20 < y)),
        (r -= r - y);
    }
    if (i) {
      var _ = e + r,
        T = i._isStart;
      (d = "scroll" + n.d2),
        R(
          i,
          _,
          n,
          (T && 20 < _) ||
            (!T && (u ? Math.max(Ge[d], qe[d]) : i.parentNode[d]) <= _ + 1)
        ),
        u &&
          ((l = Mt(a)),
          u && (i.style[n.op.p] = l[n.op.p] - n.op.m - i._offset + kt));
    }
    return (
      p &&
        h &&
        ((d = Mt(h)),
        p.seek(f),
        (g = Mt(h)),
        (p._caScrollDist = d[n.p] - g[n.p]),
        (e = (e / p._caScrollDist) * f)),
      p && p.seek(v),
      p ? e : Math.round(e)
    );
  }
  function ec(e, t, r, n) {
    if (e.parentNode !== t) {
      var o,
        i,
        a = e.style;
      if (t === Ge) {
        for (o in ((e._stOrig = a.cssText), (i = eb(e))))
          +o ||
            $.test(o) ||
            !i[o] ||
            "string" != typeof a[o] ||
            "0" === o ||
            (a[o] = i[o]);
        (a.top = r), (a.left = n);
      } else a.cssText = e._stOrig;
      (He.core.getCache(e).uncache = 1), t.appendChild(e);
    }
  }
  function fc(l, e) {
    function Uj(e, t, r, n, o) {
      var i = Uj.tween,
        a = t.onComplete,
        s = {};
      return (
        (r = r || f()),
        (o = (n && o) || 0),
        (n = n || e - r),
        i && i.kill(),
        (c = Math.round(r)),
        (t[p] = e),
        ((t.modifiers = s)[p] = function (e) {
          return (
            (e = Math.round(f())) !== c &&
            e !== u &&
            3 < Math.abs(e - c) &&
            3 < Math.abs(e - u)
              ? (i.kill(), (Uj.tween = 0))
              : (e = r + n * i.ratio + o * i.ratio * i.ratio),
            (u = c),
            (c = Math.round(e))
          );
        }),
        (t.onUpdate = function () {
          ze.cache++, j();
        }),
        (t.onComplete = function () {
          (Uj.tween = 0), a && a.call(i);
        }),
        (i = Uj.tween = He.to(l, t))
      );
    }
    var c,
      u,
      f = K(l, e),
      p = "_scroll" + e.p2;
    return (
      ((l[p] = f).wheelHandler = function () {
        return Uj.tween && Uj.tween.kill() && (Uj.tween = 0);
      }),
      ob(l, "wheel", f.wheelHandler),
      Uj
    );
  }
  var He,
    s,
    Je,
    je,
    qe,
    Ge,
    l,
    c,
    et,
    tt,
    rt,
    u,
    nt,
    ot,
    f,
    it,
    p,
    d,
    g,
    at,
    st,
    h,
    v,
    b,
    m,
    y,
    k,
    lt,
    x,
    ct,
    w,
    ut,
    ft,
    pt,
    dt = 1,
    gt = Date.now,
    _ = gt(),
    ht = 0,
    vt = 0,
    bt = Math.abs,
    T = "right",
    S = "bottom",
    mt = "width",
    yt = "height",
    xt = "Right",
    wt = "Left",
    _t = "Top",
    Tt = "Bottom",
    St = "padding",
    Ct = "margin",
    Et = "Width",
    D = "Height",
    kt = "px",
    Mt = function _getBounds(e, t) {
      var r =
          t &&
          "matrix(1, 0, 0, 1, 0, 0)" !== eb(e)[f] &&
          He.to(e, {
            x: 0,
            y: 0,
            xPercent: 0,
            yPercent: 0,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            scale: 1,
            skewX: 0,
            skewY: 0,
          }).progress(1),
        n = e.getBoundingClientRect();
      return r && r.progress(0).kill(), n;
    },
    Pt = {
      startColor: "green",
      endColor: "red",
      indent: 0,
      fontSize: "16px",
      fontWeight: "normal",
    },
    Ot = { toggleActions: "play", anticipatePin: 0 },
    I = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
    R = function _positionMarker(e, t, r, n) {
      var o = { display: "block" },
        i = r[n ? "os2" : "p2"],
        a = r[n ? "p2" : "os2"];
      (e._isFlipped = n),
        (o[r.a + "Percent"] = n ? -100 : 0),
        (o[r.a] = n ? "1px" : 0),
        (o["border" + i + Et] = 1),
        (o["border" + a + Et] = 0),
        (o[r.p] = t + "px"),
        He.set(e, o);
    },
    At = [],
    Bt = {},
    Y = {},
    X = [],
    W = function _dispatch(e) {
      return (
        (Y[e] &&
          Y[e].map(function (e) {
            return e();
          })) ||
        X
      );
    },
    H = [],
    Dt = 0,
    It = function _refreshAll(e, t) {
      if (!ht || e) {
        (ut = Q.isRefreshing = !0),
          ze.forEach(function (e) {
            return La(e) && e.cacheID++ && (e.rec = e());
          });
        var r = W("refreshInit");
        at && Q.sort(),
          t || Kb(),
          ze.forEach(function (e) {
            La(e) &&
              (e.smooth && (e.target.style.scrollBehavior = "auto"), e(0));
          }),
          At.slice(0).forEach(function (e) {
            return e.refresh();
          }),
          At.forEach(function (e, t) {
            if (e._subPinOffset && e.pin) {
              var r = e.vars.horizontal ? "offsetWidth" : "offsetHeight",
                n = e.pin[r];
              e.revert(!0, 1),
                e.adjustPinSpacing(e.pin[r] - n),
                e.revert(!1, 1);
            }
          }),
          At.forEach(function (e) {
            return (
              "max" === e.vars.end &&
              e.setPositions(
                e.start,
                Math.max(e.start + 1, Ia(e.scroller, e._dir))
              )
            );
          }),
          r.forEach(function (e) {
            return e && e.render && e.render(-1);
          }),
          ze.forEach(function (e) {
            La(e) &&
              (e.smooth &&
                requestAnimationFrame(function () {
                  return (e.target.style.scrollBehavior = "smooth");
                }),
              e.rec && e(e.rec));
          }),
          Lb(x, 1),
          c.pause(),
          Dt++,
          j(2),
          At.forEach(function (e) {
            return La(e.vars.onRefresh) && e.vars.onRefresh(e);
          }),
          (ut = Q.isRefreshing = !1),
          W("refresh");
      } else ob(Q, "scrollEnd", Gb);
    },
    U = 0,
    Lt = 1,
    j = function _updateAll(e) {
      if (!ut || 2 === e) {
        (Q.isUpdating = !0), pt && pt.update(0);
        var t = At.length,
          r = gt(),
          n = 50 <= r - _,
          o = t && At[0].scroll();
        if (
          ((Lt = o < U ? -1 : 1),
          (U = o),
          n &&
            (ht && !ot && 200 < r - ht && ((ht = 0), W("scrollEnd")),
            (rt = _),
            (_ = r)),
          Lt < 0)
        ) {
          for (it = t; 0 < it--; ) At[it] && At[it].update(0, n);
          Lt = 1;
        } else for (it = 0; it < t; it++) At[it] && At[it].update(0, n);
        Q.isUpdating = !1;
      }
      w = 0;
    },
    q = [
      "left",
      "top",
      S,
      T,
      Ct + Tt,
      Ct + xt,
      Ct + _t,
      Ct + wt,
      "display",
      "flexShrink",
      "float",
      "zIndex",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRowStart",
      "gridRowEnd",
      "gridArea",
      "justifySelf",
      "alignSelf",
      "placeSelf",
      "order",
    ],
    V = q.concat([
      mt,
      yt,
      "boxSizing",
      "max" + Et,
      "max" + D,
      "position",
      Ct,
      St,
      St + _t,
      St + xt,
      St + Tt,
      St + wt,
    ]),
    Z = /([A-Z])/g,
    Rt = function _setState(e) {
      if (e) {
        var t,
          r,
          n = e.t.style,
          o = e.length,
          i = 0;
        for ((e.t._gsap || He.core.getCache(e.t)).uncache = 1; i < o; i += 2)
          (r = e[i + 1]),
            (t = e[i]),
            r
              ? (n[t] = r)
              : n[t] && n.removeProperty(t.replace(Z, "-$1").toLowerCase());
      }
    },
    Yt = { left: 0, top: 0 },
    $ = /(webkit|moz|length|cssText|inset)/i,
    Q =
      ((ScrollTrigger.prototype.init = function init(S, C) {
        if (
          ((this.progress = this.start = 0), this.vars && this.kill(!0, !0), vt)
        ) {
          var E,
            n,
            d,
            k,
            M,
            P,
            O,
            A,
            B,
            D,
            I,
            e,
            L,
            R,
            Y,
            F,
            N,
            t,
            X,
            b,
            W,
            H,
            m,
            U,
            y,
            j,
            x,
            r,
            w,
            _,
            q,
            o,
            g,
            V,
            G,
            Z,
            $,
            T,
            i,
            Q = (S = gb(Ka(S) || Ma(S) || S.nodeType ? { trigger: S } : S, Ot))
              .onUpdate,
            ee = S.toggleClass,
            a = S.id,
            te = S.onToggle,
            re = S.onRefresh,
            ne = S.scrub,
            oe = S.trigger,
            ie = S.pin,
            ae = S.pinSpacing,
            se = S.invalidateOnRefresh,
            le = S.anticipatePin,
            s = S.onScrubComplete,
            h = S.onSnapComplete,
            ce = S.once,
            ue = S.snap,
            fe = S.pinReparent,
            l = S.pinSpacer,
            pe = S.containerAnimation,
            de = S.fastScrollEnd,
            ge = S.preventOverlaps,
            he =
              S.horizontal || (S.containerAnimation && !1 !== S.horizontal)
                ? Xe
                : Ke,
            ve = !ne && 0 !== ne,
            be = J(S.scroller || Je),
            c = He.core.getCache(be),
            me = Ea(be),
            ye =
              "fixed" ===
              ("pinType" in S
                ? S.pinType
                : z(be, "pinType") || (me && "fixed")),
            xe = [S.onEnter, S.onLeave, S.onEnterBack, S.onLeaveBack],
            we = ve && S.toggleActions.split(" "),
            u = "markers" in S ? S.markers : Ot.markers,
            _e = me ? 0 : parseFloat(eb(be)["border" + he.p2 + Et]) || 0,
            Te = this,
            Se =
              S.onRefreshInit &&
              function () {
                return S.onRefreshInit(Te);
              },
            Ce = (function _getSizeFunc(e, t, r) {
              var n = r.d,
                o = r.d2,
                i = r.a;
              return (i = z(e, "getBoundingClientRect"))
                ? function () {
                    return i()[n];
                  }
                : function () {
                    return (t ? Je["inner" + o] : e["client" + o]) || 0;
                  };
            })(be, me, he),
            Ee = (function _getOffsetsFunc(e, t) {
              return !t || ~Fe.indexOf(e)
                ? Fa(e)
                : function () {
                    return Yt;
                  };
            })(be, me),
            ke = 0,
            Me = 0,
            Pe = K(be, he);
          if (
            (lt(Te),
            (Te._dir = he),
            (le *= 45),
            (Te.scroller = be),
            (Te.scroll = pe ? pe.time.bind(pe) : Pe),
            (k = Pe()),
            (Te.vars = S),
            (C = C || S.animation),
            "refreshPriority" in S &&
              ((at = 1), -9999 === S.refreshPriority && (pt = Te)),
            (c.tweenScroll = c.tweenScroll || {
              top: fc(be, Ke),
              left: fc(be, Xe),
            }),
            (Te.tweenTo = E = c.tweenScroll[he.p]),
            (Te.scrubDuration = function (e) {
              (o = Ma(e) && e)
                ? q
                  ? q.duration(e)
                  : (q = He.to(C, {
                      ease: "expo",
                      totalProgress: "+=0.001",
                      duration: o,
                      paused: !0,
                      onComplete: function onComplete() {
                        return s && s(Te);
                      },
                    }))
                : (q && q.progress(1).kill(), (q = 0));
            }),
            C &&
              ((C.vars.lazy = !1),
              C._initted ||
                (!1 !== C.vars.immediateRender &&
                  !1 !== S.immediateRender &&
                  C.duration() &&
                  C.render(0, !0, !0)),
              (Te.animation = C.pause()),
              (C.scrollTrigger = Te).scrubDuration(ne),
              (w = 0),
              (a = a || C.vars.id)),
            At.push(Te),
            ue &&
              ((Na(ue) && !ue.push) || (ue = { snapTo: ue }),
              "scrollBehavior" in Ge.style &&
                He.set(me ? [Ge, qe] : be, { scrollBehavior: "auto" }),
              ze.forEach(function (e) {
                return (
                  La(e) &&
                  e.target === (me ? je.scrollingElement || qe : be) &&
                  (e.smooth = !1)
                );
              }),
              (d = La(ue.snapTo)
                ? ue.snapTo
                : "labels" === ue.snapTo
                ? (function _getClosestLabel(t) {
                    return function (e) {
                      return He.utils.snap(jb(t), e);
                    };
                  })(C)
                : "labelsDirectional" === ue.snapTo
                ? (function _getLabelAtDirection(r) {
                    return function (e, t) {
                      return lb(jb(r))(e, t.direction);
                    };
                  })(C)
                : !1 !== ue.directional
                ? function (e, t) {
                    return lb(ue.snapTo)(e, gt() - Me < 500 ? 0 : t.direction);
                  }
                : He.utils.snap(ue.snapTo)),
              (g = ue.duration || { min: 0.1, max: 2 }),
              (g = Na(g) ? tt(g.min, g.max) : tt(g, g)),
              (V = He.delayedCall(ue.delay || o / 2 || 0.1, function () {
                var e = Pe(),
                  t = gt() - Me < 500,
                  r = E.tween;
                if (
                  !(t || Math.abs(Te.getVelocity()) < 10) ||
                  r ||
                  ot ||
                  ke === e
                )
                  Te.isActive && ke !== e && V.restart(!0);
                else {
                  var n = (e - P) / L,
                    o = C && !ve ? C.totalProgress() : n,
                    i = t ? 0 : ((o - _) / (gt() - rt)) * 1e3 || 0,
                    a = He.utils.clamp(-n, 1 - n, (bt(i / 2) * i) / 0.185),
                    s = n + (!1 === ue.inertia ? 0 : a),
                    l = tt(0, 1, d(s, Te)),
                    c = Math.round(P + l * L),
                    u = ue.onStart,
                    f = ue.onInterrupt,
                    p = ue.onComplete;
                  if (e <= O && P <= e && c !== e) {
                    if (r && !r._initted && r.data <= bt(c - e)) return;
                    !1 === ue.inertia && (a = l - n),
                      E(
                        c,
                        {
                          duration: g(
                            bt(
                              (0.185 * Math.max(bt(s - o), bt(l - o))) /
                                i /
                                0.05 || 0
                            )
                          ),
                          ease: ue.ease || "power3",
                          data: bt(c - e),
                          onInterrupt: function onInterrupt() {
                            return V.restart(!0) && f && f(Te);
                          },
                          onComplete: function onComplete() {
                            Te.update(),
                              (ke = Pe()),
                              (w = _ =
                                C && !ve ? C.totalProgress() : Te.progress),
                              h && h(Te),
                              p && p(Te);
                          },
                        },
                        e,
                        a * L,
                        c - e - a * L
                      ),
                      u && u(Te, E.tween);
                  }
                }
              }).pause())),
            a && (Bt[a] = Te),
            (i =
              (i =
                (oe = Te.trigger = J(oe || ie)) &&
                oe._gsap &&
                oe._gsap.stRevert) && i(Te)),
            (ie = !0 === ie ? oe : J(ie)),
            Ka(ee) && (ee = { targets: oe, className: ee }),
            ie &&
              (!1 === ae ||
                ae === Ct ||
                (ae =
                  !(
                    !ae &&
                    ie.parentNode &&
                    ie.parentNode.style &&
                    "flex" === eb(ie.parentNode).display
                  ) && St),
              (Te.pin = ie),
              (n = He.core.getCache(ie)).spacer
                ? (R = n.pinState)
                : (l &&
                    ((l = J(l)) &&
                      !l.nodeType &&
                      (l = l.current || l.nativeElement),
                    (n.spacerIsNative = !!l),
                    l && (n.spacerState = _b(l))),
                  (n.spacer = N = l || je.createElement("div")),
                  N.classList.add("pin-spacer"),
                  a && N.classList.add("pin-spacer-" + a),
                  (n.pinState = R = _b(ie))),
              !1 !== S.force3D && He.set(ie, { force3D: !0 }),
              (Te.spacer = N = n.spacer),
              (r = eb(ie)),
              (m = r[ae + he.os2]),
              (X = He.getProperty(ie)),
              (b = He.quickSetter(ie, he.a, kt)),
              Yb(ie, N, r),
              (F = _b(ie))),
            u)
          ) {
            (e = Na(u) ? gb(u, Pt) : Pt),
              (D = vb("scroller-start", a, be, he, e, 0)),
              (I = vb("scroller-end", a, be, he, e, 0, D)),
              (t = D["offset" + he.op.d2]);
            var f = J(z(be, "content") || be);
            (A = this.markerStart = vb("start", a, f, he, e, t, 0, pe)),
              (B = this.markerEnd = vb("end", a, f, he, e, t, 0, pe)),
              pe && (T = He.quickSetter([A, B], he.a, kt)),
              ye ||
                (Fe.length && !0 === z(be, "fixedMarkers")) ||
                ((function _makePositionable(e) {
                  var t = eb(e).position;
                  e.style.position =
                    "absolute" === t || "fixed" === t ? t : "relative";
                })(me ? Ge : be),
                He.set([D, I], { force3D: !0 }),
                (y = He.quickSetter(D, he.a, kt)),
                (x = He.quickSetter(I, he.a, kt)));
          }
          if (pe) {
            var p = pe.vars.onUpdate,
              v = pe.vars.onUpdateParams;
            pe.eventCallback("onUpdate", function () {
              Te.update(0, 0, 1), p && p.apply(v || []);
            });
          }
          (Te.previous = function () {
            return At[At.indexOf(Te) - 1];
          }),
            (Te.next = function () {
              return At[At.indexOf(Te) + 1];
            }),
            (Te.revert = function (e, t) {
              if (!t) return Te.kill(!0);
              var r = !1 !== e || !Te.enabled,
                n = nt;
              r !== Te.isReverted &&
                (r &&
                  ((Z = Math.max(Pe(), Te.scroll.rec || 0)),
                  (G = Te.progress),
                  ($ = C && C.progress())),
                A &&
                  [A, B, D, I].forEach(function (e) {
                    return (e.style.display = r ? "none" : "block");
                  }),
                r && ((nt = 1), Te.update(r)),
                !ie ||
                  (fe && Te.isActive) ||
                  (r
                    ? (function _swapPinOut(e, t, r) {
                        Rt(r);
                        var n = e._gsap;
                        if (n.spacerIsNative) Rt(n.spacerState);
                        else if (e._gsap.swappedIn) {
                          var o = t.parentNode;
                          o && (o.insertBefore(e, t), o.removeChild(t));
                        }
                        e._gsap.swappedIn = !1;
                      })(ie, N, R)
                    : Yb(ie, N, eb(ie), U)),
                r || Te.update(r),
                (nt = n),
                (Te.isReverted = r));
            }),
            (Te.refresh = function (e, t) {
              if ((!nt && Te.enabled) || t)
                if (ie && e && ht) ob(ScrollTrigger, "scrollEnd", Gb);
                else {
                  !ut && Se && Se(Te),
                    (nt = 1),
                    (Me = gt()),
                    E.tween && (E.tween.kill(), (E.tween = 0)),
                    q && q.pause(),
                    se && C && C.revert({ kill: !1 }).invalidate(),
                    Te.isReverted || Te.revert(!0, !0),
                    (Te._subPinOffset = !1);
                  for (
                    var r,
                      n,
                      o,
                      i,
                      a,
                      s,
                      l,
                      c,
                      u,
                      f,
                      p,
                      d = Ce(),
                      g = Ee(),
                      h = pe ? pe.duration() : Ia(be, he),
                      v = 0,
                      b = 0,
                      m = S.end,
                      y = S.endTrigger || oe,
                      x =
                        S.start ||
                        (0 !== S.start && oe ? (ie ? "0 0" : "0 100%") : 0),
                      w = (Te.pinnedContainer =
                        S.pinnedContainer && J(S.pinnedContainer)),
                      _ = (oe && Math.max(0, At.indexOf(Te))) || 0,
                      T = _;
                    T--;

                  )
                    (s = At[T]).end || s.refresh(0, 1) || (nt = 1),
                      !(l = s.pin) ||
                        (l !== oe && l !== ie) ||
                        s.isReverted ||
                        ((f = f || []).unshift(s), s.revert(!0, !0)),
                      s !== At[T] && (_--, T--);
                  for (
                    La(x) && (x = x(Te)),
                      P =
                        cc(x, oe, d, he, Pe(), A, D, Te, g, _e, ye, h, pe) ||
                        (ie ? -0.001 : 0),
                      La(m) && (m = m(Te)),
                      Ka(m) &&
                        !m.indexOf("+=") &&
                        (~m.indexOf(" ")
                          ? (m = (Ka(x) ? x.split(" ")[0] : "") + m)
                          : ((v = ub(m.substr(2), d)),
                            (m = Ka(x) ? x : P + v),
                            (y = oe))),
                      O =
                        Math.max(
                          P,
                          cc(
                            m || (y ? "100% 0" : h),
                            y,
                            d,
                            he,
                            Pe() + v,
                            B,
                            I,
                            Te,
                            g,
                            _e,
                            ye,
                            h,
                            pe
                          )
                        ) || -0.001,
                      L = O - P || ((P -= 0.01) && 0.001),
                      v = 0,
                      T = _;
                    T--;

                  )
                    (l = (s = At[T]).pin) &&
                      s.start - s._pinPush <= P &&
                      !pe &&
                      0 < s.end &&
                      ((r = s.end - s.start),
                      ((l === oe && s.start - s._pinPush < P) || l === w) &&
                        !Ma(x) &&
                        (v += r * (1 - s.progress)),
                      l === ie && (b += r));
                  if (
                    ((P += v),
                    (O += v),
                    (Te._pinPush = b),
                    A &&
                      v &&
                      (((r = {})[he.a] = "+=" + v),
                      w && (r[he.p] = "-=" + Pe()),
                      He.set([A, B], r)),
                    ie)
                  )
                    (r = eb(ie)),
                      (i = he === Ke),
                      (o = Pe()),
                      (W = parseFloat(X(he.a)) + b),
                      !h &&
                        1 < O &&
                        ((p = {
                          style: (p = (me ? je.scrollingElement || qe : be)
                            .style),
                          value: p["overflow" + he.a.toUpperCase()],
                        })["overflow" + he.a.toUpperCase()] = "scroll"),
                      Yb(ie, N, r),
                      (F = _b(ie)),
                      (n = Mt(ie, !0)),
                      (c = ye && K(be, i ? Xe : Ke)()),
                      ae &&
                        (((U = [ae + he.os2, L + b + kt]).t = N),
                        (T = ae === St ? ib(ie, he) + L + b : 0) &&
                          U.push(he.d, T + kt),
                        Rt(U),
                        w &&
                          At.forEach(function (e) {
                            e.pin === w &&
                              !1 !== e.vars.pinSpacing &&
                              (e._subPinOffset = !0);
                          }),
                        ye && Pe(Z)),
                      ye &&
                        (((a = {
                          top: n.top + (i ? o - P : c) + kt,
                          left: n.left + (i ? c : o - P) + kt,
                          boxSizing: "border-box",
                          position: "fixed",
                        })[mt] = a.maxWidth =
                          Math.ceil(n.width) + kt),
                        (a[yt] = a.maxHeight = Math.ceil(n.height) + kt),
                        (a[Ct] =
                          a[Ct + _t] =
                          a[Ct + xt] =
                          a[Ct + Tt] =
                          a[Ct + wt] =
                            "0"),
                        (a[St] = r[St]),
                        (a[St + _t] = r[St + _t]),
                        (a[St + xt] = r[St + xt]),
                        (a[St + Tt] = r[St + Tt]),
                        (a[St + wt] = r[St + wt]),
                        (Y = (function _copyState(e, t, r) {
                          for (
                            var n, o = [], i = e.length, a = r ? 8 : 0;
                            a < i;
                            a += 2
                          )
                            (n = e[a]), o.push(n, n in t ? t[n] : e[a + 1]);
                          return (o.t = e.t), o;
                        })(R, a, fe)),
                        ut && Pe(0)),
                      C
                        ? ((u = C._initted),
                          st(1),
                          C.render(C.duration(), !0, !0),
                          (H = X(he.a) - W + L + b),
                          (j = 1 < Math.abs(L - H)),
                          ye && j && Y.splice(Y.length - 2, 2),
                          C.render(0, !0, !0),
                          u || C.invalidate(!0),
                          C.parent || C.totalTime(C.totalTime()),
                          st(0))
                        : (H = L),
                      p &&
                        (p.value
                          ? (p.style["overflow" + he.a.toUpperCase()] = p.value)
                          : p.style.removeProperty("overflow-" + he.a));
                  else if (oe && Pe() && !pe)
                    for (n = oe.parentNode; n && n !== Ge; )
                      n._pinOffset &&
                        ((P -= n._pinOffset), (O -= n._pinOffset)),
                        (n = n.parentNode);
                  f &&
                    f.forEach(function (e) {
                      return e.revert(!1, !0);
                    }),
                    (Te.start = P),
                    (Te.end = O),
                    (k = M = ut ? Z : Pe()),
                    pe || ut || (k < Z && Pe(Z), (Te.scroll.rec = 0)),
                    Te.revert(!1, !0),
                    V &&
                      ((ke = -1), Te.isActive && Pe(P + L * G), V.restart(!0)),
                    (nt = 0),
                    C &&
                      ve &&
                      (C._initted || $) &&
                      C.progress() !== $ &&
                      C.progress($, !0).render(C.time(), !0, !0),
                    (G === Te.progress && !pe) ||
                      (C && !ve && C.totalProgress(G, !0),
                      (Te.progress = (k - P) / L === G ? 0 : G)),
                    ie && ae && (N._pinOffset = Math.round(Te.progress * H)),
                    re && !ut && re(Te);
                }
            }),
            (Te.getVelocity = function () {
              return ((Pe() - M) / (gt() - rt)) * 1e3 || 0;
            }),
            (Te.endAnimation = function () {
              Oa(Te.callbackAnimation),
                C &&
                  (q
                    ? q.progress(1)
                    : C.paused()
                    ? ve || Oa(C, Te.direction < 0, 1)
                    : Oa(C, C.reversed()));
            }),
            (Te.labelToScroll = function (e) {
              return (
                (C &&
                  C.labels &&
                  (P || Te.refresh() || P) +
                    (C.labels[e] / C.duration()) * L) ||
                0
              );
            }),
            (Te.getTrailing = function (t) {
              var e = At.indexOf(Te),
                r =
                  0 < Te.direction ? At.slice(0, e).reverse() : At.slice(e + 1);
              return (
                Ka(t)
                  ? r.filter(function (e) {
                      return e.vars.preventOverlaps === t;
                    })
                  : r
              ).filter(function (e) {
                return 0 < Te.direction ? e.end <= P : e.start >= O;
              });
            }),
            (Te.update = function (e, t, r) {
              if (!pe || r || e) {
                var n,
                  o,
                  i,
                  a,
                  s,
                  l,
                  c,
                  u = ut ? Z : Te.scroll(),
                  f = e ? 0 : (u - P) / L,
                  p = f < 0 ? 0 : 1 < f ? 1 : f || 0,
                  d = Te.progress;
                if (
                  (t &&
                    ((M = k),
                    (k = pe ? Pe() : u),
                    ue && ((_ = w), (w = C && !ve ? C.totalProgress() : p))),
                  le &&
                    !p &&
                    ie &&
                    !nt &&
                    !dt &&
                    ht &&
                    P < u + ((u - M) / (gt() - rt)) * le &&
                    (p = 1e-4),
                  p !== d && Te.enabled)
                ) {
                  if (
                    ((a =
                      (s =
                        (n = Te.isActive = !!p && p < 1) != (!!d && d < 1)) ||
                      !!p != !!d),
                    (Te.direction = d < p ? 1 : -1),
                    (Te.progress = p),
                    a &&
                      !nt &&
                      ((o = p && !d ? 0 : 1 === p ? 1 : 1 === d ? 2 : 3),
                      ve &&
                        ((i =
                          (!s && "none" !== we[o + 1] && we[o + 1]) || we[o]),
                        (c =
                          C && ("complete" === i || "reset" === i || i in C)))),
                    ge &&
                      (s || c) &&
                      (c || ne || !C) &&
                      (La(ge)
                        ? ge(Te)
                        : Te.getTrailing(ge).forEach(function (e) {
                            return e.endAnimation();
                          })),
                    ve ||
                      (!q || nt || dt
                        ? C && C.totalProgress(p, !!nt)
                        : (q._dp._time - q._start !== q._time &&
                            q.render(q._dp._time - q._start),
                          q.resetTo
                            ? q.resetTo("totalProgress", p, C._tTime / C._tDur)
                            : ((q.vars.totalProgress = p),
                              q.invalidate().restart()))),
                    ie)
                  )
                    if ((e && ae && (N.style[ae + he.os2] = m), ye)) {
                      if (a) {
                        if (
                          ((l =
                            !e && d < p && u < O + 1 && u + 1 >= Ia(be, he)),
                          fe)
                        )
                          if (e || (!n && !l)) ec(ie, N);
                          else {
                            var g = Mt(ie, !0),
                              h = u - P;
                            ec(
                              ie,
                              Ge,
                              g.top + (he === Ke ? h : 0) + kt,
                              g.left + (he === Ke ? 0 : h) + kt
                            );
                          }
                        Rt(n || l ? Y : F),
                          (j && p < 1 && n) || b(W + (1 !== p || l ? 0 : H));
                      }
                    } else b(Ba(W + H * p));
                  !ue || E.tween || nt || dt || V.restart(!0),
                    ee &&
                      (s || (ce && p && (p < 1 || !ct))) &&
                      et(ee.targets).forEach(function (e) {
                        return e.classList[n || ce ? "add" : "remove"](
                          ee.className
                        );
                      }),
                    !Q || ve || e || Q(Te),
                    a && !nt
                      ? (ve &&
                          (c &&
                            ("complete" === i
                              ? C.pause().totalProgress(1)
                              : "reset" === i
                              ? C.restart(!0).pause()
                              : "restart" === i
                              ? C.restart(!0)
                              : C[i]()),
                          Q && Q(Te)),
                        (!s && ct) ||
                          (te && s && Pa(Te, te),
                          xe[o] && Pa(Te, xe[o]),
                          ce && (1 === p ? Te.kill(!1, 1) : (xe[o] = 0)),
                          s || (xe[(o = 1 === p ? 1 : 3)] && Pa(Te, xe[o]))),
                        de &&
                          !n &&
                          Math.abs(Te.getVelocity()) > (Ma(de) ? de : 2500) &&
                          (Oa(Te.callbackAnimation),
                          q
                            ? q.progress(1)
                            : Oa(C, "reverse" === i ? 1 : !p, 1)))
                      : ve && Q && !nt && Q(Te);
                }
                if (x) {
                  var v = pe
                    ? (u / pe.duration()) * (pe._caScrollDist || 0)
                    : u;
                  y(v + (D._isFlipped ? 1 : 0)), x(v);
                }
                T && T((-u / pe.duration()) * (pe._caScrollDist || 0));
              }
            }),
            (Te.enable = function (e, t) {
              Te.enabled ||
                ((Te.enabled = !0),
                ob(be, "resize", Db),
                ob(me ? je : be, "scroll", Bb),
                Se && ob(ScrollTrigger, "refreshInit", Se),
                !1 !== e && ((Te.progress = G = 0), (k = M = ke = Pe())),
                !1 !== t && Te.refresh());
            }),
            (Te.getTween = function (e) {
              return e && E ? E.tween : q;
            }),
            (Te.setPositions = function (e, t) {
              ie &&
                ((W += e - P),
                (H += t - e - L),
                ae === St && Te.adjustPinSpacing(t - e - L)),
                (Te.start = P = e),
                (Te.end = O = t),
                (L = t - e),
                Te.update();
            }),
            (Te.adjustPinSpacing = function (e) {
              if (U) {
                var t = U.indexOf(he.d) + 1;
                (U[t] = parseFloat(U[t]) + e + kt),
                  (U[1] = parseFloat(U[1]) + e + kt),
                  Rt(U);
              }
            }),
            (Te.disable = function (e, t) {
              if (
                Te.enabled &&
                (!1 !== e && Te.revert(!0, !0),
                (Te.enabled = Te.isActive = !1),
                t || (q && q.pause()),
                (Z = 0),
                n && (n.uncache = 1),
                Se && pb(ScrollTrigger, "refreshInit", Se),
                V && (V.pause(), E.tween && E.tween.kill() && (E.tween = 0)),
                !me)
              ) {
                for (var r = At.length; r--; )
                  if (At[r].scroller === be && At[r] !== Te) return;
                pb(be, "resize", Db), pb(be, "scroll", Bb);
              }
            }),
            (Te.kill = function (e, t) {
              Te.disable(e, t), q && !t && q.kill(), a && delete Bt[a];
              var r = At.indexOf(Te);
              0 <= r && At.splice(r, 1),
                r === it && 0 < Lt && it--,
                (r = 0),
                At.forEach(function (e) {
                  return e.scroller === Te.scroller && (r = 1);
                }),
                r || ut || (Te.scroll.rec = 0),
                C &&
                  ((C.scrollTrigger = null),
                  e && C.revert({ kill: !1 }),
                  t || C.kill()),
                A &&
                  [A, B, D, I].forEach(function (e) {
                    return e.parentNode && e.parentNode.removeChild(e);
                  }),
                pt === Te && (pt = 0),
                ie &&
                  (n && (n.uncache = 1),
                  (r = 0),
                  At.forEach(function (e) {
                    return e.pin === ie && r++;
                  }),
                  r || (n.spacer = 0)),
                S.onKill && S.onKill(Te);
            }),
            Te.enable(!1, !1),
            i && i(Te),
            C && C.add && !L
              ? He.delayedCall(0.01, function () {
                  return P || O || Te.refresh();
                }) &&
                (L = 0.01) &&
                (P = O = 0)
              : Te.refresh(),
            ie &&
              (function _queueRefreshAll() {
                if (ft !== Dt) {
                  var e = (ft = Dt);
                  requestAnimationFrame(function () {
                    return e === Dt && It(!0);
                  });
                }
              })();
        } else this.update = this.refresh = this.kill = Aa;
      }),
      (ScrollTrigger.register = function register(e) {
        return (
          s ||
            ((He = e || Da()),
            Ca() && window.document && ScrollTrigger.enable(),
            (s = vt)),
          s
        );
      }),
      (ScrollTrigger.defaults = function defaults(e) {
        if (e) for (var t in e) Ot[t] = e[t];
        return Ot;
      }),
      (ScrollTrigger.disable = function disable(t, r) {
        (vt = 0),
          At.forEach(function (e) {
            return e[r ? "kill" : "disable"](t);
          }),
          pb(Je, "wheel", Bb),
          pb(je, "scroll", Bb),
          clearInterval(u),
          pb(je, "touchcancel", Aa),
          pb(Ge, "touchstart", Aa),
          nb(pb, je, "pointerdown,touchstart,mousedown", ya),
          nb(pb, je, "pointerup,touchend,mouseup", za),
          c.kill(),
          Ja(pb);
        for (var e = 0; e < ze.length; e += 3)
          qb(pb, ze[e], ze[e + 1]), qb(pb, ze[e], ze[e + 2]);
      }),
      (ScrollTrigger.enable = function enable() {
        if (
          ((Je = window),
          (je = document),
          (qe = je.documentElement),
          (Ge = je.body),
          He &&
            ((et = He.utils.toArray),
            (tt = He.utils.clamp),
            (lt = He.core.context || Aa),
            (st = He.core.suppressOverwrites || Aa),
            (x = Je.history.scrollRestoration || "auto"),
            He.core.globals("ScrollTrigger", ScrollTrigger),
            Ge))
        ) {
          (vt = 1),
            E.register(He),
            (ScrollTrigger.isTouch = E.isTouch),
            (k =
              E.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
            ob(Je, "wheel", Bb),
            (l = [Je, je, qe, Ge]),
            He.matchMedia
              ? ((ScrollTrigger.matchMedia = function (e) {
                  var t,
                    r = He.matchMedia();
                  for (t in e) r.add(t, e[t]);
                  return r;
                }),
                He.addEventListener("matchMediaInit", function () {
                  return Kb();
                }),
                He.addEventListener("matchMediaRevert", function () {
                  return Jb();
                }),
                He.addEventListener("matchMedia", function () {
                  It(0, 1), W("matchMedia");
                }),
                He.matchMedia("(orientation: portrait)", function () {
                  return Cb(), Cb;
                }))
              : console.warn("Requires GSAP 3.11.0 or later"),
            Cb(),
            ob(je, "scroll", Bb);
          var e,
            t,
            r = Ge.style,
            n = r.borderTopStyle,
            o = He.core.Animation.prototype;
          for (
            o.revert ||
              Object.defineProperty(o, "revert", {
                value: function value() {
                  return this.time(-0.01, !0);
                },
              }),
              r.borderTopStyle = "solid",
              e = Mt(Ge),
              Ke.m = Math.round(e.top + Ke.sc()) || 0,
              Xe.m = Math.round(e.left + Xe.sc()) || 0,
              n ? (r.borderTopStyle = n) : r.removeProperty("border-top-style"),
              u = setInterval(Ab, 250),
              He.delayedCall(0.5, function () {
                return (dt = 0);
              }),
              ob(je, "touchcancel", Aa),
              ob(Ge, "touchstart", Aa),
              nb(ob, je, "pointerdown,touchstart,mousedown", ya),
              nb(ob, je, "pointerup,touchend,mouseup", za),
              f = He.utils.checkPrefix("transform"),
              V.push(f),
              s = gt(),
              c = He.delayedCall(0.2, It).pause(),
              g = [
                je,
                "visibilitychange",
                function () {
                  var e = Je.innerWidth,
                    t = Je.innerHeight;
                  je.hidden ? ((p = e), (d = t)) : (p === e && d === t) || Db();
                },
                je,
                "DOMContentLoaded",
                It,
                Je,
                "load",
                It,
                Je,
                "resize",
                Db,
              ],
              Ja(ob),
              At.forEach(function (e) {
                return e.enable(0, 1);
              }),
              t = 0;
            t < ze.length;
            t += 3
          )
            qb(pb, ze[t], ze[t + 1]), qb(pb, ze[t], ze[t + 2]);
        }
      }),
      (ScrollTrigger.config = function config(e) {
        "limitCallbacks" in e && (ct = !!e.limitCallbacks);
        var t = e.syncInterval;
        (t && clearInterval(u)) || ((u = t) && setInterval(Ab, t)),
          "ignoreMobileResize" in e &&
            (b = 1 === ScrollTrigger.isTouch && e.ignoreMobileResize),
          "autoRefreshEvents" in e &&
            (Ja(pb) || Ja(ob, e.autoRefreshEvents || "none"),
            (h = -1 === (e.autoRefreshEvents + "").indexOf("resize")));
      }),
      (ScrollTrigger.scrollerProxy = function scrollerProxy(e, t) {
        var r = J(e),
          n = ze.indexOf(r),
          o = Ea(r);
        ~n && ze.splice(n, o ? 6 : 2),
          t && (o ? Fe.unshift(Je, t, Ge, t, qe, t) : Fe.unshift(r, t));
      }),
      (ScrollTrigger.clearMatchMedia = function clearMatchMedia(t) {
        At.forEach(function (e) {
          return e._ctx && e._ctx.query === t && e._ctx.kill(!0, !0);
        });
      }),
      (ScrollTrigger.isInViewport = function isInViewport(e, t, r) {
        var n = (Ka(e) ? J(e) : e).getBoundingClientRect(),
          o = n[r ? mt : yt] * t || 0;
        return r
          ? 0 < n.right - o && n.left + o < Je.innerWidth
          : 0 < n.bottom - o && n.top + o < Je.innerHeight;
      }),
      (ScrollTrigger.positionInViewport = function positionInViewport(e, t, r) {
        Ka(e) && (e = J(e));
        var n = e.getBoundingClientRect(),
          o = n[r ? mt : yt],
          i =
            null == t
              ? o / 2
              : t in I
              ? I[t] * o
              : ~t.indexOf("%")
              ? (parseFloat(t) * o) / 100
              : parseFloat(t) || 0;
        return r ? (n.left + i) / Je.innerWidth : (n.top + i) / Je.innerHeight;
      }),
      (ScrollTrigger.killAll = function killAll(e) {
        if (
          (At.slice(0).forEach(function (e) {
            return "ScrollSmoother" !== e.vars.id && e.kill();
          }),
          !0 !== e)
        ) {
          var t = Y.killAll || [];
          (Y = {}),
            t.forEach(function (e) {
              return e();
            });
        }
      }),
      ScrollTrigger);
  function ScrollTrigger(e, t) {
    s ||
      ScrollTrigger.register(He) ||
      console.warn("Please gsap.registerPlugin(ScrollTrigger)"),
      this.init(e, t);
  }
  (Q.version = "3.11.4"),
    (Q.saveStyles = function (e) {
      return e
        ? et(e).forEach(function (e) {
            if (e && e.style) {
              var t = H.indexOf(e);
              0 <= t && H.splice(t, 5),
                H.push(
                  e,
                  e.style.cssText,
                  e.getBBox && e.getAttribute("transform"),
                  He.core.getCache(e),
                  lt()
                );
            }
          })
        : H;
    }),
    (Q.revert = function (e, t) {
      return Kb(!e, t);
    }),
    (Q.create = function (e, t) {
      return new Q(e, t);
    }),
    (Q.refresh = function (e) {
      return e ? Db() : (s || Q.register()) && It(!0);
    }),
    (Q.update = function (e) {
      return ++ze.cache && j(!0 === e ? 2 : 0);
    }),
    (Q.clearScrollMemory = Lb),
    (Q.maxScroll = function (e, t) {
      return Ia(e, t ? Xe : Ke);
    }),
    (Q.getScrollFunc = function (e, t) {
      return K(J(e), t ? Xe : Ke);
    }),
    (Q.getById = function (e) {
      return Bt[e];
    }),
    (Q.getAll = function () {
      return At.filter(function (e) {
        return "ScrollSmoother" !== e.vars.id;
      });
    }),
    (Q.isScrolling = function () {
      return !!ht;
    }),
    (Q.snapDirectional = lb),
    (Q.addEventListener = function (e, t) {
      var r = Y[e] || (Y[e] = []);
      ~r.indexOf(t) || r.push(t);
    }),
    (Q.removeEventListener = function (e, t) {
      var r = Y[e],
        n = r && r.indexOf(t);
      0 <= n && r.splice(n, 1);
    }),
    (Q.batch = function (e, t) {
      function Io(e, t) {
        var r = [],
          n = [],
          o = He.delayedCall(i, function () {
            t(r, n), (r = []), (n = []);
          }).pause();
        return function (e) {
          r.length || o.restart(!0),
            r.push(e.trigger),
            n.push(e),
            a <= r.length && o.progress(1);
        };
      }
      var r,
        n = [],
        o = {},
        i = t.interval || 0.016,
        a = t.batchMax || 1e9;
      for (r in t)
        o[r] =
          "on" === r.substr(0, 2) && La(t[r]) && "onRefreshInit" !== r
            ? Io(0, t[r])
            : t[r];
      return (
        La(a) &&
          ((a = a()),
          ob(Q, "refresh", function () {
            return (a = t.batchMax());
          })),
        et(e).forEach(function (e) {
          var t = {};
          for (r in o) t[r] = o[r];
          (t.trigger = e), n.push(Q.create(t));
        }),
        n
      );
    });
  function hc(e, t, r, n) {
    return (
      n < t ? e(n) : t < 0 && e(0),
      n < r ? (n - t) / (r - t) : r < 0 ? t / (t - r) : 1
    );
  }
  function ic(e, t) {
    !0 === t
      ? e.style.removeProperty("touch-action")
      : (e.style.touchAction =
          !0 === t
            ? "auto"
            : t
            ? "pan-" + t + (E.isTouch ? " pinch-zoom" : "")
            : "none"),
      e === qe && ic(Ge, t);
  }
  function kc(e) {
    var t,
      r = e.event,
      n = e.target,
      o = e.axis,
      i = (r.changedTouches ? r.changedTouches[0] : r).target,
      a = i._gsap || He.core.getCache(i),
      s = gt();
    if (!a._isScrollT || 2e3 < s - a._isScrollT) {
      for (
        ;
        i &&
        i !== Ge &&
        ((i.scrollHeight <= i.clientHeight && i.scrollWidth <= i.clientWidth) ||
          (!te[(t = eb(i)).overflowY] && !te[t.overflowX]));

      )
        i = i.parentNode;
      (a._isScroll =
        i &&
        i !== n &&
        !Ea(i) &&
        (te[(t = eb(i)).overflowY] || te[t.overflowX])),
        (a._isScrollT = s);
    }
    (!a._isScroll && "x" !== o) || (r.stopPropagation(), (r._gsapAllow = !0));
  }
  function lc(e, t, r, n) {
    return E.create({
      target: e,
      capture: !0,
      debounce: !1,
      lockAxis: !0,
      type: t,
      onWheel: (n = n && kc),
      onPress: n,
      onDrag: n,
      onScroll: n,
      onEnable: function onEnable() {
        return r && ob(je, E.eventTypes[0], ne, !1, !0);
      },
      onDisable: function onDisable() {
        return pb(je, E.eventTypes[0], ne, !0);
      },
    });
  }
  function pc(e) {
    function Ep() {
      return (o = !1);
    }
    function Hp() {
      (i = Ia(p, Ke)),
        (S = tt(k ? 1 : 0, i)),
        f && (T = tt(0, Ia(p, Xe))),
        (l = Dt);
    }
    function Ip() {
      (h._gsap.y = Ba(parseFloat(h._gsap.y) + v.offset) + "px"),
        (h.style.transform =
          "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " +
          parseFloat(h._gsap.y) +
          ", 0, 1)"),
        (v.offset = v.cacheID = 0);
    }
    function Op() {
      Hp(),
        a.isActive() &&
          a.vars.scrollY > i &&
          (v() > i ? a.progress(1) && v(i) : a.resetTo("scrollY", i));
    }
    Na(e) || (e = {}),
      (e.preventDefault = e.isNormalizer = e.allowClicks = !0),
      e.type || (e.type = "wheel,touch"),
      (e.debounce = !!e.debounce),
      (e.id = e.id || "normalizer");
    var n,
      i,
      l,
      o,
      a,
      c,
      u,
      s,
      f = e.normalizeScrollX,
      t = e.momentum,
      r = e.allowNestedScroll,
      p = J(e.target) || qe,
      d = He.core.globals().ScrollSmoother,
      g = d && d.get(),
      h =
        k &&
        ((e.content && J(e.content)) ||
          (g && !1 !== e.content && !g.smooth() && g.content())),
      v = K(p, Ke),
      b = K(p, Xe),
      m = 1,
      y =
        (E.isTouch && Je.visualViewport
          ? Je.visualViewport.scale * Je.visualViewport.width
          : Je.outerWidth) / Je.innerWidth,
      x = 0,
      w = La(t)
        ? function () {
            return t(n);
          }
        : function () {
            return t || 2.8;
          },
      _ = lc(p, e.type, !0, r),
      T = Aa,
      S = Aa;
    return (
      h && He.set(h, { y: "+=0" }),
      (e.ignoreCheck = function (e) {
        return (
          (k &&
            "touchmove" === e.type &&
            (function ignoreDrag() {
              if (o) {
                requestAnimationFrame(Ep);
                var e = Ba(n.deltaY / 2),
                  t = S(v.v - e);
                if (h && t !== v.v + v.offset) {
                  v.offset = t - v.v;
                  var r = Ba((parseFloat(h && h._gsap.y) || 0) - v.offset);
                  (h.style.transform =
                    "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " +
                    r +
                    ", 0, 1)"),
                    (h._gsap.y = r + "px"),
                    (v.cacheID = ze.cache),
                    j();
                }
                return !0;
              }
              v.offset && Ip(), (o = !0);
            })()) ||
          (1.05 < m && "touchstart" !== e.type) ||
          n.isGesturing ||
          (e.touches && 1 < e.touches.length)
        );
      }),
      (e.onPress = function () {
        var e = m;
        (m = Ba(((Je.visualViewport && Je.visualViewport.scale) || 1) / y)),
          a.pause(),
          e !== m && ic(p, 1.01 < m || (!f && "x")),
          (c = b()),
          (u = v()),
          Hp(),
          (l = Dt);
      }),
      (e.onRelease = e.onGestureStart =
        function (e, t) {
          if ((v.offset && Ip(), t)) {
            ze.cache++;
            var r,
              n,
              o = w();
            f &&
              ((n = (r = b()) + (0.05 * o * -e.velocityX) / 0.227),
              (o *= hc(b, r, n, Ia(p, Xe))),
              (a.vars.scrollX = T(n))),
              (n = (r = v()) + (0.05 * o * -e.velocityY) / 0.227),
              (o *= hc(v, r, n, Ia(p, Ke))),
              (a.vars.scrollY = S(n)),
              a.invalidate().duration(o).play(0.01),
              ((k && a.vars.scrollY >= i) || i - 1 <= r) &&
                He.to({}, { onUpdate: Op, duration: o });
          } else s.restart(!0);
        }),
      (e.onWheel = function () {
        a._ts && a.pause(), 1e3 < gt() - x && ((l = 0), (x = gt()));
      }),
      (e.onChange = function (e, t, r, n, o) {
        if (
          (Dt !== l && Hp(),
          t && f && b(T(n[2] === t ? c + (e.startX - e.x) : b() + t - n[1])),
          r)
        ) {
          v.offset && Ip();
          var i = o[2] === r,
            a = i ? u + e.startY - e.y : v() + r - o[1],
            s = S(a);
          i && a !== s && (u += s - a), v(s);
        }
        (r || t) && j();
      }),
      (e.onEnable = function () {
        ic(p, !f && "x"),
          Q.addEventListener("refresh", Op),
          ob(Je, "resize", Op),
          v.smooth &&
            ((v.target.style.scrollBehavior = "auto"),
            (v.smooth = b.smooth = !1)),
          _.enable();
      }),
      (e.onDisable = function () {
        ic(p, !0),
          pb(Je, "resize", Op),
          Q.removeEventListener("refresh", Op),
          _.kill();
      }),
      (e.lockAxis = !1 !== e.lockAxis),
      ((n = new E(e)).iOS = k) && !v() && v(1),
      k && He.ticker.add(Aa),
      (s = n._dc),
      (a = He.to(n, {
        ease: "power4",
        paused: !0,
        scrollX: f ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        onComplete: s.vars.onComplete,
      })),
      n
    );
  }
  var ee,
    te = { auto: 1, scroll: 1 },
    re = /(input|label|select|textarea)/i,
    ne = function _captureInputs(e) {
      var t = re.test(e.target.tagName);
      (t || ee) && ((e._gsapAllow = !0), (ee = t));
    };
  (Q.sort = function (e) {
    return At.sort(
      e ||
        function (e, t) {
          return (
            -1e6 * (e.vars.refreshPriority || 0) +
            e.start -
            (t.start + -1e6 * (t.vars.refreshPriority || 0))
          );
        }
    );
  }),
    (Q.observe = function (e) {
      return new E(e);
    }),
    (Q.normalizeScroll = function (e) {
      if (void 0 === e) return v;
      if (!0 === e && v) return v.enable();
      if (!1 === e) return v && v.kill();
      var t = e instanceof E ? e : pc(e);
      return v && v.target === t.target && v.kill(), Ea(t.target) && (v = t), t;
    }),
    (Q.core = {
      _getVelocityProp: L,
      _inputObserver: lc,
      _scrollers: ze,
      _proxies: Fe,
      bridge: {
        ss: function ss() {
          ht || W("scrollStart"), (ht = gt());
        },
        ref: function ref() {
          return nt;
        },
      },
    }),
    Da() && He.registerPlugin(Q),
    (e.ScrollTrigger = Q),
    (e.default = Q);
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
  } else {
    delete e.default;
  }
});

/**
 * Swiper 9.0.5
 * https://swiperjs.com
 * Copyright 2014-2023 Vladimir Kharlampidi */
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Swiper =
        t());
})(this, function () {
  "use strict";
  function e(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "constructor" in e &&
      e.constructor === Object
    );
  }
  function t(s, a) {
    void 0 === s && (s = {}),
      void 0 === a && (a = {}),
      Object.keys(a).forEach((i) => {
        void 0 === s[i]
          ? (s[i] = a[i])
          : e(a[i]) && e(s[i]) && Object.keys(a[i]).length > 0 && t(s[i], a[i]);
      });
  }
  const s = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function a() {
    const e = "undefined" != typeof document ? document : {};
    return t(e, s), e;
  }
  const i = {
    document: s,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => "" }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) =>
      "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
    cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function r() {
    const e = "undefined" != typeof window ? window : {};
    return t(e, i), e;
  }
  function n(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
  }
  function l() {
    return Date.now();
  }
  function o(e, t) {
    void 0 === t && (t = "x");
    const s = r();
    let a, i, n;
    const l = (function (e) {
      const t = r();
      let s;
      return (
        t.getComputedStyle && (s = t.getComputedStyle(e, null)),
        !s && e.currentStyle && (s = e.currentStyle),
        s || (s = e.style),
        s
      );
    })(e);
    return (
      s.WebKitCSSMatrix
        ? ((i = l.transform || l.webkitTransform),
          i.split(",").length > 6 &&
            (i = i
              .split(", ")
              .map((e) => e.replace(",", "."))
              .join(", ")),
          (n = new s.WebKitCSSMatrix("none" === i ? "" : i)))
        : ((n =
            l.MozTransform ||
            l.OTransform ||
            l.MsTransform ||
            l.msTransform ||
            l.transform ||
            l
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,")),
          (a = n.toString().split(","))),
      "x" === t &&
        (i = s.WebKitCSSMatrix
          ? n.m41
          : 16 === a.length
          ? parseFloat(a[12])
          : parseFloat(a[4])),
      "y" === t &&
        (i = s.WebKitCSSMatrix
          ? n.m42
          : 16 === a.length
          ? parseFloat(a[13])
          : parseFloat(a[5])),
      i || 0
    );
  }
  function d(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function c(e) {
    return "undefined" != typeof window && void 0 !== window.HTMLElement
      ? e instanceof HTMLElement
      : e && (1 === e.nodeType || 11 === e.nodeType);
  }
  function p() {
    const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
      t = ["__proto__", "constructor", "prototype"];
    for (let s = 1; s < arguments.length; s += 1) {
      const a = s < 0 || arguments.length <= s ? void 0 : arguments[s];
      if (null != a && !c(a)) {
        const s = Object.keys(Object(a)).filter((e) => t.indexOf(e) < 0);
        for (let t = 0, i = s.length; t < i; t += 1) {
          const i = s[t],
            r = Object.getOwnPropertyDescriptor(a, i);
          void 0 !== r &&
            r.enumerable &&
            (d(e[i]) && d(a[i])
              ? a[i].__swiper__
                ? (e[i] = a[i])
                : p(e[i], a[i])
              : !d(e[i]) && d(a[i])
              ? ((e[i] = {}), a[i].__swiper__ ? (e[i] = a[i]) : p(e[i], a[i]))
              : (e[i] = a[i]));
        }
      }
    }
    return e;
  }
  function u(e, t, s) {
    e.style.setProperty(t, s);
  }
  function m(e) {
    let { swiper: t, targetPosition: s, side: a } = e;
    const i = r(),
      n = -t.translate;
    let l,
      o = null;
    const d = t.params.speed;
    (t.wrapperEl.style.scrollSnapType = "none"),
      i.cancelAnimationFrame(t.cssModeFrameID);
    const c = s > n ? "next" : "prev",
      p = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
      u = () => {
        (l = new Date().getTime()), null === o && (o = l);
        const e = Math.max(Math.min((l - o) / d, 1), 0),
          r = 0.5 - Math.cos(e * Math.PI) / 2;
        let c = n + r * (s - n);
        if ((p(c, s) && (c = s), t.wrapperEl.scrollTo({ [a]: c }), p(c, s)))
          return (
            (t.wrapperEl.style.overflow = "hidden"),
            (t.wrapperEl.style.scrollSnapType = ""),
            setTimeout(() => {
              (t.wrapperEl.style.overflow = ""),
                t.wrapperEl.scrollTo({ [a]: c });
            }),
            void i.cancelAnimationFrame(t.cssModeFrameID)
          );
        t.cssModeFrameID = i.requestAnimationFrame(u);
      };
    u();
  }
  function h(e) {
    return (
      e.querySelector(".swiper-slide-transform") ||
      (e.shadowEl && e.shadowEl.querySelector(".swiper-slide-transform")) ||
      e
    );
  }
  function f(e, t) {
    return (
      void 0 === t && (t = ""), [...e.children].filter((e) => e.matches(t))
    );
  }
  function g(e, t) {
    void 0 === t && (t = []);
    const s = document.createElement(e);
    return s.classList.add(...(Array.isArray(t) ? t : [t])), s;
  }
  function v(e) {
    const t = r(),
      s = a(),
      i = e.getBoundingClientRect(),
      n = s.body,
      l = e.clientTop || n.clientTop || 0,
      o = e.clientLeft || n.clientLeft || 0,
      d = e === t ? t.scrollY : e.scrollTop,
      c = e === t ? t.scrollX : e.scrollLeft;
    return { top: i.top + d - l, left: i.left + c - o };
  }
  function w(e, t) {
    return r().getComputedStyle(e, null).getPropertyValue(t);
  }
  function b(e) {
    let t,
      s = e;
    if (s) {
      for (t = 0; null !== (s = s.previousSibling); )
        1 === s.nodeType && (t += 1);
      return t;
    }
  }
  function y(e, t) {
    const s = [];
    let a = e.parentElement;
    for (; a; )
      t ? a.matches(t) && s.push(a) : s.push(a), (a = a.parentElement);
    return s;
  }
  function E(e, t) {
    t &&
      e.addEventListener("transitionend", function s(a) {
        a.target === e &&
          (t.call(e, a), e.removeEventListener("transitionend", s));
      });
  }
  function x(e, t, s) {
    const a = r();
    return s
      ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
          parseFloat(
            a
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-right" : "margin-top")
          ) +
          parseFloat(
            a
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-left" : "margin-bottom")
          )
      : e.offsetWidth;
  }
  let S, T, M;
  function C() {
    return (
      S ||
        (S = (function () {
          const e = r(),
            t = a();
          return {
            smoothScroll:
              t.documentElement && "scrollBehavior" in t.documentElement.style,
            touch: !!(
              "ontouchstart" in e ||
              (e.DocumentTouch && t instanceof e.DocumentTouch)
            ),
          };
        })()),
      S
    );
  }
  function P(e) {
    return (
      void 0 === e && (e = {}),
      T ||
        (T = (function (e) {
          let { userAgent: t } = void 0 === e ? {} : e;
          const s = C(),
            a = r(),
            i = a.navigator.platform,
            n = t || a.navigator.userAgent,
            l = { ios: !1, android: !1 },
            o = a.screen.width,
            d = a.screen.height,
            c = n.match(/(Android);?[\s\/]+([\d.]+)?/);
          let p = n.match(/(iPad).*OS\s([\d_]+)/);
          const u = n.match(/(iPod)(.*OS\s([\d_]+))?/),
            m = !p && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            h = "Win32" === i;
          let f = "MacIntel" === i;
          return (
            !p &&
              f &&
              s.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(`${o}x${d}`) >= 0 &&
              ((p = n.match(/(Version)\/([\d.]+)/)),
              p || (p = [0, 1, "13_0_0"]),
              (f = !1)),
            c && !h && ((l.os = "android"), (l.android = !0)),
            (p || m || u) && ((l.os = "ios"), (l.ios = !0)),
            l
          );
        })(e)),
      T
    );
  }
  function L() {
    return (
      M ||
        (M = (function () {
          const e = r();
          let t = !1;
          function s() {
            const t = e.navigator.userAgent.toLowerCase();
            return (
              t.indexOf("safari") >= 0 &&
              t.indexOf("chrome") < 0 &&
              t.indexOf("android") < 0
            );
          }
          if (s()) {
            const s = String(e.navigator.userAgent);
            if (s.includes("Version/")) {
              const [e, a] = s
                .split("Version/")[1]
                .split(" ")[0]
                .split(".")
                .map((e) => Number(e));
              t = e < 16 || (16 === e && a < 2);
            }
          }
          return {
            isSafari: t || s(),
            needPerspectiveFix: t,
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              e.navigator.userAgent
            ),
          };
        })()),
      M
    );
  }
  var A = {
    on(e, t, s) {
      const a = this;
      if (!a.eventsListeners || a.destroyed) return a;
      if ("function" != typeof t) return a;
      const i = s ? "unshift" : "push";
      return (
        e.split(" ").forEach((e) => {
          a.eventsListeners[e] || (a.eventsListeners[e] = []),
            a.eventsListeners[e][i](t);
        }),
        a
      );
    },
    once(e, t, s) {
      const a = this;
      if (!a.eventsListeners || a.destroyed) return a;
      if ("function" != typeof t) return a;
      function i() {
        a.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
        for (var s = arguments.length, r = new Array(s), n = 0; n < s; n++)
          r[n] = arguments[n];
        t.apply(a, r);
      }
      return (i.__emitterProxy = t), a.on(e, i, s);
    },
    onAny(e, t) {
      const s = this;
      if (!s.eventsListeners || s.destroyed) return s;
      if ("function" != typeof e) return s;
      const a = t ? "unshift" : "push";
      return (
        s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[a](e), s
      );
    },
    offAny(e) {
      const t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsAnyListeners) return t;
      const s = t.eventsAnyListeners.indexOf(e);
      return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
    },
    off(e, t) {
      const s = this;
      return !s.eventsListeners || s.destroyed
        ? s
        : s.eventsListeners
        ? (e.split(" ").forEach((e) => {
            void 0 === t
              ? (s.eventsListeners[e] = [])
              : s.eventsListeners[e] &&
                s.eventsListeners[e].forEach((a, i) => {
                  (a === t || (a.__emitterProxy && a.__emitterProxy === t)) &&
                    s.eventsListeners[e].splice(i, 1);
                });
          }),
          s)
        : s;
    },
    emit() {
      const e = this;
      if (!e.eventsListeners || e.destroyed) return e;
      if (!e.eventsListeners) return e;
      let t, s, a;
      for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++)
        r[n] = arguments[n];
      "string" == typeof r[0] || Array.isArray(r[0])
        ? ((t = r[0]), (s = r.slice(1, r.length)), (a = e))
        : ((t = r[0].events), (s = r[0].data), (a = r[0].context || e)),
        s.unshift(a);
      return (
        (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
          e.eventsAnyListeners &&
            e.eventsAnyListeners.length &&
            e.eventsAnyListeners.forEach((e) => {
              e.apply(a, [t, ...s]);
            }),
            e.eventsListeners &&
              e.eventsListeners[t] &&
              e.eventsListeners[t].forEach((e) => {
                e.apply(a, s);
              });
        }),
        e
      );
    },
  };
  var z = {
    updateSize: function () {
      const e = this;
      let t, s;
      const a = e.el;
      (t =
        void 0 !== e.params.width && null !== e.params.width
          ? e.params.width
          : a.clientWidth),
        (s =
          void 0 !== e.params.height && null !== e.params.height
            ? e.params.height
            : a.clientHeight),
        (0 === t && e.isHorizontal()) ||
          (0 === s && e.isVertical()) ||
          ((t =
            t -
            parseInt(w(a, "padding-left") || 0, 10) -
            parseInt(w(a, "padding-right") || 0, 10)),
          (s =
            s -
            parseInt(w(a, "padding-top") || 0, 10) -
            parseInt(w(a, "padding-bottom") || 0, 10)),
          Number.isNaN(t) && (t = 0),
          Number.isNaN(s) && (s = 0),
          Object.assign(e, {
            width: t,
            height: s,
            size: e.isHorizontal() ? t : s,
          }));
    },
    updateSlides: function () {
      const e = this;
      function t(t) {
        return e.isHorizontal()
          ? t
          : {
              width: "height",
              "margin-top": "margin-left",
              "margin-bottom ": "margin-right",
              "margin-left": "margin-top",
              "margin-right": "margin-bottom",
              "padding-left": "padding-top",
              "padding-right": "padding-bottom",
              marginRight: "marginBottom",
            }[t];
      }
      function s(e, s) {
        return parseFloat(e.getPropertyValue(t(s)) || 0);
      }
      const a = e.params,
        {
          wrapperEl: i,
          slidesEl: r,
          size: n,
          rtlTranslate: l,
          wrongRTL: o,
        } = e,
        d = e.virtual && a.virtual.enabled,
        c = d ? e.virtual.slides.length : e.slides.length,
        p = f(r, `.${e.params.slideClass}, swiper-slide`),
        m = d ? e.virtual.slides.length : p.length;
      let h = [];
      const g = [],
        v = [];
      let b = a.slidesOffsetBefore;
      "function" == typeof b && (b = a.slidesOffsetBefore.call(e));
      let y = a.slidesOffsetAfter;
      "function" == typeof y && (y = a.slidesOffsetAfter.call(e));
      const E = e.snapGrid.length,
        S = e.slidesGrid.length;
      let T = a.spaceBetween,
        M = -b,
        C = 0,
        P = 0;
      if (void 0 === n) return;
      "string" == typeof T &&
        T.indexOf("%") >= 0 &&
        (T = (parseFloat(T.replace("%", "")) / 100) * n),
        (e.virtualSize = -T),
        p.forEach((e) => {
          l ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
            (e.style.marginBottom = ""),
            (e.style.marginTop = "");
        }),
        a.centeredSlides &&
          a.cssMode &&
          (u(i, "--swiper-centered-offset-before", ""),
          u(i, "--swiper-centered-offset-after", ""));
      const L = a.grid && a.grid.rows > 1 && e.grid;
      let A;
      L && e.grid.initSlides(m);
      const z =
        "auto" === a.slidesPerView &&
        a.breakpoints &&
        Object.keys(a.breakpoints).filter(
          (e) => void 0 !== a.breakpoints[e].slidesPerView
        ).length > 0;
      for (let i = 0; i < m; i += 1) {
        let r;
        if (
          ((A = 0),
          p[i] && (r = p[i]),
          L && e.grid.updateSlide(i, r, m, t),
          !p[i] || "none" !== w(r, "display"))
        ) {
          if ("auto" === a.slidesPerView) {
            z && (p[i].style[t("width")] = "");
            const n = getComputedStyle(r),
              l = r.style.transform,
              o = r.style.webkitTransform;
            if (
              (l && (r.style.transform = "none"),
              o && (r.style.webkitTransform = "none"),
              a.roundLengths)
            )
              A = e.isHorizontal() ? x(r, "width", !0) : x(r, "height", !0);
            else {
              const e = s(n, "width"),
                t = s(n, "padding-left"),
                a = s(n, "padding-right"),
                i = s(n, "margin-left"),
                l = s(n, "margin-right"),
                o = n.getPropertyValue("box-sizing");
              if (o && "border-box" === o) A = e + i + l;
              else {
                const { clientWidth: s, offsetWidth: n } = r;
                A = e + t + a + i + l + (n - s);
              }
            }
            l && (r.style.transform = l),
              o && (r.style.webkitTransform = o),
              a.roundLengths && (A = Math.floor(A));
          } else
            (A = (n - (a.slidesPerView - 1) * T) / a.slidesPerView),
              a.roundLengths && (A = Math.floor(A)),
              p[i] && (p[i].style[t("width")] = `${A}px`);
          p[i] && (p[i].swiperSlideSize = A),
            v.push(A),
            a.centeredSlides
              ? ((M = M + A / 2 + C / 2 + T),
                0 === C && 0 !== i && (M = M - n / 2 - T),
                0 === i && (M = M - n / 2 - T),
                Math.abs(M) < 0.001 && (M = 0),
                a.roundLengths && (M = Math.floor(M)),
                P % a.slidesPerGroup == 0 && h.push(M),
                g.push(M))
              : (a.roundLengths && (M = Math.floor(M)),
                (P - Math.min(e.params.slidesPerGroupSkip, P)) %
                  e.params.slidesPerGroup ==
                  0 && h.push(M),
                g.push(M),
                (M = M + A + T)),
            (e.virtualSize += A + T),
            (C = A),
            (P += 1);
        }
      }
      if (
        ((e.virtualSize = Math.max(e.virtualSize, n) + y),
        l &&
          o &&
          ("slide" === a.effect || "coverflow" === a.effect) &&
          (i.style.width = `${e.virtualSize + a.spaceBetween}px`),
        a.setWrapperSize &&
          (i.style[t("width")] = `${e.virtualSize + a.spaceBetween}px`),
        L && e.grid.updateWrapperSize(A, h, t),
        !a.centeredSlides)
      ) {
        const t = [];
        for (let s = 0; s < h.length; s += 1) {
          let i = h[s];
          a.roundLengths && (i = Math.floor(i)),
            h[s] <= e.virtualSize - n && t.push(i);
        }
        (h = t),
          Math.floor(e.virtualSize - n) - Math.floor(h[h.length - 1]) > 1 &&
            h.push(e.virtualSize - n);
      }
      if (d && a.loop) {
        const t = v[0] + T;
        if (a.slidesPerGroup > 1) {
          const s = Math.ceil(
              (e.virtual.slidesBefore + e.virtual.slidesAfter) /
                a.slidesPerGroup
            ),
            i = t * a.slidesPerGroup;
          for (let e = 0; e < s; e += 1) h.push(h[h.length - 1] + i);
        }
        for (
          let s = 0;
          s < e.virtual.slidesBefore + e.virtual.slidesAfter;
          s += 1
        )
          1 === a.slidesPerGroup && h.push(h[h.length - 1] + t),
            g.push(g[g.length - 1] + t),
            (e.virtualSize += t);
      }
      if ((0 === h.length && (h = [0]), 0 !== a.spaceBetween)) {
        const s = e.isHorizontal() && l ? "marginLeft" : t("marginRight");
        p.filter(
          (e, t) => !(a.cssMode && !a.loop) || t !== p.length - 1
        ).forEach((e) => {
          e.style[s] = `${T}px`;
        });
      }
      if (a.centeredSlides && a.centeredSlidesBounds) {
        let e = 0;
        v.forEach((t) => {
          e += t + (a.spaceBetween ? a.spaceBetween : 0);
        }),
          (e -= a.spaceBetween);
        const t = e - n;
        h = h.map((e) => (e < 0 ? -b : e > t ? t + y : e));
      }
      if (a.centerInsufficientSlides) {
        let e = 0;
        if (
          (v.forEach((t) => {
            e += t + (a.spaceBetween ? a.spaceBetween : 0);
          }),
          (e -= a.spaceBetween),
          e < n)
        ) {
          const t = (n - e) / 2;
          h.forEach((e, s) => {
            h[s] = e - t;
          }),
            g.forEach((e, s) => {
              g[s] = e + t;
            });
        }
      }
      if (
        (Object.assign(e, {
          slides: p,
          snapGrid: h,
          slidesGrid: g,
          slidesSizesGrid: v,
        }),
        a.centeredSlides && a.cssMode && !a.centeredSlidesBounds)
      ) {
        u(i, "--swiper-centered-offset-before", -h[0] + "px"),
          u(
            i,
            "--swiper-centered-offset-after",
            e.size / 2 - v[v.length - 1] / 2 + "px"
          );
        const t = -e.snapGrid[0],
          s = -e.slidesGrid[0];
        (e.snapGrid = e.snapGrid.map((e) => e + t)),
          (e.slidesGrid = e.slidesGrid.map((e) => e + s));
      }
      if (
        (m !== c && e.emit("slidesLengthChange"),
        h.length !== E &&
          (e.params.watchOverflow && e.checkOverflow(),
          e.emit("snapGridLengthChange")),
        g.length !== S && e.emit("slidesGridLengthChange"),
        a.watchSlidesProgress && e.updateSlidesOffset(),
        !(d || a.cssMode || ("slide" !== a.effect && "fade" !== a.effect)))
      ) {
        const t = `${a.containerModifierClass}backface-hidden`,
          s = e.el.classList.contains(t);
        m <= a.maxBackfaceHiddenSlides
          ? s || e.el.classList.add(t)
          : s && e.el.classList.remove(t);
      }
    },
    updateAutoHeight: function (e) {
      const t = this,
        s = [],
        a = t.virtual && t.params.virtual.enabled;
      let i,
        r = 0;
      "number" == typeof e
        ? t.setTransition(e)
        : !0 === e && t.setTransition(t.params.speed);
      const n = (e) =>
        a
          ? t.slides.filter(
              (t) =>
                parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e
            )[0]
          : t.slides[e];
      if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
        if (t.params.centeredSlides)
          (t.visibleSlides || []).forEach((e) => {
            s.push(e);
          });
        else
          for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
            const e = t.activeIndex + i;
            if (e > t.slides.length && !a) break;
            s.push(n(e));
          }
      else s.push(n(t.activeIndex));
      for (i = 0; i < s.length; i += 1)
        if (void 0 !== s[i]) {
          const e = s[i].offsetHeight;
          r = e > r ? e : r;
        }
      (r || 0 === r) && (t.wrapperEl.style.height = `${r}px`);
    },
    updateSlidesOffset: function () {
      const e = this,
        t = e.slides,
        s = e.isElement
          ? e.isHorizontal()
            ? e.wrapperEl.offsetLeft
            : e.wrapperEl.offsetTop
          : 0;
      for (let a = 0; a < t.length; a += 1)
        t[a].swiperSlideOffset =
          (e.isHorizontal() ? t[a].offsetLeft : t[a].offsetTop) - s;
    },
    updateSlidesProgress: function (e) {
      void 0 === e && (e = (this && this.translate) || 0);
      const t = this,
        s = t.params,
        { slides: a, rtlTranslate: i, snapGrid: r } = t;
      if (0 === a.length) return;
      void 0 === a[0].swiperSlideOffset && t.updateSlidesOffset();
      let n = -e;
      i && (n = e),
        a.forEach((e) => {
          e.classList.remove(s.slideVisibleClass);
        }),
        (t.visibleSlidesIndexes = []),
        (t.visibleSlides = []);
      for (let e = 0; e < a.length; e += 1) {
        const l = a[e];
        let o = l.swiperSlideOffset;
        s.cssMode && s.centeredSlides && (o -= a[0].swiperSlideOffset);
        const d =
            (n + (s.centeredSlides ? t.minTranslate() : 0) - o) /
            (l.swiperSlideSize + s.spaceBetween),
          c =
            (n - r[0] + (s.centeredSlides ? t.minTranslate() : 0) - o) /
            (l.swiperSlideSize + s.spaceBetween),
          p = -(n - o),
          u = p + t.slidesSizesGrid[e];
        ((p >= 0 && p < t.size - 1) ||
          (u > 1 && u <= t.size) ||
          (p <= 0 && u >= t.size)) &&
          (t.visibleSlides.push(l),
          t.visibleSlidesIndexes.push(e),
          a[e].classList.add(s.slideVisibleClass)),
          (l.progress = i ? -d : d),
          (l.originalProgress = i ? -c : c);
      }
    },
    updateProgress: function (e) {
      const t = this;
      if (void 0 === e) {
        const s = t.rtlTranslate ? -1 : 1;
        e = (t && t.translate && t.translate * s) || 0;
      }
      const s = t.params,
        a = t.maxTranslate() - t.minTranslate();
      let { progress: i, isBeginning: r, isEnd: n, progressLoop: l } = t;
      const o = r,
        d = n;
      if (0 === a) (i = 0), (r = !0), (n = !0);
      else {
        i = (e - t.minTranslate()) / a;
        const s = Math.abs(e - t.minTranslate()) < 1,
          l = Math.abs(e - t.maxTranslate()) < 1;
        (r = s || i <= 0), (n = l || i >= 1), s && (i = 0), l && (i = 1);
      }
      if (s.loop) {
        const s = b(
            t.slides.filter(
              (e) => "0" === e.getAttribute("data-swiper-slide-index")
            )[0]
          ),
          a = b(
            t.slides.filter(
              (e) =>
                1 * e.getAttribute("data-swiper-slide-index") ==
                t.slides.length - 1
            )[0]
          ),
          i = t.slidesGrid[s],
          r = t.slidesGrid[a],
          n = t.slidesGrid[t.slidesGrid.length - 1],
          o = Math.abs(e);
        (l = o >= i ? (o - i) / n : (o + n - r) / n), l > 1 && (l -= 1);
      }
      Object.assign(t, {
        progress: i,
        progressLoop: l,
        isBeginning: r,
        isEnd: n,
      }),
        (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
          t.updateSlidesProgress(e),
        r && !o && t.emit("reachBeginning toEdge"),
        n && !d && t.emit("reachEnd toEdge"),
        ((o && !r) || (d && !n)) && t.emit("fromEdge"),
        t.emit("progress", i);
    },
    updateSlidesClasses: function () {
      const e = this,
        { slides: t, params: s, slidesEl: a, activeIndex: i } = e,
        r = e.virtual && s.virtual.enabled,
        n = (e) => f(a, `.${s.slideClass}${e}, swiper-slide${e}`)[0];
      let l;
      if (
        (t.forEach((e) => {
          e.classList.remove(
            s.slideActiveClass,
            s.slideNextClass,
            s.slidePrevClass
          );
        }),
        r)
      )
        if (s.loop) {
          let t = i - e.virtual.slidesBefore;
          t < 0 && (t = e.virtual.slides.length + t),
            t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
            (l = n(`[data-swiper-slide-index="${t}"]`));
        } else l = n(`[data-swiper-slide-index="${i}"]`);
      else l = t[i];
      if (l) {
        l.classList.add(s.slideActiveClass);
        let e = (function (e, t) {
          const s = [];
          for (; e.nextElementSibling; ) {
            const a = e.nextElementSibling;
            t ? a.matches(t) && s.push(a) : s.push(a), (e = a);
          }
          return s;
        })(l, `.${s.slideClass}, swiper-slide`)[0];
        s.loop && !e && (e = t[0]), e && e.classList.add(s.slideNextClass);
        let a = (function (e, t) {
          const s = [];
          for (; e.previousElementSibling; ) {
            const a = e.previousElementSibling;
            t ? a.matches(t) && s.push(a) : s.push(a), (e = a);
          }
          return s;
        })(l, `.${s.slideClass}, swiper-slide`)[0];
        s.loop && 0 === !a && (a = t[t.length - 1]),
          a && a.classList.add(s.slidePrevClass);
      }
      e.emitSlidesClasses();
    },
    updateActiveIndex: function (e) {
      const t = this,
        s = t.rtlTranslate ? t.translate : -t.translate,
        {
          snapGrid: a,
          params: i,
          activeIndex: r,
          realIndex: n,
          snapIndex: l,
        } = t;
      let o,
        d = e;
      const c = (e) => {
        let s = e - t.virtual.slidesBefore;
        return (
          s < 0 && (s = t.virtual.slides.length + s),
          s >= t.virtual.slides.length && (s -= t.virtual.slides.length),
          s
        );
      };
      if (
        (void 0 === d &&
          (d = (function (e) {
            const { slidesGrid: t, params: s } = e,
              a = e.rtlTranslate ? e.translate : -e.translate;
            let i;
            for (let e = 0; e < t.length; e += 1)
              void 0 !== t[e + 1]
                ? a >= t[e] && a < t[e + 1] - (t[e + 1] - t[e]) / 2
                  ? (i = e)
                  : a >= t[e] && a < t[e + 1] && (i = e + 1)
                : a >= t[e] && (i = e);
            return (
              s.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i
            );
          })(t)),
        a.indexOf(s) >= 0)
      )
        o = a.indexOf(s);
      else {
        const e = Math.min(i.slidesPerGroupSkip, d);
        o = e + Math.floor((d - e) / i.slidesPerGroup);
      }
      if ((o >= a.length && (o = a.length - 1), d === r))
        return (
          o !== l && ((t.snapIndex = o), t.emit("snapIndexChange")),
          void (
            t.params.loop &&
            t.virtual &&
            t.params.virtual.enabled &&
            (t.realIndex = c(d))
          )
        );
      let p;
      (p =
        t.virtual && i.virtual.enabled && i.loop
          ? c(d)
          : t.slides[d]
          ? parseInt(
              t.slides[d].getAttribute("data-swiper-slide-index") || d,
              10
            )
          : d),
        Object.assign(t, {
          snapIndex: o,
          realIndex: p,
          previousIndex: r,
          activeIndex: d,
        }),
        t.emit("activeIndexChange"),
        t.emit("snapIndexChange"),
        n !== p && t.emit("realIndexChange"),
        (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
    },
    updateClickedSlide: function (e) {
      const t = this,
        s = t.params,
        a = e.closest(`.${s.slideClass}, swiper-slide`);
      let i,
        r = !1;
      if (a)
        for (let e = 0; e < t.slides.length; e += 1)
          if (t.slides[e] === a) {
            (r = !0), (i = e);
            break;
          }
      if (!a || !r)
        return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
      (t.clickedSlide = a),
        t.virtual && t.params.virtual.enabled
          ? (t.clickedIndex = parseInt(
              a.getAttribute("data-swiper-slide-index"),
              10
            ))
          : (t.clickedIndex = i),
        s.slideToClickedSlide &&
          void 0 !== t.clickedIndex &&
          t.clickedIndex !== t.activeIndex &&
          t.slideToClickedSlide();
    },
  };
  var $ = {
    getTranslate: function (e) {
      void 0 === e && (e = this.isHorizontal() ? "x" : "y");
      const { params: t, rtlTranslate: s, translate: a, wrapperEl: i } = this;
      if (t.virtualTranslate) return s ? -a : a;
      if (t.cssMode) return a;
      let r = o(i, e);
      return s && (r = -r), r || 0;
    },
    setTranslate: function (e, t) {
      const s = this,
        { rtlTranslate: a, params: i, wrapperEl: r, progress: n } = s;
      let l,
        o = 0,
        d = 0;
      s.isHorizontal() ? (o = a ? -e : e) : (d = e),
        i.roundLengths && ((o = Math.floor(o)), (d = Math.floor(d))),
        i.cssMode
          ? (r[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal()
              ? -o
              : -d)
          : i.virtualTranslate ||
            (r.style.transform = `translate3d(${o}px, ${d}px, 0px)`),
        (s.previousTranslate = s.translate),
        (s.translate = s.isHorizontal() ? o : d);
      const c = s.maxTranslate() - s.minTranslate();
      (l = 0 === c ? 0 : (e - s.minTranslate()) / c),
        l !== n && s.updateProgress(e),
        s.emit("setTranslate", s.translate, t);
    },
    minTranslate: function () {
      return -this.snapGrid[0];
    },
    maxTranslate: function () {
      return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function (e, t, s, a, i) {
      void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        void 0 === a && (a = !0);
      const r = this,
        { params: n, wrapperEl: l } = r;
      if (r.animating && n.preventInteractionOnTransition) return !1;
      const o = r.minTranslate(),
        d = r.maxTranslate();
      let c;
      if (
        ((c = a && e > o ? o : a && e < d ? d : e),
        r.updateProgress(c),
        n.cssMode)
      ) {
        const e = r.isHorizontal();
        if (0 === t) l[e ? "scrollLeft" : "scrollTop"] = -c;
        else {
          if (!r.support.smoothScroll)
            return (
              m({ swiper: r, targetPosition: -c, side: e ? "left" : "top" }), !0
            );
          l.scrollTo({ [e ? "left" : "top"]: -c, behavior: "smooth" });
        }
        return !0;
      }
      return (
        0 === t
          ? (r.setTransition(0),
            r.setTranslate(c),
            s &&
              (r.emit("beforeTransitionStart", t, i), r.emit("transitionEnd")))
          : (r.setTransition(t),
            r.setTranslate(c),
            s &&
              (r.emit("beforeTransitionStart", t, i),
              r.emit("transitionStart")),
            r.animating ||
              ((r.animating = !0),
              r.onTranslateToWrapperTransitionEnd ||
                (r.onTranslateToWrapperTransitionEnd = function (e) {
                  r &&
                    !r.destroyed &&
                    e.target === this &&
                    (r.wrapperEl.removeEventListener(
                      "transitionend",
                      r.onTranslateToWrapperTransitionEnd
                    ),
                    (r.onTranslateToWrapperTransitionEnd = null),
                    delete r.onTranslateToWrapperTransitionEnd,
                    s && r.emit("transitionEnd"));
                }),
              r.wrapperEl.addEventListener(
                "transitionend",
                r.onTranslateToWrapperTransitionEnd
              ))),
        !0
      );
    },
  };
  function k(e) {
    let { swiper: t, runCallbacks: s, direction: a, step: i } = e;
    const { activeIndex: r, previousIndex: n } = t;
    let l = a;
    if (
      (l || (l = r > n ? "next" : r < n ? "prev" : "reset"),
      t.emit(`transition${i}`),
      s && r !== n)
    ) {
      if ("reset" === l) return void t.emit(`slideResetTransition${i}`);
      t.emit(`slideChangeTransition${i}`),
        "next" === l
          ? t.emit(`slideNextTransition${i}`)
          : t.emit(`slidePrevTransition${i}`);
    }
  }
  var I = {
    slideTo: function (e, t, s, a, i) {
      void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        "string" == typeof e && (e = parseInt(e, 10));
      const r = this;
      let n = e;
      n < 0 && (n = 0);
      const {
        params: l,
        snapGrid: o,
        slidesGrid: d,
        previousIndex: c,
        activeIndex: p,
        rtlTranslate: u,
        wrapperEl: h,
        enabled: f,
      } = r;
      if ((r.animating && l.preventInteractionOnTransition) || (!f && !a && !i))
        return !1;
      const g = Math.min(r.params.slidesPerGroupSkip, n);
      let v = g + Math.floor((n - g) / r.params.slidesPerGroup);
      v >= o.length && (v = o.length - 1);
      const w = -o[v];
      if (l.normalizeSlideIndex)
        for (let e = 0; e < d.length; e += 1) {
          const t = -Math.floor(100 * w),
            s = Math.floor(100 * d[e]),
            a = Math.floor(100 * d[e + 1]);
          void 0 !== d[e + 1]
            ? t >= s && t < a - (a - s) / 2
              ? (n = e)
              : t >= s && t < a && (n = e + 1)
            : t >= s && (n = e);
        }
      if (r.initialized && n !== p) {
        if (!r.allowSlideNext && w < r.translate && w < r.minTranslate())
          return !1;
        if (
          !r.allowSlidePrev &&
          w > r.translate &&
          w > r.maxTranslate() &&
          (p || 0) !== n
        )
          return !1;
      }
      let b;
      if (
        (n !== (c || 0) && s && r.emit("beforeSlideChangeStart"),
        r.updateProgress(w),
        (b = n > p ? "next" : n < p ? "prev" : "reset"),
        (u && -w === r.translate) || (!u && w === r.translate))
      )
        return (
          r.updateActiveIndex(n),
          l.autoHeight && r.updateAutoHeight(),
          r.updateSlidesClasses(),
          "slide" !== l.effect && r.setTranslate(w),
          "reset" !== b && (r.transitionStart(s, b), r.transitionEnd(s, b)),
          !1
        );
      if (l.cssMode) {
        const e = r.isHorizontal(),
          s = u ? w : -w;
        if (0 === t) {
          const t = r.virtual && r.params.virtual.enabled;
          t &&
            ((r.wrapperEl.style.scrollSnapType = "none"),
            (r._immediateVirtual = !0)),
            t && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0
              ? ((r._cssModeVirtualInitialSet = !0),
                requestAnimationFrame(() => {
                  h[e ? "scrollLeft" : "scrollTop"] = s;
                }))
              : (h[e ? "scrollLeft" : "scrollTop"] = s),
            t &&
              requestAnimationFrame(() => {
                (r.wrapperEl.style.scrollSnapType = ""),
                  (r._immediateVirtual = !1);
              });
        } else {
          if (!r.support.smoothScroll)
            return (
              m({ swiper: r, targetPosition: s, side: e ? "left" : "top" }), !0
            );
          h.scrollTo({ [e ? "left" : "top"]: s, behavior: "smooth" });
        }
        return !0;
      }
      return (
        r.setTransition(t),
        r.setTranslate(w),
        r.updateActiveIndex(n),
        r.updateSlidesClasses(),
        r.emit("beforeTransitionStart", t, a),
        r.transitionStart(s, b),
        0 === t
          ? r.transitionEnd(s, b)
          : r.animating ||
            ((r.animating = !0),
            r.onSlideToWrapperTransitionEnd ||
              (r.onSlideToWrapperTransitionEnd = function (e) {
                r &&
                  !r.destroyed &&
                  e.target === this &&
                  (r.wrapperEl.removeEventListener(
                    "transitionend",
                    r.onSlideToWrapperTransitionEnd
                  ),
                  (r.onSlideToWrapperTransitionEnd = null),
                  delete r.onSlideToWrapperTransitionEnd,
                  r.transitionEnd(s, b));
              }),
            r.wrapperEl.addEventListener(
              "transitionend",
              r.onSlideToWrapperTransitionEnd
            )),
        !0
      );
    },
    slideToLoop: function (e, t, s, a) {
      if (
        (void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        "string" == typeof e)
      ) {
        e = parseInt(e, 10);
      }
      const i = this;
      let r = e;
      return (
        i.params.loop &&
          (i.virtual && i.params.virtual.enabled
            ? (r += i.virtual.slidesBefore)
            : (r = b(
                i.slides.filter(
                  (e) => 1 * e.getAttribute("data-swiper-slide-index") === r
                )[0]
              ))),
        i.slideTo(r, t, s, a)
      );
    },
    slideNext: function (e, t, s) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      const a = this,
        { enabled: i, params: r, animating: n } = a;
      if (!i) return a;
      let l = r.slidesPerGroup;
      "auto" === r.slidesPerView &&
        1 === r.slidesPerGroup &&
        r.slidesPerGroupAuto &&
        (l = Math.max(a.slidesPerViewDynamic("current", !0), 1));
      const o = a.activeIndex < r.slidesPerGroupSkip ? 1 : l,
        d = a.virtual && r.virtual.enabled;
      if (r.loop) {
        if (n && !d && r.loopPreventsSliding) return !1;
        a.loopFix({ direction: "next" }),
          (a._clientLeft = a.wrapperEl.clientLeft);
      }
      return r.rewind && a.isEnd
        ? a.slideTo(0, e, t, s)
        : a.slideTo(a.activeIndex + o, e, t, s);
    },
    slidePrev: function (e, t, s) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      const a = this,
        {
          params: i,
          snapGrid: r,
          slidesGrid: n,
          rtlTranslate: l,
          enabled: o,
          animating: d,
        } = a;
      if (!o) return a;
      const c = a.virtual && i.virtual.enabled;
      if (i.loop) {
        if (d && !c && i.loopPreventsSliding) return !1;
        a.loopFix({ direction: "prev" }),
          (a._clientLeft = a.wrapperEl.clientLeft);
      }
      function p(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
      }
      const u = p(l ? a.translate : -a.translate),
        m = r.map((e) => p(e));
      let h = r[m.indexOf(u) - 1];
      if (void 0 === h && i.cssMode) {
        let e;
        r.forEach((t, s) => {
          u >= t && (e = s);
        }),
          void 0 !== e && (h = r[e > 0 ? e - 1 : e]);
      }
      let f = 0;
      if (
        (void 0 !== h &&
          ((f = n.indexOf(h)),
          f < 0 && (f = a.activeIndex - 1),
          "auto" === i.slidesPerView &&
            1 === i.slidesPerGroup &&
            i.slidesPerGroupAuto &&
            ((f = f - a.slidesPerViewDynamic("previous", !0) + 1),
            (f = Math.max(f, 0)))),
        i.rewind && a.isBeginning)
      ) {
        const i =
          a.params.virtual && a.params.virtual.enabled && a.virtual
            ? a.virtual.slides.length - 1
            : a.slides.length - 1;
        return a.slideTo(i, e, t, s);
      }
      return a.slideTo(f, e, t, s);
    },
    slideReset: function (e, t, s) {
      return (
        void 0 === e && (e = this.params.speed),
        void 0 === t && (t = !0),
        this.slideTo(this.activeIndex, e, t, s)
      );
    },
    slideToClosest: function (e, t, s, a) {
      void 0 === e && (e = this.params.speed),
        void 0 === t && (t = !0),
        void 0 === a && (a = 0.5);
      const i = this;
      let r = i.activeIndex;
      const n = Math.min(i.params.slidesPerGroupSkip, r),
        l = n + Math.floor((r - n) / i.params.slidesPerGroup),
        o = i.rtlTranslate ? i.translate : -i.translate;
      if (o >= i.snapGrid[l]) {
        const e = i.snapGrid[l];
        o - e > (i.snapGrid[l + 1] - e) * a && (r += i.params.slidesPerGroup);
      } else {
        const e = i.snapGrid[l - 1];
        o - e <= (i.snapGrid[l] - e) * a && (r -= i.params.slidesPerGroup);
      }
      return (
        (r = Math.max(r, 0)),
        (r = Math.min(r, i.slidesGrid.length - 1)),
        i.slideTo(r, e, t, s)
      );
    },
    slideToClickedSlide: function () {
      const e = this,
        { params: t, slidesEl: s } = e,
        a =
          "auto" === t.slidesPerView
            ? e.slidesPerViewDynamic()
            : t.slidesPerView;
      let i,
        r = e.clickedIndex;
      const l = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
      if (t.loop) {
        if (e.animating) return;
        (i = parseInt(
          e.clickedSlide.getAttribute("data-swiper-slide-index"),
          10
        )),
          t.centeredSlides
            ? r < e.loopedSlides - a / 2 ||
              r > e.slides.length - e.loopedSlides + a / 2
              ? (e.loopFix(),
                (r = b(f(s, `${l}[data-swiper-slide-index="${i}"]`)[0])),
                n(() => {
                  e.slideTo(r);
                }))
              : e.slideTo(r)
            : r > e.slides.length - a
            ? (e.loopFix(),
              (r = b(f(s, `${l}[data-swiper-slide-index="${i}"]`)[0])),
              n(() => {
                e.slideTo(r);
              }))
            : e.slideTo(r);
      } else e.slideTo(r);
    },
  };
  var O = {
    loopCreate: function (e) {
      const t = this,
        { params: s, slidesEl: a } = t;
      if (!s.loop || (t.virtual && t.params.virtual.enabled)) return;
      f(a, `.${s.slideClass}, swiper-slide`).forEach((e, t) => {
        e.setAttribute("data-swiper-slide-index", t);
      }),
        t.loopFix({
          slideRealIndex: e,
          direction: s.centeredSlides ? void 0 : "next",
        });
    },
    loopFix: function (e) {
      let {
        slideRealIndex: t,
        slideTo: s = !0,
        direction: a,
        setTranslate: i,
        activeSlideIndex: r,
        byController: n,
        byMousewheel: l,
      } = void 0 === e ? {} : e;
      const o = this;
      if (!o.params.loop) return;
      o.emit("beforeLoopFix");
      const {
        slides: d,
        allowSlidePrev: c,
        allowSlideNext: p,
        slidesEl: u,
        params: m,
      } = o;
      if (
        ((o.allowSlidePrev = !0),
        (o.allowSlideNext = !0),
        o.virtual && m.virtual.enabled)
      )
        return (
          s &&
            (m.centeredSlides || 0 !== o.snapIndex
              ? m.centeredSlides && o.snapIndex < m.slidesPerView
                ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0)
                : o.snapIndex === o.snapGrid.length - 1 &&
                  o.slideTo(o.virtual.slidesBefore, 0, !1, !0)
              : o.slideTo(o.virtual.slides.length, 0, !1, !0)),
          (o.allowSlidePrev = c),
          (o.allowSlideNext = p),
          void o.emit("loopFix")
        );
      const h =
        "auto" === m.slidesPerView
          ? o.slidesPerViewDynamic()
          : Math.ceil(parseFloat(m.slidesPerView, 10));
      let f = m.loopedSlides || h;
      f % m.slidesPerGroup != 0 &&
        (f += m.slidesPerGroup - (f % m.slidesPerGroup)),
        (o.loopedSlides = f);
      const g = [],
        v = [];
      let w = o.activeIndex;
      void 0 === r
        ? (r = b(
            o.slides.filter((e) =>
              e.classList.contains("swiper-slide-active")
            )[0]
          ))
        : (w = r);
      const y = "next" === a || !a,
        E = "prev" === a || !a;
      let x = 0,
        S = 0;
      if (r < f) {
        x = f - r;
        for (let e = 0; e < f - r; e += 1) {
          const t = e - Math.floor(e / d.length) * d.length;
          g.push(d.length - t - 1);
        }
      } else if (r > o.slides.length - 2 * f) {
        S = r - (o.slides.length - 2 * f);
        for (let e = 0; e < S; e += 1) {
          const t = e - Math.floor(e / d.length) * d.length;
          v.push(t);
        }
      }
      if (
        (E &&
          g.forEach((e) => {
            u.prepend(o.slides[e]);
          }),
        y &&
          v.forEach((e) => {
            u.append(o.slides[e]);
          }),
        o.recalcSlides(),
        m.watchSlidesProgress && o.updateSlidesOffset(),
        s)
      )
        if (g.length > 0 && E)
          if (void 0 === t) {
            const e = o.slidesGrid[w],
              t = o.slidesGrid[w + x] - e;
            l
              ? o.setTranslate(o.translate - t)
              : (o.slideTo(w + x, 0, !1, !0),
                i && (o.touches[o.isHorizontal() ? "startX" : "startY"] += t));
          } else i && o.slideToLoop(t, 0, !1, !0);
        else if (v.length > 0 && y)
          if (void 0 === t) {
            const e = o.slidesGrid[w],
              t = o.slidesGrid[w - S] - e;
            l
              ? o.setTranslate(o.translate - t)
              : (o.slideTo(w - S, 0, !1, !0),
                i && (o.touches[o.isHorizontal() ? "startX" : "startY"] += t));
          } else o.slideToLoop(t, 0, !1, !0);
      if (
        ((o.allowSlidePrev = c),
        (o.allowSlideNext = p),
        o.controller && o.controller.control && !n)
      ) {
        const e = {
          slideRealIndex: t,
          slideTo: !1,
          direction: a,
          setTranslate: i,
          activeSlideIndex: r,
          byController: !0,
        };
        Array.isArray(o.controller.control)
          ? o.controller.control.forEach((t) => {
              t.params.loop && t.loopFix(e);
            })
          : o.controller.control instanceof o.constructor &&
            o.controller.control.params.loop &&
            o.controller.control.loopFix(e);
      }
      o.emit("loopFix");
    },
    loopDestroy: function () {
      const e = this,
        { slides: t, params: s, slidesEl: a } = e;
      if (!s.loop || (e.virtual && e.params.virtual.enabled)) return;
      e.recalcSlides();
      const i = [];
      t.forEach((e) => {
        const t =
          void 0 === e.swiperSlideIndex
            ? 1 * e.getAttribute("data-swiper-slide-index")
            : e.swiperSlideIndex;
        i[t] = e;
      }),
        t.forEach((e) => {
          e.removeAttribute("data-swiper-slide-index");
        }),
        i.forEach((e) => {
          a.append(e);
        }),
        e.recalcSlides(),
        e.slideTo(e.realIndex, 0);
    },
  };
  function D(e) {
    const t = this,
      s = a(),
      i = r(),
      n = t.touchEventsData;
    n.evCache.push(e);
    const { params: o, touches: d, enabled: c } = t;
    if (!c) return;
    if (!o.simulateTouch && "mouse" === e.pointerType) return;
    if (t.animating && o.preventInteractionOnTransition) return;
    !t.animating && o.cssMode && o.loop && t.loopFix();
    let p = e;
    p.originalEvent && (p = p.originalEvent);
    let u = p.target;
    if ("wrapper" === o.touchEventsTarget && !t.wrapperEl.contains(u)) return;
    if ("which" in p && 3 === p.which) return;
    if ("button" in p && p.button > 0) return;
    if (n.isTouched && n.isMoved) return;
    const m = !!o.noSwipingClass && "" !== o.noSwipingClass,
      h = e.composedPath ? e.composedPath() : e.path;
    m && p.target && p.target.shadowRoot && h && (u = h[0]);
    const f = o.noSwipingSelector
        ? o.noSwipingSelector
        : `.${o.noSwipingClass}`,
      g = !(!p.target || !p.target.shadowRoot);
    if (
      o.noSwiping &&
      (g
        ? (function (e, t) {
            return (
              void 0 === t && (t = this),
              (function t(s) {
                if (!s || s === a() || s === r()) return null;
                s.assignedSlot && (s = s.assignedSlot);
                const i = s.closest(e);
                return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
              })(t)
            );
          })(f, u)
        : u.closest(f))
    )
      return void (t.allowClick = !0);
    if (o.swipeHandler && !u.closest(o.swipeHandler)) return;
    (d.currentX = p.pageX), (d.currentY = p.pageY);
    const v = d.currentX,
      w = d.currentY,
      b = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
      y = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
    if (b && (v <= y || v >= i.innerWidth - y)) {
      if ("prevent" !== b) return;
      e.preventDefault();
    }
    Object.assign(n, {
      isTouched: !0,
      isMoved: !1,
      allowTouchCallbacks: !0,
      isScrolling: void 0,
      startMoving: void 0,
    }),
      (d.startX = v),
      (d.startY = w),
      (n.touchStartTime = l()),
      (t.allowClick = !0),
      t.updateSize(),
      (t.swipeDirection = void 0),
      o.threshold > 0 && (n.allowThresholdMove = !1);
    let E = !0;
    u.matches(n.focusableElements) &&
      ((E = !1), "SELECT" === u.nodeName && (n.isTouched = !1)),
      s.activeElement &&
        s.activeElement.matches(n.focusableElements) &&
        s.activeElement !== u &&
        s.activeElement.blur();
    const x = E && t.allowTouchMove && o.touchStartPreventDefault;
    (!o.touchStartForcePreventDefault && !x) ||
      u.isContentEditable ||
      p.preventDefault(),
      t.params.freeMode &&
        t.params.freeMode.enabled &&
        t.freeMode &&
        t.animating &&
        !o.cssMode &&
        t.freeMode.onTouchStart(),
      t.emit("touchStart", p);
  }
  function G(e) {
    const t = a(),
      s = this,
      i = s.touchEventsData,
      { params: r, touches: n, rtlTranslate: o, enabled: d } = s;
    if (!d) return;
    if (!r.simulateTouch && "mouse" === e.pointerType) return;
    let c = e;
    if ((c.originalEvent && (c = c.originalEvent), !i.isTouched))
      return void (
        i.startMoving &&
        i.isScrolling &&
        s.emit("touchMoveOpposite", c)
      );
    const p = i.evCache.findIndex((e) => e.pointerId === c.pointerId);
    p >= 0 && (i.evCache[p] = c);
    const u = i.evCache.length > 1 ? i.evCache[0] : c,
      m = u.pageX,
      h = u.pageY;
    if (c.preventedByNestedSwiper) return (n.startX = m), void (n.startY = h);
    if (!s.allowTouchMove)
      return (
        c.target.matches(i.focusableElements) || (s.allowClick = !1),
        void (
          i.isTouched &&
          (Object.assign(n, {
            startX: m,
            startY: h,
            prevX: s.touches.currentX,
            prevY: s.touches.currentY,
            currentX: m,
            currentY: h,
          }),
          (i.touchStartTime = l()))
        )
      );
    if (r.touchReleaseOnEdges && !r.loop)
      if (s.isVertical()) {
        if (
          (h < n.startY && s.translate <= s.maxTranslate()) ||
          (h > n.startY && s.translate >= s.minTranslate())
        )
          return (i.isTouched = !1), void (i.isMoved = !1);
      } else if (
        (m < n.startX && s.translate <= s.maxTranslate()) ||
        (m > n.startX && s.translate >= s.minTranslate())
      )
        return;
    if (
      t.activeElement &&
      c.target === t.activeElement &&
      c.target.matches(i.focusableElements)
    )
      return (i.isMoved = !0), void (s.allowClick = !1);
    if (
      (i.allowTouchCallbacks && s.emit("touchMove", c),
      c.targetTouches && c.targetTouches.length > 1)
    )
      return;
    (n.currentX = m), (n.currentY = h);
    const f = n.currentX - n.startX,
      g = n.currentY - n.startY;
    if (s.params.threshold && Math.sqrt(f ** 2 + g ** 2) < s.params.threshold)
      return;
    if (void 0 === i.isScrolling) {
      let e;
      (s.isHorizontal() && n.currentY === n.startY) ||
      (s.isVertical() && n.currentX === n.startX)
        ? (i.isScrolling = !1)
        : f * f + g * g >= 25 &&
          ((e = (180 * Math.atan2(Math.abs(g), Math.abs(f))) / Math.PI),
          (i.isScrolling = s.isHorizontal()
            ? e > r.touchAngle
            : 90 - e > r.touchAngle));
    }
    if (
      (i.isScrolling && s.emit("touchMoveOpposite", c),
      void 0 === i.startMoving &&
        ((n.currentX === n.startX && n.currentY === n.startY) ||
          (i.startMoving = !0)),
      i.isScrolling ||
        (s.zoom &&
          s.params.zoom &&
          s.params.zoom.enabled &&
          i.evCache.length > 1))
    )
      return void (i.isTouched = !1);
    if (!i.startMoving) return;
    (s.allowClick = !1),
      !r.cssMode && c.cancelable && c.preventDefault(),
      r.touchMoveStopPropagation && !r.nested && c.stopPropagation();
    let v = s.isHorizontal() ? f : g,
      w = s.isHorizontal()
        ? n.currentX - n.previousX
        : n.currentY - n.previousY;
    r.oneWayMovement &&
      ((v = Math.abs(v) * (o ? 1 : -1)), (w = Math.abs(w) * (o ? 1 : -1))),
      (n.diff = v),
      (v *= r.touchRatio),
      o && ((v = -v), (w = -w));
    const b = s.touchesDirection;
    (s.swipeDirection = v > 0 ? "prev" : "next"),
      (s.touchesDirection = w > 0 ? "prev" : "next");
    const y = s.params.loop && !r.cssMode;
    if (!i.isMoved) {
      if (
        (y && s.loopFix({ direction: s.swipeDirection }),
        (i.startTranslate = s.getTranslate()),
        s.setTransition(0),
        s.animating)
      ) {
        const e = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0,
        });
        s.wrapperEl.dispatchEvent(e);
      }
      (i.allowMomentumBounce = !1),
        !r.grabCursor ||
          (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) ||
          s.setGrabCursor(!0),
        s.emit("sliderFirstMove", c);
    }
    let E;
    i.isMoved &&
      b !== s.touchesDirection &&
      y &&
      Math.abs(v) >= 1 &&
      (s.loopFix({ direction: s.swipeDirection, setTranslate: !0 }), (E = !0)),
      s.emit("sliderMove", c),
      (i.isMoved = !0),
      (i.currentTranslate = v + i.startTranslate);
    let x = !0,
      S = r.resistanceRatio;
    if (
      (r.touchReleaseOnEdges && (S = 0),
      v > 0
        ? (y &&
            !E &&
            i.currentTranslate >
              (r.centeredSlides
                ? s.minTranslate() - s.size / 2
                : s.minTranslate()) &&
            s.loopFix({
              direction: "prev",
              setTranslate: !0,
              activeSlideIndex: 0,
            }),
          i.currentTranslate > s.minTranslate() &&
            ((x = !1),
            r.resistance &&
              (i.currentTranslate =
                s.minTranslate() -
                1 +
                (-s.minTranslate() + i.startTranslate + v) ** S)))
        : v < 0 &&
          (y &&
            !E &&
            i.currentTranslate <
              (r.centeredSlides
                ? s.maxTranslate() + s.size / 2
                : s.maxTranslate()) &&
            s.loopFix({
              direction: "next",
              setTranslate: !0,
              activeSlideIndex:
                s.slides.length -
                ("auto" === r.slidesPerView
                  ? s.slidesPerViewDynamic()
                  : Math.ceil(parseFloat(r.slidesPerView, 10))),
            }),
          i.currentTranslate < s.maxTranslate() &&
            ((x = !1),
            r.resistance &&
              (i.currentTranslate =
                s.maxTranslate() +
                1 -
                (s.maxTranslate() - i.startTranslate - v) ** S))),
      x && (c.preventedByNestedSwiper = !0),
      !s.allowSlideNext &&
        "next" === s.swipeDirection &&
        i.currentTranslate < i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      !s.allowSlidePrev &&
        "prev" === s.swipeDirection &&
        i.currentTranslate > i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      s.allowSlidePrev ||
        s.allowSlideNext ||
        (i.currentTranslate = i.startTranslate),
      r.threshold > 0)
    ) {
      if (!(Math.abs(v) > r.threshold || i.allowThresholdMove))
        return void (i.currentTranslate = i.startTranslate);
      if (!i.allowThresholdMove)
        return (
          (i.allowThresholdMove = !0),
          (n.startX = n.currentX),
          (n.startY = n.currentY),
          (i.currentTranslate = i.startTranslate),
          void (n.diff = s.isHorizontal()
            ? n.currentX - n.startX
            : n.currentY - n.startY)
        );
    }
    r.followFinger &&
      !r.cssMode &&
      (((r.freeMode && r.freeMode.enabled && s.freeMode) ||
        r.watchSlidesProgress) &&
        (s.updateActiveIndex(), s.updateSlidesClasses()),
      s.params.freeMode &&
        r.freeMode.enabled &&
        s.freeMode &&
        s.freeMode.onTouchMove(),
      s.updateProgress(i.currentTranslate),
      s.setTranslate(i.currentTranslate));
  }
  function B(e) {
    const t = this,
      s = t.touchEventsData,
      a = s.evCache.findIndex((t) => t.pointerId === e.pointerId);
    if (
      (a >= 0 && s.evCache.splice(a, 1),
      ["pointercancel", "pointerout", "pointerleave"].includes(e.type))
    )
      return;
    const {
      params: i,
      touches: r,
      rtlTranslate: o,
      slidesGrid: d,
      enabled: c,
    } = t;
    if (!c) return;
    if (!i.simulateTouch && "mouse" === e.pointerType) return;
    let p = e;
    if (
      (p.originalEvent && (p = p.originalEvent),
      s.allowTouchCallbacks && t.emit("touchEnd", p),
      (s.allowTouchCallbacks = !1),
      !s.isTouched)
    )
      return (
        s.isMoved && i.grabCursor && t.setGrabCursor(!1),
        (s.isMoved = !1),
        void (s.startMoving = !1)
      );
    i.grabCursor &&
      s.isMoved &&
      s.isTouched &&
      (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
      t.setGrabCursor(!1);
    const u = l(),
      m = u - s.touchStartTime;
    if (t.allowClick) {
      const e = p.path || (p.composedPath && p.composedPath());
      t.updateClickedSlide((e && e[0]) || p.target),
        t.emit("tap click", p),
        m < 300 &&
          u - s.lastClickTime < 300 &&
          t.emit("doubleTap doubleClick", p);
    }
    if (
      ((s.lastClickTime = l()),
      n(() => {
        t.destroyed || (t.allowClick = !0);
      }),
      !s.isTouched ||
        !s.isMoved ||
        !t.swipeDirection ||
        0 === r.diff ||
        s.currentTranslate === s.startTranslate)
    )
      return (s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1);
    let h;
    if (
      ((s.isTouched = !1),
      (s.isMoved = !1),
      (s.startMoving = !1),
      (h = i.followFinger
        ? o
          ? t.translate
          : -t.translate
        : -s.currentTranslate),
      i.cssMode)
    )
      return;
    if (t.params.freeMode && i.freeMode.enabled)
      return void t.freeMode.onTouchEnd({ currentPos: h });
    let f = 0,
      g = t.slidesSizesGrid[0];
    for (
      let e = 0;
      e < d.length;
      e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
    ) {
      const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
      void 0 !== d[e + t]
        ? h >= d[e] && h < d[e + t] && ((f = e), (g = d[e + t] - d[e]))
        : h >= d[e] && ((f = e), (g = d[d.length - 1] - d[d.length - 2]));
    }
    let v = null,
      w = null;
    i.rewind &&
      (t.isBeginning
        ? (w =
            t.params.virtual && t.params.virtual.enabled && t.virtual
              ? t.virtual.slides.length - 1
              : t.slides.length - 1)
        : t.isEnd && (v = 0));
    const b = (h - d[f]) / g,
      y = f < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    if (m > i.longSwipesMs) {
      if (!i.longSwipes) return void t.slideTo(t.activeIndex);
      "next" === t.swipeDirection &&
        (b >= i.longSwipesRatio
          ? t.slideTo(i.rewind && t.isEnd ? v : f + y)
          : t.slideTo(f)),
        "prev" === t.swipeDirection &&
          (b > 1 - i.longSwipesRatio
            ? t.slideTo(f + y)
            : null !== w && b < 0 && Math.abs(b) > i.longSwipesRatio
            ? t.slideTo(w)
            : t.slideTo(f));
    } else {
      if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
      t.navigation &&
      (p.target === t.navigation.nextEl || p.target === t.navigation.prevEl)
        ? p.target === t.navigation.nextEl
          ? t.slideTo(f + y)
          : t.slideTo(f)
        : ("next" === t.swipeDirection && t.slideTo(null !== v ? v : f + y),
          "prev" === t.swipeDirection && t.slideTo(null !== w ? w : f));
    }
  }
  let H;
  function X() {
    const e = this,
      { params: t, el: s } = e;
    if (s && 0 === s.offsetWidth) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: a, allowSlidePrev: i, snapGrid: r } = e,
      n = e.virtual && e.params.virtual.enabled;
    (e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses();
    const l = n && t.loop;
    !("auto" === t.slidesPerView || t.slidesPerView > 1) ||
    !e.isEnd ||
    e.isBeginning ||
    e.params.centeredSlides ||
    l
      ? e.params.loop && !n
        ? e.slideToLoop(e.realIndex, 0, !1, !0)
        : e.slideTo(e.activeIndex, 0, !1, !0)
      : e.slideTo(e.slides.length - 1, 0, !1, !0),
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        (clearTimeout(H),
        (H = setTimeout(() => {
          e.autoplay.resume();
        }, 500))),
      (e.allowSlidePrev = i),
      (e.allowSlideNext = a),
      e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
  }
  function Y(e) {
    const t = this;
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation &&
          t.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function N() {
    const e = this,
      { wrapperEl: t, rtlTranslate: s, enabled: a } = e;
    if (!a) return;
    let i;
    (e.previousTranslate = e.translate),
      e.isHorizontal()
        ? (e.translate = -t.scrollLeft)
        : (e.translate = -t.scrollTop),
      0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses();
    const r = e.maxTranslate() - e.minTranslate();
    (i = 0 === r ? 0 : (e.translate - e.minTranslate()) / r),
      i !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
      e.emit("setTranslate", e.translate, !1);
  }
  const R = (e, t) => {
    if (!e || e.destroyed || !e.params) return;
    const s = t.closest(
      e.isElement ? "swiper-slide" : `.${e.params.slideClass}`
    );
    if (s) {
      const t = s.querySelector(`.${e.params.lazyPreloaderClass}`);
      t && t.remove();
    }
  };
  function q(e) {
    R(this, e.target), this.update();
  }
  let V = !1;
  function F() {}
  const W = (e, t) => {
    const s = a(),
      { params: i, el: r, wrapperEl: n, device: l } = e,
      o = !!i.nested,
      d = "on" === t ? "addEventListener" : "removeEventListener",
      c = t;
    r[d]("pointerdown", e.onTouchStart, { passive: !1 }),
      s[d]("pointermove", e.onTouchMove, { passive: !1, capture: o }),
      s[d]("pointerup", e.onTouchEnd, { passive: !0 }),
      s[d]("pointercancel", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerout", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerleave", e.onTouchEnd, { passive: !0 }),
      (i.preventClicks || i.preventClicksPropagation) &&
        r[d]("click", e.onClick, !0),
      i.cssMode && n[d]("scroll", e.onScroll),
      i.updateOnWindowResize
        ? e[c](
            l.ios || l.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            X,
            !0
          )
        : e[c]("observerUpdate", X, !0),
      r[d]("load", e.onLoad, { capture: !0 });
  };
  const j = (e, t) => e.grid && t.grid && t.grid.rows > 1;
  var _ = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopedSlides: null,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  function U(e, t) {
    return function (s) {
      void 0 === s && (s = {});
      const a = Object.keys(s)[0],
        i = s[a];
      "object" == typeof i && null !== i
        ? (["navigation", "pagination", "scrollbar"].indexOf(a) >= 0 &&
            !0 === e[a] &&
            (e[a] = { auto: !0 }),
          a in e && "enabled" in i
            ? (!0 === e[a] && (e[a] = { enabled: !0 }),
              "object" != typeof e[a] ||
                "enabled" in e[a] ||
                (e[a].enabled = !0),
              e[a] || (e[a] = { enabled: !1 }),
              p(t, s))
            : p(t, s))
        : p(t, s);
    };
  }
  const K = {
      eventsEmitter: A,
      update: z,
      translate: $,
      transition: {
        setTransition: function (e, t) {
          const s = this;
          s.params.cssMode || (s.wrapperEl.style.transitionDuration = `${e}ms`),
            s.emit("setTransition", e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          const s = this,
            { params: a } = s;
          a.cssMode ||
            (a.autoHeight && s.updateAutoHeight(),
            k({ swiper: s, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          const s = this,
            { params: a } = s;
          (s.animating = !1),
            a.cssMode ||
              (s.setTransition(0),
              k({ swiper: s, runCallbacks: e, direction: t, step: "End" }));
        },
      },
      slide: I,
      loop: O,
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this;
          if (
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const s =
            "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          (s.style.cursor = "move"), (s.style.cursor = e ? "grabbing" : "grab");
        },
        unsetGrabCursor: function () {
          const e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = "");
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            t = a(),
            { params: s } = e;
          (e.onTouchStart = D.bind(e)),
            (e.onTouchMove = G.bind(e)),
            (e.onTouchEnd = B.bind(e)),
            s.cssMode && (e.onScroll = N.bind(e)),
            (e.onClick = Y.bind(e)),
            (e.onLoad = q.bind(e)),
            V || (t.addEventListener("touchstart", F), (V = !0)),
            W(e, "on");
        },
        detachEvents: function () {
          W(this, "off");
        },
      },
      breakpoints: {
        setBreakpoint: function () {
          const e = this,
            { realIndex: t, initialized: s, params: a, el: i } = e,
            r = a.breakpoints;
          if (!r || (r && 0 === Object.keys(r).length)) return;
          const n = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
          if (!n || e.currentBreakpoint === n) return;
          const l = (n in r ? r[n] : void 0) || e.originalParams,
            o = j(e, a),
            d = j(e, l),
            c = a.enabled;
          o && !d
            ? (i.classList.remove(
                `${a.containerModifierClass}grid`,
                `${a.containerModifierClass}grid-column`
              ),
              e.emitContainerClasses())
            : !o &&
              d &&
              (i.classList.add(`${a.containerModifierClass}grid`),
              ((l.grid.fill && "column" === l.grid.fill) ||
                (!l.grid.fill && "column" === a.grid.fill)) &&
                i.classList.add(`${a.containerModifierClass}grid-column`),
              e.emitContainerClasses()),
            ["navigation", "pagination", "scrollbar"].forEach((t) => {
              const s = a[t] && a[t].enabled,
                i = l[t] && l[t].enabled;
              s && !i && e[t].disable(), !s && i && e[t].enable();
            });
          const u = l.direction && l.direction !== a.direction,
            m = a.loop && (l.slidesPerView !== a.slidesPerView || u);
          u && s && e.changeDirection(), p(e.params, l);
          const h = e.params.enabled;
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            c && !h ? e.disable() : !c && h && e.enable(),
            (e.currentBreakpoint = n),
            e.emit("_beforeBreakpoint", l),
            m && s && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()),
            e.emit("breakpoint", l);
        },
        getBreakpoint: function (e, t, s) {
          if ((void 0 === t && (t = "window"), !e || ("container" === t && !s)))
            return;
          let a = !1;
          const i = r(),
            n = "window" === t ? i.innerHeight : s.clientHeight,
            l = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1));
                return { value: n * t, point: e };
              }
              return { value: e, point: e };
            });
          l.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < l.length; e += 1) {
            const { point: r, value: n } = l[e];
            "window" === t
              ? i.matchMedia(`(min-width: ${n}px)`).matches && (a = r)
              : n <= s.clientWidth && (a = r);
          }
          return a || "max";
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: s } = e,
            { slidesOffsetBefore: a } = s;
          if (a) {
            const t = e.slides.length - 1,
              s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * a;
            e.isLocked = e.size > s;
          } else e.isLocked = 1 === e.snapGrid.length;
          !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
        },
      },
      classes: {
        addClasses: function () {
          const e = this,
            { classNames: t, params: s, rtl: a, el: i, device: r } = e,
            n = (function (e, t) {
              const s = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((a) => {
                        e[a] && s.push(t + a);
                      })
                    : "string" == typeof e && s.push(t + e);
                }),
                s
              );
            })(
              [
                "initialized",
                s.direction,
                { "free-mode": e.params.freeMode && s.freeMode.enabled },
                { autoheight: s.autoHeight },
                { rtl: a },
                { grid: s.grid && s.grid.rows > 1 },
                {
                  "grid-column":
                    s.grid && s.grid.rows > 1 && "column" === s.grid.fill,
                },
                { android: r.android },
                { ios: r.ios },
                { "css-mode": s.cssMode },
                { centered: s.cssMode && s.centeredSlides },
                { "watch-progress": s.watchSlidesProgress },
              ],
              s.containerModifierClass
            );
          t.push(...n), i.classList.add(...t), e.emitContainerClasses();
        },
        removeClasses: function () {
          const { el: e, classNames: t } = this;
          e.classList.remove(...t), this.emitContainerClasses();
        },
      },
    },
    Z = {};
  class Q {
    constructor() {
      let e, t;
      for (var s = arguments.length, i = new Array(s), r = 0; r < s; r++)
        i[r] = arguments[r];
      1 === i.length &&
      i[0].constructor &&
      "Object" === Object.prototype.toString.call(i[0]).slice(8, -1)
        ? (t = i[0])
        : ([e, t] = i),
        t || (t = {}),
        (t = p({}, t)),
        e && !t.el && (t.el = e);
      const n = a();
      if (
        t.el &&
        "string" == typeof t.el &&
        n.querySelectorAll(t.el).length > 1
      ) {
        const e = [];
        return (
          n.querySelectorAll(t.el).forEach((s) => {
            const a = p({}, t, { el: s });
            e.push(new Q(a));
          }),
          e
        );
      }
      const o = this;
      (o.__swiper__ = !0),
        (o.support = C()),
        (o.device = P({ userAgent: t.userAgent })),
        (o.browser = L()),
        (o.eventsListeners = {}),
        (o.eventsAnyListeners = []),
        (o.modules = [...o.__modules__]),
        t.modules && Array.isArray(t.modules) && o.modules.push(...t.modules);
      const d = {};
      o.modules.forEach((e) => {
        e({
          params: t,
          swiper: o,
          extendParams: U(t, d),
          on: o.on.bind(o),
          once: o.once.bind(o),
          off: o.off.bind(o),
          emit: o.emit.bind(o),
        });
      });
      const c = p({}, _, d);
      return (
        (o.params = p({}, c, Z, t)),
        (o.originalParams = p({}, o.params)),
        (o.passedParams = p({}, t)),
        o.params &&
          o.params.on &&
          Object.keys(o.params.on).forEach((e) => {
            o.on(e, o.params.on[e]);
          }),
        o.params && o.params.onAny && o.onAny(o.params.onAny),
        Object.assign(o, {
          enabled: o.params.enabled,
          el: e,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === o.params.direction,
          isVertical: () => "vertical" === o.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          allowSlideNext: o.params.allowSlideNext,
          allowSlidePrev: o.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: o.params.focusableElements,
            lastClickTime: l(),
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            evCache: [],
          },
          allowClick: !0,
          allowTouchMove: o.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        o.emit("_swiper"),
        o.params.init && o.init(),
        o
      );
    }
    recalcSlides() {
      const { slidesEl: e, params: t } = this;
      this.slides = f(e, `.${t.slideClass}, swiper-slide`);
    }
    enable() {
      const e = this;
      e.enabled ||
        ((e.enabled = !0),
        e.params.grabCursor && e.setGrabCursor(),
        e.emit("enable"));
    }
    disable() {
      const e = this;
      e.enabled &&
        ((e.enabled = !1),
        e.params.grabCursor && e.unsetGrabCursor(),
        e.emit("disable"));
    }
    setProgress(e, t) {
      const s = this;
      e = Math.min(Math.max(e, 0), 1);
      const a = s.minTranslate(),
        i = (s.maxTranslate() - a) * e + a;
      s.translateTo(i, void 0 === t ? 0 : t),
        s.updateActiveIndex(),
        s.updateSlidesClasses();
    }
    emitContainerClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = e.el.className
        .split(" ")
        .filter(
          (t) =>
            0 === t.indexOf("swiper") ||
            0 === t.indexOf(e.params.containerModifierClass)
        );
      e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
      const t = this;
      return t.destroyed
        ? ""
        : e.className
            .split(" ")
            .filter(
              (e) =>
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
            )
            .join(" ");
    }
    emitSlidesClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = [];
      e.slides.forEach((s) => {
        const a = e.getSlideClasses(s);
        t.push({ slideEl: s, classNames: a }), e.emit("_slideClass", s, a);
      }),
        e.emit("_slideClasses", t);
    }
    slidesPerViewDynamic(e, t) {
      void 0 === e && (e = "current"), void 0 === t && (t = !1);
      const {
        params: s,
        slides: a,
        slidesGrid: i,
        slidesSizesGrid: r,
        size: n,
        activeIndex: l,
      } = this;
      let o = 1;
      if (s.centeredSlides) {
        let e,
          t = a[l].swiperSlideSize;
        for (let s = l + 1; s < a.length; s += 1)
          a[s] &&
            !e &&
            ((t += a[s].swiperSlideSize), (o += 1), t > n && (e = !0));
        for (let s = l - 1; s >= 0; s -= 1)
          a[s] &&
            !e &&
            ((t += a[s].swiperSlideSize), (o += 1), t > n && (e = !0));
      } else if ("current" === e)
        for (let e = l + 1; e < a.length; e += 1) {
          (t ? i[e] + r[e] - i[l] < n : i[e] - i[l] < n) && (o += 1);
        }
      else
        for (let e = l - 1; e >= 0; e -= 1) {
          i[l] - i[e] < n && (o += 1);
        }
      return o;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: t, params: s } = e;
      function a() {
        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
          s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
        e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
      }
      let i;
      s.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
          t.complete && R(e, t);
        }),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        e.params.freeMode && e.params.freeMode.enabled
          ? (a(), e.params.autoHeight && e.updateAutoHeight())
          : ((i =
              ("auto" === e.params.slidesPerView ||
                e.params.slidesPerView > 1) &&
              e.isEnd &&
              !e.params.centeredSlides
                ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                : e.slideTo(e.activeIndex, 0, !1, !0)),
            i || a()),
        s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
        e.emit("update");
    }
    changeDirection(e, t) {
      void 0 === t && (t = !0);
      const s = this,
        a = s.params.direction;
      return (
        e || (e = "horizontal" === a ? "vertical" : "horizontal"),
        e === a ||
          ("horizontal" !== e && "vertical" !== e) ||
          (s.el.classList.remove(`${s.params.containerModifierClass}${a}`),
          s.el.classList.add(`${s.params.containerModifierClass}${e}`),
          s.emitContainerClasses(),
          (s.params.direction = e),
          s.slides.forEach((t) => {
            "vertical" === e ? (t.style.width = "") : (t.style.height = "");
          }),
          s.emit("changeDirection"),
          t && s.update()),
        s
      );
    }
    changeLanguageDirection(e) {
      const t = this;
      (t.rtl && "rtl" === e) ||
        (!t.rtl && "ltr" === e) ||
        ((t.rtl = "rtl" === e),
        (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = "rtl"))
          : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = "ltr")),
        t.update());
    }
    mount(e) {
      const t = this;
      if (t.mounted) return !0;
      let s = e || t.params.el;
      if (("string" == typeof s && (s = document.querySelector(s)), !s))
        return !1;
      (s.swiper = t), s.shadowEl && (t.isElement = !0);
      const a = () =>
        `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let i = (() => {
        if (s && s.shadowRoot && s.shadowRoot.querySelector) {
          return s.shadowRoot.querySelector(a());
        }
        return f(s, a())[0];
      })();
      return (
        !i &&
          t.params.createElements &&
          ((i = g("div", t.params.wrapperClass)),
          s.append(i),
          f(s, `.${t.params.slideClass}`).forEach((e) => {
            i.append(e);
          })),
        Object.assign(t, {
          el: s,
          wrapperEl: i,
          slidesEl: t.isElement ? s : i,
          mounted: !0,
          rtl: "rtl" === s.dir.toLowerCase() || "rtl" === w(s, "direction"),
          rtlTranslate:
            "horizontal" === t.params.direction &&
            ("rtl" === s.dir.toLowerCase() || "rtl" === w(s, "direction")),
          wrongRTL: "-webkit-box" === w(i, "display"),
        }),
        !0
      );
    }
    init(e) {
      const t = this;
      if (t.initialized) return t;
      return (
        !1 === t.mount(e) ||
          (t.emit("beforeInit"),
          t.params.breakpoints && t.setBreakpoint(),
          t.addClasses(),
          t.updateSize(),
          t.updateSlides(),
          t.params.watchOverflow && t.checkOverflow(),
          t.params.grabCursor && t.enabled && t.setGrabCursor(),
          t.params.loop && t.virtual && t.params.virtual.enabled
            ? t.slideTo(
                t.params.initialSlide + t.virtual.slidesBefore,
                0,
                t.params.runCallbacksOnInit,
                !1,
                !0
              )
            : t.slideTo(
                t.params.initialSlide,
                0,
                t.params.runCallbacksOnInit,
                !1,
                !0
              ),
          t.params.loop && t.loopCreate(),
          t.attachEvents(),
          [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
            e.complete
              ? R(t, e)
              : e.addEventListener("load", (e) => {
                  R(t, e.target);
                });
          }),
          (t.initialized = !0),
          t.emit("init"),
          t.emit("afterInit")),
        t
      );
    }
    destroy(e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0);
      const s = this,
        { params: a, el: i, wrapperEl: r, slides: n } = s;
      return (
        void 0 === s.params ||
          s.destroyed ||
          (s.emit("beforeDestroy"),
          (s.initialized = !1),
          s.detachEvents(),
          a.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            i.removeAttribute("style"),
            r.removeAttribute("style"),
            n &&
              n.length &&
              n.forEach((e) => {
                e.classList.remove(
                  a.slideVisibleClass,
                  a.slideActiveClass,
                  a.slideNextClass,
                  a.slidePrevClass
                ),
                  e.removeAttribute("style"),
                  e.removeAttribute("data-swiper-slide-index");
              })),
          s.emit("destroy"),
          Object.keys(s.eventsListeners).forEach((e) => {
            s.off(e);
          }),
          !1 !== e &&
            ((s.el.swiper = null),
            (function (e) {
              const t = e;
              Object.keys(t).forEach((e) => {
                try {
                  t[e] = null;
                } catch (e) {}
                try {
                  delete t[e];
                } catch (e) {}
              });
            })(s)),
          (s.destroyed = !0)),
        null
      );
    }
    static extendDefaults(e) {
      p(Z, e);
    }
    static get extendedDefaults() {
      return Z;
    }
    static get defaults() {
      return _;
    }
    static installModule(e) {
      Q.prototype.__modules__ || (Q.prototype.__modules__ = []);
      const t = Q.prototype.__modules__;
      "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return Array.isArray(e)
        ? (e.forEach((e) => Q.installModule(e)), Q)
        : (Q.installModule(e), Q);
    }
  }
  function J(e, t, s, a) {
    return (
      e.params.createElements &&
        Object.keys(a).forEach((i) => {
          if (!s[i] && !0 === s.auto) {
            let r = f(e.el, `.${a[i]}`)[0];
            r || ((r = g("div", a[i])), (r.className = a[i]), e.el.append(r)),
              (s[i] = r),
              (t[i] = r);
          }
        }),
      s
    );
  }
  function ee(e) {
    return (
      void 0 === e && (e = ""),
      `.${e
        .trim()
        .replace(/([\.:!\/])/g, "\\$1")
        .replace(/ /g, ".")}`
    );
  }
  function te(e) {
    const t = this,
      { params: s, slidesEl: a } = t;
    s.loop && t.loopDestroy();
    const i = (e) => {
      if ("string" == typeof e) {
        const t = document.createElement("div");
        (t.innerHTML = e), a.append(t.children[0]), (t.innerHTML = "");
      } else a.append(e);
    };
    if ("object" == typeof e && "length" in e)
      for (let t = 0; t < e.length; t += 1) e[t] && i(e[t]);
    else i(e);
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update();
  }
  function se(e) {
    const t = this,
      { params: s, activeIndex: a, slidesEl: i } = t;
    s.loop && t.loopDestroy();
    let r = a + 1;
    const n = (e) => {
      if ("string" == typeof e) {
        const t = document.createElement("div");
        (t.innerHTML = e), i.prepend(t.children[0]), (t.innerHTML = "");
      } else i.prepend(e);
    };
    if ("object" == typeof e && "length" in e) {
      for (let t = 0; t < e.length; t += 1) e[t] && n(e[t]);
      r = a + e.length;
    } else n(e);
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      t.slideTo(r, 0, !1);
  }
  function ae(e, t) {
    const s = this,
      { params: a, activeIndex: i, slidesEl: r } = s;
    let n = i;
    a.loop && ((n -= s.loopedSlides), s.loopDestroy(), s.recalcSlides());
    const l = s.slides.length;
    if (e <= 0) return void s.prependSlide(t);
    if (e >= l) return void s.appendSlide(t);
    let o = n > e ? n + 1 : n;
    const d = [];
    for (let t = l - 1; t >= e; t -= 1) {
      const e = s.slides[t];
      e.remove(), d.unshift(e);
    }
    if ("object" == typeof t && "length" in t) {
      for (let e = 0; e < t.length; e += 1) t[e] && r.append(t[e]);
      o = n > e ? n + t.length : n;
    } else r.append(t);
    for (let e = 0; e < d.length; e += 1) r.append(d[e]);
    s.recalcSlides(),
      a.loop && s.loopCreate(),
      (a.observer && !s.isElement) || s.update(),
      a.loop ? s.slideTo(o + s.loopedSlides, 0, !1) : s.slideTo(o, 0, !1);
  }
  function ie(e) {
    const t = this,
      { params: s, activeIndex: a } = t;
    let i = a;
    s.loop && ((i -= t.loopedSlides), t.loopDestroy());
    let r,
      n = i;
    if ("object" == typeof e && "length" in e) {
      for (let s = 0; s < e.length; s += 1)
        (r = e[s]), t.slides[r] && t.slides[r].remove(), r < n && (n -= 1);
      n = Math.max(n, 0);
    } else (r = e), t.slides[r] && t.slides[r].remove(), r < n && (n -= 1), (n = Math.max(n, 0));
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      s.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
  }
  function re() {
    const e = this,
      t = [];
    for (let s = 0; s < e.slides.length; s += 1) t.push(s);
    e.removeSlide(t);
  }
  function ne(e) {
    const {
      effect: t,
      swiper: s,
      on: a,
      setTranslate: i,
      setTransition: r,
      overwriteParams: n,
      perspective: l,
      recreateShadows: o,
      getEffectParams: d,
    } = e;
    let c;
    a("beforeInit", () => {
      if (s.params.effect !== t) return;
      s.classNames.push(`${s.params.containerModifierClass}${t}`),
        l && l() && s.classNames.push(`${s.params.containerModifierClass}3d`);
      const e = n ? n() : {};
      Object.assign(s.params, e), Object.assign(s.originalParams, e);
    }),
      a("setTranslate", () => {
        s.params.effect === t && i();
      }),
      a("setTransition", (e, a) => {
        s.params.effect === t && r(a);
      }),
      a("transitionEnd", () => {
        if (s.params.effect === t && o) {
          if (!d || !d().slideShadows) return;
          s.slides.forEach((e) => {
            e.querySelectorAll(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            ).forEach((e) => e.remove());
          }),
            o();
        }
      }),
      a("virtualUpdate", () => {
        s.params.effect === t &&
          (s.slides.length || (c = !0),
          requestAnimationFrame(() => {
            c && s.slides && s.slides.length && (i(), (c = !1));
          }));
      });
  }
  function le(e, t) {
    const s = h(t);
    return (
      s !== t &&
        ((s.style.backfaceVisibility = "hidden"),
        (s.style["-webkit-backface-visibility"] = "hidden")),
      s
    );
  }
  function oe(e) {
    let { swiper: t, duration: s, transformElements: a, allSlides: i } = e;
    const { activeIndex: r } = t;
    if (t.params.virtualTranslate && 0 !== s) {
      let e,
        s = !1;
      (e = i
        ? a
        : a.filter(
            (e) =>
              b(
                e.classList.contains("swiper-slide-transform")
                  ? ((e) => {
                      if (!e.parentElement)
                        return t.slides.filter(
                          (t) => t.shadowEl && t.shadowEl === e.parentNode
                        )[0];
                      return e.parentElement;
                    })(e)
                  : e
              ) === r
          )),
        e.forEach((e) => {
          E(e, () => {
            if (s) return;
            if (!t || t.destroyed) return;
            (s = !0), (t.animating = !1);
            const e = new window.CustomEvent("transitionend", {
              bubbles: !0,
              cancelable: !0,
            });
            t.wrapperEl.dispatchEvent(e);
          });
        });
    }
  }
  function de(e, t, s) {
    const a = "swiper-slide-shadow" + (s ? `-${s}` : ""),
      i = h(t);
    let r = i.querySelector(`.${a}`);
    return (
      r ||
        ((r = g("div", "swiper-slide-shadow" + (s ? `-${s}` : ""))),
        i.append(r)),
      r
    );
  }
  Object.keys(K).forEach((e) => {
    Object.keys(K[e]).forEach((t) => {
      Q.prototype[t] = K[e][t];
    });
  }),
    Q.use([
      function (e) {
        let { swiper: t, on: s, emit: a } = e;
        const i = r();
        let n = null,
          l = null;
        const o = () => {
            t &&
              !t.destroyed &&
              t.initialized &&
              (a("beforeResize"), a("resize"));
          },
          d = () => {
            t && !t.destroyed && t.initialized && a("orientationchange");
          };
        s("init", () => {
          t.params.resizeObserver && void 0 !== i.ResizeObserver
            ? t &&
              !t.destroyed &&
              t.initialized &&
              ((n = new ResizeObserver((e) => {
                l = i.requestAnimationFrame(() => {
                  const { width: s, height: a } = t;
                  let i = s,
                    r = a;
                  e.forEach((e) => {
                    let { contentBoxSize: s, contentRect: a, target: n } = e;
                    (n && n !== t.el) ||
                      ((i = a ? a.width : (s[0] || s).inlineSize),
                      (r = a ? a.height : (s[0] || s).blockSize));
                  }),
                    (i === s && r === a) || o();
                });
              })),
              n.observe(t.el))
            : (i.addEventListener("resize", o),
              i.addEventListener("orientationchange", d));
        }),
          s("destroy", () => {
            l && i.cancelAnimationFrame(l),
              n && n.unobserve && t.el && (n.unobserve(t.el), (n = null)),
              i.removeEventListener("resize", o),
              i.removeEventListener("orientationchange", d);
          });
      },
      function (e) {
        let { swiper: t, extendParams: s, on: a, emit: i } = e;
        const n = [],
          l = r(),
          o = function (e, t) {
            void 0 === t && (t = {});
            const s = new (l.MutationObserver || l.WebkitMutationObserver)(
              (e) => {
                if (1 === e.length) return void i("observerUpdate", e[0]);
                const t = function () {
                  i("observerUpdate", e[0]);
                };
                l.requestAnimationFrame
                  ? l.requestAnimationFrame(t)
                  : l.setTimeout(t, 0);
              }
            );
            s.observe(e, {
              attributes: void 0 === t.attributes || t.attributes,
              childList: void 0 === t.childList || t.childList,
              characterData: void 0 === t.characterData || t.characterData,
            }),
              n.push(s);
          };
        s({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          a("init", () => {
            if (t.params.observer) {
              if (t.params.observeParents) {
                const e = y(t.el);
                for (let t = 0; t < e.length; t += 1) o(e[t]);
              }
              o(t.el, { childList: t.params.observeSlideChildren }),
                o(t.wrapperEl, { attributes: !1 });
            }
          }),
          a("destroy", () => {
            n.forEach((e) => {
              e.disconnect();
            }),
              n.splice(0, n.length);
          });
      },
    ]);
  const ce = [
    function (e) {
      let t,
        { swiper: s, extendParams: i, on: r, emit: n } = e;
      i({
        virtual: {
          enabled: !1,
          slides: [],
          cache: !0,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: !0,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      });
      const l = a();
      s.virtual = {
        cache: {},
        from: void 0,
        to: void 0,
        slides: [],
        offset: 0,
        slidesGrid: [],
      };
      const o = l.createElement("div");
      function d(e, t) {
        const a = s.params.virtual;
        if (a.cache && s.virtual.cache[t]) return s.virtual.cache[t];
        let i;
        return (
          a.renderSlide
            ? ((i = a.renderSlide.call(s, e, t)),
              "string" == typeof i && ((o.innerHTML = i), (i = o.children[0])))
            : (i = s.isElement
                ? g("swiper-slide")
                : g("div", s.params.slideClass)),
          i.setAttribute("data-swiper-slide-index", t),
          a.renderSlide || (i.textContent = e),
          a.cache && (s.virtual.cache[t] = i),
          i
        );
      }
      function c(e) {
        const {
            slidesPerView: t,
            slidesPerGroup: a,
            centeredSlides: i,
            loop: r,
          } = s.params,
          { addSlidesBefore: l, addSlidesAfter: o } = s.params.virtual,
          { from: c, to: p, slides: u, slidesGrid: m, offset: h } = s.virtual;
        s.params.cssMode || s.updateActiveIndex();
        const g = s.activeIndex || 0;
        let v, w, b;
        (v = s.rtlTranslate ? "right" : s.isHorizontal() ? "left" : "top"),
          i
            ? ((w = Math.floor(t / 2) + a + o), (b = Math.floor(t / 2) + a + l))
            : ((w = t + (a - 1) + o), (b = (r ? t : a) + l));
        let y = g - b,
          E = g + w;
        r || ((y = Math.max(y, 0)), (E = Math.min(E, u.length - 1)));
        let x = (s.slidesGrid[y] || 0) - (s.slidesGrid[0] || 0);
        function S() {
          s.updateSlides(),
            s.updateProgress(),
            s.updateSlidesClasses(),
            n("virtualUpdate");
        }
        if (
          (r && g >= b
            ? ((y -= b), i || (x += s.slidesGrid[0]))
            : r && g < b && ((y = -b), i && (x += s.slidesGrid[0])),
          Object.assign(s.virtual, {
            from: y,
            to: E,
            offset: x,
            slidesGrid: s.slidesGrid,
            slidesBefore: b,
            slidesAfter: w,
          }),
          c === y && p === E && !e)
        )
          return (
            s.slidesGrid !== m &&
              x !== h &&
              s.slides.forEach((e) => {
                e.style[v] = `${x}px`;
              }),
            s.updateProgress(),
            void n("virtualUpdate")
          );
        if (s.params.virtual.renderExternal)
          return (
            s.params.virtual.renderExternal.call(s, {
              offset: x,
              from: y,
              to: E,
              slides: (function () {
                const e = [];
                for (let t = y; t <= E; t += 1) e.push(u[t]);
                return e;
              })(),
            }),
            void (s.params.virtual.renderExternalUpdate
              ? S()
              : n("virtualUpdate"))
          );
        const T = [],
          M = [],
          C = (e) => {
            let t = e;
            return (
              e < 0 ? (t = u.length + e) : t >= u.length && (t -= u.length), t
            );
          };
        if (e)
          s.slidesEl
            .querySelectorAll(`.${s.params.slideClass}, swiper-slide`)
            .forEach((e) => {
              e.remove();
            });
        else
          for (let e = c; e <= p; e += 1)
            if (e < y || e > E) {
              const t = C(e);
              s.slidesEl
                .querySelectorAll(
                  `.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`
                )
                .forEach((e) => {
                  e.remove();
                });
            }
        const P = r ? -u.length : 0,
          L = r ? 2 * u.length : u.length;
        for (let t = P; t < L; t += 1)
          if (t >= y && t <= E) {
            const s = C(t);
            void 0 === p || e
              ? M.push(s)
              : (t > p && M.push(s), t < c && T.push(s));
          }
        if (
          (M.forEach((e) => {
            s.slidesEl.append(d(u[e], e));
          }),
          r)
        )
          for (let e = T.length - 1; e >= 0; e -= 1) {
            const t = T[e];
            s.slidesEl.prepend(d(u[t], t));
          }
        else
          T.sort((e, t) => t - e),
            T.forEach((e) => {
              s.slidesEl.prepend(d(u[e], e));
            });
        f(s.slidesEl, ".swiper-slide, swiper-slide").forEach((e) => {
          e.style[v] = `${x}px`;
        }),
          S();
      }
      r("beforeInit", () => {
        if (!s.params.virtual.enabled) return;
        let e;
        if (void 0 === s.passedParams.virtual.slides) {
          const t = [...s.slidesEl.children].filter((e) =>
            e.matches(`.${s.params.slideClass}, swiper-slide`)
          );
          t &&
            t.length &&
            ((s.virtual.slides = [...t]),
            (e = !0),
            t.forEach((e, t) => {
              e.setAttribute("data-swiper-slide-index", t),
                (s.virtual.cache[t] = e),
                e.remove();
            }));
        }
        e || (s.virtual.slides = s.params.virtual.slides),
          s.classNames.push(`${s.params.containerModifierClass}virtual`),
          (s.params.watchSlidesProgress = !0),
          (s.originalParams.watchSlidesProgress = !0),
          s.params.initialSlide || c();
      }),
        r("setTranslate", () => {
          s.params.virtual.enabled &&
            (s.params.cssMode && !s._immediateVirtual
              ? (clearTimeout(t),
                (t = setTimeout(() => {
                  c();
                }, 100)))
              : c());
        }),
        r("init update resize", () => {
          s.params.virtual.enabled &&
            s.params.cssMode &&
            u(s.wrapperEl, "--swiper-virtual-size", `${s.virtualSize}px`);
        }),
        Object.assign(s.virtual, {
          appendSlide: function (e) {
            if ("object" == typeof e && "length" in e)
              for (let t = 0; t < e.length; t += 1)
                e[t] && s.virtual.slides.push(e[t]);
            else s.virtual.slides.push(e);
            c(!0);
          },
          prependSlide: function (e) {
            const t = s.activeIndex;
            let a = t + 1,
              i = 1;
            if (Array.isArray(e)) {
              for (let t = 0; t < e.length; t += 1)
                e[t] && s.virtual.slides.unshift(e[t]);
              (a = t + e.length), (i = e.length);
            } else s.virtual.slides.unshift(e);
            if (s.params.virtual.cache) {
              const e = s.virtual.cache,
                t = {};
              Object.keys(e).forEach((s) => {
                const a = e[s],
                  r = a.getAttribute("data-swiper-slide-index");
                r &&
                  a.setAttribute(
                    "data-swiper-slide-index",
                    parseInt(r, 10) + i
                  ),
                  (t[parseInt(s, 10) + i] = a);
              }),
                (s.virtual.cache = t);
            }
            c(!0), s.slideTo(a, 0);
          },
          removeSlide: function (e) {
            if (null == e) return;
            let t = s.activeIndex;
            if (Array.isArray(e))
              for (let a = e.length - 1; a >= 0; a -= 1)
                s.virtual.slides.splice(e[a], 1),
                  s.params.virtual.cache && delete s.virtual.cache[e[a]],
                  e[a] < t && (t -= 1),
                  (t = Math.max(t, 0));
            else
              s.virtual.slides.splice(e, 1),
                s.params.virtual.cache && delete s.virtual.cache[e],
                e < t && (t -= 1),
                (t = Math.max(t, 0));
            c(!0), s.slideTo(t, 0);
          },
          removeAllSlides: function () {
            (s.virtual.slides = []),
              s.params.virtual.cache && (s.virtual.cache = {}),
              c(!0),
              s.slideTo(0, 0);
          },
          update: c,
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: n } = e;
      const l = a(),
        o = r();
      function d(e) {
        if (!t.enabled) return;
        const { rtlTranslate: s } = t;
        let a = e;
        a.originalEvent && (a = a.originalEvent);
        const i = a.keyCode || a.charCode,
          r = t.params.keyboard.pageUpDown,
          d = r && 33 === i,
          c = r && 34 === i,
          p = 37 === i,
          u = 39 === i,
          m = 38 === i,
          h = 40 === i;
        if (
          !t.allowSlideNext &&
          ((t.isHorizontal() && u) || (t.isVertical() && h) || c)
        )
          return !1;
        if (
          !t.allowSlidePrev &&
          ((t.isHorizontal() && p) || (t.isVertical() && m) || d)
        )
          return !1;
        if (
          !(
            a.shiftKey ||
            a.altKey ||
            a.ctrlKey ||
            a.metaKey ||
            (l.activeElement &&
              l.activeElement.nodeName &&
              ("input" === l.activeElement.nodeName.toLowerCase() ||
                "textarea" === l.activeElement.nodeName.toLowerCase()))
          )
        ) {
          if (
            t.params.keyboard.onlyInViewport &&
            (d || c || p || u || m || h)
          ) {
            let e = !1;
            if (
              y(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 &&
              0 === y(t.el, `.${t.params.slideActiveClass}`).length
            )
              return;
            const a = t.el,
              i = a.clientWidth,
              r = a.clientHeight,
              n = o.innerWidth,
              l = o.innerHeight,
              d = v(a);
            s && (d.left -= a.scrollLeft);
            const c = [
              [d.left, d.top],
              [d.left + i, d.top],
              [d.left, d.top + r],
              [d.left + i, d.top + r],
            ];
            for (let t = 0; t < c.length; t += 1) {
              const s = c[t];
              if (s[0] >= 0 && s[0] <= n && s[1] >= 0 && s[1] <= l) {
                if (0 === s[0] && 0 === s[1]) continue;
                e = !0;
              }
            }
            if (!e) return;
          }
          t.isHorizontal()
            ? ((d || c || p || u) &&
                (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
              (((c || u) && !s) || ((d || p) && s)) && t.slideNext(),
              (((d || p) && !s) || ((c || u) && s)) && t.slidePrev())
            : ((d || c || m || h) &&
                (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
              (c || h) && t.slideNext(),
              (d || m) && t.slidePrev()),
            n("keyPress", i);
        }
      }
      function c() {
        t.keyboard.enabled ||
          (l.addEventListener("keydown", d), (t.keyboard.enabled = !0));
      }
      function p() {
        t.keyboard.enabled &&
          (l.removeEventListener("keydown", d), (t.keyboard.enabled = !1));
      }
      (t.keyboard = { enabled: !1 }),
        s({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
        i("init", () => {
          t.params.keyboard.enabled && c();
        }),
        i("destroy", () => {
          t.keyboard.enabled && p();
        }),
        Object.assign(t.keyboard, { enable: c, disable: p });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e;
      const o = r();
      let d;
      s({
        mousewheel: {
          enabled: !1,
          releaseOnEdges: !1,
          invert: !1,
          forceToAxis: !1,
          sensitivity: 1,
          eventsTarget: "container",
          thresholdDelta: null,
          thresholdTime: null,
        },
      }),
        (t.mousewheel = { enabled: !1 });
      let c,
        p = l();
      const u = [];
      function m() {
        t.enabled && (t.mouseEntered = !0);
      }
      function h() {
        t.enabled && (t.mouseEntered = !1);
      }
      function f(e) {
        return (
          !(
            t.params.mousewheel.thresholdDelta &&
            e.delta < t.params.mousewheel.thresholdDelta
          ) &&
          !(
            t.params.mousewheel.thresholdTime &&
            l() - p < t.params.mousewheel.thresholdTime
          ) &&
          ((e.delta >= 6 && l() - p < 60) ||
            (e.direction < 0
              ? (t.isEnd && !t.params.loop) ||
                t.animating ||
                (t.slideNext(), i("scroll", e.raw))
              : (t.isBeginning && !t.params.loop) ||
                t.animating ||
                (t.slidePrev(), i("scroll", e.raw)),
            (p = new o.Date().getTime()),
            !1))
        );
      }
      function g(e) {
        let s = e,
          a = !0;
        if (!t.enabled) return;
        const r = t.params.mousewheel;
        t.params.cssMode && s.preventDefault();
        let o = t.el;
        "container" !== t.params.mousewheel.eventsTarget &&
          (o = document.querySelector(t.params.mousewheel.eventsTarget));
        const p = o && o.contains(s.target);
        if (!t.mouseEntered && !p && !r.releaseOnEdges) return !0;
        s.originalEvent && (s = s.originalEvent);
        let m = 0;
        const h = t.rtlTranslate ? -1 : 1,
          g = (function (e) {
            let t = 0,
              s = 0,
              a = 0,
              i = 0;
            return (
              "detail" in e && (s = e.detail),
              "wheelDelta" in e && (s = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (s = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = s), (s = 0)),
              (a = 10 * t),
              (i = 10 * s),
              "deltaY" in e && (i = e.deltaY),
              "deltaX" in e && (a = e.deltaX),
              e.shiftKey && !a && ((a = i), (i = 0)),
              (a || i) &&
                e.deltaMode &&
                (1 === e.deltaMode
                  ? ((a *= 40), (i *= 40))
                  : ((a *= 800), (i *= 800))),
              a && !t && (t = a < 1 ? -1 : 1),
              i && !s && (s = i < 1 ? -1 : 1),
              { spinX: t, spinY: s, pixelX: a, pixelY: i }
            );
          })(s);
        if (r.forceToAxis)
          if (t.isHorizontal()) {
            if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
            m = -g.pixelX * h;
          } else {
            if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
            m = -g.pixelY;
          }
        else
          m =
            Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * h : -g.pixelY;
        if (0 === m) return !0;
        r.invert && (m = -m);
        let v = t.getTranslate() + m * r.sensitivity;
        if (
          (v >= t.minTranslate() && (v = t.minTranslate()),
          v <= t.maxTranslate() && (v = t.maxTranslate()),
          (a =
            !!t.params.loop ||
            !(v === t.minTranslate() || v === t.maxTranslate())),
          a && t.params.nested && s.stopPropagation(),
          t.params.freeMode && t.params.freeMode.enabled)
        ) {
          const e = { time: l(), delta: Math.abs(m), direction: Math.sign(m) },
            a =
              c &&
              e.time < c.time + 500 &&
              e.delta <= c.delta &&
              e.direction === c.direction;
          if (!a) {
            c = void 0;
            let l = t.getTranslate() + m * r.sensitivity;
            const o = t.isBeginning,
              p = t.isEnd;
            if (
              (l >= t.minTranslate() && (l = t.minTranslate()),
              l <= t.maxTranslate() && (l = t.maxTranslate()),
              t.setTransition(0),
              t.setTranslate(l),
              t.updateProgress(),
              t.updateActiveIndex(),
              t.updateSlidesClasses(),
              ((!o && t.isBeginning) || (!p && t.isEnd)) &&
                t.updateSlidesClasses(),
              t.params.loop &&
                t.loopFix({
                  direction: e.direction < 0 ? "next" : "prev",
                  byMousewheel: !0,
                }),
              t.params.freeMode.sticky)
            ) {
              clearTimeout(d), (d = void 0), u.length >= 15 && u.shift();
              const s = u.length ? u[u.length - 1] : void 0,
                a = u[0];
              if (
                (u.push(e),
                s && (e.delta > s.delta || e.direction !== s.direction))
              )
                u.splice(0);
              else if (
                u.length >= 15 &&
                e.time - a.time < 500 &&
                a.delta - e.delta >= 1 &&
                e.delta <= 6
              ) {
                const s = m > 0 ? 0.8 : 0.2;
                (c = e),
                  u.splice(0),
                  (d = n(() => {
                    t.slideToClosest(t.params.speed, !0, void 0, s);
                  }, 0));
              }
              d ||
                (d = n(() => {
                  (c = e),
                    u.splice(0),
                    t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                }, 500));
            }
            if (
              (a || i("scroll", s),
              t.params.autoplay &&
                t.params.autoplayDisableOnInteraction &&
                t.autoplay.stop(),
              l === t.minTranslate() || l === t.maxTranslate())
            )
              return !0;
          }
        } else {
          const s = {
            time: l(),
            delta: Math.abs(m),
            direction: Math.sign(m),
            raw: e,
          };
          u.length >= 2 && u.shift();
          const a = u.length ? u[u.length - 1] : void 0;
          if (
            (u.push(s),
            a
              ? (s.direction !== a.direction ||
                  s.delta > a.delta ||
                  s.time > a.time + 150) &&
                f(s)
              : f(s),
            (function (e) {
              const s = t.params.mousewheel;
              if (e.direction < 0) {
                if (t.isEnd && !t.params.loop && s.releaseOnEdges) return !0;
              } else if (t.isBeginning && !t.params.loop && s.releaseOnEdges)
                return !0;
              return !1;
            })(s))
          )
            return !0;
        }
        return s.preventDefault ? s.preventDefault() : (s.returnValue = !1), !1;
      }
      function v(e) {
        let s = t.el;
        "container" !== t.params.mousewheel.eventsTarget &&
          (s = document.querySelector(t.params.mousewheel.eventsTarget)),
          s[e]("mouseenter", m),
          s[e]("mouseleave", h),
          s[e]("wheel", g);
      }
      function w() {
        return t.params.cssMode
          ? (t.wrapperEl.removeEventListener("wheel", g), !0)
          : !t.mousewheel.enabled &&
              (v("addEventListener"), (t.mousewheel.enabled = !0), !0);
      }
      function b() {
        return t.params.cssMode
          ? (t.wrapperEl.addEventListener(event, g), !0)
          : !!t.mousewheel.enabled &&
              (v("removeEventListener"), (t.mousewheel.enabled = !1), !0);
      }
      a("init", () => {
        !t.params.mousewheel.enabled && t.params.cssMode && b(),
          t.params.mousewheel.enabled && w();
      }),
        a("destroy", () => {
          t.params.cssMode && w(), t.mousewheel.enabled && b();
        }),
        Object.assign(t.mousewheel, { enable: w, disable: b });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e;
      s({
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: !1,
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          lockClass: "swiper-button-lock",
          navigationDisabledClass: "swiper-navigation-disabled",
        },
      }),
        (t.navigation = { nextEl: null, prevEl: null });
      const r = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
      function n(e) {
        let s;
        return e &&
          "string" == typeof e &&
          t.isElement &&
          ((s = t.el.shadowRoot.querySelector(e)), s)
          ? s
          : (e &&
              ("string" == typeof e && (s = [...document.querySelectorAll(e)]),
              t.params.uniqueNavElements &&
                "string" == typeof e &&
                s.length > 1 &&
                1 === t.el.querySelectorAll(e).length &&
                (s = t.el.querySelector(e))),
            e && !s ? e : s);
      }
      function l(e, s) {
        const a = t.params.navigation;
        (e = r(e)).forEach((e) => {
          e &&
            (e.classList[s ? "add" : "remove"](...a.disabledClass.split(" ")),
            "BUTTON" === e.tagName && (e.disabled = s),
            t.params.watchOverflow &&
              t.enabled &&
              e.classList[t.isLocked ? "add" : "remove"](a.lockClass));
        });
      }
      function o() {
        const { nextEl: e, prevEl: s } = t.navigation;
        if (t.params.loop) return l(s, !1), void l(e, !1);
        l(s, t.isBeginning && !t.params.rewind),
          l(e, t.isEnd && !t.params.rewind);
      }
      function d(e) {
        e.preventDefault(),
          (!t.isBeginning || t.params.loop || t.params.rewind) &&
            (t.slidePrev(), i("navigationPrev"));
      }
      function c(e) {
        e.preventDefault(),
          (!t.isEnd || t.params.loop || t.params.rewind) &&
            (t.slideNext(), i("navigationNext"));
      }
      function p() {
        const e = t.params.navigation;
        if (
          ((t.params.navigation = J(
            t,
            t.originalParams.navigation,
            t.params.navigation,
            { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
          )),
          !e.nextEl && !e.prevEl)
        )
          return;
        let s = n(e.nextEl),
          a = n(e.prevEl);
        Object.assign(t.navigation, { nextEl: s, prevEl: a }),
          (s = r(s)),
          (a = r(a));
        const i = (s, a) => {
          s && s.addEventListener("click", "next" === a ? c : d),
            !t.enabled && s && s.classList.add(...e.lockClass.split(" "));
        };
        s.forEach((e) => i(e, "next")), a.forEach((e) => i(e, "prev"));
      }
      function u() {
        let { nextEl: e, prevEl: s } = t.navigation;
        (e = r(e)), (s = r(s));
        const a = (e, s) => {
          e.removeEventListener("click", "next" === s ? c : d),
            e.classList.remove(...t.params.navigation.disabledClass.split(" "));
        };
        e.forEach((e) => a(e, "next")), s.forEach((e) => a(e, "prev"));
      }
      a("init", () => {
        !1 === t.params.navigation.enabled ? m() : (p(), o());
      }),
        a("toEdge fromEdge lock unlock", () => {
          o();
        }),
        a("destroy", () => {
          u();
        }),
        a("enable disable", () => {
          let { nextEl: e, prevEl: s } = t.navigation;
          (e = r(e)),
            (s = r(s)),
            [...e, ...s]
              .filter((e) => !!e)
              .forEach((e) =>
                e.classList[t.enabled ? "remove" : "add"](
                  t.params.navigation.lockClass
                )
              );
        }),
        a("click", (e, s) => {
          let { nextEl: a, prevEl: n } = t.navigation;
          (a = r(a)), (n = r(n));
          const l = s.target;
          if (
            t.params.navigation.hideOnClick &&
            !n.includes(l) &&
            !a.includes(l)
          ) {
            if (
              t.pagination &&
              t.params.pagination &&
              t.params.pagination.clickable &&
              (t.pagination.el === l || t.pagination.el.contains(l))
            )
              return;
            let e;
            a.length
              ? (e = a[0].classList.contains(t.params.navigation.hiddenClass))
              : n.length &&
                (e = n[0].classList.contains(t.params.navigation.hiddenClass)),
              i(!0 === e ? "navigationShow" : "navigationHide"),
              [...a, ...n]
                .filter((e) => !!e)
                .forEach((e) =>
                  e.classList.toggle(t.params.navigation.hiddenClass)
                );
          }
        });
      const m = () => {
        t.el.classList.add(
          ...t.params.navigation.navigationDisabledClass.split(" ")
        ),
          u();
      };
      Object.assign(t.navigation, {
        enable: () => {
          t.el.classList.remove(
            ...t.params.navigation.navigationDisabledClass.split(" ")
          ),
            p(),
            o();
        },
        disable: m,
        update: o,
        init: p,
        destroy: u,
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e;
      const r = "swiper-pagination";
      let n;
      s({
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: !1,
          hideOnClick: !1,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: !1,
          type: "bullets",
          dynamicBullets: !1,
          dynamicMainBullets: 1,
          formatFractionCurrent: (e) => e,
          formatFractionTotal: (e) => e,
          bulletClass: `${r}-bullet`,
          bulletActiveClass: `${r}-bullet-active`,
          modifierClass: `${r}-`,
          currentClass: `${r}-current`,
          totalClass: `${r}-total`,
          hiddenClass: `${r}-hidden`,
          progressbarFillClass: `${r}-progressbar-fill`,
          progressbarOppositeClass: `${r}-progressbar-opposite`,
          clickableClass: `${r}-clickable`,
          lockClass: `${r}-lock`,
          horizontalClass: `${r}-horizontal`,
          verticalClass: `${r}-vertical`,
          paginationDisabledClass: `${r}-disabled`,
        },
      }),
        (t.pagination = { el: null, bullets: [] });
      let l = 0;
      const o = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
      function d() {
        return (
          !t.params.pagination.el ||
          !t.pagination.el ||
          (Array.isArray(t.pagination.el) && 0 === t.pagination.el.length)
        );
      }
      function c(e, s) {
        const { bulletActiveClass: a } = t.params.pagination;
        e &&
          (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) &&
          (e.classList.add(`${a}-${s}`),
          (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) &&
            e.classList.add(`${a}-${s}-${s}`));
      }
      function p(e) {
        const s = e.target.closest(ee(t.params.pagination.bulletClass));
        if (!s) return;
        e.preventDefault();
        const a = b(s) * t.params.slidesPerGroup;
        t.params.loop ? t.slideToLoop(a) : t.slideTo(a);
      }
      function u() {
        const e = t.rtl,
          s = t.params.pagination;
        if (d()) return;
        let a,
          r = t.pagination.el;
        r = o(r);
        const p =
            t.virtual && t.params.virtual.enabled
              ? t.virtual.slides.length
              : t.slides.length,
          u = t.params.loop
            ? Math.ceil(p / t.params.slidesPerGroup)
            : t.snapGrid.length;
        if (
          ((a = t.params.loop
            ? t.params.slidesPerGroup > 1
              ? Math.floor(t.realIndex / t.params.slidesPerGroup)
              : t.realIndex
            : void 0 !== t.snapIndex
            ? t.snapIndex
            : t.activeIndex || 0),
          "bullets" === s.type &&
            t.pagination.bullets &&
            t.pagination.bullets.length > 0)
        ) {
          const i = t.pagination.bullets;
          let o, d, p;
          if (
            (s.dynamicBullets &&
              ((n = x(i[0], t.isHorizontal() ? "width" : "height", !0)),
              r.forEach((e) => {
                e.style[t.isHorizontal() ? "width" : "height"] =
                  n * (s.dynamicMainBullets + 4) + "px";
              }),
              s.dynamicMainBullets > 1 &&
                void 0 !== t.previousIndex &&
                ((l += a - (t.previousIndex || 0)),
                l > s.dynamicMainBullets - 1
                  ? (l = s.dynamicMainBullets - 1)
                  : l < 0 && (l = 0)),
              (o = Math.max(a - l, 0)),
              (d = o + (Math.min(i.length, s.dynamicMainBullets) - 1)),
              (p = (d + o) / 2)),
            i.forEach((e) => {
              e.classList.remove(
                ...[
                  "",
                  "-next",
                  "-next-next",
                  "-prev",
                  "-prev-prev",
                  "-main",
                ].map((e) => `${s.bulletActiveClass}${e}`)
              );
            }),
            r.length > 1)
          )
            i.forEach((e) => {
              const t = b(e);
              t === a && e.classList.add(s.bulletActiveClass),
                s.dynamicBullets &&
                  (t >= o &&
                    t <= d &&
                    e.classList.add(`${s.bulletActiveClass}-main`),
                  t === o && c(e, "prev"),
                  t === d && c(e, "next"));
            });
          else {
            const e = i[a];
            if ((e && e.classList.add(s.bulletActiveClass), s.dynamicBullets)) {
              const e = i[o],
                t = i[d];
              for (let e = o; e <= d; e += 1)
                i[e].classList.add(`${s.bulletActiveClass}-main`);
              c(e, "prev"), c(t, "next");
            }
          }
          if (s.dynamicBullets) {
            const a = Math.min(i.length, s.dynamicMainBullets + 4),
              r = (n * a - n) / 2 - p * n,
              l = e ? "right" : "left";
            i.forEach((e) => {
              e.style[t.isHorizontal() ? l : "top"] = `${r}px`;
            });
          }
        }
        r.forEach((e, r) => {
          if (
            ("fraction" === s.type &&
              (e.querySelectorAll(ee(s.currentClass)).forEach((e) => {
                e.textContent = s.formatFractionCurrent(a + 1);
              }),
              e.querySelectorAll(ee(s.totalClass)).forEach((e) => {
                e.textContent = s.formatFractionTotal(u);
              })),
            "progressbar" === s.type)
          ) {
            let i;
            i = s.progressbarOpposite
              ? t.isHorizontal()
                ? "vertical"
                : "horizontal"
              : t.isHorizontal()
              ? "horizontal"
              : "vertical";
            const r = (a + 1) / u;
            let n = 1,
              l = 1;
            "horizontal" === i ? (n = r) : (l = r),
              e.querySelectorAll(ee(s.progressbarFillClass)).forEach((e) => {
                (e.style.transform = `translate3d(0,0,0) scaleX(${n}) scaleY(${l})`),
                  (e.style.transitionDuration = `${t.params.speed}ms`);
              });
          }
          "custom" === s.type && s.renderCustom
            ? ((e.innerHTML = s.renderCustom(t, a + 1, u)),
              0 === r && i("paginationRender", e))
            : (0 === r && i("paginationRender", e), i("paginationUpdate", e)),
            t.params.watchOverflow &&
              t.enabled &&
              e.classList[t.isLocked ? "add" : "remove"](s.lockClass);
        });
      }
      function m() {
        const e = t.params.pagination;
        if (d()) return;
        const s =
          t.virtual && t.params.virtual.enabled
            ? t.virtual.slides.length
            : t.slides.length;
        let a = t.pagination.el;
        a = o(a);
        let r = "";
        if ("bullets" === e.type) {
          let a = t.params.loop
            ? Math.ceil(s / t.params.slidesPerGroup)
            : t.snapGrid.length;
          t.params.freeMode && t.params.freeMode.enabled && a > s && (a = s);
          for (let s = 0; s < a; s += 1)
            e.renderBullet
              ? (r += e.renderBullet.call(t, s, e.bulletClass))
              : (r += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
        }
        "fraction" === e.type &&
          (r = e.renderFraction
            ? e.renderFraction.call(t, e.currentClass, e.totalClass)
            : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
          "progressbar" === e.type &&
            (r = e.renderProgressbar
              ? e.renderProgressbar.call(t, e.progressbarFillClass)
              : `<span class="${e.progressbarFillClass}"></span>`),
          a.forEach((s) => {
            "custom" !== e.type && (s.innerHTML = r || ""),
              "bullets" === e.type &&
                (t.pagination.bullets = [
                  ...s.querySelectorAll(ee(e.bulletClass)),
                ]);
          }),
          "custom" !== e.type && i("paginationRender", a[0]);
      }
      function h() {
        t.params.pagination = J(
          t,
          t.originalParams.pagination,
          t.params.pagination,
          { el: "swiper-pagination" }
        );
        const e = t.params.pagination;
        if (!e.el) return;
        let s;
        "string" == typeof e.el &&
          t.isElement &&
          (s = t.el.shadowRoot.querySelector(e.el)),
          s ||
            "string" != typeof e.el ||
            (s = [...document.querySelectorAll(e.el)]),
          s || (s = e.el),
          s &&
            0 !== s.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              Array.isArray(s) &&
              s.length > 1 &&
              ((s = [...t.el.querySelectorAll(e.el)]),
              s.length > 1 &&
                (s = s.filter((e) => y(e, ".swiper")[0] === t.el)[0])),
            Array.isArray(s) && 1 === s.length && (s = s[0]),
            Object.assign(t.pagination, { el: s }),
            (s = o(s)),
            s.forEach((s) => {
              "bullets" === e.type &&
                e.clickable &&
                s.classList.add(e.clickableClass),
                s.classList.add(e.modifierClass + e.type),
                s.classList.add(
                  t.isHorizontal() ? e.horizontalClass : e.verticalClass
                ),
                "bullets" === e.type &&
                  e.dynamicBullets &&
                  (s.classList.add(`${e.modifierClass}${e.type}-dynamic`),
                  (l = 0),
                  e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                "progressbar" === e.type &&
                  e.progressbarOpposite &&
                  s.classList.add(e.progressbarOppositeClass),
                e.clickable && s.addEventListener("click", p),
                t.enabled || s.classList.add(e.lockClass);
            }));
      }
      function f() {
        const e = t.params.pagination;
        if (d()) return;
        let s = t.pagination.el;
        s &&
          ((s = o(s)),
          s.forEach((s) => {
            s.classList.remove(e.hiddenClass),
              s.classList.remove(e.modifierClass + e.type),
              s.classList.remove(
                t.isHorizontal() ? e.horizontalClass : e.verticalClass
              ),
              e.clickable && s.removeEventListener("click", p);
          })),
          t.pagination.bullets &&
            t.pagination.bullets.forEach((t) =>
              t.classList.remove(e.bulletActiveClass)
            );
      }
      a("init", () => {
        !1 === t.params.pagination.enabled ? g() : (h(), m(), u());
      }),
        a("activeIndexChange", () => {
          void 0 === t.snapIndex && u();
        }),
        a("snapIndexChange", () => {
          u();
        }),
        a("snapGridLengthChange", () => {
          m(), u();
        }),
        a("destroy", () => {
          f();
        }),
        a("enable disable", () => {
          let { el: e } = t.pagination;
          e &&
            ((e = o(e)),
            e.forEach((e) =>
              e.classList[t.enabled ? "remove" : "add"](
                t.params.pagination.lockClass
              )
            ));
        }),
        a("lock unlock", () => {
          u();
        }),
        a("click", (e, s) => {
          const a = s.target;
          let { el: r } = t.pagination;
          if (
            (Array.isArray(r) || (r = [r].filter((e) => !!e)),
            t.params.pagination.el &&
              t.params.pagination.hideOnClick &&
              r &&
              r.length > 0 &&
              !a.classList.contains(t.params.pagination.bulletClass))
          ) {
            if (
              t.navigation &&
              ((t.navigation.nextEl && a === t.navigation.nextEl) ||
                (t.navigation.prevEl && a === t.navigation.prevEl))
            )
              return;
            const e = r[0].classList.contains(t.params.pagination.hiddenClass);
            i(!0 === e ? "paginationShow" : "paginationHide"),
              r.forEach((e) =>
                e.classList.toggle(t.params.pagination.hiddenClass)
              );
          }
        });
      const g = () => {
        t.el.classList.add(t.params.pagination.paginationDisabledClass);
        let { el: e } = t.pagination;
        e &&
          ((e = o(e)),
          e.forEach((e) =>
            e.classList.add(t.params.pagination.paginationDisabledClass)
          )),
          f();
      };
      Object.assign(t.pagination, {
        enable: () => {
          t.el.classList.remove(t.params.pagination.paginationDisabledClass);
          let { el: e } = t.pagination;
          e &&
            ((e = o(e)),
            e.forEach((e) =>
              e.classList.remove(t.params.pagination.paginationDisabledClass)
            )),
            h(),
            m(),
            u();
        },
        disable: g,
        render: m,
        update: u,
        init: h,
        destroy: f,
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e;
      const l = a();
      let o,
        d,
        c,
        p,
        u = !1,
        m = null,
        h = null;
      function f() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
        const { scrollbar: e, rtlTranslate: s } = t,
          { dragEl: a, el: i } = e,
          r = t.params.scrollbar,
          n = t.params.loop ? t.progressLoop : t.progress;
        let l = d,
          o = (c - d) * n;
        s
          ? ((o = -o),
            o > 0 ? ((l = d - o), (o = 0)) : -o + d > c && (l = c + o))
          : o < 0
          ? ((l = d + o), (o = 0))
          : o + d > c && (l = c - o),
          t.isHorizontal()
            ? ((a.style.transform = `translate3d(${o}px, 0, 0)`),
              (a.style.width = `${l}px`))
            : ((a.style.transform = `translate3d(0px, ${o}px, 0)`),
              (a.style.height = `${l}px`)),
          r.hide &&
            (clearTimeout(m),
            (i.style.opacity = 1),
            (m = setTimeout(() => {
              (i.style.opacity = 0), (i.style.transitionDuration = "400ms");
            }, 1e3)));
      }
      function w() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
        const { scrollbar: e } = t,
          { dragEl: s, el: a } = e;
        (s.style.width = ""),
          (s.style.height = ""),
          (c = t.isHorizontal() ? a.offsetWidth : a.offsetHeight),
          (p =
            t.size /
            (t.virtualSize +
              t.params.slidesOffsetBefore -
              (t.params.centeredSlides ? t.snapGrid[0] : 0))),
          (d =
            "auto" === t.params.scrollbar.dragSize
              ? c * p
              : parseInt(t.params.scrollbar.dragSize, 10)),
          t.isHorizontal()
            ? (s.style.width = `${d}px`)
            : (s.style.height = `${d}px`),
          (a.style.display = p >= 1 ? "none" : ""),
          t.params.scrollbar.hide && (a.style.opacity = 0),
          t.params.watchOverflow &&
            t.enabled &&
            e.el.classList[t.isLocked ? "add" : "remove"](
              t.params.scrollbar.lockClass
            );
      }
      function b(e) {
        return t.isHorizontal() ? e.clientX : e.clientY;
      }
      function y(e) {
        const { scrollbar: s, rtlTranslate: a } = t,
          { el: i } = s;
        let r;
        (r =
          (b(e) -
            v(i)[t.isHorizontal() ? "left" : "top"] -
            (null !== o ? o : d / 2)) /
          (c - d)),
          (r = Math.max(Math.min(r, 1), 0)),
          a && (r = 1 - r);
        const n = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * r;
        t.updateProgress(n),
          t.setTranslate(n),
          t.updateActiveIndex(),
          t.updateSlidesClasses();
      }
      function E(e) {
        const s = t.params.scrollbar,
          { scrollbar: a, wrapperEl: i } = t,
          { el: n, dragEl: l } = a;
        (u = !0),
          (o =
            e.target === l
              ? b(e) -
                e.target.getBoundingClientRect()[
                  t.isHorizontal() ? "left" : "top"
                ]
              : null),
          e.preventDefault(),
          e.stopPropagation(),
          (i.style.transitionDuration = "100ms"),
          (l.style.transitionDuration = "100ms"),
          y(e),
          clearTimeout(h),
          (n.style.transitionDuration = "0ms"),
          s.hide && (n.style.opacity = 1),
          t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
          r("scrollbarDragStart", e);
      }
      function x(e) {
        const { scrollbar: s, wrapperEl: a } = t,
          { el: i, dragEl: n } = s;
        u &&
          (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
          y(e),
          (a.style.transitionDuration = "0ms"),
          (i.style.transitionDuration = "0ms"),
          (n.style.transitionDuration = "0ms"),
          r("scrollbarDragMove", e));
      }
      function S(e) {
        const s = t.params.scrollbar,
          { scrollbar: a, wrapperEl: i } = t,
          { el: l } = a;
        u &&
          ((u = !1),
          t.params.cssMode &&
            ((t.wrapperEl.style["scroll-snap-type"] = ""),
            (i.style.transitionDuration = "")),
          s.hide &&
            (clearTimeout(h),
            (h = n(() => {
              (l.style.opacity = 0), (l.style.transitionDuration = "400ms");
            }, 1e3))),
          r("scrollbarDragEnd", e),
          s.snapOnRelease && t.slideToClosest());
      }
      function T(e) {
        const { scrollbar: s, params: a } = t,
          i = s.el;
        if (!i) return;
        const r = i,
          n = !!a.passiveListeners && { passive: !1, capture: !1 },
          o = !!a.passiveListeners && { passive: !0, capture: !1 };
        if (!r) return;
        const d = "on" === e ? "addEventListener" : "removeEventListener";
        r[d]("pointerdown", E, n),
          l[d]("pointermove", x, n),
          l[d]("pointerup", S, o);
      }
      function M() {
        const { scrollbar: e, el: s } = t;
        t.params.scrollbar = J(
          t,
          t.originalParams.scrollbar,
          t.params.scrollbar,
          { el: "swiper-scrollbar" }
        );
        const a = t.params.scrollbar;
        if (!a.el) return;
        let i, r;
        "string" == typeof a.el &&
          t.isElement &&
          (i = t.el.shadowRoot.querySelector(a.el)),
          i || "string" != typeof a.el
            ? i || (i = a.el)
            : (i = l.querySelectorAll(a.el)),
          t.params.uniqueNavElements &&
            "string" == typeof a.el &&
            i.length > 1 &&
            1 === s.querySelectorAll(a.el).length &&
            (i = s.querySelector(a.el)),
          i.length > 0 && (i = i[0]),
          i.classList.add(
            t.isHorizontal() ? a.horizontalClass : a.verticalClass
          ),
          i &&
            ((r = i.querySelector(`.${t.params.scrollbar.dragClass}`)),
            r || ((r = g("div", t.params.scrollbar.dragClass)), i.append(r))),
          Object.assign(e, { el: i, dragEl: r }),
          a.draggable && t.params.scrollbar.el && t.scrollbar.el && T("on"),
          i &&
            i.classList[t.enabled ? "remove" : "add"](
              t.params.scrollbar.lockClass
            );
      }
      function C() {
        const e = t.params.scrollbar,
          s = t.scrollbar.el;
        s &&
          s.classList.remove(
            t.isHorizontal() ? e.horizontalClass : e.verticalClass
          ),
          t.params.scrollbar.el && t.scrollbar.el && T("off");
      }
      s({
        scrollbar: {
          el: null,
          dragSize: "auto",
          hide: !1,
          draggable: !1,
          snapOnRelease: !0,
          lockClass: "swiper-scrollbar-lock",
          dragClass: "swiper-scrollbar-drag",
          scrollbarDisabledClass: "swiper-scrollbar-disabled",
          horizontalClass: "swiper-scrollbar-horizontal",
          verticalClass: "swiper-scrollbar-vertical",
        },
      }),
        (t.scrollbar = { el: null, dragEl: null }),
        i("init", () => {
          !1 === t.params.scrollbar.enabled ? P() : (M(), w(), f());
        }),
        i("update resize observerUpdate lock unlock", () => {
          w();
        }),
        i("setTranslate", () => {
          f();
        }),
        i("setTransition", (e, s) => {
          !(function (e) {
            t.params.scrollbar.el &&
              t.scrollbar.el &&
              (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`);
          })(s);
        }),
        i("enable disable", () => {
          const { el: e } = t.scrollbar;
          e &&
            e.classList[t.enabled ? "remove" : "add"](
              t.params.scrollbar.lockClass
            );
        }),
        i("destroy", () => {
          C();
        });
      const P = () => {
        t.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),
          t.scrollbar.el &&
            t.scrollbar.el.classList.add(
              t.params.scrollbar.scrollbarDisabledClass
            ),
          C();
      };
      Object.assign(t.scrollbar, {
        enable: () => {
          t.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),
            t.scrollbar.el &&
              t.scrollbar.el.classList.remove(
                t.params.scrollbar.scrollbarDisabledClass
              ),
            M(),
            w(),
            f();
        },
        disable: P,
        updateSize: w,
        setTranslate: f,
        init: M,
        destroy: C,
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({ parallax: { enabled: !1 } });
      const i = (e, s) => {
          const { rtl: a } = t,
            i = a ? -1 : 1,
            r = e.getAttribute("data-swiper-parallax") || "0";
          let n = e.getAttribute("data-swiper-parallax-x"),
            l = e.getAttribute("data-swiper-parallax-y");
          const o = e.getAttribute("data-swiper-parallax-scale"),
            d = e.getAttribute("data-swiper-parallax-opacity"),
            c = e.getAttribute("data-swiper-parallax-rotate");
          if (
            (n || l
              ? ((n = n || "0"), (l = l || "0"))
              : t.isHorizontal()
              ? ((n = r), (l = "0"))
              : ((l = r), (n = "0")),
            (n =
              n.indexOf("%") >= 0
                ? parseInt(n, 10) * s * i + "%"
                : n * s * i + "px"),
            (l =
              l.indexOf("%") >= 0 ? parseInt(l, 10) * s + "%" : l * s + "px"),
            null != d)
          ) {
            const t = d - (d - 1) * (1 - Math.abs(s));
            e.style.opacity = t;
          }
          let p = `translate3d(${n}, ${l}, 0px)`;
          if (null != o) {
            p += ` scale(${o - (o - 1) * (1 - Math.abs(s))})`;
          }
          if (c && null != c) {
            p += ` rotate(${c * s * -1}deg)`;
          }
          e.style.transform = p;
        },
        r = () => {
          const { el: e, slides: s, progress: a, snapGrid: r } = t;
          f(
            e,
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          ).forEach((e) => {
            i(e, a);
          }),
            s.forEach((e, s) => {
              let n = e.progress;
              t.params.slidesPerGroup > 1 &&
                "auto" !== t.params.slidesPerView &&
                (n += Math.ceil(s / 2) - a * (r.length - 1)),
                (n = Math.min(Math.max(n, -1), 1)),
                e
                  .querySelectorAll(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]"
                  )
                  .forEach((e) => {
                    i(e, n);
                  });
            });
        };
      a("beforeInit", () => {
        t.params.parallax.enabled &&
          ((t.params.watchSlidesProgress = !0),
          (t.originalParams.watchSlidesProgress = !0));
      }),
        a("init", () => {
          t.params.parallax.enabled && r();
        }),
        a("setTranslate", () => {
          t.params.parallax.enabled && r();
        }),
        a("setTransition", (e, s) => {
          t.params.parallax.enabled &&
            (function (e) {
              void 0 === e && (e = t.params.speed);
              const { el: s } = t;
              s.querySelectorAll(
                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
              ).forEach((t) => {
                let s =
                  parseInt(
                    t.getAttribute("data-swiper-parallax-duration"),
                    10
                  ) || e;
                0 === e && (s = 0), (t.style.transitionDuration = `${s}ms`);
              });
            })(s);
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e;
      const n = r();
      s({
        zoom: {
          enabled: !1,
          maxRatio: 3,
          minRatio: 1,
          toggle: !0,
          containerClass: "swiper-zoom-container",
          zoomedSlideClass: "swiper-slide-zoomed",
        },
      }),
        (t.zoom = { enabled: !1 });
      let l,
        d,
        c = 1,
        p = !1;
      const u = [],
        m = {
          slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          imageEl: void 0,
          imageWrapEl: void 0,
          maxRatio: 3,
        },
        h = {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {},
        },
        g = {
          x: void 0,
          y: void 0,
          prevPositionX: void 0,
          prevPositionY: void 0,
          prevTime: void 0,
        };
      let w = 1;
      function b() {
        if (u.length < 2) return 1;
        const e = u[0].pageX,
          t = u[0].pageY,
          s = u[1].pageX,
          a = u[1].pageY;
        return Math.sqrt((s - e) ** 2 + (a - t) ** 2);
      }
      function E(e) {
        const s = t.isElement ? "swiper-slide" : `.${t.params.slideClass}`;
        return (
          !!e.target.matches(s) ||
          t.slides.filter((t) => t.contains(e.target)).length > 0
        );
      }
      function x(e) {
        if (!E(e)) return;
        const s = t.params.zoom;
        if (((l = !1), (d = !1), u.push(e), !(u.length < 2))) {
          if (((l = !0), (m.scaleStart = b()), !m.slideEl)) {
            (m.slideEl = e.target.closest(
              `.${t.params.slideClass}, swiper-slide`
            )),
              m.slideEl || (m.slideEl = t.slides[t.activeIndex]);
            let a = m.slideEl.querySelector(`.${s.containerClass}`);
            if (
              (a &&
                (a = a.querySelectorAll(
                  "picture, img, svg, canvas, .swiper-zoom-target"
                )[0]),
              (m.imageEl = a),
              (m.imageWrapEl = a
                ? y(m.imageEl, `.${s.containerClass}`)[0]
                : void 0),
              !m.imageWrapEl)
            )
              return void (m.imageEl = void 0);
            m.maxRatio =
              m.imageWrapEl.getAttribute("data-swiper-zoom") || s.maxRatio;
          }
          if (m.imageEl) {
            const [e, t] = (function () {
              if (u.length < 2) return { x: null, y: null };
              const e = m.imageEl.getBoundingClientRect();
              return [
                (u[0].pageX + (u[1].pageX - u[0].pageX) / 2 - e.x) / c,
                (u[0].pageY + (u[1].pageY - u[0].pageY) / 2 - e.y) / c,
              ];
            })();
            (m.imageEl.style.transformOrigin = `${e}px ${t}px`),
              (m.imageEl.style.transitionDuration = "0ms");
          }
          p = !0;
        }
      }
      function S(e) {
        if (!E(e)) return;
        const s = t.params.zoom,
          a = t.zoom,
          i = u.findIndex((t) => t.pointerId === e.pointerId);
        i >= 0 && (u[i] = e),
          u.length < 2 ||
            ((d = !0),
            (m.scaleMove = b()),
            m.imageEl &&
              ((a.scale = (m.scaleMove / m.scaleStart) * c),
              a.scale > m.maxRatio &&
                (a.scale = m.maxRatio - 1 + (a.scale - m.maxRatio + 1) ** 0.5),
              a.scale < s.minRatio &&
                (a.scale = s.minRatio + 1 - (s.minRatio - a.scale + 1) ** 0.5),
              (m.imageEl.style.transform = `translate3d(0,0,0) scale(${a.scale})`)));
      }
      function T(e) {
        if (!E(e)) return;
        const s = t.params.zoom,
          a = t.zoom,
          i = u.findIndex((t) => t.pointerId === e.pointerId);
        i >= 0 && u.splice(i, 1),
          l &&
            d &&
            ((l = !1),
            (d = !1),
            m.imageEl &&
              ((a.scale = Math.max(Math.min(a.scale, m.maxRatio), s.minRatio)),
              (m.imageEl.style.transitionDuration = `${t.params.speed}ms`),
              (m.imageEl.style.transform = `translate3d(0,0,0) scale(${a.scale})`),
              (c = a.scale),
              (p = !1),
              1 === a.scale && (m.slideEl = void 0)));
      }
      function M(e) {
        if (
          !E(e) ||
          !(function (e) {
            const s = `.${t.params.zoom.containerClass}`;
            return (
              !!e.target.matches(s) ||
              [...t.el.querySelectorAll(s)].filter((t) => t.contains(e.target))
                .length > 0
            );
          })(e)
        )
          return;
        const s = t.zoom;
        if (!m.imageEl) return;
        if (((t.allowClick = !1), !h.isTouched || !m.slideEl)) return;
        h.isMoved ||
          ((h.width = m.imageEl.offsetWidth),
          (h.height = m.imageEl.offsetHeight),
          (h.startX = o(m.imageWrapEl, "x") || 0),
          (h.startY = o(m.imageWrapEl, "y") || 0),
          (m.slideWidth = m.slideEl.offsetWidth),
          (m.slideHeight = m.slideEl.offsetHeight),
          (m.imageWrapEl.style.transitionDuration = "0ms"));
        const a = h.width * s.scale,
          i = h.height * s.scale;
        if (!(a < m.slideWidth && i < m.slideHeight)) {
          if (
            ((h.minX = Math.min(m.slideWidth / 2 - a / 2, 0)),
            (h.maxX = -h.minX),
            (h.minY = Math.min(m.slideHeight / 2 - i / 2, 0)),
            (h.maxY = -h.minY),
            (h.touchesCurrent.x = u.length > 0 ? u[0].pageX : e.pageX),
            (h.touchesCurrent.y = u.length > 0 ? u[0].pageY : e.pageY),
            !h.isMoved && !p)
          ) {
            if (
              t.isHorizontal() &&
              ((Math.floor(h.minX) === Math.floor(h.startX) &&
                h.touchesCurrent.x < h.touchesStart.x) ||
                (Math.floor(h.maxX) === Math.floor(h.startX) &&
                  h.touchesCurrent.x > h.touchesStart.x))
            )
              return void (h.isTouched = !1);
            if (
              !t.isHorizontal() &&
              ((Math.floor(h.minY) === Math.floor(h.startY) &&
                h.touchesCurrent.y < h.touchesStart.y) ||
                (Math.floor(h.maxY) === Math.floor(h.startY) &&
                  h.touchesCurrent.y > h.touchesStart.y))
            )
              return void (h.isTouched = !1);
          }
          e.cancelable && e.preventDefault(),
            e.stopPropagation(),
            (h.isMoved = !0),
            (h.currentX = h.touchesCurrent.x - h.touchesStart.x + h.startX),
            (h.currentY = h.touchesCurrent.y - h.touchesStart.y + h.startY),
            h.currentX < h.minX &&
              (h.currentX = h.minX + 1 - (h.minX - h.currentX + 1) ** 0.8),
            h.currentX > h.maxX &&
              (h.currentX = h.maxX - 1 + (h.currentX - h.maxX + 1) ** 0.8),
            h.currentY < h.minY &&
              (h.currentY = h.minY + 1 - (h.minY - h.currentY + 1) ** 0.8),
            h.currentY > h.maxY &&
              (h.currentY = h.maxY - 1 + (h.currentY - h.maxY + 1) ** 0.8),
            g.prevPositionX || (g.prevPositionX = h.touchesCurrent.x),
            g.prevPositionY || (g.prevPositionY = h.touchesCurrent.y),
            g.prevTime || (g.prevTime = Date.now()),
            (g.x =
              (h.touchesCurrent.x - g.prevPositionX) /
              (Date.now() - g.prevTime) /
              2),
            (g.y =
              (h.touchesCurrent.y - g.prevPositionY) /
              (Date.now() - g.prevTime) /
              2),
            Math.abs(h.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0),
            Math.abs(h.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0),
            (g.prevPositionX = h.touchesCurrent.x),
            (g.prevPositionY = h.touchesCurrent.y),
            (g.prevTime = Date.now()),
            (m.imageWrapEl.style.transform = `translate3d(${h.currentX}px, ${h.currentY}px,0)`);
        }
      }
      function C() {
        const e = t.zoom;
        m.slideEl &&
          t.previousIndex !== t.activeIndex &&
          (m.imageEl &&
            (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
          m.imageWrapEl &&
            (m.imageWrapEl.style.transform = "translate3d(0,0,0)"),
          (e.scale = 1),
          (c = 1),
          (m.slideEl = void 0),
          (m.imageEl = void 0),
          (m.imageWrapEl = void 0));
      }
      function P(e) {
        const s = t.zoom,
          a = t.params.zoom;
        if (!m.slideEl) {
          e &&
            e.target &&
            (m.slideEl = e.target.closest(
              `.${t.params.slideClass}, swiper-slide`
            )),
            m.slideEl ||
              (t.params.virtual && t.params.virtual.enabled && t.virtual
                ? (m.slideEl = f(
                    t.slidesEl,
                    `.${t.params.slideActiveClass}`
                  )[0])
                : (m.slideEl = t.slides[t.activeIndex]));
          let s = m.slideEl.querySelector(`.${a.containerClass}`);
          s &&
            (s = s.querySelectorAll(
              "picture, img, svg, canvas, .swiper-zoom-target"
            )[0]),
            (m.imageEl = s),
            (m.imageWrapEl = s
              ? y(m.imageEl, `.${a.containerClass}`)[0]
              : void 0);
        }
        if (!m.imageEl || !m.imageWrapEl) return;
        let i, r, l, o, d, p, u, g, w, b, E, x, S, T, M, C, P, L;
        t.params.cssMode &&
          ((t.wrapperEl.style.overflow = "hidden"),
          (t.wrapperEl.style.touchAction = "none")),
          m.slideEl.classList.add(`${a.zoomedSlideClass}`),
          void 0 === h.touchesStart.x && e
            ? ((i = e.pageX), (r = e.pageY))
            : ((i = h.touchesStart.x), (r = h.touchesStart.y));
        const A = "number" == typeof e ? e : null;
        1 === c && A && ((i = void 0), (r = void 0)),
          (s.scale =
            A || m.imageWrapEl.getAttribute("data-swiper-zoom") || a.maxRatio),
          (c =
            A || m.imageWrapEl.getAttribute("data-swiper-zoom") || a.maxRatio),
          !e || (1 === c && A)
            ? ((u = 0), (g = 0))
            : ((P = m.slideEl.offsetWidth),
              (L = m.slideEl.offsetHeight),
              (l = v(m.slideEl).left + n.scrollX),
              (o = v(m.slideEl).top + n.scrollY),
              (d = l + P / 2 - i),
              (p = o + L / 2 - r),
              (w = m.imageEl.offsetWidth),
              (b = m.imageEl.offsetHeight),
              (E = w * s.scale),
              (x = b * s.scale),
              (S = Math.min(P / 2 - E / 2, 0)),
              (T = Math.min(L / 2 - x / 2, 0)),
              (M = -S),
              (C = -T),
              (u = d * s.scale),
              (g = p * s.scale),
              u < S && (u = S),
              u > M && (u = M),
              g < T && (g = T),
              g > C && (g = C)),
          (m.imageWrapEl.style.transitionDuration = "300ms"),
          (m.imageWrapEl.style.transform = `translate3d(${u}px, ${g}px,0)`),
          (m.imageEl.style.transitionDuration = "300ms"),
          (m.imageEl.style.transform = `translate3d(0,0,0) scale(${s.scale})`);
      }
      function L() {
        const e = t.zoom,
          s = t.params.zoom;
        if (!m.slideEl) {
          t.params.virtual && t.params.virtual.enabled && t.virtual
            ? (m.slideEl = f(t.slidesEl, `.${t.params.slideActiveClass}`)[0])
            : (m.slideEl = t.slides[t.activeIndex]);
          let e = m.slideEl.querySelector(`.${s.containerClass}`);
          e &&
            (e = e.querySelectorAll(
              "picture, img, svg, canvas, .swiper-zoom-target"
            )[0]),
            (m.imageEl = e),
            (m.imageWrapEl = e
              ? y(m.imageEl, `.${s.containerClass}`)[0]
              : void 0);
        }
        m.imageEl &&
          m.imageWrapEl &&
          (t.params.cssMode &&
            ((t.wrapperEl.style.overflow = ""),
            (t.wrapperEl.style.touchAction = "")),
          (e.scale = 1),
          (c = 1),
          (m.imageWrapEl.style.transitionDuration = "300ms"),
          (m.imageWrapEl.style.transform = "translate3d(0,0,0)"),
          (m.imageEl.style.transitionDuration = "300ms"),
          (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
          m.slideEl.classList.remove(`${s.zoomedSlideClass}`),
          (m.slideEl = void 0));
      }
      function A(e) {
        const s = t.zoom;
        s.scale && 1 !== s.scale ? L() : P(e);
      }
      function z() {
        return {
          passiveListener: !!t.params.passiveListeners && {
            passive: !0,
            capture: !1,
          },
          activeListenerWithCapture: !t.params.passiveListeners || {
            passive: !1,
            capture: !0,
          },
        };
      }
      function $() {
        const e = t.zoom;
        if (e.enabled) return;
        e.enabled = !0;
        const { passiveListener: s, activeListenerWithCapture: a } = z();
        t.wrapperEl.addEventListener("pointerdown", x, s),
          t.wrapperEl.addEventListener("pointermove", S, a),
          ["pointerup", "pointercancel"].forEach((e) => {
            t.wrapperEl.addEventListener(e, T, s);
          }),
          t.wrapperEl.addEventListener("pointermove", M, a);
      }
      function k() {
        const e = t.zoom;
        if (!e.enabled) return;
        e.enabled = !1;
        const { passiveListener: s, activeListenerWithCapture: a } = z();
        t.wrapperEl.removeEventListener("pointerdown", x, s),
          t.wrapperEl.removeEventListener("pointermove", S, a),
          ["pointerup", "pointercancel"].forEach((e) => {
            t.wrapperEl.removeEventListener(e, T, s);
          }),
          t.wrapperEl.removeEventListener("pointermove", M, a);
      }
      Object.defineProperty(t.zoom, "scale", {
        get: () => w,
        set(e) {
          if (w !== e) {
            const t = m.imageEl,
              s = m.slideEl;
            i("zoomChange", e, t, s);
          }
          w = e;
        },
      }),
        a("init", () => {
          t.params.zoom.enabled && $();
        }),
        a("destroy", () => {
          k();
        }),
        a("touchStart", (e, s) => {
          t.zoom.enabled &&
            (function (e) {
              const s = t.device;
              m.imageEl &&
                (h.isTouched ||
                  (s.android && e.cancelable && e.preventDefault(),
                  (h.isTouched = !0),
                  (h.touchesStart.x = e.pageX),
                  (h.touchesStart.y = e.pageY)));
            })(s);
        }),
        a("touchEnd", (e, s) => {
          t.zoom.enabled &&
            (function () {
              const e = t.zoom;
              if (!m.imageEl) return;
              if (!h.isTouched || !h.isMoved)
                return (h.isTouched = !1), void (h.isMoved = !1);
              (h.isTouched = !1), (h.isMoved = !1);
              let s = 300,
                a = 300;
              const i = g.x * s,
                r = h.currentX + i,
                n = g.y * a,
                l = h.currentY + n;
              0 !== g.x && (s = Math.abs((r - h.currentX) / g.x)),
                0 !== g.y && (a = Math.abs((l - h.currentY) / g.y));
              const o = Math.max(s, a);
              (h.currentX = r), (h.currentY = l);
              const d = h.width * e.scale,
                c = h.height * e.scale;
              (h.minX = Math.min(m.slideWidth / 2 - d / 2, 0)),
                (h.maxX = -h.minX),
                (h.minY = Math.min(m.slideHeight / 2 - c / 2, 0)),
                (h.maxY = -h.minY),
                (h.currentX = Math.max(Math.min(h.currentX, h.maxX), h.minX)),
                (h.currentY = Math.max(Math.min(h.currentY, h.maxY), h.minY)),
                (m.imageWrapEl.style.transitionDuration = `${o}ms`),
                (m.imageWrapEl.style.transform = `translate3d(${h.currentX}px, ${h.currentY}px,0)`);
            })();
        }),
        a("doubleTap", (e, s) => {
          !t.animating &&
            t.params.zoom.enabled &&
            t.zoom.enabled &&
            t.params.zoom.toggle &&
            A(s);
        }),
        a("transitionEnd", () => {
          t.zoom.enabled && t.params.zoom.enabled && C();
        }),
        a("slideChange", () => {
          t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && C();
        }),
        Object.assign(t.zoom, {
          enable: $,
          disable: k,
          in: P,
          out: L,
          toggle: A,
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      function i(e, t) {
        const s = (function () {
          let e, t, s;
          return (a, i) => {
            for (t = -1, e = a.length; e - t > 1; )
              (s = (e + t) >> 1), a[s] <= i ? (t = s) : (e = s);
            return e;
          };
        })();
        let a, i;
        return (
          (this.x = e),
          (this.y = t),
          (this.lastIndex = e.length - 1),
          (this.interpolate = function (e) {
            return e
              ? ((i = s(this.x, e)),
                (a = i - 1),
                ((e - this.x[a]) * (this.y[i] - this.y[a])) /
                  (this.x[i] - this.x[a]) +
                  this.y[a])
              : 0;
          }),
          this
        );
      }
      function r() {
        t.controller.control &&
          t.controller.spline &&
          ((t.controller.spline = void 0), delete t.controller.spline);
      }
      s({ controller: { control: void 0, inverse: !1, by: "slide" } }),
        (t.controller = { control: void 0 }),
        a("beforeInit", () => {
          if (
            "undefined" != typeof window &&
            ("string" == typeof t.params.controller.control ||
              t.params.controller.control instanceof HTMLElement)
          ) {
            const e = document.querySelector(t.params.controller.control);
            if (e && e.swiper) t.controller.control = e.swiper;
            else if (e) {
              const s = (a) => {
                (t.controller.control = a.detail[0]),
                  t.update(),
                  e.removeEventListener("init", s);
              };
              e.addEventListener("init", s);
            }
          } else t.controller.control = t.params.controller.control;
        }),
        a("update", () => {
          r();
        }),
        a("resize", () => {
          r();
        }),
        a("observerUpdate", () => {
          r();
        }),
        a("setTranslate", (e, s, a) => {
          t.controller.control && t.controller.setTranslate(s, a);
        }),
        a("setTransition", (e, s, a) => {
          t.controller.control && t.controller.setTransition(s, a);
        }),
        Object.assign(t.controller, {
          setTranslate: function (e, s) {
            const a = t.controller.control;
            let r, n;
            const l = t.constructor;
            function o(e) {
              const s = t.rtlTranslate ? -t.translate : t.translate;
              "slide" === t.params.controller.by &&
                (!(function (e) {
                  t.controller.spline ||
                    (t.controller.spline = t.params.loop
                      ? new i(t.slidesGrid, e.slidesGrid)
                      : new i(t.snapGrid, e.snapGrid));
                })(e),
                (n = -t.controller.spline.interpolate(-s))),
                (n && "container" !== t.params.controller.by) ||
                  ((r =
                    (e.maxTranslate() - e.minTranslate()) /
                    (t.maxTranslate() - t.minTranslate())),
                  (n = (s - t.minTranslate()) * r + e.minTranslate())),
                t.params.controller.inverse && (n = e.maxTranslate() - n),
                e.updateProgress(n),
                e.setTranslate(n, t),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
            }
            if (Array.isArray(a))
              for (let e = 0; e < a.length; e += 1)
                a[e] !== s && a[e] instanceof l && o(a[e]);
            else a instanceof l && s !== a && o(a);
          },
          setTransition: function (e, s) {
            const a = t.constructor,
              i = t.controller.control;
            let r;
            function l(s) {
              s.setTransition(e, t),
                0 !== e &&
                  (s.transitionStart(),
                  s.params.autoHeight &&
                    n(() => {
                      s.updateAutoHeight();
                    }),
                  E(s.wrapperEl, () => {
                    i && s.transitionEnd();
                  }));
            }
            if (Array.isArray(i))
              for (r = 0; r < i.length; r += 1)
                i[r] !== s && i[r] instanceof a && l(i[r]);
            else i instanceof a && s !== i && l(i);
          },
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({
        a11y: {
          enabled: !0,
          notificationClass: "swiper-notification",
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
          paginationBulletMessage: "Go to slide {{index}}",
          slideLabelMessage: "{{index}} / {{slidesLength}}",
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          itemRoleDescriptionMessage: null,
          slideRole: "group",
          id: null,
        },
      }),
        (t.a11y = { clicked: !1 });
      let i = null;
      function r(e) {
        const t = i;
        0 !== t.length && ((t.innerHTML = ""), (t.innerHTML = e));
      }
      const n = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
      function l(e) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("tabIndex", "0");
        });
      }
      function o(e) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("tabIndex", "-1");
        });
      }
      function d(e, t) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("role", t);
        });
      }
      function c(e, t) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("aria-roledescription", t);
        });
      }
      function p(e, t) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("aria-label", t);
        });
      }
      function u(e) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("aria-disabled", !0);
        });
      }
      function m(e) {
        (e = n(e)).forEach((e) => {
          e.setAttribute("aria-disabled", !1);
        });
      }
      function h(e) {
        if (13 !== e.keyCode && 32 !== e.keyCode) return;
        const s = t.params.a11y,
          a = e.target;
        (t.pagination &&
          t.pagination.el &&
          (a === t.pagination.el || t.pagination.el.contains(e.target)) &&
          !e.target.matches(ee(t.params.pagination.bulletClass))) ||
          (t.navigation &&
            t.navigation.nextEl &&
            a === t.navigation.nextEl &&
            ((t.isEnd && !t.params.loop) || t.slideNext(),
            t.isEnd ? r(s.lastSlideMessage) : r(s.nextSlideMessage)),
          t.navigation &&
            t.navigation.prevEl &&
            a === t.navigation.prevEl &&
            ((t.isBeginning && !t.params.loop) || t.slidePrev(),
            t.isBeginning ? r(s.firstSlideMessage) : r(s.prevSlideMessage)),
          t.pagination &&
            a.matches(ee(t.params.pagination.bulletClass)) &&
            a.click());
      }
      function f() {
        return (
          t.pagination && t.pagination.bullets && t.pagination.bullets.length
        );
      }
      function v() {
        return f() && t.params.pagination.clickable;
      }
      const w = (e, t, s) => {
          l(e),
            "BUTTON" !== e.tagName &&
              (d(e, "button"), e.addEventListener("keydown", h)),
            p(e, s),
            (function (e, t) {
              (e = n(e)).forEach((e) => {
                e.setAttribute("aria-controls", t);
              });
            })(e, t);
        },
        y = () => {
          t.a11y.clicked = !0;
        },
        E = () => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              t.destroyed || (t.a11y.clicked = !1);
            });
          });
        },
        x = (e) => {
          if (t.a11y.clicked) return;
          const s = e.target.closest(`.${t.params.slideClass}, swiper-slide`);
          if (!s || !t.slides.includes(s)) return;
          const a = t.slides.indexOf(s) === t.activeIndex,
            i =
              t.params.watchSlidesProgress &&
              t.visibleSlides &&
              t.visibleSlides.includes(s);
          a ||
            i ||
            (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) ||
            (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0),
            t.slideTo(t.slides.indexOf(s), 0));
        },
        S = () => {
          const e = t.params.a11y;
          e.itemRoleDescriptionMessage &&
            c(t.slides, e.itemRoleDescriptionMessage),
            e.slideRole && d(t.slides, e.slideRole);
          const s = t.slides.length;
          e.slideLabelMessage &&
            t.slides.forEach((a, i) => {
              const r = t.params.loop
                ? parseInt(a.getAttribute("data-swiper-slide-index"), 10)
                : i;
              p(
                a,
                e.slideLabelMessage
                  .replace(/\{\{index\}\}/, r + 1)
                  .replace(/\{\{slidesLength\}\}/, s)
              );
            });
        },
        T = () => {
          const e = t.params.a11y;
          t.el.append(i);
          const s = t.el;
          e.containerRoleDescriptionMessage &&
            c(s, e.containerRoleDescriptionMessage),
            e.containerMessage && p(s, e.containerMessage);
          const a = t.wrapperEl,
            r =
              e.id ||
              a.getAttribute("id") ||
              `swiper-wrapper-${
                ((l = 16),
                void 0 === l && (l = 16),
                "x"
                  .repeat(l)
                  .replace(/x/g, () =>
                    Math.round(16 * Math.random()).toString(16)
                  ))
              }`;
          var l;
          const o =
            t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
          var d;
          (d = r),
            n(a).forEach((e) => {
              e.setAttribute("id", d);
            }),
            (function (e, t) {
              (e = n(e)).forEach((e) => {
                e.setAttribute("aria-live", t);
              });
            })(a, o),
            S();
          let { nextEl: u, prevEl: m } = t.navigation ? t.navigation : {};
          if (
            ((u = n(u)),
            (m = n(m)),
            u && u.forEach((t) => w(t, r, e.nextSlideMessage)),
            m && m.forEach((t) => w(t, r, e.prevSlideMessage)),
            v())
          ) {
            (Array.isArray(t.pagination.el)
              ? t.pagination.el
              : [t.pagination.el]
            ).forEach((e) => {
              e.addEventListener("keydown", h);
            });
          }
          t.el.addEventListener("focus", x, !0),
            t.el.addEventListener("pointerdown", y, !0),
            t.el.addEventListener("pointerup", E, !0);
        };
      a("beforeInit", () => {
        (i = g("span", t.params.a11y.notificationClass)),
          i.setAttribute("aria-live", "assertive"),
          i.setAttribute("aria-atomic", "true"),
          t.isElement && i.setAttribute("slot", "container-end");
      }),
        a("afterInit", () => {
          t.params.a11y.enabled && T();
        }),
        a(
          "slidesLengthChange snapGridLengthChange slidesGridLengthChange",
          () => {
            t.params.a11y.enabled && S();
          }
        ),
        a("fromEdge toEdge afterInit lock unlock", () => {
          t.params.a11y.enabled &&
            (function () {
              if (t.params.loop || t.params.rewind || !t.navigation) return;
              const { nextEl: e, prevEl: s } = t.navigation;
              s && (t.isBeginning ? (u(s), o(s)) : (m(s), l(s))),
                e && (t.isEnd ? (u(e), o(e)) : (m(e), l(e)));
            })();
        }),
        a("paginationUpdate", () => {
          t.params.a11y.enabled &&
            (function () {
              const e = t.params.a11y;
              f() &&
                t.pagination.bullets.forEach((s) => {
                  t.params.pagination.clickable &&
                    (l(s),
                    t.params.pagination.renderBullet ||
                      (d(s, "button"),
                      p(
                        s,
                        e.paginationBulletMessage.replace(
                          /\{\{index\}\}/,
                          b(s) + 1
                        )
                      ))),
                    s.matches(`.${t.params.pagination.bulletActiveClass}`)
                      ? s.setAttribute("aria-current", "true")
                      : s.removeAttribute("aria-current");
                });
            })();
        }),
        a("destroy", () => {
          t.params.a11y.enabled &&
            (function () {
              i && i.length > 0 && i.remove();
              let { nextEl: e, prevEl: s } = t.navigation ? t.navigation : {};
              (e = n(e)),
                (s = n(s)),
                e && e.forEach((e) => e.removeEventListener("keydown", h)),
                s && s.forEach((e) => e.removeEventListener("keydown", h)),
                v() &&
                  (Array.isArray(t.pagination.el)
                    ? t.pagination.el
                    : [t.pagination.el]
                  ).forEach((e) => {
                    e.removeEventListener("keydown", h);
                  });
              t.el.removeEventListener("focus", x, !0),
                t.el.removeEventListener("pointerdown", y, !0),
                t.el.removeEventListener("pointerup", E, !0);
            })();
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({
        history: {
          enabled: !1,
          root: "",
          replaceState: !1,
          key: "slides",
          keepQuery: !1,
        },
      });
      let i = !1,
        n = {};
      const l = (e) =>
          e
            .toString()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, ""),
        o = (e) => {
          const t = r();
          let s;
          s = e ? new URL(e) : t.location;
          const a = s.pathname
              .slice(1)
              .split("/")
              .filter((e) => "" !== e),
            i = a.length;
          return { key: a[i - 2], value: a[i - 1] };
        },
        d = (e, s) => {
          const a = r();
          if (!i || !t.params.history.enabled) return;
          let n;
          n = t.params.url ? new URL(t.params.url) : a.location;
          const o = t.slides[s];
          let d = l(o.getAttribute("data-history"));
          if (t.params.history.root.length > 0) {
            let s = t.params.history.root;
            "/" === s[s.length - 1] && (s = s.slice(0, s.length - 1)),
              (d = `${s}/${e ? `${e}/` : ""}${d}`);
          } else n.pathname.includes(e) || (d = `${e ? `${e}/` : ""}${d}`);
          t.params.history.keepQuery && (d += n.search);
          const c = a.history.state;
          (c && c.value === d) ||
            (t.params.history.replaceState
              ? a.history.replaceState({ value: d }, null, d)
              : a.history.pushState({ value: d }, null, d));
        },
        c = (e, s, a) => {
          if (s)
            for (let i = 0, r = t.slides.length; i < r; i += 1) {
              const r = t.slides[i];
              if (l(r.getAttribute("data-history")) === s) {
                const s = b(r);
                t.slideTo(s, e, a);
              }
            }
          else t.slideTo(0, e, a);
        },
        p = () => {
          (n = o(t.params.url)), c(t.params.speed, n.value, !1);
        };
      a("init", () => {
        t.params.history.enabled &&
          (() => {
            const e = r();
            if (t.params.history) {
              if (!e.history || !e.history.pushState)
                return (
                  (t.params.history.enabled = !1),
                  void (t.params.hashNavigation.enabled = !0)
                );
              (i = !0),
                (n = o(t.params.url)),
                n.key || n.value
                  ? (c(0, n.value, t.params.runCallbacksOnInit),
                    t.params.history.replaceState ||
                      e.addEventListener("popstate", p))
                  : t.params.history.replaceState ||
                    e.addEventListener("popstate", p);
            }
          })();
      }),
        a("destroy", () => {
          t.params.history.enabled &&
            (() => {
              const e = r();
              t.params.history.replaceState ||
                e.removeEventListener("popstate", p);
            })();
        }),
        a("transitionEnd _freeModeNoMomentumRelease", () => {
          i && d(t.params.history.key, t.activeIndex);
        }),
        a("slideChange", () => {
          i && t.params.cssMode && d(t.params.history.key, t.activeIndex);
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, emit: i, on: n } = e,
        l = !1;
      const o = a(),
        d = r();
      s({ hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } });
      const c = () => {
          i("hashChange");
          const e = o.location.hash.replace("#", "");
          if (e !== t.slides[t.activeIndex].getAttribute("data-hash")) {
            const s = b(
              f(
                t.slidesEl,
                `.${t.params.slideClass}[data-hash="${e}"], swiper-slide[data-hash="${e}"]`
              )[0]
            );
            if (void 0 === s) return;
            t.slideTo(s);
          }
        },
        p = () => {
          if (l && t.params.hashNavigation.enabled)
            if (
              t.params.hashNavigation.replaceState &&
              d.history &&
              d.history.replaceState
            )
              d.history.replaceState(
                null,
                null,
                `#${t.slides[t.activeIndex].getAttribute("data-hash")}` || ""
              ),
                i("hashSet");
            else {
              const e = t.slides[t.activeIndex],
                s =
                  e.getAttribute("data-hash") || e.getAttribute("data-history");
              (o.location.hash = s || ""), i("hashSet");
            }
        };
      n("init", () => {
        t.params.hashNavigation.enabled &&
          (() => {
            if (
              !t.params.hashNavigation.enabled ||
              (t.params.history && t.params.history.enabled)
            )
              return;
            l = !0;
            const e = o.location.hash.replace("#", "");
            if (e) {
              const s = 0;
              for (let a = 0, i = t.slides.length; a < i; a += 1) {
                const i = t.slides[a];
                if (
                  (i.getAttribute("data-hash") ||
                    i.getAttribute("data-history")) === e
                ) {
                  const e = b(i);
                  t.slideTo(e, s, t.params.runCallbacksOnInit, !0);
                }
              }
            }
            t.params.hashNavigation.watchState &&
              d.addEventListener("hashchange", c);
          })();
      }),
        n("destroy", () => {
          t.params.hashNavigation.enabled &&
            t.params.hashNavigation.watchState &&
            d.removeEventListener("hashchange", c);
        }),
        n("transitionEnd _freeModeNoMomentumRelease", () => {
          l && p();
        }),
        n("slideChange", () => {
          l && t.params.cssMode && p();
        });
    },
    function (e) {
      let t,
        s,
        { swiper: i, extendParams: r, on: n, emit: l, params: o } = e;
      (i.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
        r({
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !0,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        });
      let d,
        c,
        p,
        u,
        m,
        h,
        f,
        g = o && o.autoplay ? o.autoplay.delay : 3e3,
        v = o && o.autoplay ? o.autoplay.delay : 3e3,
        w = new Date().getTime;
      function b(e) {
        i &&
          !i.destroyed &&
          i.wrapperEl &&
          e.target === i.wrapperEl &&
          (i.wrapperEl.removeEventListener("transitionend", b), M());
      }
      const y = () => {
          if (i.destroyed || !i.autoplay.running) return;
          i.autoplay.paused ? (c = !0) : c && ((v = d), (c = !1));
          const e = i.autoplay.paused ? d : w + v - new Date().getTime();
          (i.autoplay.timeLeft = e),
            l("autoplayTimeLeft", e, e / g),
            (s = requestAnimationFrame(() => {
              y();
            }));
        },
        E = (e) => {
          if (i.destroyed || !i.autoplay.running) return;
          cancelAnimationFrame(s), y();
          let a = void 0 === e ? i.params.autoplay.delay : e;
          (g = i.params.autoplay.delay), (v = i.params.autoplay.delay);
          const r = (() => {
            let e;
            if (
              ((e =
                i.virtual && i.params.virtual.enabled
                  ? i.slides.filter((e) =>
                      e.classList.contains("swiper-slide-active")
                    )[0]
                  : i.slides[i.activeIndex]),
              !e)
            )
              return;
            return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
          })();
          !Number.isNaN(r) &&
            r > 0 &&
            void 0 === e &&
            ((a = r), (g = r), (v = r)),
            (d = a);
          const n = i.params.speed,
            o = () => {
              i &&
                !i.destroyed &&
                (i.params.autoplay.reverseDirection
                  ? !i.isBeginning || i.params.loop || i.params.rewind
                    ? (i.slidePrev(n, !0, !0), l("autoplay"))
                    : i.params.autoplay.stopOnLastSlide ||
                      (i.slideTo(i.slides.length - 1, n, !0, !0), l("autoplay"))
                  : !i.isEnd || i.params.loop || i.params.rewind
                  ? (i.slideNext(n, !0, !0), l("autoplay"))
                  : i.params.autoplay.stopOnLastSlide ||
                    (i.slideTo(0, n, !0, !0), l("autoplay")),
                i.params.cssMode &&
                  ((w = new Date().getTime()),
                  requestAnimationFrame(() => {
                    E();
                  })));
            };
          return (
            a > 0
              ? (clearTimeout(t),
                (t = setTimeout(() => {
                  o();
                }, a)))
              : requestAnimationFrame(() => {
                  o();
                }),
            a
          );
        },
        x = () => {
          (i.autoplay.running = !0), E(), l("autoplayStart");
        },
        S = () => {
          (i.autoplay.running = !1),
            clearTimeout(t),
            cancelAnimationFrame(s),
            l("autoplayStop");
        },
        T = (e, s) => {
          if (i.destroyed || !i.autoplay.running) return;
          clearTimeout(t), e || (f = !0);
          const a = () => {
            l("autoplayPause"),
              i.params.autoplay.waitForTransition
                ? i.wrapperEl.addEventListener("transitionend", b)
                : M();
          };
          if (((i.autoplay.paused = !0), s))
            return h && (d = i.params.autoplay.delay), (h = !1), void a();
          const r = d || i.params.autoplay.delay;
          (d = r - (new Date().getTime() - w)),
            (i.isEnd && d < 0 && !i.params.loop) || (d < 0 && (d = 0), a());
        },
        M = () => {
          (i.isEnd && d < 0 && !i.params.loop) ||
            i.destroyed ||
            !i.autoplay.running ||
            ((w = new Date().getTime()),
            f ? ((f = !1), E(d)) : E(),
            (i.autoplay.paused = !1),
            l("autoplayResume"));
        },
        C = () => {
          if (i.destroyed || !i.autoplay.running) return;
          const e = a();
          "hidden" === e.visibilityState && ((f = !0), T(!0)),
            "visible" === e.visibilityState && M();
        },
        P = (e) => {
          "mouse" === e.pointerType && ((f = !0), T(!0));
        },
        L = (e) => {
          "mouse" === e.pointerType && i.autoplay.paused && M();
        };
      n("init", () => {
        i.params.autoplay.enabled &&
          (i.params.autoplay.pauseOnMouseEnter &&
            (i.el.addEventListener("pointerenter", P),
            i.el.addEventListener("pointerleave", L)),
          a().addEventListener("visibilitychange", C),
          (w = new Date().getTime()),
          x());
      }),
        n("destroy", () => {
          i.el.removeEventListener("pointerenter", P),
            i.el.removeEventListener("pointerleave", L),
            a().removeEventListener("visibilitychange", C),
            i.autoplay.running && S();
        }),
        n("beforeTransitionStart", (e, t, s) => {
          !i.destroyed &&
            i.autoplay.running &&
            (s || !i.params.autoplay.disableOnInteraction ? T(!0, !0) : S());
        }),
        n("sliderFirstMove", () => {
          !i.destroyed &&
            i.autoplay.running &&
            (i.params.autoplay.disableOnInteraction
              ? S()
              : ((p = !0),
                (u = !1),
                (f = !1),
                (m = setTimeout(() => {
                  (f = !0), (u = !0), T(!0);
                }, 200))));
        }),
        n("touchEnd", () => {
          if (!i.destroyed && i.autoplay.running && p) {
            if (
              (clearTimeout(m),
              clearTimeout(t),
              i.params.autoplay.disableOnInteraction)
            )
              return (u = !1), void (p = !1);
            u && i.params.cssMode && M(), (u = !1), (p = !1);
          }
        }),
        n("slideChange", () => {
          !i.destroyed && i.autoplay.running && (h = !0);
        }),
        Object.assign(i.autoplay, { start: x, stop: S, pause: T, resume: M });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        thumbs: {
          swiper: null,
          multipleActiveThumbs: !0,
          autoScrollOffset: 0,
          slideThumbActiveClass: "swiper-slide-thumb-active",
          thumbsContainerClass: "swiper-thumbs",
        },
      });
      let r = !1,
        n = !1;
      function l() {
        const e = t.thumbs.swiper;
        if (!e || e.destroyed) return;
        const s = e.clickedIndex,
          a = e.clickedSlide;
        if (a && a.classList.contains(t.params.thumbs.slideThumbActiveClass))
          return;
        if (null == s) return;
        let i;
        (i = e.params.loop
          ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)
          : s),
          t.params.loop ? t.slideToLoop(i) : t.slideTo(i);
      }
      function o() {
        const { thumbs: e } = t.params;
        if (r) return !1;
        r = !0;
        const s = t.constructor;
        if (e.swiper instanceof s)
          (t.thumbs.swiper = e.swiper),
            Object.assign(t.thumbs.swiper.originalParams, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
            Object.assign(t.thumbs.swiper.params, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
            t.thumbs.swiper.update();
        else if (d(e.swiper)) {
          const a = Object.assign({}, e.swiper);
          Object.assign(a, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1,
          }),
            (t.thumbs.swiper = new s(a)),
            (n = !0);
        }
        return (
          t.thumbs.swiper.el.classList.add(
            t.params.thumbs.thumbsContainerClass
          ),
          t.thumbs.swiper.on("tap", l),
          !0
        );
      }
      function c(e) {
        const s = t.thumbs.swiper;
        if (!s || s.destroyed) return;
        const a =
          "auto" === s.params.slidesPerView
            ? s.slidesPerViewDynamic()
            : s.params.slidesPerView;
        let i = 1;
        const r = t.params.thumbs.slideThumbActiveClass;
        if (
          (t.params.slidesPerView > 1 &&
            !t.params.centeredSlides &&
            (i = t.params.slidesPerView),
          t.params.thumbs.multipleActiveThumbs || (i = 1),
          (i = Math.floor(i)),
          s.slides.forEach((e) => e.classList.remove(r)),
          s.params.loop || (s.params.virtual && s.params.virtual.enabled))
        )
          for (let e = 0; e < i; e += 1)
            f(
              s.slidesEl,
              `[data-swiper-slide-index="${t.realIndex + e}"]`
            ).forEach((e) => {
              e.classList.add(r);
            });
        else
          for (let e = 0; e < i; e += 1)
            s.slides[t.realIndex + e] &&
              s.slides[t.realIndex + e].classList.add(r);
        const n = t.params.thumbs.autoScrollOffset,
          l = n && !s.params.loop;
        if (t.realIndex !== s.realIndex || l) {
          const i = s.activeIndex;
          let r, o;
          if (s.params.loop) {
            const e = s.slides.filter(
              (e) =>
                e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`
            )[0];
            (r = s.slides.indexOf(e)),
              (o = t.activeIndex > t.previousIndex ? "next" : "prev");
          } else (r = t.realIndex), (o = r > t.previousIndex ? "next" : "prev");
          l && (r += "next" === o ? n : -1 * n),
            s.visibleSlidesIndexes &&
              s.visibleSlidesIndexes.indexOf(r) < 0 &&
              (s.params.centeredSlides
                ? (r =
                    r > i
                      ? r - Math.floor(a / 2) + 1
                      : r + Math.floor(a / 2) - 1)
                : r > i && s.params.slidesPerGroup,
              s.slideTo(r, e ? 0 : void 0));
        }
      }
      (t.thumbs = { swiper: null }),
        i("beforeInit", () => {
          const { thumbs: e } = t.params;
          if (e && e.swiper)
            if (
              "string" == typeof e.swiper ||
              e.swiper instanceof HTMLElement
            ) {
              const s = a(),
                i = () => {
                  const a =
                    "string" == typeof e.swiper
                      ? s.querySelector(e.swiper)
                      : e.swiper;
                  if (a && a.swiper) (e.swiper = a.swiper), o(), c(!0);
                  else if (a) {
                    const s = (i) => {
                      (e.swiper = i.detail[0]),
                        a.removeEventListener("init", s),
                        o(),
                        c(!0),
                        e.swiper.update(),
                        t.update();
                    };
                    a.addEventListener("init", s);
                  }
                  return a;
                },
                r = () => {
                  if (t.destroyed) return;
                  i() || requestAnimationFrame(r);
                };
              requestAnimationFrame(r);
            } else o(), c(!0);
        }),
        i("slideChange update resize observerUpdate", () => {
          c();
        }),
        i("setTransition", (e, s) => {
          const a = t.thumbs.swiper;
          a && !a.destroyed && a.setTransition(s);
        }),
        i("beforeDestroy", () => {
          const e = t.thumbs.swiper;
          e && !e.destroyed && n && e.destroy();
        }),
        Object.assign(t.thumbs, { init: o, update: c });
    },
    function (e) {
      let { swiper: t, extendParams: s, emit: a, once: i } = e;
      s({
        freeMode: {
          enabled: !1,
          momentum: !0,
          momentumRatio: 1,
          momentumBounce: !0,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: !1,
          minimumVelocity: 0.02,
        },
      }),
        Object.assign(t, {
          freeMode: {
            onTouchStart: function () {
              const e = t.getTranslate();
              t.setTranslate(e),
                t.setTransition(0),
                (t.touchEventsData.velocities.length = 0),
                t.freeMode.onTouchEnd({
                  currentPos: t.rtl ? t.translate : -t.translate,
                });
            },
            onTouchMove: function () {
              const { touchEventsData: e, touches: s } = t;
              0 === e.velocities.length &&
                e.velocities.push({
                  position: s[t.isHorizontal() ? "startX" : "startY"],
                  time: e.touchStartTime,
                }),
                e.velocities.push({
                  position: s[t.isHorizontal() ? "currentX" : "currentY"],
                  time: l(),
                });
            },
            onTouchEnd: function (e) {
              let { currentPos: s } = e;
              const {
                  params: r,
                  wrapperEl: n,
                  rtlTranslate: o,
                  snapGrid: d,
                  touchEventsData: c,
                } = t,
                p = l() - c.touchStartTime;
              if (s < -t.minTranslate()) t.slideTo(t.activeIndex);
              else if (s > -t.maxTranslate())
                t.slides.length < d.length
                  ? t.slideTo(d.length - 1)
                  : t.slideTo(t.slides.length - 1);
              else {
                if (r.freeMode.momentum) {
                  if (c.velocities.length > 1) {
                    const e = c.velocities.pop(),
                      s = c.velocities.pop(),
                      a = e.position - s.position,
                      i = e.time - s.time;
                    (t.velocity = a / i),
                      (t.velocity /= 2),
                      Math.abs(t.velocity) < r.freeMode.minimumVelocity &&
                        (t.velocity = 0),
                      (i > 150 || l() - e.time > 300) && (t.velocity = 0);
                  } else t.velocity = 0;
                  (t.velocity *= r.freeMode.momentumVelocityRatio),
                    (c.velocities.length = 0);
                  let e = 1e3 * r.freeMode.momentumRatio;
                  const s = t.velocity * e;
                  let p = t.translate + s;
                  o && (p = -p);
                  let u,
                    m = !1;
                  const h =
                    20 * Math.abs(t.velocity) * r.freeMode.momentumBounceRatio;
                  let f;
                  if (p < t.maxTranslate())
                    r.freeMode.momentumBounce
                      ? (p + t.maxTranslate() < -h &&
                          (p = t.maxTranslate() - h),
                        (u = t.maxTranslate()),
                        (m = !0),
                        (c.allowMomentumBounce = !0))
                      : (p = t.maxTranslate()),
                      r.loop && r.centeredSlides && (f = !0);
                  else if (p > t.minTranslate())
                    r.freeMode.momentumBounce
                      ? (p - t.minTranslate() > h && (p = t.minTranslate() + h),
                        (u = t.minTranslate()),
                        (m = !0),
                        (c.allowMomentumBounce = !0))
                      : (p = t.minTranslate()),
                      r.loop && r.centeredSlides && (f = !0);
                  else if (r.freeMode.sticky) {
                    let e;
                    for (let t = 0; t < d.length; t += 1)
                      if (d[t] > -p) {
                        e = t;
                        break;
                      }
                    (p =
                      Math.abs(d[e] - p) < Math.abs(d[e - 1] - p) ||
                      "next" === t.swipeDirection
                        ? d[e]
                        : d[e - 1]),
                      (p = -p);
                  }
                  if (
                    (f &&
                      i("transitionEnd", () => {
                        t.loopFix();
                      }),
                    0 !== t.velocity)
                  ) {
                    if (
                      ((e = o
                        ? Math.abs((-p - t.translate) / t.velocity)
                        : Math.abs((p - t.translate) / t.velocity)),
                      r.freeMode.sticky)
                    ) {
                      const s = Math.abs((o ? -p : p) - t.translate),
                        a = t.slidesSizesGrid[t.activeIndex];
                      e =
                        s < a
                          ? r.speed
                          : s < 2 * a
                          ? 1.5 * r.speed
                          : 2.5 * r.speed;
                    }
                  } else if (r.freeMode.sticky) return void t.slideToClosest();
                  r.freeMode.momentumBounce && m
                    ? (t.updateProgress(u),
                      t.setTransition(e),
                      t.setTranslate(p),
                      t.transitionStart(!0, t.swipeDirection),
                      (t.animating = !0),
                      E(n, () => {
                        t &&
                          !t.destroyed &&
                          c.allowMomentumBounce &&
                          (a("momentumBounce"),
                          t.setTransition(r.speed),
                          setTimeout(() => {
                            t.setTranslate(u),
                              E(n, () => {
                                t && !t.destroyed && t.transitionEnd();
                              });
                          }, 0));
                      }))
                    : t.velocity
                    ? (a("_freeModeNoMomentumRelease"),
                      t.updateProgress(p),
                      t.setTransition(e),
                      t.setTranslate(p),
                      t.transitionStart(!0, t.swipeDirection),
                      t.animating ||
                        ((t.animating = !0),
                        E(n, () => {
                          t && !t.destroyed && t.transitionEnd();
                        })))
                    : t.updateProgress(p),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses();
                } else {
                  if (r.freeMode.sticky) return void t.slideToClosest();
                  r.freeMode && a("_freeModeNoMomentumRelease");
                }
                (!r.freeMode.momentum || p >= r.longSwipesMs) &&
                  (t.updateProgress(),
                  t.updateActiveIndex(),
                  t.updateSlidesClasses());
              }
            },
          },
        });
    },
    function (e) {
      let t,
        s,
        a,
        { swiper: i, extendParams: r } = e;
      r({ grid: { rows: 1, fill: "column" } }),
        (i.grid = {
          initSlides: (e) => {
            const { slidesPerView: r } = i.params,
              { rows: n, fill: l } = i.params.grid;
            (s = t / n),
              (a = Math.floor(e / n)),
              (t = Math.floor(e / n) === e / n ? e : Math.ceil(e / n) * n),
              "auto" !== r && "row" === l && (t = Math.max(t, r * n));
          },
          updateSlide: (e, r, n, l) => {
            const { slidesPerGroup: o, spaceBetween: d } = i.params,
              { rows: c, fill: p } = i.params.grid;
            let u, m, h;
            if ("row" === p && o > 1) {
              const s = Math.floor(e / (o * c)),
                a = e - c * o * s,
                i = 0 === s ? o : Math.min(Math.ceil((n - s * c * o) / c), o);
              (h = Math.floor(a / i)),
                (m = a - h * i + s * o),
                (u = m + (h * t) / c),
                (r.style.order = u);
            } else
              "column" === p
                ? ((m = Math.floor(e / c)),
                  (h = e - m * c),
                  (m > a || (m === a && h === c - 1)) &&
                    ((h += 1), h >= c && ((h = 0), (m += 1))))
                : ((h = Math.floor(e / s)), (m = e - h * s));
            r.style[l("margin-top")] = 0 !== h ? d && `${d}px` : "";
          },
          updateWrapperSize: (e, s, a) => {
            const {
                spaceBetween: r,
                centeredSlides: n,
                roundLengths: l,
              } = i.params,
              { rows: o } = i.params.grid;
            if (
              ((i.virtualSize = (e + r) * t),
              (i.virtualSize = Math.ceil(i.virtualSize / o) - r),
              (i.wrapperEl.style[a("width")] = `${i.virtualSize + r}px`),
              n)
            ) {
              const e = [];
              for (let t = 0; t < s.length; t += 1) {
                let a = s[t];
                l && (a = Math.floor(a)),
                  s[t] < i.virtualSize + s[0] && e.push(a);
              }
              s.splice(0, s.length), s.push(...e);
            }
          },
        });
    },
    function (e) {
      let { swiper: t } = e;
      Object.assign(t, {
        appendSlide: te.bind(t),
        prependSlide: se.bind(t),
        addSlide: ae.bind(t),
        removeSlide: ie.bind(t),
        removeAllSlides: re.bind(t),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({ fadeEffect: { crossFade: !1 } }),
        ne({
          effect: "fade",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { slides: e } = t;
            t.params.fadeEffect;
            for (let s = 0; s < e.length; s += 1) {
              const e = t.slides[s];
              let a = -e.swiperSlideOffset;
              t.params.virtualTranslate || (a -= t.translate);
              let i = 0;
              t.isHorizontal() || ((i = a), (a = 0));
              const r = t.params.fadeEffect.crossFade
                  ? Math.max(1 - Math.abs(e.progress), 0)
                  : 1 + Math.min(Math.max(e.progress, -1), 0),
                n = le(0, e);
              (n.style.opacity = r),
                (n.style.transform = `translate3d(${a}px, ${i}px, 0px)`);
            }
          },
          setTransition: (e) => {
            const s = t.slides.map((e) => h(e));
            s.forEach((t) => {
              t.style.transitionDuration = `${e}ms`;
            }),
              oe({
                swiper: t,
                duration: e,
                transformElements: s,
                allSlides: !0,
              });
          },
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !t.params.cssMode,
          }),
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({
        cubeEffect: {
          slideShadows: !0,
          shadow: !0,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      });
      const i = (e, t, s) => {
        let a = s
            ? e.querySelector(".swiper-slide-shadow-left")
            : e.querySelector(".swiper-slide-shadow-top"),
          i = s
            ? e.querySelector(".swiper-slide-shadow-right")
            : e.querySelector(".swiper-slide-shadow-bottom");
        a ||
          ((a = g("div", "swiper-slide-shadow-" + (s ? "left" : "top"))),
          e.append(a)),
          i ||
            ((i = g("div", "swiper-slide-shadow-" + (s ? "right" : "bottom"))),
            e.append(i)),
          a && (a.style.opacity = Math.max(-t, 0)),
          i && (i.style.opacity = Math.max(t, 0));
      };
      ne({
        effect: "cube",
        swiper: t,
        on: a,
        setTranslate: () => {
          const {
              el: e,
              wrapperEl: s,
              slides: a,
              width: r,
              height: n,
              rtlTranslate: l,
              size: o,
              browser: d,
            } = t,
            c = t.params.cubeEffect,
            p = t.isHorizontal(),
            u = t.virtual && t.params.virtual.enabled;
          let m,
            h = 0;
          c.shadow &&
            (p
              ? ((m = t.slidesEl.querySelector(".swiper-cube-shadow")),
                m ||
                  ((m = g("div", "swiper-cube-shadow")), t.slidesEl.append(m)),
                (m.style.height = `${r}px`))
              : ((m = e.querySelector(".swiper-cube-shadow")),
                m || ((m = g("div", "swiper-cube-shadow")), e.append(m))));
          for (let e = 0; e < a.length; e += 1) {
            const t = a[e];
            let s = e;
            u && (s = parseInt(t.getAttribute("data-swiper-slide-index"), 10));
            let r = 90 * s,
              n = Math.floor(r / 360);
            l && ((r = -r), (n = Math.floor(-r / 360)));
            const d = Math.max(Math.min(t.progress, 1), -1);
            let m = 0,
              f = 0,
              g = 0;
            s % 4 == 0
              ? ((m = 4 * -n * o), (g = 0))
              : (s - 1) % 4 == 0
              ? ((m = 0), (g = 4 * -n * o))
              : (s - 2) % 4 == 0
              ? ((m = o + 4 * n * o), (g = o))
              : (s - 3) % 4 == 0 && ((m = -o), (g = 3 * o + 4 * o * n)),
              l && (m = -m),
              p || ((f = m), (m = 0));
            const v = `rotateX(${p ? 0 : -r}deg) rotateY(${
              p ? r : 0
            }deg) translate3d(${m}px, ${f}px, ${g}px)`;
            d <= 1 &&
              d > -1 &&
              ((h = 90 * s + 90 * d), l && (h = 90 * -s - 90 * d)),
              (t.style.transform = v),
              c.slideShadows && i(t, d, p);
          }
          if (
            ((s.style.transformOrigin = `50% 50% -${o / 2}px`),
            (s.style["-webkit-transform-origin"] = `50% 50% -${o / 2}px`),
            c.shadow)
          )
            if (p)
              m.style.transform = `translate3d(0px, ${
                r / 2 + c.shadowOffset
              }px, ${-r / 2}px) rotateX(90deg) rotateZ(0deg) scale(${
                c.shadowScale
              })`;
            else {
              const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                t =
                  1.5 -
                  (Math.sin((2 * e * Math.PI) / 360) / 2 +
                    Math.cos((2 * e * Math.PI) / 360) / 2),
                s = c.shadowScale,
                a = c.shadowScale / t,
                i = c.shadowOffset;
              m.style.transform = `scale3d(${s}, 1, ${a}) translate3d(0px, ${
                n / 2 + i
              }px, ${-n / 2 / a}px) rotateX(-90deg)`;
            }
          const f =
            (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -o / 2 : 0;
          (s.style.transform = `translate3d(0px,0,${f}px) rotateX(${
            t.isHorizontal() ? 0 : h
          }deg) rotateY(${t.isHorizontal() ? -h : 0}deg)`),
            s.style.setProperty("--swiper-cube-translate-z", `${f}px`);
        },
        setTransition: (e) => {
          const { el: s, slides: a } = t;
          if (
            (a.forEach((t) => {
              (t.style.transitionDuration = `${e}ms`),
                t
                  .querySelectorAll(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .forEach((t) => {
                    t.style.transitionDuration = `${e}ms`;
                  });
            }),
            t.params.cubeEffect.shadow && !t.isHorizontal())
          ) {
            const t = s.querySelector(".swiper-cube-shadow");
            t && (t.style.transitionDuration = `${e}ms`);
          }
        },
        recreateShadows: () => {
          const e = t.isHorizontal();
          t.slides.forEach((t) => {
            const s = Math.max(Math.min(t.progress, 1), -1);
            i(t, s, e);
          });
        },
        getEffectParams: () => t.params.cubeEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: !1,
          virtualTranslate: !0,
        }),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
      const i = (e, s, a) => {
        let i = t.isHorizontal()
            ? e.querySelector(".swiper-slide-shadow-left")
            : e.querySelector(".swiper-slide-shadow-top"),
          r = t.isHorizontal()
            ? e.querySelector(".swiper-slide-shadow-right")
            : e.querySelector(".swiper-slide-shadow-bottom");
        i || (i = de(0, e, t.isHorizontal() ? "left" : "top")),
          r || (r = de(0, e, t.isHorizontal() ? "right" : "bottom")),
          i && (i.style.opacity = Math.max(-s, 0)),
          r && (r.style.opacity = Math.max(s, 0));
      };
      ne({
        effect: "flip",
        swiper: t,
        on: a,
        setTranslate: () => {
          const { slides: e, rtlTranslate: s } = t,
            a = t.params.flipEffect;
          for (let r = 0; r < e.length; r += 1) {
            const n = e[r];
            let l = n.progress;
            t.params.flipEffect.limitRotation &&
              (l = Math.max(Math.min(n.progress, 1), -1));
            const o = n.swiperSlideOffset;
            let d = -180 * l,
              c = 0,
              p = t.params.cssMode ? -o - t.translate : -o,
              u = 0;
            t.isHorizontal()
              ? s && (d = -d)
              : ((u = p), (p = 0), (c = -d), (d = 0)),
              (n.style.zIndex = -Math.abs(Math.round(l)) + e.length),
              a.slideShadows && i(n, l);
            const m = `translate3d(${p}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`;
            le(0, n).style.transform = m;
          }
        },
        setTransition: (e) => {
          const s = t.slides.map((e) => h(e));
          s.forEach((t) => {
            (t.style.transitionDuration = `${e}ms`),
              t
                .querySelectorAll(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .forEach((t) => {
                  t.style.transitionDuration = `${e}ms`;
                });
          }),
            oe({ swiper: t, duration: e, transformElements: s });
        },
        recreateShadows: () => {
          t.params.flipEffect;
          t.slides.forEach((e) => {
            let s = e.progress;
            t.params.flipEffect.limitRotation &&
              (s = Math.max(Math.min(e.progress, 1), -1)),
              i(e, s);
          });
        },
        getEffectParams: () => t.params.flipEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !t.params.cssMode,
        }),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          scale: 1,
          modifier: 1,
          slideShadows: !0,
        },
      }),
        ne({
          effect: "coverflow",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { width: e, height: s, slides: a, slidesSizesGrid: i } = t,
              r = t.params.coverflowEffect,
              n = t.isHorizontal(),
              l = t.translate,
              o = n ? e / 2 - l : s / 2 - l,
              d = n ? r.rotate : -r.rotate,
              c = r.depth;
            for (let e = 0, t = a.length; e < t; e += 1) {
              const t = a[e],
                s = i[e],
                l = (o - t.swiperSlideOffset - s / 2) / s,
                p =
                  "function" == typeof r.modifier
                    ? r.modifier(l)
                    : l * r.modifier;
              let u = n ? d * p : 0,
                m = n ? 0 : d * p,
                h = -c * Math.abs(p),
                f = r.stretch;
              "string" == typeof f &&
                -1 !== f.indexOf("%") &&
                (f = (parseFloat(r.stretch) / 100) * s);
              let g = n ? 0 : f * p,
                v = n ? f * p : 0,
                w = 1 - (1 - r.scale) * Math.abs(p);
              Math.abs(v) < 0.001 && (v = 0),
                Math.abs(g) < 0.001 && (g = 0),
                Math.abs(h) < 0.001 && (h = 0),
                Math.abs(u) < 0.001 && (u = 0),
                Math.abs(m) < 0.001 && (m = 0),
                Math.abs(w) < 0.001 && (w = 0);
              const b = `translate3d(${v}px,${g}px,${h}px)  rotateX(${m}deg) rotateY(${u}deg) scale(${w})`;
              if (
                ((le(0, t).style.transform = b),
                (t.style.zIndex = 1 - Math.abs(Math.round(p))),
                r.slideShadows)
              ) {
                let e = n
                    ? t.querySelector(".swiper-slide-shadow-left")
                    : t.querySelector(".swiper-slide-shadow-top"),
                  s = n
                    ? t.querySelector(".swiper-slide-shadow-right")
                    : t.querySelector(".swiper-slide-shadow-bottom");
                e || (e = de(0, t, n ? "left" : "top")),
                  s || (s = de(0, t, n ? "right" : "bottom")),
                  e && (e.style.opacity = p > 0 ? p : 0),
                  s && (s.style.opacity = -p > 0 ? -p : 0);
              }
            }
          },
          setTransition: (e) => {
            t.slides
              .map((e) => h(e))
              .forEach((t) => {
                (t.style.transitionDuration = `${e}ms`),
                  t
                    .querySelectorAll(
                      ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                    )
                    .forEach((t) => {
                      t.style.transitionDuration = `${e}ms`;
                    });
              });
          },
          perspective: () => !0,
          overwriteParams: () => ({ watchSlidesProgress: !0 }),
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({
        creativeEffect: {
          limitProgress: 1,
          shadowPerProgress: !1,
          progressMultiplier: 1,
          perspective: !0,
          prev: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
          next: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
        },
      });
      const i = (e) => ("string" == typeof e ? e : `${e}px`);
      ne({
        effect: "creative",
        swiper: t,
        on: a,
        setTranslate: () => {
          const { slides: e, wrapperEl: s, slidesSizesGrid: a } = t,
            r = t.params.creativeEffect,
            { progressMultiplier: n } = r,
            l = t.params.centeredSlides;
          if (l) {
            const e = a[0] / 2 - t.params.slidesOffsetBefore || 0;
            s.style.transform = `translateX(calc(50% - ${e}px))`;
          }
          for (let s = 0; s < e.length; s += 1) {
            const a = e[s],
              o = a.progress,
              d = Math.min(
                Math.max(a.progress, -r.limitProgress),
                r.limitProgress
              );
            let c = d;
            l ||
              (c = Math.min(
                Math.max(a.originalProgress, -r.limitProgress),
                r.limitProgress
              ));
            const p = a.swiperSlideOffset,
              u = [t.params.cssMode ? -p - t.translate : -p, 0, 0],
              m = [0, 0, 0];
            let h = !1;
            t.isHorizontal() || ((u[1] = u[0]), (u[0] = 0));
            let f = {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              scale: 1,
              opacity: 1,
            };
            d < 0
              ? ((f = r.next), (h = !0))
              : d > 0 && ((f = r.prev), (h = !0)),
              u.forEach((e, t) => {
                u[t] = `calc(${e}px + (${i(f.translate[t])} * ${Math.abs(
                  d * n
                )}))`;
              }),
              m.forEach((e, t) => {
                m[t] = f.rotate[t] * Math.abs(d * n);
              }),
              (a.style.zIndex = -Math.abs(Math.round(o)) + e.length);
            const g = u.join(", "),
              v = `rotateX(${m[0]}deg) rotateY(${m[1]}deg) rotateZ(${m[2]}deg)`,
              w =
                c < 0
                  ? `scale(${1 + (1 - f.scale) * c * n})`
                  : `scale(${1 - (1 - f.scale) * c * n})`,
              b =
                c < 0
                  ? 1 + (1 - f.opacity) * c * n
                  : 1 - (1 - f.opacity) * c * n,
              y = `translate3d(${g}) ${v} ${w}`;
            if ((h && f.shadow) || !h) {
              let e = a.querySelector(".swiper-slide-shadow");
              if ((!e && f.shadow && (e = de(0, a)), e)) {
                const t = r.shadowPerProgress ? d * (1 / r.limitProgress) : d;
                e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
              }
            }
            const E = le(0, a);
            (E.style.transform = y),
              (E.style.opacity = b),
              f.origin && (E.style.transformOrigin = b);
          }
        },
        setTransition: (e) => {
          const s = t.slides.map((e) => h(e));
          s.forEach((t) => {
            (t.style.transitionDuration = `${e}ms`),
              t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                t.style.transitionDuration = `${e}ms`;
              });
          }),
            oe({ swiper: t, duration: e, transformElements: s, allSlides: !0 });
        },
        perspective: () => t.params.creativeEffect.perspective,
        overwriteParams: () => ({
          watchSlidesProgress: !0,
          virtualTranslate: !t.params.cssMode,
        }),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e;
      s({
        cardsEffect: {
          slideShadows: !0,
          rotate: !0,
          perSlideRotate: 2,
          perSlideOffset: 8,
        },
      }),
        ne({
          effect: "cards",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { slides: e, activeIndex: s } = t,
              a = t.params.cardsEffect,
              { startTranslate: i, isTouched: r } = t.touchEventsData,
              n = t.translate;
            for (let l = 0; l < e.length; l += 1) {
              const o = e[l],
                d = o.progress,
                c = Math.min(Math.max(d, -4), 4);
              let p = o.swiperSlideOffset;
              t.params.centeredSlides &&
                !t.params.cssMode &&
                (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`),
                t.params.centeredSlides &&
                  t.params.cssMode &&
                  (p -= e[0].swiperSlideOffset);
              let u = t.params.cssMode ? -p - t.translate : -p,
                m = 0;
              const h = -100 * Math.abs(c);
              let f = 1,
                g = -a.perSlideRotate * c,
                v = a.perSlideOffset - 0.75 * Math.abs(c);
              const w =
                  t.virtual && t.params.virtual.enabled
                    ? t.virtual.from + l
                    : l,
                b =
                  (w === s || w === s - 1) &&
                  c > 0 &&
                  c < 1 &&
                  (r || t.params.cssMode) &&
                  n < i,
                y =
                  (w === s || w === s + 1) &&
                  c < 0 &&
                  c > -1 &&
                  (r || t.params.cssMode) &&
                  n > i;
              if (b || y) {
                const e = (1 - Math.abs((Math.abs(c) - 0.5) / 0.5)) ** 0.5;
                (g += -28 * c * e),
                  (f += -0.5 * e),
                  (v += 96 * e),
                  (m = -25 * e * Math.abs(c) + "%");
              }
              if (
                ((u =
                  c < 0
                    ? `calc(${u}px + (${v * Math.abs(c)}%))`
                    : c > 0
                    ? `calc(${u}px + (-${v * Math.abs(c)}%))`
                    : `${u}px`),
                !t.isHorizontal())
              ) {
                const e = m;
                (m = u), (u = e);
              }
              const E = c < 0 ? "" + (1 + (1 - f) * c) : "" + (1 - (1 - f) * c),
                x = `\n        translate3d(${u}, ${m}, ${h}px)\n        rotateZ(${
                  a.rotate ? g : 0
                }deg)\n        scale(${E})\n      `;
              if (a.slideShadows) {
                let e = o.querySelector(".swiper-slide-shadow");
                e || (e = de(0, o)),
                  e &&
                    (e.style.opacity = Math.min(
                      Math.max((Math.abs(c) - 0.5) / 0.5, 0),
                      1
                    ));
              }
              o.style.zIndex = -Math.abs(Math.round(d)) + e.length;
              le(0, o).style.transform = x;
            }
          },
          setTransition: (e) => {
            const s = t.slides.map((e) => h(e));
            s.forEach((t) => {
              (t.style.transitionDuration = `${e}ms`),
                t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                  t.style.transitionDuration = `${e}ms`;
                });
            }),
              oe({ swiper: t, duration: e, transformElements: s });
          },
          perspective: () => !0,
          overwriteParams: () => ({
            watchSlidesProgress: !0,
            virtualTranslate: !t.params.cssMode,
          }),
        });
    },
  ];
  return Q.use(ce), Q;
});
//# sourceMappingURL=swiper-bundle.min.js.map

/**
 * Barba 2.9.7
 * https://barba.js.org
 * Copyright barba.js */
!(function (t, n) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = n())
    : "function" == typeof define && define.amd
    ? define(n)
    : ((t = t || self).barba = n());
})(this, function () {
  function t(t, n) {
    for (var r = 0; r < n.length; r++) {
      var e = n[r];
      (e.enumerable = e.enumerable || !1),
        (e.configurable = !0),
        "value" in e && (e.writable = !0),
        Object.defineProperty(t, e.key, e);
    }
  }
  function n(n, r, e) {
    return r && t(n.prototype, r), e && t(n, e), n;
  }
  function r() {
    return (r =
      Object.assign ||
      function (t) {
        for (var n = 1; n < arguments.length; n++) {
          var r = arguments[n];
          for (var e in r)
            Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
        }
        return t;
      }).apply(this, arguments);
  }
  function e(t, n) {
    (t.prototype = Object.create(n.prototype)),
      (t.prototype.constructor = t),
      (t.__proto__ = n);
  }
  function i(t) {
    return (i = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
  }
  function o(t, n) {
    return (o =
      Object.setPrototypeOf ||
      function (t, n) {
        return (t.__proto__ = n), t;
      })(t, n);
  }
  function u(t, n, r) {
    return (u = (function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (t) {
        return !1;
      }
    })()
      ? Reflect.construct
      : function (t, n, r) {
          var e = [null];
          e.push.apply(e, n);
          var i = new (Function.bind.apply(t, e))();
          return r && o(i, r.prototype), i;
        }).apply(null, arguments);
  }
  function f(t) {
    var n = "function" == typeof Map ? new Map() : void 0;
    return (f = function (t) {
      if (
        null === t ||
        -1 === Function.toString.call(t).indexOf("[native code]")
      )
        return t;
      if ("function" != typeof t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      if (void 0 !== n) {
        if (n.has(t)) return n.get(t);
        n.set(t, r);
      }
      function r() {
        return u(t, arguments, i(this).constructor);
      }
      return (
        (r.prototype = Object.create(t.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
        o(r, t)
      );
    })(t);
  }
  function s(t, n) {
    try {
      var r = t();
    } catch (t) {
      return n(t);
    }
    return r && r.then ? r.then(void 0, n) : r;
  }
  "undefined" != typeof Symbol &&
    (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))),
    "undefined" != typeof Symbol &&
      (Symbol.asyncIterator ||
        (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
  var c,
    a = "2.9.7",
    h = function () {};
  !(function (t) {
    (t[(t.off = 0)] = "off"),
      (t[(t.error = 1)] = "error"),
      (t[(t.warning = 2)] = "warning"),
      (t[(t.info = 3)] = "info"),
      (t[(t.debug = 4)] = "debug");
  })(c || (c = {}));
  var v = c.off,
    l = (function () {
      function t(t) {
        this.t = t;
      }
      (t.getLevel = function () {
        return v;
      }),
        (t.setLevel = function (t) {
          return (v = c[t]);
        });
      var n = t.prototype;
      return (
        (n.error = function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
            n[r] = arguments[r];
          this.i(console.error, c.error, n);
        }),
        (n.warn = function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
            n[r] = arguments[r];
          this.i(console.warn, c.warning, n);
        }),
        (n.info = function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
            n[r] = arguments[r];
          this.i(console.info, c.info, n);
        }),
        (n.debug = function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
            n[r] = arguments[r];
          this.i(console.log, c.debug, n);
        }),
        (n.i = function (n, r, e) {
          r <= t.getLevel() &&
            n.apply(console, ["[" + this.t + "] "].concat(e));
        }),
        t
      );
    })(),
    d = O,
    m = E,
    p = g,
    w = x,
    b = T,
    y = "/",
    P = new RegExp(
      [
        "(\\\\.)",
        "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?",
      ].join("|"),
      "g"
    );
  function g(t, n) {
    for (
      var r,
        e = [],
        i = 0,
        o = 0,
        u = "",
        f = (n && n.delimiter) || y,
        s = (n && n.whitelist) || void 0,
        c = !1;
      null !== (r = P.exec(t));

    ) {
      var a = r[0],
        h = r[1],
        v = r.index;
      if (((u += t.slice(o, v)), (o = v + a.length), h)) (u += h[1]), (c = !0);
      else {
        var l = "",
          d = r[2],
          m = r[3],
          p = r[4],
          w = r[5];
        if (!c && u.length) {
          var b = u.length - 1,
            g = u[b];
          (!s || s.indexOf(g) > -1) && ((l = g), (u = u.slice(0, b)));
        }
        u && (e.push(u), (u = ""), (c = !1));
        var E = m || p,
          x = l || f;
        e.push({
          name: d || i++,
          prefix: l,
          delimiter: x,
          optional: "?" === w || "*" === w,
          repeat: "+" === w || "*" === w,
          pattern: E ? A(E) : "[^" + k(x === f ? x : x + f) + "]+?",
        });
      }
    }
    return (u || o < t.length) && e.push(u + t.substr(o)), e;
  }
  function E(t, n) {
    return function (r, e) {
      var i = t.exec(r);
      if (!i) return !1;
      for (
        var o = i[0],
          u = i.index,
          f = {},
          s = (e && e.decode) || decodeURIComponent,
          c = 1;
        c < i.length;
        c++
      )
        if (void 0 !== i[c]) {
          var a = n[c - 1];
          f[a.name] = a.repeat
            ? i[c].split(a.delimiter).map(function (t) {
                return s(t, a);
              })
            : s(i[c], a);
        }
      return { path: o, index: u, params: f };
    };
  }
  function x(t, n) {
    for (var r = new Array(t.length), e = 0; e < t.length; e++)
      "object" == typeof t[e] &&
        (r[e] = new RegExp("^(?:" + t[e].pattern + ")$", R(n)));
    return function (n, e) {
      for (
        var i = "",
          o = (e && e.encode) || encodeURIComponent,
          u = !e || !1 !== e.validate,
          f = 0;
        f < t.length;
        f++
      ) {
        var s = t[f];
        if ("string" != typeof s) {
          var c,
            a = n ? n[s.name] : void 0;
          if (Array.isArray(a)) {
            if (!s.repeat)
              throw new TypeError(
                'Expected "' + s.name + '" to not repeat, but got array'
              );
            if (0 === a.length) {
              if (s.optional) continue;
              throw new TypeError('Expected "' + s.name + '" to not be empty');
            }
            for (var h = 0; h < a.length; h++) {
              if (((c = o(a[h], s)), u && !r[f].test(c)))
                throw new TypeError(
                  'Expected all "' + s.name + '" to match "' + s.pattern + '"'
                );
              i += (0 === h ? s.prefix : s.delimiter) + c;
            }
          } else if (
            "string" != typeof a &&
            "number" != typeof a &&
            "boolean" != typeof a
          ) {
            if (!s.optional)
              throw new TypeError(
                'Expected "' +
                  s.name +
                  '" to be ' +
                  (s.repeat ? "an array" : "a string")
              );
          } else {
            if (((c = o(String(a), s)), u && !r[f].test(c)))
              throw new TypeError(
                'Expected "' +
                  s.name +
                  '" to match "' +
                  s.pattern +
                  '", but got "' +
                  c +
                  '"'
              );
            i += s.prefix + c;
          }
        } else i += s;
      }
      return i;
    };
  }
  function k(t) {
    return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  }
  function A(t) {
    return t.replace(/([=!:$/()])/g, "\\$1");
  }
  function R(t) {
    return t && t.sensitive ? "" : "i";
  }
  function T(t, n, r) {
    for (
      var e = (r = r || {}).strict,
        i = !1 !== r.start,
        o = !1 !== r.end,
        u = r.delimiter || y,
        f = []
          .concat(r.endsWith || [])
          .map(k)
          .concat("$")
          .join("|"),
        s = i ? "^" : "",
        c = 0;
      c < t.length;
      c++
    ) {
      var a = t[c];
      if ("string" == typeof a) s += k(a);
      else {
        var h = a.repeat
          ? "(?:" +
            a.pattern +
            ")(?:" +
            k(a.delimiter) +
            "(?:" +
            a.pattern +
            "))*"
          : a.pattern;
        n && n.push(a),
          (s += a.optional
            ? a.prefix
              ? "(?:" + k(a.prefix) + "(" + h + "))?"
              : "(" + h + ")?"
            : k(a.prefix) + "(" + h + ")");
      }
    }
    if (o)
      e || (s += "(?:" + k(u) + ")?"), (s += "$" === f ? "$" : "(?=" + f + ")");
    else {
      var v = t[t.length - 1],
        l = "string" == typeof v ? v[v.length - 1] === u : void 0 === v;
      e || (s += "(?:" + k(u) + "(?=" + f + "))?"),
        l || (s += "(?=" + k(u) + "|" + f + ")");
    }
    return new RegExp(s, R(r));
  }
  function O(t, n, r) {
    return t instanceof RegExp
      ? (function (t, n) {
          if (!n) return t;
          var r = t.source.match(/\((?!\?)/g);
          if (r)
            for (var e = 0; e < r.length; e++)
              n.push({
                name: e,
                prefix: null,
                delimiter: null,
                optional: !1,
                repeat: !1,
                pattern: null,
              });
          return t;
        })(t, n)
      : Array.isArray(t)
      ? (function (t, n, r) {
          for (var e = [], i = 0; i < t.length; i++)
            e.push(O(t[i], n, r).source);
          return new RegExp("(?:" + e.join("|") + ")", R(r));
        })(t, n, r)
      : (function (t, n, r) {
          return T(g(t, r), n, r);
        })(t, n, r);
  }
  (d.match = function (t, n) {
    var r = [];
    return E(O(t, r, n), r);
  }),
    (d.regexpToFunction = m),
    (d.parse = p),
    (d.compile = function (t, n) {
      return x(g(t, n), n);
    }),
    (d.tokensToFunction = w),
    (d.tokensToRegExp = b);
  var S = {
      container: "container",
      history: "history",
      namespace: "namespace",
      prefix: "data-barba",
      prevent: "prevent",
      wrapper: "wrapper",
    },
    j = new ((function () {
      function t() {
        (this.o = S), (this.u = new DOMParser());
      }
      var n = t.prototype;
      return (
        (n.toString = function (t) {
          return t.outerHTML;
        }),
        (n.toDocument = function (t) {
          return this.u.parseFromString(t, "text/html");
        }),
        (n.toElement = function (t) {
          var n = document.createElement("div");
          return (n.innerHTML = t), n;
        }),
        (n.getHtml = function (t) {
          return (
            void 0 === t && (t = document), this.toString(t.documentElement)
          );
        }),
        (n.getWrapper = function (t) {
          return (
            void 0 === t && (t = document),
            t.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]')
          );
        }),
        (n.getContainer = function (t) {
          return (
            void 0 === t && (t = document),
            t.querySelector(
              "[" + this.o.prefix + '="' + this.o.container + '"]'
            )
          );
        }),
        (n.removeContainer = function (t) {
          document.body.contains(t) && t.parentNode.removeChild(t);
        }),
        (n.addContainer = function (t, n) {
          var r = this.getContainer();
          r ? this.s(t, r) : n.appendChild(t);
        }),
        (n.getNamespace = function (t) {
          void 0 === t && (t = document);
          var n = t.querySelector(
            "[" + this.o.prefix + "-" + this.o.namespace + "]"
          );
          return n
            ? n.getAttribute(this.o.prefix + "-" + this.o.namespace)
            : null;
        }),
        (n.getHref = function (t) {
          if (t.tagName && "a" === t.tagName.toLowerCase()) {
            if ("string" == typeof t.href) return t.href;
            var n = t.getAttribute("href") || t.getAttribute("xlink:href");
            if (n) return this.resolveUrl(n.baseVal || n);
          }
          return null;
        }),
        (n.resolveUrl = function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
            n[r] = arguments[r];
          var e = n.length;
          if (0 === e)
            throw new Error(
              "resolveUrl requires at least one argument; got none."
            );
          var i = document.createElement("base");
          if (((i.href = arguments[0]), 1 === e)) return i.href;
          var o = document.getElementsByTagName("head")[0];
          o.insertBefore(i, o.firstChild);
          for (var u, f = document.createElement("a"), s = 1; s < e; s++)
            (f.href = arguments[s]), (i.href = u = f.href);
          return o.removeChild(i), u;
        }),
        (n.s = function (t, n) {
          n.parentNode.insertBefore(t, n.nextSibling);
        }),
        t
      );
    })())(),
    M = new ((function () {
      function t() {
        (this.h = []), (this.v = -1);
      }
      var e = t.prototype;
      return (
        (e.init = function (t, n) {
          this.l = "barba";
          var r = {
            ns: n,
            scroll: { x: window.scrollX, y: window.scrollY },
            url: t,
          };
          this.h.push(r), (this.v = 0);
          var e = { from: this.l, index: 0, states: [].concat(this.h) };
          window.history && window.history.replaceState(e, "", t);
        }),
        (e.change = function (t, n, r) {
          if (r && r.state) {
            var e = r.state,
              i = e.index;
            (n = this.m(this.v - i)), this.replace(e.states), (this.v = i);
          } else this.add(t, n);
          return n;
        }),
        (e.add = function (t, n) {
          var r = this.size,
            e = this.p(n),
            i = {
              ns: "tmp",
              scroll: { x: window.scrollX, y: window.scrollY },
              url: t,
            };
          this.h.push(i), (this.v = r);
          var o = { from: this.l, index: r, states: [].concat(this.h) };
          switch (e) {
            case "push":
              window.history && window.history.pushState(o, "", t);
              break;
            case "replace":
              window.history && window.history.replaceState(o, "", t);
          }
        }),
        (e.update = function (t, n) {
          var e = n || this.v,
            i = r({}, this.get(e), {}, t);
          this.set(e, i);
        }),
        (e.remove = function (t) {
          t ? this.h.splice(t, 1) : this.h.pop(), this.v--;
        }),
        (e.clear = function () {
          (this.h = []), (this.v = -1);
        }),
        (e.replace = function (t) {
          this.h = t;
        }),
        (e.get = function (t) {
          return this.h[t];
        }),
        (e.set = function (t, n) {
          return (this.h[t] = n);
        }),
        (e.p = function (t) {
          var n = "push",
            r = t,
            e = S.prefix + "-" + S.history;
          return (
            r.hasAttribute && r.hasAttribute(e) && (n = r.getAttribute(e)), n
          );
        }),
        (e.m = function (t) {
          return Math.abs(t) > 1
            ? t > 0
              ? "forward"
              : "back"
            : 0 === t
            ? "popstate"
            : t > 0
            ? "back"
            : "forward";
        }),
        n(t, [
          {
            key: "current",
            get: function () {
              return this.h[this.v];
            },
          },
          {
            key: "state",
            get: function () {
              return this.h[this.h.length - 1];
            },
          },
          {
            key: "previous",
            get: function () {
              return this.v < 1 ? null : this.h[this.v - 1];
            },
          },
          {
            key: "size",
            get: function () {
              return this.h.length;
            },
          },
        ]),
        t
      );
    })())(),
    L = function (t, n) {
      try {
        var r = (function () {
          if (!n.next.html)
            return Promise.resolve(t).then(function (t) {
              var r = n.next;
              if (t) {
                var e = j.toElement(t);
                (r.namespace = j.getNamespace(e)),
                  (r.container = j.getContainer(e)),
                  (r.html = t),
                  M.update({ ns: r.namespace });
                var i = j.toDocument(t);
                document.title = i.title;
              }
            });
        })();
        return Promise.resolve(r && r.then ? r.then(function () {}) : void 0);
      } catch (t) {
        return Promise.reject(t);
      }
    },
    $ = d,
    _ = {
      __proto__: null,
      update: L,
      nextTick: function () {
        return new Promise(function (t) {
          window.requestAnimationFrame(t);
        });
      },
      pathToRegexp: $,
    },
    q = function () {
      return window.location.origin;
    },
    B = function (t) {
      return void 0 === t && (t = window.location.href), U(t).port;
    },
    U = function (t) {
      var n,
        r = t.match(/:\d+/);
      if (null === r)
        /^http/.test(t) && (n = 80), /^https/.test(t) && (n = 443);
      else {
        var e = r[0].substring(1);
        n = parseInt(e, 10);
      }
      var i,
        o = t.replace(q(), ""),
        u = {},
        f = o.indexOf("#");
      f >= 0 && ((i = o.slice(f + 1)), (o = o.slice(0, f)));
      var s = o.indexOf("?");
      return (
        s >= 0 && ((u = D(o.slice(s + 1))), (o = o.slice(0, s))),
        { hash: i, path: o, port: n, query: u }
      );
    },
    D = function (t) {
      return t.split("&").reduce(function (t, n) {
        var r = n.split("=");
        return (t[r[0]] = r[1]), t;
      }, {});
    },
    F = function (t) {
      return (
        void 0 === t && (t = window.location.href),
        t.replace(/(\/#.*|\/|#.*)$/, "")
      );
    },
    H = {
      __proto__: null,
      getHref: function () {
        return window.location.href;
      },
      getOrigin: q,
      getPort: B,
      getPath: function (t) {
        return void 0 === t && (t = window.location.href), U(t).path;
      },
      parse: U,
      parseQuery: D,
      clean: F,
    };
  function I(t, n, r) {
    return (
      void 0 === n && (n = 2e3),
      new Promise(function (e, i) {
        var o = new XMLHttpRequest();
        (o.onreadystatechange = function () {
          if (o.readyState === XMLHttpRequest.DONE)
            if (200 === o.status) e(o.responseText);
            else if (o.status) {
              var n = { status: o.status, statusText: o.statusText };
              r(t, n), i(n);
            }
        }),
          (o.ontimeout = function () {
            var e = new Error("Timeout error [" + n + "]");
            r(t, e), i(e);
          }),
          (o.onerror = function () {
            var n = new Error("Fetch error");
            r(t, n), i(n);
          }),
          o.open("GET", t),
          (o.timeout = n),
          o.setRequestHeader(
            "Accept",
            "text/html,application/xhtml+xml,application/xml"
          ),
          o.setRequestHeader("x-barba", "yes"),
          o.send();
      })
    );
  }
  var C = function (t) {
    return (
      !!t &&
      ("object" == typeof t || "function" == typeof t) &&
      "function" == typeof t.then
    );
  };
  function N(t, n) {
    return (
      void 0 === n && (n = {}),
      function () {
        for (var r = arguments.length, e = new Array(r), i = 0; i < r; i++)
          e[i] = arguments[i];
        var o = !1,
          u = new Promise(function (r, i) {
            n.async = function () {
              return (
                (o = !0),
                function (t, n) {
                  t ? i(t) : r(n);
                }
              );
            };
            var u = t.apply(n, e);
            o || (C(u) ? u.then(r, i) : r(u));
          });
        return u;
      }
    );
  }
  var X = new ((function (t) {
      function n() {
        var n;
        return (
          ((n = t.call(this) || this).logger = new l("@barba/core")),
          (n.all = [
            "ready",
            "page",
            "reset",
            "currentAdded",
            "currentRemoved",
            "nextAdded",
            "nextRemoved",
            "beforeOnce",
            "once",
            "afterOnce",
            "before",
            "beforeLeave",
            "leave",
            "afterLeave",
            "beforeEnter",
            "enter",
            "afterEnter",
            "after",
          ]),
          (n.registered = new Map()),
          n.init(),
          n
        );
      }
      e(n, t);
      var r = n.prototype;
      return (
        (r.init = function () {
          var t = this;
          this.registered.clear(),
            this.all.forEach(function (n) {
              t[n] ||
                (t[n] = function (r, e) {
                  t.registered.has(n) || t.registered.set(n, new Set()),
                    t.registered.get(n).add({ ctx: e || {}, fn: r });
                });
            });
        }),
        (r.do = function (t) {
          for (
            var n = this,
              r = arguments.length,
              e = new Array(r > 1 ? r - 1 : 0),
              i = 1;
            i < r;
            i++
          )
            e[i - 1] = arguments[i];
          if (this.registered.has(t)) {
            var o = Promise.resolve();
            return (
              this.registered.get(t).forEach(function (t) {
                o = o.then(function () {
                  return N(t.fn, t.ctx).apply(void 0, e);
                });
              }),
              o.catch(function (r) {
                n.logger.debug("Hook error [" + t + "]"), n.logger.error(r);
              })
            );
          }
          return Promise.resolve();
        }),
        (r.clear = function () {
          var t = this;
          this.all.forEach(function (n) {
            delete t[n];
          }),
            this.init();
        }),
        (r.help = function () {
          this.logger.info("Available hooks: " + this.all.join(","));
          var t = [];
          this.registered.forEach(function (n, r) {
            return t.push(r);
          }),
            this.logger.info("Registered hooks: " + t.join(","));
        }),
        n
      );
    })(h))(),
    z = (function () {
      function t(t) {
        if (((this.P = []), "boolean" == typeof t)) this.g = t;
        else {
          var n = Array.isArray(t) ? t : [t];
          this.P = n.map(function (t) {
            return $(t);
          });
        }
      }
      return (
        (t.prototype.checkHref = function (t) {
          if ("boolean" == typeof this.g) return this.g;
          var n = U(t).path;
          return this.P.some(function (t) {
            return null !== t.exec(n);
          });
        }),
        t
      );
    })(),
    G = (function (t) {
      function n(n) {
        var r;
        return ((r = t.call(this, n) || this).k = new Map()), r;
      }
      e(n, t);
      var i = n.prototype;
      return (
        (i.set = function (t, n, r) {
          return (
            this.k.set(t, { action: r, request: n }), { action: r, request: n }
          );
        }),
        (i.get = function (t) {
          return this.k.get(t);
        }),
        (i.getRequest = function (t) {
          return this.k.get(t).request;
        }),
        (i.getAction = function (t) {
          return this.k.get(t).action;
        }),
        (i.has = function (t) {
          return !this.checkHref(t) && this.k.has(t);
        }),
        (i.delete = function (t) {
          return this.k.delete(t);
        }),
        (i.update = function (t, n) {
          var e = r({}, this.k.get(t), {}, n);
          return this.k.set(t, e), e;
        }),
        n
      );
    })(z),
    Q = function () {
      return !window.history.pushState;
    },
    W = function (t) {
      return !t.el || !t.href;
    },
    J = function (t) {
      var n = t.event;
      return n.which > 1 || n.metaKey || n.ctrlKey || n.shiftKey || n.altKey;
    },
    K = function (t) {
      var n = t.el;
      return n.hasAttribute("target") && "_blank" === n.target;
    },
    V = function (t) {
      var n = t.el;
      return (
        (void 0 !== n.protocol && window.location.protocol !== n.protocol) ||
        (void 0 !== n.hostname && window.location.hostname !== n.hostname)
      );
    },
    Y = function (t) {
      var n = t.el;
      return void 0 !== n.port && B() !== B(n.href);
    },
    Z = function (t) {
      var n = t.el;
      return n.getAttribute && "string" == typeof n.getAttribute("download");
    },
    tt = function (t) {
      return t.el.hasAttribute(S.prefix + "-" + S.prevent);
    },
    nt = function (t) {
      return Boolean(
        t.el.closest("[" + S.prefix + "-" + S.prevent + '="all"]')
      );
    },
    rt = function (t) {
      var n = t.href;
      return F(n) === F() && B(n) === B();
    },
    et = (function (t) {
      function n(n) {
        var r;
        return (
          ((r = t.call(this, n) || this).suite = []),
          (r.tests = new Map()),
          r.init(),
          r
        );
      }
      e(n, t);
      var r = n.prototype;
      return (
        (r.init = function () {
          this.add("pushState", Q),
            this.add("exists", W),
            this.add("newTab", J),
            this.add("blank", K),
            this.add("corsDomain", V),
            this.add("corsPort", Y),
            this.add("download", Z),
            this.add("preventSelf", tt),
            this.add("preventAll", nt),
            this.add("sameUrl", rt, !1);
        }),
        (r.add = function (t, n, r) {
          void 0 === r && (r = !0),
            this.tests.set(t, n),
            r && this.suite.push(t);
        }),
        (r.run = function (t, n, r, e) {
          return this.tests.get(t)({ el: n, event: r, href: e });
        }),
        (r.checkLink = function (t, n, r) {
          var e = this;
          return this.suite.some(function (i) {
            return e.run(i, t, n, r);
          });
        }),
        n
      );
    })(z),
    it = (function (t) {
      function n(r, e) {
        var i;
        void 0 === e && (e = "Barba error");
        for (
          var o = arguments.length, u = new Array(o > 2 ? o - 2 : 0), f = 2;
          f < o;
          f++
        )
          u[f - 2] = arguments[f];
        return (
          ((i = t.call.apply(t, [this].concat(u)) || this).error = r),
          (i.label = e),
          Error.captureStackTrace &&
            Error.captureStackTrace(
              (function (t) {
                if (void 0 === t)
                  throw new ReferenceError(
                    "this hasn't been initialised - super() hasn't been called"
                  );
                return t;
              })(i),
              n
            ),
          (i.name = "BarbaError"),
          i
        );
      }
      return e(n, t), n;
    })(f(Error)),
    ot = (function () {
      function t(t) {
        void 0 === t && (t = []),
          (this.logger = new l("@barba/core")),
          (this.all = []),
          (this.page = []),
          (this.once = []),
          (this.A = [
            { name: "namespace", type: "strings" },
            { name: "custom", type: "function" },
          ]),
          t && (this.all = this.all.concat(t)),
          this.update();
      }
      var n = t.prototype;
      return (
        (n.add = function (t, n) {
          switch (t) {
            case "rule":
              this.A.splice(n.position || 0, 0, n.value);
              break;
            case "transition":
            default:
              this.all.push(n);
          }
          this.update();
        }),
        (n.resolve = function (t, n) {
          var r = this;
          void 0 === n && (n = {});
          var e = n.once ? this.once : this.page;
          e = e.filter(
            n.self
              ? function (t) {
                  return t.name && "self" === t.name;
                }
              : function (t) {
                  return !t.name || "self" !== t.name;
                }
          );
          var i = new Map(),
            o = e.find(function (e) {
              var o = !0,
                u = {};
              return (
                !(!n.self || "self" !== e.name) ||
                (r.A.reverse().forEach(function (n) {
                  o &&
                    ((o = r.R(e, n, t, u)),
                    e.from &&
                      e.to &&
                      (o = r.R(e, n, t, u, "from") && r.R(e, n, t, u, "to")),
                    e.from && !e.to && (o = r.R(e, n, t, u, "from")),
                    !e.from && e.to && (o = r.R(e, n, t, u, "to")));
                }),
                i.set(e, u),
                o)
              );
            }),
            u = i.get(o),
            f = [];
          if ((f.push(n.once ? "once" : "page"), n.self && f.push("self"), u)) {
            var s,
              c = [o];
            Object.keys(u).length > 0 && c.push(u),
              (s = this.logger).info.apply(
                s,
                ["Transition found [" + f.join(",") + "]"].concat(c)
              );
          } else this.logger.info("No transition found [" + f.join(",") + "]");
          return o;
        }),
        (n.update = function () {
          var t = this;
          (this.all = this.all
            .map(function (n) {
              return t.T(n);
            })
            .sort(function (t, n) {
              return t.priority - n.priority;
            })
            .reverse()
            .map(function (t) {
              return delete t.priority, t;
            })),
            (this.page = this.all.filter(function (t) {
              return void 0 !== t.leave || void 0 !== t.enter;
            })),
            (this.once = this.all.filter(function (t) {
              return void 0 !== t.once;
            }));
        }),
        (n.R = function (t, n, r, e, i) {
          var o = !0,
            u = !1,
            f = t,
            s = n.name,
            c = s,
            a = s,
            h = s,
            v = i ? f[i] : f,
            l = "to" === i ? r.next : r.current;
          if (i ? v && v[s] : v[s]) {
            switch (n.type) {
              case "strings":
              default:
                var d = Array.isArray(v[c]) ? v[c] : [v[c]];
                l[c] && -1 !== d.indexOf(l[c]) && (u = !0),
                  -1 === d.indexOf(l[c]) && (o = !1);
                break;
              case "object":
                var m = Array.isArray(v[a]) ? v[a] : [v[a]];
                l[a]
                  ? (l[a].name && -1 !== m.indexOf(l[a].name) && (u = !0),
                    -1 === m.indexOf(l[a].name) && (o = !1))
                  : (o = !1);
                break;
              case "function":
                v[h](r) ? (u = !0) : (o = !1);
            }
            u &&
              (i ? ((e[i] = e[i] || {}), (e[i][s] = f[i][s])) : (e[s] = f[s]));
          }
          return o;
        }),
        (n.O = function (t, n, r) {
          var e = 0;
          return (
            (t[n] || (t.from && t.from[n]) || (t.to && t.to[n])) &&
              ((e += Math.pow(10, r)),
              t.from && t.from[n] && (e += 1),
              t.to && t.to[n] && (e += 2)),
            e
          );
        }),
        (n.T = function (t) {
          var n = this;
          t.priority = 0;
          var r = 0;
          return (
            this.A.forEach(function (e, i) {
              r += n.O(t, e.name, i + 1);
            }),
            (t.priority = r),
            t
          );
        }),
        t
      );
    })(),
    ut = (function () {
      function t(t) {
        void 0 === t && (t = []),
          (this.logger = new l("@barba/core")),
          (this.S = !1),
          (this.store = new ot(t));
      }
      var r = t.prototype;
      return (
        (r.get = function (t, n) {
          return this.store.resolve(t, n);
        }),
        (r.doOnce = function (t) {
          var n = t.data,
            r = t.transition;
          try {
            var e = function () {
                i.S = !1;
              },
              i = this,
              o = r || {};
            i.S = !0;
            var u = s(
              function () {
                return Promise.resolve(i.j("beforeOnce", n, o)).then(
                  function () {
                    return Promise.resolve(i.once(n, o)).then(function () {
                      return Promise.resolve(i.j("afterOnce", n, o)).then(
                        function () {}
                      );
                    });
                  }
                );
              },
              function (t) {
                (i.S = !1),
                  i.logger.debug("Transition error [before/after/once]"),
                  i.logger.error(t);
              }
            );
            return Promise.resolve(u && u.then ? u.then(e) : e());
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.doPage = function (t) {
          var n = t.data,
            r = t.transition,
            e = t.page,
            i = t.wrapper;
          try {
            var o = function (t) {
                if (u) return t;
                f.S = !1;
              },
              u = !1,
              f = this,
              c = r || {},
              a = !0 === c.sync || !1;
            f.S = !0;
            var h = s(
              function () {
                function t() {
                  return Promise.resolve(f.j("before", n, c)).then(function () {
                    var t = !1;
                    function r(r) {
                      return t
                        ? r
                        : Promise.resolve(f.remove(n)).then(function () {
                            return Promise.resolve(f.j("after", n, c)).then(
                              function () {}
                            );
                          });
                    }
                    var o = (function () {
                      if (a)
                        return s(
                          function () {
                            return Promise.resolve(f.add(n, i)).then(
                              function () {
                                return Promise.resolve(
                                  f.j("beforeLeave", n, c)
                                ).then(function () {
                                  return Promise.resolve(
                                    f.j("beforeEnter", n, c)
                                  ).then(function () {
                                    return Promise.resolve(
                                      Promise.all([
                                        f.leave(n, c),
                                        f.enter(n, c),
                                      ])
                                    ).then(function () {
                                      return Promise.resolve(
                                        f.j("afterLeave", n, c)
                                      ).then(function () {
                                        return Promise.resolve(
                                          f.j("afterEnter", n, c)
                                        ).then(function () {});
                                      });
                                    });
                                  });
                                });
                              }
                            );
                          },
                          function (t) {
                            if (f.M(t))
                              throw new it(t, "Transition error [sync]");
                          }
                        );
                      var r = function (r) {
                          return t
                            ? r
                            : s(
                                function () {
                                  var t = (function () {
                                    if (!1 !== o)
                                      return Promise.resolve(f.add(n, i)).then(
                                        function () {
                                          return Promise.resolve(
                                            f.j("beforeEnter", n, c)
                                          ).then(function () {
                                            return Promise.resolve(
                                              f.enter(n, c, o)
                                            ).then(function () {
                                              return Promise.resolve(
                                                f.j("afterEnter", n, c)
                                              ).then(function () {});
                                            });
                                          });
                                        }
                                      );
                                  })();
                                  if (t && t.then)
                                    return t.then(function () {});
                                },
                                function (t) {
                                  if (f.M(t))
                                    throw new it(
                                      t,
                                      "Transition error [before/after/enter]"
                                    );
                                }
                              );
                        },
                        o = !1,
                        u = s(
                          function () {
                            return Promise.resolve(
                              f.j("beforeLeave", n, c)
                            ).then(function () {
                              return Promise.resolve(
                                Promise.all([f.leave(n, c), L(e, n)]).then(
                                  function (t) {
                                    return t[0];
                                  }
                                )
                              ).then(function (t) {
                                return (
                                  (o = t),
                                  Promise.resolve(f.j("afterLeave", n, c)).then(
                                    function () {}
                                  )
                                );
                              });
                            });
                          },
                          function (t) {
                            if (f.M(t))
                              throw new it(
                                t,
                                "Transition error [before/after/leave]"
                              );
                          }
                        );
                      return u && u.then ? u.then(r) : r(u);
                    })();
                    return o && o.then ? o.then(r) : r(o);
                  });
                }
                var r = (function () {
                  if (a) return Promise.resolve(L(e, n)).then(function () {});
                })();
                return r && r.then ? r.then(t) : t();
              },
              function (t) {
                if (((f.S = !1), t.name && "BarbaError" === t.name))
                  throw (f.logger.debug(t.label), f.logger.error(t.error), t);
                throw (
                  (f.logger.debug("Transition error [page]"),
                  f.logger.error(t),
                  t)
                );
              }
            );
            return Promise.resolve(h && h.then ? h.then(o) : o(h));
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.once = function (t, n) {
          try {
            return Promise.resolve(X.do("once", t, n)).then(function () {
              return n.once ? N(n.once, n)(t) : Promise.resolve();
            });
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.leave = function (t, n) {
          try {
            return Promise.resolve(X.do("leave", t, n)).then(function () {
              return n.leave ? N(n.leave, n)(t) : Promise.resolve();
            });
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.enter = function (t, n, r) {
          try {
            return Promise.resolve(X.do("enter", t, n)).then(function () {
              return n.enter ? N(n.enter, n)(t, r) : Promise.resolve();
            });
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.add = function (t, n) {
          try {
            return (
              j.addContainer(t.next.container, n),
              X.do("nextAdded", t),
              Promise.resolve()
            );
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.remove = function (t) {
          try {
            return (
              j.removeContainer(t.current.container),
              X.do("currentRemoved", t),
              Promise.resolve()
            );
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        (r.M = function (t) {
          return t.message
            ? !/Timeout error|Fetch error/.test(t.message)
            : !t.status;
        }),
        (r.j = function (t, n, r) {
          try {
            return Promise.resolve(X.do(t, n, r)).then(function () {
              return r[t] ? N(r[t], r)(n) : Promise.resolve();
            });
          } catch (t) {
            return Promise.reject(t);
          }
        }),
        n(t, [
          {
            key: "isRunning",
            get: function () {
              return this.S;
            },
            set: function (t) {
              this.S = t;
            },
          },
          {
            key: "hasOnce",
            get: function () {
              return this.store.once.length > 0;
            },
          },
          {
            key: "hasSelf",
            get: function () {
              return this.store.all.some(function (t) {
                return "self" === t.name;
              });
            },
          },
          {
            key: "shouldWait",
            get: function () {
              return this.store.all.some(function (t) {
                return (t.to && !t.to.route) || t.sync;
              });
            },
          },
        ]),
        t
      );
    })(),
    ft = (function () {
      function t(t) {
        var n = this;
        (this.names = [
          "beforeLeave",
          "afterLeave",
          "beforeEnter",
          "afterEnter",
        ]),
          (this.byNamespace = new Map()),
          0 !== t.length &&
            (t.forEach(function (t) {
              n.byNamespace.set(t.namespace, t);
            }),
            this.names.forEach(function (t) {
              X[t](n.L(t));
            }));
      }
      return (
        (t.prototype.L = function (t) {
          var n = this;
          return function (r) {
            var e = t.match(/enter/i) ? r.next : r.current,
              i = n.byNamespace.get(e.namespace);
            return i && i[t] ? N(i[t], i)(r) : Promise.resolve();
          };
        }),
        t
      );
    })();
  Element.prototype.matches ||
    (Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector),
    Element.prototype.closest ||
      (Element.prototype.closest = function (t) {
        var n = this;
        do {
          if (n.matches(t)) return n;
          n = n.parentElement || n.parentNode;
        } while (null !== n && 1 === n.nodeType);
        return null;
      });
  var st = {
    container: null,
    html: "",
    namespace: "",
    url: { hash: "", href: "", path: "", port: null, query: {} },
  };
  return new ((function () {
    function t() {
      (this.version = a),
        (this.schemaPage = st),
        (this.Logger = l),
        (this.logger = new l("@barba/core")),
        (this.plugins = []),
        (this.hooks = X),
        (this.dom = j),
        (this.helpers = _),
        (this.history = M),
        (this.request = I),
        (this.url = H);
    }
    var e = t.prototype;
    return (
      (e.use = function (t, n) {
        var r = this.plugins;
        r.indexOf(t) > -1
          ? this.logger.warn("Plugin [" + t.name + "] already installed.")
          : "function" == typeof t.install
          ? (t.install(this, n), r.push(t))
          : this.logger.warn(
              "Plugin [" + t.name + '] has no "install" method.'
            );
      }),
      (e.init = function (t) {
        var n = void 0 === t ? {} : t,
          e = n.transitions,
          i = void 0 === e ? [] : e,
          o = n.views,
          u = void 0 === o ? [] : o,
          f = n.schema,
          s = void 0 === f ? S : f,
          c = n.requestError,
          a = n.timeout,
          h = void 0 === a ? 2e3 : a,
          v = n.cacheIgnore,
          d = void 0 !== v && v,
          m = n.prefetchIgnore,
          p = void 0 !== m && m,
          w = n.preventRunning,
          b = void 0 !== w && w,
          y = n.prevent,
          P = void 0 === y ? null : y,
          g = n.debug,
          E = n.logLevel;
        if (
          (l.setLevel(
            !0 === (void 0 !== g && g) ? "debug" : void 0 === E ? "off" : E
          ),
          this.logger.info(this.version),
          Object.keys(s).forEach(function (t) {
            S[t] && (S[t] = s[t]);
          }),
          (this.$ = c),
          (this.timeout = h),
          (this.cacheIgnore = d),
          (this.prefetchIgnore = p),
          (this.preventRunning = b),
          (this._ = this.dom.getWrapper()),
          !this._)
        )
          throw new Error("[@barba/core] No Barba wrapper found");
        this._.setAttribute("aria-live", "polite"), this.q();
        var x = this.data.current;
        if (!x.container)
          throw new Error("[@barba/core] No Barba container found");
        if (
          ((this.cache = new G(d)),
          (this.prevent = new et(p)),
          (this.transitions = new ut(i)),
          (this.views = new ft(u)),
          null !== P)
        ) {
          if ("function" != typeof P)
            throw new Error("[@barba/core] Prevent should be a function");
          this.prevent.add("preventCustom", P);
        }
        this.history.init(x.url.href, x.namespace),
          (this.B = this.B.bind(this)),
          (this.U = this.U.bind(this)),
          (this.D = this.D.bind(this)),
          this.F(),
          this.plugins.forEach(function (t) {
            return t.init();
          });
        var k = this.data;
        (k.trigger = "barba"),
          (k.next = k.current),
          (k.current = r({}, this.schemaPage)),
          this.hooks.do("ready", k),
          this.once(k),
          this.q();
      }),
      (e.destroy = function () {
        this.q(),
          this.H(),
          this.history.clear(),
          this.hooks.clear(),
          (this.plugins = []);
      }),
      (e.force = function (t) {
        window.location.assign(t);
      }),
      (e.go = function (t, n, r) {
        var e;
        if ((void 0 === n && (n = "barba"), this.transitions.isRunning))
          this.force(t);
        else if (
          !(e =
            "popstate" === n
              ? this.history.current &&
                this.url.getPath(this.history.current.url) ===
                  this.url.getPath(t)
              : this.prevent.run("sameUrl", null, null, t)) ||
          this.transitions.hasSelf
        )
          return (
            (n = this.history.change(t, n, r)),
            r && (r.stopPropagation(), r.preventDefault()),
            this.page(t, n, e)
          );
      }),
      (e.once = function (t) {
        try {
          var n = this;
          return Promise.resolve(n.hooks.do("beforeEnter", t)).then(
            function () {
              function r() {
                return Promise.resolve(n.hooks.do("afterEnter", t)).then(
                  function () {}
                );
              }
              var e = (function () {
                if (n.transitions.hasOnce) {
                  var r = n.transitions.get(t, { once: !0 });
                  return Promise.resolve(
                    n.transitions.doOnce({ transition: r, data: t })
                  ).then(function () {});
                }
              })();
              return e && e.then ? e.then(r) : r();
            }
          );
        } catch (t) {
          return Promise.reject(t);
        }
      }),
      (e.page = function (t, n, e) {
        try {
          var i = function () {
              var t = o.data;
              return Promise.resolve(o.hooks.do("page", t)).then(function () {
                var n = s(
                  function () {
                    var n = o.transitions.get(t, { once: !1, self: e });
                    return Promise.resolve(
                      o.transitions.doPage({
                        data: t,
                        page: u,
                        transition: n,
                        wrapper: o._,
                      })
                    ).then(function () {
                      o.q();
                    });
                  },
                  function () {
                    0 === l.getLevel() && o.force(t.current.url.href);
                  }
                );
                if (n && n.then) return n.then(function () {});
              });
            },
            o = this;
          (o.data.next.url = r({ href: t }, o.url.parse(t))),
            (o.data.trigger = n);
          var u = o.cache.has(t)
              ? o.cache.update(t, { action: "click" }).request
              : o.cache.set(
                  t,
                  o.request(t, o.timeout, o.onRequestError.bind(o, n)),
                  "click"
                ).request,
            f = (function () {
              if (o.transitions.shouldWait)
                return Promise.resolve(L(u, o.data)).then(function () {});
            })();
          return Promise.resolve(f && f.then ? f.then(i) : i());
        } catch (t) {
          return Promise.reject(t);
        }
      }),
      (e.onRequestError = function (t) {
        this.transitions.isRunning = !1;
        for (
          var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), e = 1;
          e < n;
          e++
        )
          r[e - 1] = arguments[e];
        var i = r[0],
          o = r[1],
          u = this.cache.getAction(i);
        return (
          this.cache.delete(i),
          !(
            (this.$ && !1 === this.$(t, u, i, o)) ||
            ("click" === u && this.force(i), 1)
          )
        );
      }),
      (e.prefetch = function (t) {
        var n = this;
        this.cache.has(t) ||
          this.cache.set(
            t,
            this.request(
              t,
              this.timeout,
              this.onRequestError.bind(this, "barba")
            ).catch(function (t) {
              n.logger.error(t);
            }),
            "prefetch"
          );
      }),
      (e.F = function () {
        !0 !== this.prefetchIgnore &&
          (document.addEventListener("mouseover", this.B),
          document.addEventListener("touchstart", this.B)),
          document.addEventListener("click", this.U),
          window.addEventListener("popstate", this.D);
      }),
      (e.H = function () {
        !0 !== this.prefetchIgnore &&
          (document.removeEventListener("mouseover", this.B),
          document.removeEventListener("touchstart", this.B)),
          document.removeEventListener("click", this.U),
          window.removeEventListener("popstate", this.D);
      }),
      (e.B = function (t) {
        var n = this,
          r = this.I(t);
        if (r) {
          var e = this.dom.getHref(r);
          this.prevent.checkHref(e) ||
            this.cache.has(e) ||
            this.cache.set(
              e,
              this.request(
                e,
                this.timeout,
                this.onRequestError.bind(this, r)
              ).catch(function (t) {
                n.logger.error(t);
              }),
              "enter"
            );
        }
      }),
      (e.U = function (t) {
        var n = this.I(t);
        if (n)
          return this.transitions.isRunning && this.preventRunning
            ? (t.preventDefault(), void t.stopPropagation())
            : void this.go(this.dom.getHref(n), n, t);
      }),
      (e.D = function (t) {
        this.go(this.url.getHref(), "popstate", t);
      }),
      (e.I = function (t) {
        for (var n = t.target; n && !this.dom.getHref(n); ) n = n.parentNode;
        if (n && !this.prevent.checkLink(n, t, this.dom.getHref(n))) return n;
      }),
      (e.q = function () {
        var t = this.url.getHref(),
          n = {
            container: this.dom.getContainer(),
            html: this.dom.getHtml(),
            namespace: this.dom.getNamespace(),
            url: r({ href: t }, this.url.parse(t)),
          };
        (this.C = {
          current: n,
          next: r({}, this.schemaPage),
          trigger: void 0,
        }),
          this.hooks.do("reset", this.data);
      }),
      n(t, [
        {
          key: "data",
          get: function () {
            return this.C;
          },
        },
        {
          key: "wrapper",
          get: function () {
            return this._;
          },
        },
      ]),
      t
    );
  })())();
});
//# sourceMappingURL=barba.umd.js.map
/**
 * Muuri v0.9.5
 * https://muuri.dev/
 * Copyright (c) 2015-present, Haltu Oy
 * Released under the MIT license
 * https://github.com/haltu/muuri/blob/master/LICENSE.md
 * @license MIT
 *
 * Muuri Packer
 * Copyright (c) 2016-present, Niklas Rämö <inramo@gmail.com>
 * @license MIT
 *
 * Muuri Ticker / Muuri Emitter / Muuri Dragger
 * Copyright (c) 2018-present, Niklas Rämö <inramo@gmail.com>
 * @license MIT
 *
 * Muuri AutoScroller
 * Copyright (c) 2019-present, Niklas Rämö <inramo@gmail.com>
 * @license MIT
 */
!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t = "undefined" != typeof globalThis ? globalThis : t || self).Muuri =
        e());
})(this, function () {
  "use strict";
  var t = {},
    e = "function" == typeof Map ? new Map() : null,
    i = "swap",
    s = "move",
    n = "layoutStart",
    o = "layoutEnd",
    r = "layoutAbort",
    h = "remove",
    a = "hideStart",
    _ = "filter",
    l = "sort",
    d = "move",
    u = "send",
    c = "beforeSend",
    f = "receive",
    p = "beforeReceive",
    m = "dragReleaseEnd",
    g = "ontouchstart" in window,
    v = !!window.PointerEvent,
    y = !!window.navigator.msPointerEnabled;
  function S() {
    (this._events = {}),
      (this._queue = []),
      (this._counter = 0),
      (this._clearOnEmit = !1);
  }
  (S.prototype.on = function (t, e) {
    if (!this._events || !t || !e) return this;
    var i = this._events[t];
    return i || (i = this._events[t] = []), i.push(e), this;
  }),
    (S.prototype.off = function (t, e) {
      if (!this._events || !t || !e) return this;
      var i,
        s = this._events[t];
      if (!s || !s.length) return this;
      for (; -1 !== (i = s.indexOf(e)); ) s.splice(i, 1);
      return this;
    }),
    (S.prototype.clear = function (t) {
      if (!this._events || !t) return this;
      var e = this._events[t];
      return e && ((e.length = 0), delete this._events[t]), this;
    }),
    (S.prototype.emit = function (t) {
      if (!this._events || !t) return (this._clearOnEmit = !1), this;
      var e = this._events[t];
      if (!e || !e.length) return (this._clearOnEmit = !1), this;
      var i,
        s = this._queue,
        n = s.length,
        o = arguments.length - 1;
      o > 3 && ((i = []).push.apply(i, arguments), i.shift()),
        s.push.apply(s, e),
        this._clearOnEmit && ((e.length = 0), (this._clearOnEmit = !1)),
        ++this._counter;
      for (var r = n, h = s.length; r < h; r++)
        if (
          (0 === o
            ? s[r]()
            : 1 === o
            ? s[r](arguments[1])
            : 2 === o
            ? s[r](arguments[1], arguments[2])
            : 3 === o
            ? s[r](arguments[1], arguments[2], arguments[3])
            : s[r].apply(null, i),
          !this._events)
        )
          return this;
      return --this._counter, this._counter || (s.length = 0), this;
    }),
    (S.prototype.burst = function () {
      return this._events
        ? ((this._clearOnEmit = !0), this.emit.apply(this, arguments), this)
        : this;
    }),
    (S.prototype.countListeners = function (t) {
      if (!this._events) return 0;
      var e = this._events[t];
      return e ? e.length : 0;
    }),
    (S.prototype.destroy = function () {
      return this._events
        ? ((this._queue.length = this._counter = 0),
          (this._events = null),
          this)
        : this;
    });
  var w = v ? "pointerout" : y ? "MSPointerOut" : "";
  function D(t) {
    w &&
      ((this._dragger = t),
      (this._timeout = null),
      (this._outEvent = null),
      (this._isActive = !1),
      (this._addBehaviour = this._addBehaviour.bind(this)),
      (this._removeBehaviour = this._removeBehaviour.bind(this)),
      (this._onTimeout = this._onTimeout.bind(this)),
      (this._resetData = this._resetData.bind(this)),
      (this._onStart = this._onStart.bind(this)),
      (this._onOut = this._onOut.bind(this)),
      this._dragger.on("start", this._onStart));
  }
  (D.prototype._addBehaviour = function () {
    this._isActive ||
      ((this._isActive = !0),
      this._dragger.on("move", this._resetData),
      this._dragger.on("cancel", this._removeBehaviour),
      this._dragger.on("end", this._removeBehaviour),
      window.addEventListener(w, this._onOut));
  }),
    (D.prototype._removeBehaviour = function () {
      this._isActive &&
        (this._dragger.off("move", this._resetData),
        this._dragger.off("cancel", this._removeBehaviour),
        this._dragger.off("end", this._removeBehaviour),
        window.removeEventListener(w, this._onOut),
        this._resetData(),
        (this._isActive = !1));
    }),
    (D.prototype._resetData = function () {
      window.clearTimeout(this._timeout),
        (this._timeout = null),
        (this._outEvent = null);
    }),
    (D.prototype._onStart = function (t) {
      "mouse" !== t.pointerType && this._addBehaviour();
    }),
    (D.prototype._onOut = function (t) {
      this._dragger._getTrackedTouch(t) &&
        (this._resetData(),
        (this._outEvent = t),
        (this._timeout = window.setTimeout(this._onTimeout, 100)));
    }),
    (D.prototype._onTimeout = function () {
      var t = this._outEvent;
      this._resetData(), this._dragger.isActive() && this._dragger._onCancel(t);
    }),
    (D.prototype.destroy = function () {
      w && (this._dragger.off("start", this._onStart), this._removeBehaviour());
    });
  var b = ["", "webkit", "moz", "ms", "o", "Webkit", "Moz", "MS", "O"],
    A = {};
  function E(t, e) {
    var i = A[e] || "";
    if (i) return i;
    for (var s = e[0].toUpperCase() + e.slice(1), n = 0; n < b.length; ) {
      if ((i = b[n] ? b[n] + s : e) in t) return (A[e] = i), i;
      ++n;
    }
    return "";
  }
  function T() {
    var t = !1;
    try {
      var e = Object.defineProperty({}, "passive", {
        get: function () {
          t = !0;
        },
      });
      window.addEventListener("testPassive", null, e),
        window.removeEventListener("testPassive", null, e);
    } catch (t) {}
    return t;
  }
  var x = window.navigator.userAgent.toLowerCase(),
    k = x.indexOf("edge") > -1,
    L = x.indexOf("trident") > -1,
    R = x.indexOf("firefox") > -1,
    I = x.indexOf("android") > -1,
    C = !!T() && { passive: !0 },
    M = "touchAction",
    P = E(document.documentElement.style, M);
  function X(t, e) {
    (this._element = t),
      (this._emitter = new S()),
      (this._isDestroyed = !1),
      (this._cssProps = {}),
      (this._touchAction = ""),
      (this._isActive = !1),
      (this._pointerId = null),
      (this._startTime = 0),
      (this._startX = 0),
      (this._startY = 0),
      (this._currentX = 0),
      (this._currentY = 0),
      (this._onStart = this._onStart.bind(this)),
      (this._onMove = this._onMove.bind(this)),
      (this._onCancel = this._onCancel.bind(this)),
      (this._onEnd = this._onEnd.bind(this)),
      (this._edgeHack = null),
      (k || L) && (v || y) && (this._edgeHack = new D(this)),
      this.setCssProps(e),
      this._touchAction || this.setTouchAction("auto"),
      t.addEventListener("dragstart", X._preventDefault, !1),
      t.addEventListener(X._inputEvents.start, this._onStart, C);
  }
  (X._pointerEvents = {
    start: "pointerdown",
    move: "pointermove",
    cancel: "pointercancel",
    end: "pointerup",
  }),
    (X._msPointerEvents = {
      start: "MSPointerDown",
      move: "MSPointerMove",
      cancel: "MSPointerCancel",
      end: "MSPointerUp",
    }),
    (X._touchEvents = {
      start: "touchstart",
      move: "touchmove",
      cancel: "touchcancel",
      end: "touchend",
    }),
    (X._mouseEvents = {
      start: "mousedown",
      move: "mousemove",
      cancel: "",
      end: "mouseup",
    }),
    (X._inputEvents = g
      ? X._touchEvents
      : v
      ? X._pointerEvents
      : y
      ? X._msPointerEvents
      : X._mouseEvents),
    (X._emitter = new S()),
    (X._emitterEvents = {
      start: "start",
      move: "move",
      end: "end",
      cancel: "cancel",
    }),
    (X._activeInstances = []),
    (X._preventDefault = function (t) {
      t.preventDefault && !1 !== t.cancelable && t.preventDefault();
    }),
    (X._activateInstance = function (t) {
      X._activeInstances.indexOf(t) > -1 ||
        (X._activeInstances.push(t),
        X._emitter.on(X._emitterEvents.move, t._onMove),
        X._emitter.on(X._emitterEvents.cancel, t._onCancel),
        X._emitter.on(X._emitterEvents.end, t._onEnd),
        1 === X._activeInstances.length && X._bindListeners());
    }),
    (X._deactivateInstance = function (t) {
      var e = X._activeInstances.indexOf(t);
      -1 !== e &&
        (X._activeInstances.splice(e, 1),
        X._emitter.off(X._emitterEvents.move, t._onMove),
        X._emitter.off(X._emitterEvents.cancel, t._onCancel),
        X._emitter.off(X._emitterEvents.end, t._onEnd),
        X._activeInstances.length || X._unbindListeners());
    }),
    (X._bindListeners = function () {
      window.addEventListener(X._inputEvents.move, X._onMove, C),
        window.addEventListener(X._inputEvents.end, X._onEnd, C),
        X._inputEvents.cancel &&
          window.addEventListener(X._inputEvents.cancel, X._onCancel, C);
    }),
    (X._unbindListeners = function () {
      window.removeEventListener(X._inputEvents.move, X._onMove, C),
        window.removeEventListener(X._inputEvents.end, X._onEnd, C),
        X._inputEvents.cancel &&
          window.removeEventListener(X._inputEvents.cancel, X._onCancel, C);
    }),
    (X._getEventPointerId = function (t) {
      return "number" == typeof t.pointerId
        ? t.pointerId
        : t.changedTouches
        ? t.changedTouches[0]
          ? t.changedTouches[0].identifier
          : null
        : 1;
    }),
    (X._getTouchById = function (t, e) {
      if ("number" == typeof t.pointerId) return t.pointerId === e ? t : null;
      if (t.changedTouches) {
        for (var i = 0; i < t.changedTouches.length; i++)
          if (t.changedTouches[i].identifier === e) return t.changedTouches[i];
        return null;
      }
      return t;
    }),
    (X._onMove = function (t) {
      X._emitter.emit(X._emitterEvents.move, t);
    }),
    (X._onCancel = function (t) {
      X._emitter.emit(X._emitterEvents.cancel, t);
    }),
    (X._onEnd = function (t) {
      X._emitter.emit(X._emitterEvents.end, t);
    }),
    (X.prototype._reset = function () {
      (this._pointerId = null),
        (this._startTime = 0),
        (this._startX = 0),
        (this._startY = 0),
        (this._currentX = 0),
        (this._currentY = 0),
        (this._isActive = !1),
        X._deactivateInstance(this);
    }),
    (X.prototype._createEvent = function (t, e) {
      var i = this._getTrackedTouch(e);
      return {
        type: t,
        srcEvent: e,
        distance: this.getDistance(),
        deltaX: this.getDeltaX(),
        deltaY: this.getDeltaY(),
        deltaTime: t === X._emitterEvents.start ? 0 : this.getDeltaTime(),
        isFirst: t === X._emitterEvents.start,
        isFinal: t === X._emitterEvents.end || t === X._emitterEvents.cancel,
        pointerType: e.pointerType || (e.touches ? "touch" : "mouse"),
        identifier: this._pointerId,
        screenX: i.screenX,
        screenY: i.screenY,
        clientX: i.clientX,
        clientY: i.clientY,
        pageX: i.pageX,
        pageY: i.pageY,
        target: i.target,
      };
    }),
    (X.prototype._emit = function (t, e) {
      this._emitter.emit(t, this._createEvent(t, e));
    }),
    (X.prototype._getTrackedTouch = function (t) {
      return null === this._pointerId
        ? null
        : X._getTouchById(t, this._pointerId);
    }),
    (X.prototype._onStart = function (t) {
      if (
        !this._isDestroyed &&
        null === this._pointerId &&
        ((this._pointerId = X._getEventPointerId(t)), null !== this._pointerId)
      ) {
        var e = this._getTrackedTouch(t);
        (this._startX = this._currentX = e.clientX),
          (this._startY = this._currentY = e.clientY),
          (this._startTime = Date.now()),
          (this._isActive = !0),
          this._emit(X._emitterEvents.start, t),
          this._isActive && X._activateInstance(this);
      }
    }),
    (X.prototype._onMove = function (t) {
      var e = this._getTrackedTouch(t);
      e &&
        ((this._currentX = e.clientX),
        (this._currentY = e.clientY),
        this._emit(X._emitterEvents.move, t));
    }),
    (X.prototype._onCancel = function (t) {
      this._getTrackedTouch(t) &&
        (this._emit(X._emitterEvents.cancel, t), this._reset());
    }),
    (X.prototype._onEnd = function (t) {
      this._getTrackedTouch(t) &&
        (this._emit(X._emitterEvents.end, t), this._reset());
    }),
    (X.prototype.isActive = function () {
      return this._isActive;
    }),
    (X.prototype.setTouchAction = function (t) {
      (this._touchAction = t),
        P && ((this._cssProps[P] = ""), (this._element.style[P] = t)),
        g &&
          (this._element.removeEventListener(
            X._touchEvents.start,
            X._preventDefault,
            !0
          ),
          (this._element.style[P] !== t || (R && I)) &&
            this._element.addEventListener(
              X._touchEvents.start,
              X._preventDefault,
              !0
            ));
    }),
    (X.prototype.setCssProps = function (t) {
      if (t) {
        var e,
          i,
          s = this._cssProps,
          n = this._element;
        for (e in s) (n.style[e] = s[e]), delete s[e];
        for (e in t)
          t[e] &&
            (e !== M
              ? (i = E(n.style, e)) && ((s[i] = ""), (n.style[i] = t[e]))
              : this.setTouchAction(t[e]));
      }
    }),
    (X.prototype.getDeltaX = function () {
      return this._currentX - this._startX;
    }),
    (X.prototype.getDeltaY = function () {
      return this._currentY - this._startY;
    }),
    (X.prototype.getDistance = function () {
      var t = this.getDeltaX(),
        e = this.getDeltaY();
      return Math.sqrt(t * t + e * e);
    }),
    (X.prototype.getDeltaTime = function () {
      return this._startTime ? Date.now() - this._startTime : 0;
    }),
    (X.prototype.on = function (t, e) {
      this._emitter.on(t, e);
    }),
    (X.prototype.off = function (t, e) {
      this._emitter.off(t, e);
    }),
    (X.prototype.destroy = function () {
      if (!this._isDestroyed) {
        var t = this._element;
        for (var e in (this._edgeHack && this._edgeHack.destroy(),
        this._reset(),
        this._emitter.destroy(),
        t.removeEventListener(X._inputEvents.start, this._onStart, C),
        t.removeEventListener("dragstart", X._preventDefault, !1),
        t.removeEventListener(X._touchEvents.start, X._preventDefault, !0),
        this._cssProps))
          (t.style[e] = this._cssProps[e]), delete this._cssProps[e];
        (this._element = null), (this._isDestroyed = !0);
      }
    });
  var Y = (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (t) {
      return this.setTimeout(function () {
        t(Date.now());
      }, 16.666666666666668);
    }
  ).bind(window);
  function q(t) {
    (this._nextStep = null),
      (this._lanes = []),
      (this._stepQueue = []),
      (this._stepCallbacks = {}),
      (this._step = this._step.bind(this));
    for (var e = 0; e < t; e++) this._lanes.push(new O());
  }
  function O() {
    (this.queue = []), (this.indices = {}), (this.callbacks = {});
  }
  (q.prototype._step = function (t) {
    var e,
      i,
      s,
      n,
      o,
      r,
      h = this._lanes,
      a = this._stepQueue,
      _ = this._stepCallbacks;
    for (this._nextStep = null, e = 0; e < h.length; e++) {
      for (
        n = h[e].queue, o = h[e].callbacks, r = h[e].indices, i = 0;
        i < n.length;
        i++
      )
        (s = n[i]) && (a.push(s), (_[s] = o[s]), delete o[s], delete r[s]);
      n.length = 0;
    }
    for (e = 0; e < a.length; e++) _[(s = a[e])] && _[s](t), delete _[s];
    a.length = 0;
  }),
    (q.prototype.add = function (t, e, i) {
      this._lanes[t].add(e, i),
        this._nextStep || (this._nextStep = Y(this._step));
    }),
    (q.prototype.remove = function (t, e) {
      this._lanes[t].remove(e);
    }),
    (O.prototype.add = function (t, e) {
      var i = this.indices[t];
      void 0 !== i && (this.queue[i] = void 0),
        this.queue.push(t),
        (this.callbacks[t] = e),
        (this.indices[t] = this.queue.length - 1);
    }),
    (O.prototype.remove = function (t) {
      var e = this.indices[t];
      void 0 !== e &&
        ((this.queue[e] = void 0),
        delete this.callbacks[t],
        delete this.indices[t]);
    });
  var H = "layoutRead",
    G = "layoutWrite",
    W = "visibilityRead",
    B = "visibilityWrite",
    N = "dragStartRead",
    F = "dragStartWrite",
    z = "dragMoveRead",
    V = "dragMoveWrite",
    j = "dragScrollRead",
    Q = "dragScrollWrite",
    U = "dragSortRead",
    Z = "placeholderLayoutRead",
    J = "placeholderLayoutWrite",
    $ = "placeholderResizeWrite",
    K = "autoScrollRead",
    tt = "autoScrollWrite",
    et = "debounceRead",
    it = new q(3);
  function st(t) {
    it.remove(0, H + t), it.remove(2, G + t);
  }
  function nt(t) {
    it.remove(0, W + t), it.remove(2, B + t);
  }
  function ot(t) {
    it.remove(0, N + t), it.remove(2, F + t);
  }
  function rt(t) {
    it.remove(0, z + t), it.remove(2, V + t);
  }
  function ht(t) {
    it.remove(0, j + t), it.remove(2, Q + t);
  }
  function at(t, e) {
    it.add(1, U + t, e);
  }
  function _t(t) {
    it.remove(0, Z + t), it.remove(2, J + t);
  }
  function lt(t, e) {
    it.add(0, K, t), it.add(2, tt, e);
  }
  function dt(t) {
    return "function" == typeof t;
  }
  var ut = "function" == typeof WeakMap ? new WeakMap() : null;
  function ct(t, e) {
    var i = ut && ut.get(t);
    return (
      i || ((i = window.getComputedStyle(t, null)), ut && ut.set(t, i)),
      i.getPropertyValue(e)
    );
  }
  function ft(t, e) {
    return parseFloat(ct(t, e)) || 0;
  }
  var pt,
    mt = document.documentElement,
    gt = document.body,
    vt = { value: 0, offset: 0 };
  function yt(t) {
    return t === window || t === mt || t === gt ? window : t;
  }
  function St(t) {
    return t === window ? t.pageXOffset : t.scrollLeft;
  }
  function wt(t) {
    return t === window ? t.pageYOffset : t.scrollTop;
  }
  function Dt(t) {
    return t === window
      ? mt.scrollWidth - mt.clientWidth
      : t.scrollWidth - t.clientWidth;
  }
  function bt(t) {
    return t === window
      ? mt.scrollHeight - mt.clientHeight
      : t.scrollHeight - t.clientHeight;
  }
  function At(t, e) {
    if (((e = e || {}), t === window))
      (e.width = mt.clientWidth),
        (e.height = mt.clientHeight),
        (e.left = 0),
        (e.right = e.width),
        (e.top = 0),
        (e.bottom = e.height);
    else {
      var i = t.getBoundingClientRect(),
        s = t.clientLeft || ft(t, "border-left-width"),
        n = t.clientTop || ft(t, "border-top-width");
      (e.width = t.clientWidth),
        (e.height = t.clientHeight),
        (e.left = i.left + s),
        (e.right = e.left + e.width),
        (e.top = i.top + n),
        (e.bottom = e.top + e.height);
    }
    return e;
  }
  function Et(t) {
    return t._drag._getGrid()._settings.dragAutoScroll;
  }
  function Tt(t) {
    if (t._drag && t._isActive) {
      var e = t._drag;
      (e._scrollDiffX = e._scrollDiffY = 0), t._setTranslate(e._left, e._top);
    }
  }
  function xt(t, e, i, s) {
    return (
      (vt.value = Math.min(s / 2, t)),
      (vt.offset = Math.max(0, i + 2 * vt.value + s * e - s) / 2),
      vt
    );
  }
  function kt() {
    this.reset();
  }
  function Lt() {
    (this.element = null),
      (this.requestX = null),
      (this.requestY = null),
      (this.scrollLeft = 0),
      (this.scrollTop = 0);
  }
  function Rt(t, e) {
    (this.pool = []), (this.createItem = t), (this.releaseItem = e);
  }
  function It(t, e) {
    var i = (function (t, e) {
      return (function (t, e) {
        return !(
          t.left + t.width <= e.left ||
          e.left + e.width <= t.left ||
          t.top + t.height <= e.top ||
          e.top + e.height <= t.top
        );
      })(t, e)
        ? (Math.min(t.left + t.width, e.left + e.width) -
            Math.max(t.left, e.left)) *
            (Math.min(t.top + t.height, e.top + e.height) -
              Math.max(t.top, e.top))
        : 0;
    })(t, e);
    return i
      ? (i / (Math.min(t.width, e.width) * Math.min(t.height, e.height))) * 100
      : 0;
  }
  (kt.prototype.reset = function () {
    this.isActive && this.onStop(),
      (this.item = null),
      (this.element = null),
      (this.isActive = !1),
      (this.isEnding = !1),
      (this.direction = null),
      (this.value = null),
      (this.maxValue = 0),
      (this.threshold = 0),
      (this.distance = 0),
      (this.speed = 0),
      (this.duration = 0),
      (this.action = null);
  }),
    (kt.prototype.hasReachedEnd = function () {
      return 4 & this.direction ? this.value >= this.maxValue : this.value <= 0;
    }),
    (kt.prototype.computeCurrentScrollValue = function () {
      return null === this.value
        ? 1 & this.direction
          ? St(this.element)
          : wt(this.element)
        : Math.max(0, Math.min(this.value, this.maxValue));
    }),
    (kt.prototype.computeNextScrollValue = function (t) {
      var e = this.speed * (t / 1e3),
        i = 4 & this.direction ? this.value + e : this.value - e;
      return Math.max(0, Math.min(i, this.maxValue));
    }),
    (kt.prototype.computeSpeed =
      ((pt = {
        direction: null,
        threshold: 0,
        distance: 0,
        value: 0,
        maxValue: 0,
        deltaTime: 0,
        duration: 0,
        isEnding: !1,
      }),
      function (t) {
        var e = this.item,
          i = Et(e).speed;
        return dt(i)
          ? ((pt.direction = this.direction),
            (pt.threshold = this.threshold),
            (pt.distance = this.distance),
            (pt.value = this.value),
            (pt.maxValue = this.maxValue),
            (pt.duration = this.duration),
            (pt.speed = this.speed),
            (pt.deltaTime = t),
            (pt.isEnding = this.isEnding),
            i(e, this.element, pt))
          : i;
      })),
    (kt.prototype.tick = function (t) {
      return (
        this.isActive || ((this.isActive = !0), this.onStart()),
        (this.value = this.computeCurrentScrollValue()),
        (this.speed = this.computeSpeed(t)),
        (this.value = this.computeNextScrollValue(t)),
        (this.duration += t),
        this.value
      );
    }),
    (kt.prototype.onStart = function () {
      var t = this.item,
        e = Et(t).onStart;
      dt(e) && e(t, this.element, this.direction);
    }),
    (kt.prototype.onStop = function () {
      var t = this.item,
        e = Et(t).onStop;
      dt(e) && e(t, this.element, this.direction), t._drag && t._drag.sort();
    }),
    (Lt.prototype.reset = function () {
      this.requestX && (this.requestX.action = null),
        this.requestY && (this.requestY.action = null),
        (this.element = null),
        (this.requestX = null),
        (this.requestY = null),
        (this.scrollLeft = 0),
        (this.scrollTop = 0);
    }),
    (Lt.prototype.addRequest = function (t) {
      1 & t.direction
        ? (this.removeRequest(this.requestX), (this.requestX = t))
        : (this.removeRequest(this.requestY), (this.requestY = t)),
        (t.action = this);
    }),
    (Lt.prototype.removeRequest = function (t) {
      t &&
        (this.requestX === t
          ? ((this.requestX = null), (t.action = null))
          : this.requestY === t && ((this.requestY = null), (t.action = null)));
    }),
    (Lt.prototype.computeScrollValues = function () {
      (this.scrollLeft = this.requestX
        ? this.requestX.value
        : St(this.element)),
        (this.scrollTop = this.requestY
          ? this.requestY.value
          : wt(this.element));
    }),
    (Lt.prototype.scroll = function () {
      var t = this.element;
      t &&
        (t.scrollTo
          ? t.scrollTo(this.scrollLeft, this.scrollTop)
          : ((t.scrollLeft = this.scrollLeft), (t.scrollTop = this.scrollTop)));
    }),
    (Rt.prototype.pick = function () {
      return this.pool.pop() || this.createItem();
    }),
    (Rt.prototype.release = function (t) {
      this.releaseItem(t), -1 === this.pool.indexOf(t) && this.pool.push(t);
    }),
    (Rt.prototype.reset = function () {
      this.pool.length = 0;
    });
  var Ct = { width: 0, height: 0, left: 0, right: 0, top: 0, bottom: 0 },
    Mt = { width: 0, height: 0, left: 0, right: 0, top: 0, bottom: 0 };
  function Pt() {
    (this._isDestroyed = !1),
      (this._isTicking = !1),
      (this._tickTime = 0),
      (this._tickDeltaTime = 0),
      (this._items = []),
      (this._actions = []),
      (this._requests = {}),
      (this._requests[1] = {}),
      (this._requests[2] = {}),
      (this._requestOverlapCheck = {}),
      (this._dragPositions = {}),
      (this._dragDirections = {}),
      (this._overlapCheckInterval = 150),
      (this._requestPool = new Rt(
        function () {
          return new kt();
        },
        function (t) {
          t.reset();
        }
      )),
      (this._actionPool = new Rt(
        function () {
          return new Lt();
        },
        function (t) {
          t.reset();
        }
      )),
      (this._readTick = this._readTick.bind(this)),
      (this._writeTick = this._writeTick.bind(this));
  }
  (Pt.AXIS_X = 1),
    (Pt.AXIS_Y = 2),
    (Pt.FORWARD = 4),
    (Pt.BACKWARD = 8),
    (Pt.LEFT = 9),
    (Pt.RIGHT = 5),
    (Pt.UP = 10),
    (Pt.DOWN = 6),
    (Pt.smoothSpeed = function (t, e, i) {
      return function (s, n, o) {
        var r = 0;
        if (!o.isEnding)
          if (o.threshold > 0) {
            var h = o.threshold - Math.max(0, o.distance);
            r = (t / o.threshold) * h;
          } else r = t;
        var a = o.speed,
          _ = r;
        return a === r
          ? _
          : a < r
          ? ((_ = a + e * (o.deltaTime / 1e3)), Math.min(r, _))
          : ((_ = a - i * (o.deltaTime / 1e3)), Math.max(r, _));
      };
    }),
    (Pt.pointerHandle = function (t) {
      var e = { left: 0, top: 0, width: 0, height: 0 },
        i = t || 1;
      return function (t, s, n, o, r, h, a) {
        return (
          (e.left = h - 0.5 * i),
          (e.top = a - 0.5 * i),
          (e.width = i),
          (e.height = i),
          e
        );
      };
    }),
    (Pt.prototype._readTick = function (t) {
      this._isDestroyed ||
        (t && this._tickTime
          ? ((this._tickDeltaTime = t - this._tickTime),
            (this._tickTime = t),
            this._updateRequests(),
            this._updateActions())
          : ((this._tickTime = t), (this._tickDeltaTime = 0)));
    }),
    (Pt.prototype._writeTick = function () {
      this._isDestroyed ||
        (this._applyActions(), lt(this._readTick, this._writeTick));
    }),
    (Pt.prototype._startTicking = function () {
      (this._isTicking = !0), lt(this._readTick, this._writeTick);
    }),
    (Pt.prototype._stopTicking = function () {
      (this._isTicking = !1),
        (this._tickTime = 0),
        (this._tickDeltaTime = 0),
        it.remove(0, K),
        it.remove(2, tt);
    }),
    (Pt.prototype._getItemHandleRect = function (t, e, i) {
      var s = t._drag;
      if (e) {
        var n = s._dragMoveEvent || s._dragStartEvent,
          o = e(
            t,
            s._clientX,
            s._clientY,
            t._width,
            t._height,
            n.clientX,
            n.clientY
          );
        (i.left = o.left),
          (i.top = o.top),
          (i.width = o.width),
          (i.height = o.height);
      } else
        (i.left = s._clientX),
          (i.top = s._clientY),
          (i.width = t._width),
          (i.height = t._height);
      return (i.right = i.left + i.width), (i.bottom = i.top + i.height), i;
    }),
    (Pt.prototype._requestItemScroll = function (t, e, i, s, n, o, r) {
      var h = this._requests[e],
        a = h[t._id];
      a
        ? (a.element === i && a.direction === s) || a.reset()
        : (a = this._requestPool.pick()),
        (a.item = t),
        (a.element = i),
        (a.direction = s),
        (a.threshold = n),
        (a.distance = o),
        (a.maxValue = r),
        (h[t._id] = a);
    }),
    (Pt.prototype._cancelItemScroll = function (t, e) {
      var i = this._requests[e],
        s = i[t._id];
      s &&
        (s.action && s.action.removeRequest(s),
        this._requestPool.release(s),
        delete i[t._id]);
    }),
    (Pt.prototype._checkItemOverlap = function (t, e, i) {
      var s = Et(t),
        n = dt(s.targets) ? s.targets(t) : s.targets,
        o = s.threshold,
        r = s.safeZone;
      if (!n || !n.length)
        return (
          e && this._cancelItemScroll(t, 1),
          void (i && this._cancelItemScroll(t, 2))
        );
      var h = this._dragDirections[t._id],
        a = h[0],
        _ = h[1];
      if (!a && !_)
        return (
          e && this._cancelItemScroll(t, 1),
          void (i && this._cancelItemScroll(t, 2))
        );
      for (
        var l = this._getItemHandleRect(t, s.handle, Ct),
          d = Mt,
          u = null,
          c = null,
          f = !0,
          p = !0,
          m = 0,
          g = 0,
          v = null,
          y = null,
          S = 0,
          w = 0,
          D = 0,
          b = null,
          A = -1 / 0,
          E = 0,
          T = 0,
          x = null,
          k = 0,
          L = 0,
          R = null,
          I = -1 / 0,
          C = 0,
          M = 0,
          P = null,
          X = 0,
          Y = 0,
          q = 0;
        q < n.length;
        q++
      )
        (u = n[q]),
          (f = e && a && 2 !== u.axis),
          (p = i && _ && 1 !== u.axis),
          (g = u.priority || 0),
          ((!f || g < A) && (!p || g < I)) ||
            ((c = yt(u.element || u)),
            (w = f ? Dt(c) : -1),
            (D = p ? bt(c) : -1),
            (w || D) &&
              ((m = It(l, (d = At(c, d)))) <= 0 ||
                (f &&
                  g >= A &&
                  w > 0 &&
                  (g > A || m > T) &&
                  ((y = null),
                  (v = xt(
                    "number" == typeof u.threshold ? u.threshold : o,
                    r,
                    l.width,
                    d.width
                  )),
                  5 === a
                    ? (S = d.right + v.offset - l.right) <= v.value &&
                      St(c) < w &&
                      (y = 5)
                    : 9 === a &&
                      (S = l.left - (d.left - v.offset)) <= v.value &&
                      St(c) > 0 &&
                      (y = 9),
                  null !== y &&
                    ((b = c),
                    (A = g),
                    (E = v.value),
                    (T = m),
                    (x = y),
                    (k = S),
                    (L = w))),
                p &&
                  g >= I &&
                  D > 0 &&
                  (g > I || m > M) &&
                  ((y = null),
                  (v = xt(
                    "number" == typeof u.threshold ? u.threshold : o,
                    r,
                    l.height,
                    d.height
                  )),
                  6 === _
                    ? (S = d.bottom + v.offset - l.bottom) <= v.value &&
                      wt(c) < D &&
                      (y = 6)
                    : 10 === _ &&
                      (S = l.top - (d.top - v.offset)) <= v.value &&
                      wt(c) > 0 &&
                      (y = 10),
                  null !== y &&
                    ((R = c),
                    (I = g),
                    (C = v.value),
                    (M = m),
                    (P = y),
                    (X = S),
                    (Y = D))))));
      e &&
        (b
          ? this._requestItemScroll(t, 1, b, x, E, k, L)
          : this._cancelItemScroll(t, 1)),
        i &&
          (R
            ? this._requestItemScroll(t, 2, R, P, C, X, Y)
            : this._cancelItemScroll(t, 2));
    }),
    (Pt.prototype._updateScrollRequest = function (t) {
      for (
        var e = t.item,
          i = Et(e),
          s = dt(i.targets) ? i.targets(e) : i.targets,
          n = (s && s.length) || 0,
          o = i.threshold,
          r = i.safeZone,
          h = this._getItemHandleRect(e, i.handle, Ct),
          a = Mt,
          _ = null,
          l = null,
          d = !1,
          u = null,
          c = null,
          f = null,
          p = null,
          m = null,
          g = 0;
        g < n;
        g++
      )
        if ((l = yt((_ = s[g]).element || _)) === t.element) {
          if ((d = !!(1 & t.direction))) {
            if (2 === _.axis) continue;
          } else if (1 === _.axis) continue;
          if ((p = d ? Dt(l) : bt(l)) <= 0) break;
          if (It(h, (a = At(l, a))) <= 0) break;
          if (
            ((u = xt(
              "number" == typeof _.threshold ? _.threshold : o,
              r,
              d ? h.width : h.height,
              d ? a.width : a.height
            )),
            (c =
              9 === t.direction
                ? h.left - (a.left - u.offset)
                : 5 === t.direction
                ? a.right + u.offset - h.right
                : 10 === t.direction
                ? h.top - (a.top - u.offset)
                : a.bottom + u.offset - h.bottom) > u.value)
          )
            break;
          if (
            ((f = d ? St(l) : wt(l)), (m = 4 & t.direction ? f >= p : f <= 0))
          )
            break;
          return (
            (t.maxValue = p),
            (t.threshold = u.value),
            (t.distance = c),
            (t.isEnding = !1),
            !0
          );
        }
      return (
        !0 === i.smoothStop && t.speed > 0
          ? (null === m && (m = t.hasReachedEnd()), (t.isEnding = !m))
          : (t.isEnding = !1),
        t.isEnding
      );
    }),
    (Pt.prototype._updateRequests = function () {
      for (
        var t,
          e,
          i,
          s,
          n,
          o,
          r,
          h = this._items,
          a = this._requests[1],
          _ = this._requests[2],
          l = 0;
        l < h.length;
        l++
      )
        (t = h[l]),
          (n =
            (s = this._requestOverlapCheck[t._id]) > 0 &&
            this._tickTime - s > this._overlapCheckInterval),
          (o = !0),
          (e = a[t._id]) &&
            e.isActive &&
            (o = !this._updateScrollRequest(e)) &&
            ((n = !0), this._cancelItemScroll(t, 1)),
          (r = !0),
          (i = _[t._id]) &&
            i.isActive &&
            (r = !this._updateScrollRequest(i)) &&
            ((n = !0), this._cancelItemScroll(t, 2)),
          n &&
            ((this._requestOverlapCheck[t._id] = 0),
            this._checkItemOverlap(t, o, r));
    }),
    (Pt.prototype._requestAction = function (t, e) {
      for (
        var i = this._actions, s = 1 === e, n = null, o = 0;
        o < i.length;
        o++
      ) {
        if (((n = i[o]), t.element === n.element)) {
          if (s ? n.requestX : n.requestY)
            return void this._cancelItemScroll(t.item, e);
          break;
        }
        n = null;
      }
      n || (n = this._actionPool.pick()),
        (n.element = t.element),
        n.addRequest(t),
        t.tick(this._tickDeltaTime),
        i.push(n);
    }),
    (Pt.prototype._updateActions = function () {
      var t,
        e,
        i,
        s,
        n = this._items,
        o = this._requests,
        r = this._actions;
      for (s = 0; s < n.length; s++)
        (t = n[s]._id),
          (e = o[1][t]),
          (i = o[2][t]),
          e && this._requestAction(e, 1),
          i && this._requestAction(i, 2);
      for (s = 0; s < r.length; s++) r[s].computeScrollValues();
    }),
    (Pt.prototype._applyActions = function () {
      var t,
        e = this._actions,
        i = this._items;
      if (e.length) {
        for (t = 0; t < e.length; t++)
          e[t].scroll(), this._actionPool.release(e[t]);
        for (e.length = 0, t = 0; t < i.length; t++)
          (s = i[t])._drag && s._drag._prepareScroll();
        var s;
        for (t = 0; t < i.length; t++) Tt(i[t]);
      }
    }),
    (Pt.prototype._updateDragDirection = function (t) {
      var e = this._dragPositions[t._id],
        i = this._dragDirections[t._id],
        s = t._drag._left,
        n = t._drag._top;
      if (e.length) {
        var o = e[0],
          r = e[1];
        (i[0] = s > o ? 5 : s < o ? 9 : i[0] || 0),
          (i[1] = n > r ? 6 : n < r ? 10 : i[1] || 0);
      }
      (e[0] = s), (e[1] = n);
    }),
    (Pt.prototype.addItem = function (t) {
      this._isDestroyed ||
        (-1 === this._items.indexOf(t) &&
          (this._items.push(t),
          (this._requestOverlapCheck[t._id] = this._tickTime),
          (this._dragDirections[t._id] = [0, 0]),
          (this._dragPositions[t._id] = []),
          this._isTicking || this._startTicking()));
    }),
    (Pt.prototype.updateItem = function (t) {
      this._isDestroyed ||
        (this._dragDirections[t._id] &&
          (this._updateDragDirection(t),
          this._requestOverlapCheck[t._id] ||
            (this._requestOverlapCheck[t._id] = this._tickTime)));
    }),
    (Pt.prototype.removeItem = function (t) {
      if (!this._isDestroyed) {
        var e = this._items.indexOf(t);
        if (-1 !== e) {
          var i = t._id;
          this._requests[1][i] &&
            (this._cancelItemScroll(t, 1), delete this._requests[1][i]),
            this._requests[2][i] &&
              (this._cancelItemScroll(t, 2), delete this._requests[2][i]),
            delete this._requestOverlapCheck[i],
            delete this._dragPositions[i],
            delete this._dragDirections[i],
            this._items.splice(e, 1),
            this._isTicking && !this._items.length && this._stopTicking();
        }
      }
    }),
    (Pt.prototype.isItemScrollingX = function (t) {
      var e = this._requests[1][t._id];
      return !(!e || !e.isActive);
    }),
    (Pt.prototype.isItemScrollingY = function (t) {
      var e = this._requests[2][t._id];
      return !(!e || !e.isActive);
    }),
    (Pt.prototype.isItemScrolling = function (t) {
      return this.isItemScrollingX(t) || this.isItemScrollingY(t);
    }),
    (Pt.prototype.destroy = function () {
      if (!this._isDestroyed) {
        for (var t = this._items.slice(0), e = 0; e < t.length; e++)
          this.removeItem(t[e]);
        (this._actions.length = 0),
          this._requestPool.reset(),
          this._actionPool.reset(),
          (this._isDestroyed = !0);
      }
    });
  var Xt = window.Element.prototype,
    Yt =
      Xt.matches ||
      Xt.matchesSelector ||
      Xt.webkitMatchesSelector ||
      Xt.mozMatchesSelector ||
      Xt.msMatchesSelector ||
      Xt.oMatchesSelector ||
      function () {
        return !1;
      };
  function qt(t, e) {
    return Yt.call(t, e);
  }
  function Ot(t, e) {
    e &&
      (t.classList
        ? t.classList.add(e)
        : qt(t, "." + e) || (t.className += " " + e));
  }
  var Ht = [];
  function Gt(t, e, i) {
    var s = "number" == typeof i ? i : -1;
    s < 0 && (s = t.length - s + 1),
      t.splice.apply(t, Ht.concat(s, 0, e)),
      (Ht.length = 0);
  }
  function Wt(t, e, i) {
    var s = Math.max(0, t.length - 1 + (i || 0));
    return e > s ? s : e < 0 ? Math.max(s + e + 1, 0) : e;
  }
  function Bt(t, e, i) {
    if (!(t.length < 2)) {
      var s = Wt(t, e),
        n = Wt(t, i);
      s !== n && t.splice(n, 0, t.splice(s, 1)[0]);
    }
  }
  function Nt(t, e, i) {
    if (!(t.length < 2)) {
      var s,
        n = Wt(t, e),
        o = Wt(t, i);
      n !== o && ((s = t[n]), (t[n] = t[o]), (t[o] = s));
    }
  }
  var Ft = E(document.documentElement.style, "transform") || "transform",
    zt = /([A-Z])/g,
    Vt = /^(webkit-|moz-|ms-|o-)/,
    jt = /^(-m-s-)/;
  function Qt(t) {
    var e = t.replace(zt, "-$1").toLowerCase();
    return (e = (e = e.replace(Vt, "-$1")).replace(jt, "-ms-"));
  }
  var Ut = Qt(Ft);
  function Zt(t) {
    var e = ct(t, Ut);
    if (!e || "none" === e) return !1;
    var i = ct(t, "display");
    return "inline" !== i && "none" !== i;
  }
  function Jt(t) {
    for (
      var e = document, i = t || e;
      i && i !== e && "static" === ct(i, "position") && !Zt(i);

    )
      i = i.parentElement || e;
    return i;
  }
  var $t = {},
    Kt = {},
    te = {};
  function ee(t, e) {
    var i,
      s = e || {};
    return (
      (s.left = 0),
      (s.top = 0),
      t === document
        ? s
        : ((s.left = window.pageXOffset || 0),
          (s.top = window.pageYOffset || 0),
          t.self === window.self ||
            ((i = t.getBoundingClientRect()),
            (s.left += i.left),
            (s.top += i.top),
            (s.left += ft(t, "border-left-width")),
            (s.top += ft(t, "border-top-width"))),
          s)
    );
  }
  function ie(t, e, i) {
    return (
      (te.left = 0),
      (te.top = 0),
      t === e ||
        (i && (t = Jt(t)) === (e = Jt(e))) ||
        (ee(t, $t),
        ee(e, Kt),
        (te.left = Kt.left - $t.left),
        (te.top = Kt.top - $t.top)),
      te
    );
  }
  function se(t) {
    return "auto" === t || "scroll" === t || "overlay" === t;
  }
  function ne(t) {
    return (
      se(ct(t, "overflow")) ||
      se(ct(t, "overflow-x")) ||
      se(ct(t, "overflow-y"))
    );
  }
  function oe(t, e) {
    for (e = e || []; t && t !== document; )
      t.getRootNode && t instanceof DocumentFragment
        ? (t = t.getRootNode().host)
        : (ne(t) && e.push(t), (t = t.parentNode));
    return e.push(window), e;
  }
  var re = {},
    he = /^matrix3d/,
    ae = /([^,]*,){4}/,
    _e = /([^,]*,){12}/,
    le = /[^,]*,/;
  function de(t) {
    (re.x = 0), (re.y = 0);
    var e = ct(t, Ut);
    if (!e || "none" === e) return re;
    var i = he.test(e),
      s = e.replace(i ? _e : ae, ""),
      n = s.replace(le, "");
    return (re.x = parseFloat(s) || 0), (re.y = parseFloat(n) || 0), re;
  }
  function ue(t, e) {
    e &&
      (t.classList
        ? t.classList.remove(e)
        : qt(t, "." + e) &&
          (t.className = (" " + t.className + " ")
            .replace(" " + e + " ", " ")
            .trim()));
  }
  var ce,
    fe,
    pe,
    me,
    ge =
      /^(iPad|iPhone|iPod)/.test(window.navigator.platform) ||
      (/^Mac/.test(window.navigator.platform) &&
        window.navigator.maxTouchPoints > 1),
    ve = !!T() && { passive: !0 };
  function ye(t) {
    var e = t._element,
      i = t.getGrid(),
      s = i._settings;
    (this._item = t),
      (this._gridId = i._id),
      (this._isDestroyed = !1),
      (this._isMigrating = !1),
      (this._startPredicate = dt(s.dragStartPredicate)
        ? s.dragStartPredicate
        : ye.defaultStartPredicate),
      (this._startPredicateState = 0),
      (this._startPredicateResult = void 0),
      (this._isSortNeeded = !1),
      (this._sortTimer = void 0),
      (this._blockedSortIndex = null),
      (this._sortX1 = 0),
      (this._sortX2 = 0),
      (this._sortY1 = 0),
      (this._sortY2 = 0),
      this._reset(),
      (this._preStartCheck = this._preStartCheck.bind(this)),
      (this._preEndCheck = this._preEndCheck.bind(this)),
      (this._onScroll = this._onScroll.bind(this)),
      (this._prepareStart = this._prepareStart.bind(this)),
      (this._applyStart = this._applyStart.bind(this)),
      (this._prepareMove = this._prepareMove.bind(this)),
      (this._applyMove = this._applyMove.bind(this)),
      (this._prepareScroll = this._prepareScroll.bind(this)),
      (this._applyScroll = this._applyScroll.bind(this)),
      (this._handleSort = this._handleSort.bind(this)),
      (this._handleSortDelayed = this._handleSortDelayed.bind(this)),
      (this._handle = (s.dragHandle && e.querySelector(s.dragHandle)) || e),
      (this._dragger = new X(this._handle, s.dragCssProps)),
      this._dragger.on("start", this._preStartCheck),
      this._dragger.on("move", this._preStartCheck),
      this._dragger.on("cancel", this._preEndCheck),
      this._dragger.on("end", this._preEndCheck);
  }
  function Se(t, e) {
    var i,
      s,
      n = {};
    if (Array.isArray(e))
      for (s = 0; s < e.length; s++) n[(i = e[s])] = ct(t, Qt(i));
    else for (i in e) n[i] = ct(t, Qt(i));
    return n;
  }
  (ye.autoScroller = new Pt()),
    (ye.defaultStartPredicate = function (t, e, i) {
      var s = t._drag;
      if (e.isFirst && e.srcEvent.button) return !1;
      if (
        !ge &&
        e.isFirst &&
        !0 === e.srcEvent.isTrusted &&
        !1 === e.srcEvent.defaultPrevented &&
        !1 === e.srcEvent.cancelable
      )
        return !1;
      if (!e.isFinal) {
        var n = s._startPredicateData;
        if (!n) {
          var o = i || s._getGrid()._settings.dragStartPredicate || {};
          s._startPredicateData = n = {
            distance: Math.max(o.distance, 0) || 0,
            delay: Math.max(o.delay, 0) || 0,
          };
        }
        return (
          n.delay &&
            ((n.event = e),
            n.delayTimer ||
              (n.delayTimer = window.setTimeout(function () {
                (n.delay = 0),
                  s._resolveStartPredicate(n.event) &&
                    (s._forceResolveStartPredicate(n.event),
                    s._resetStartPredicate());
              }, n.delay))),
          s._resolveStartPredicate(e)
        );
      }
      s._finishStartPredicate(e);
    }),
    (ye.defaultSortPredicate =
      ((ce = {}),
      (fe = {}),
      (pe = {}),
      (me = []),
      function (t, e) {
        var n = t._drag,
          o = n._getGrid(),
          r = e && "number" == typeof e.threshold ? e.threshold : 50,
          h = e && e.action === i ? i : s,
          a = e && e.migrateAction === i ? i : s;
        (r = Math.min(Math.max(r, 1), 100)),
          (ce.width = t._width),
          (ce.height = t._height),
          (ce.left = n._clientX),
          (ce.top = n._clientY);
        var _ = (function (t, e, i) {
          var s,
            n,
            o,
            r,
            h,
            a,
            _,
            l,
            d,
            u,
            c = null,
            f = e._settings.dragSort,
            p = -1;
          if (
            (!0 === f ? ((me[0] = e), (n = me)) : dt(f) && (n = f.call(e, t)),
            !n || !Array.isArray(n) || !n.length)
          )
            return c;
          for (u = 0; u < n.length; u++)
            if (!(o = n[u])._isDestroyed) {
              for (
                o._updateBoundingRect(),
                  a = Math.max(0, o._left),
                  _ = Math.max(0, o._top),
                  l = Math.min(window.innerWidth, o._right),
                  d = Math.min(window.innerHeight, o._bottom),
                  r = o._element.parentNode;
                r &&
                r !== document &&
                r !== document.documentElement &&
                r !== document.body;

              )
                if (r.getRootNode && r instanceof DocumentFragment)
                  r = r.getRootNode().host;
                else {
                  if (
                    ("visible" !== ct(r, "overflow") &&
                      ((h = r.getBoundingClientRect()),
                      (a = Math.max(a, h.left)),
                      (_ = Math.max(_, h.top)),
                      (l = Math.min(l, h.right)),
                      (d = Math.min(d, h.bottom))),
                    "fixed" === ct(r, "position"))
                  )
                    break;
                  r = r.parentNode;
                }
              a >= l ||
                _ >= d ||
                ((fe.left = a),
                (fe.top = _),
                (fe.width = l - a),
                (fe.height = d - _),
                (s = It(ce, fe)) > i && s > p && ((p = s), (c = o)));
            }
          return (me.length = 0), c;
        })(t, o, r);
        if (!_) return null;
        var l,
          d,
          u,
          c = t.getGrid() !== _,
          f = 0,
          p = 0,
          m = 0,
          g = -1,
          v = !1;
        for (
          _ === o
            ? ((ce.left = n._gridX + t._marginLeft),
              (ce.top = n._gridY + t._marginTop))
            : (_._updateBorders(1, 0, 1, 0),
              (f = _._left + _._borderLeft),
              (p = _._top + _._borderTop)),
            u = 0;
          u < _._items.length;
          u++
        )
          (l = _._items[u])._isActive &&
            l !== t &&
            ((v = !0),
            (fe.width = l._width),
            (fe.height = l._height),
            (fe.left = l._left + l._marginLeft + f),
            (fe.top = l._top + l._marginTop + p),
            (d = It(ce, fe)) > m && ((g = u), (m = d)));
        return (
          c && m < r && ((g = v ? g : 0), (m = r)),
          m >= r
            ? ((pe.grid = _), (pe.index = g), (pe.action = c ? a : h), pe)
            : null
        );
      })),
    (ye.prototype.stop = function () {
      if (this._isActive)
        if (this._isMigrating) this._finishMigration();
        else {
          var t = this._item,
            e = t._id;
          if (
            (ye.autoScroller.removeItem(t),
            ot(e),
            rt(e),
            ht(e),
            this._cancelSort(),
            this._isStarted)
          ) {
            this._unbindScrollListeners();
            var i = t._element,
              s = this._getGrid(),
              n = s._settings.itemDraggingClass;
            i.parentNode !== s._element &&
              (s._element.appendChild(i),
              t._setTranslate(this._gridX, this._gridY),
              n && i.clientWidth),
              ue(i, n);
          }
          this._reset();
        }
    }),
    (ye.prototype.sort = function (t) {
      var e = this._item;
      this._isActive &&
        e._isActive &&
        this._dragMoveEvent &&
        (!0 === t ? this._handleSort() : at(e._id, this._handleSort));
    }),
    (ye.prototype.destroy = function () {
      this._isDestroyed ||
        (this.stop(),
        this._dragger.destroy(),
        ye.autoScroller.removeItem(this._item),
        (this._isDestroyed = !0));
    }),
    (ye.prototype._getGrid = function () {
      return t[this._gridId] || null;
    }),
    (ye.prototype._reset = function () {
      (this._isActive = !1),
        (this._isStarted = !1),
        (this._container = null),
        (this._containingBlock = null),
        (this._dragStartEvent = null),
        (this._dragMoveEvent = null),
        (this._dragPrevMoveEvent = null),
        (this._scrollEvent = null),
        (this._scrollers = []),
        (this._left = 0),
        (this._top = 0),
        (this._gridX = 0),
        (this._gridY = 0),
        (this._clientX = 0),
        (this._clientY = 0),
        (this._scrollDiffX = 0),
        (this._scrollDiffY = 0),
        (this._moveDiffX = 0),
        (this._moveDiffY = 0),
        (this._containerDiffX = 0),
        (this._containerDiffY = 0);
    }),
    (ye.prototype._bindScrollListeners = function () {
      var t,
        e,
        i = this._getGrid()._element,
        s = this._container,
        n = this._scrollers;
      if (((n.length = 0), oe(this._item._element.parentNode, n), s !== i))
        for (oe(i, (t = [])), e = 0; e < t.length; e++)
          n.indexOf(t[e]) < 0 && n.push(t[e]);
      for (e = 0; e < n.length; e++)
        n[e].addEventListener("scroll", this._onScroll, ve);
    }),
    (ye.prototype._unbindScrollListeners = function () {
      var t,
        e = this._scrollers;
      for (t = 0; t < e.length; t++)
        e[t].removeEventListener("scroll", this._onScroll, ve);
      e.length = 0;
    }),
    (ye.prototype._resolveStartPredicate = function (t) {
      var e = this._startPredicateData;
      if (!(t.distance < e.distance || e.delay))
        return this._resetStartPredicate(), !0;
    }),
    (ye.prototype._forceResolveStartPredicate = function (t) {
      this._isDestroyed ||
        1 !== this._startPredicateState ||
        ((this._startPredicateState = 2), this._onStart(t));
    }),
    (ye.prototype._finishStartPredicate = function (t) {
      var e = this._item._element,
        i =
          Math.abs(t.deltaX) < 2 && Math.abs(t.deltaY) < 2 && t.deltaTime < 200;
      this._resetStartPredicate(),
        i &&
          (function (t) {
            if ("a" !== t.tagName.toLowerCase()) return;
            var e = t.getAttribute("href");
            if (!e) return;
            var i = t.getAttribute("target");
            i && "_self" !== i ? window.open(e, i) : (window.location.href = e);
          })(e);
    }),
    (ye.prototype._resetHeuristics = function (t, e) {
      (this._blockedSortIndex = null),
        (this._sortX1 = this._sortX2 = t),
        (this._sortY1 = this._sortY2 = e);
    }),
    (ye.prototype._checkHeuristics = function (t, e) {
      var i = this._getGrid()._settings.dragSortHeuristics,
        s = i.minDragDistance;
      if (s <= 0) return (this._blockedSortIndex = null), !0;
      var n = t - this._sortX2,
        o = e - this._sortY2,
        r = s > 3 && i.minBounceBackAngle > 0;
      if (
        (r || (this._blockedSortIndex = null),
        Math.abs(n) > s || Math.abs(o) > s)
      ) {
        if (r) {
          var h = Math.atan2(n, o),
            a = Math.atan2(
              this._sortX2 - this._sortX1,
              this._sortY2 - this._sortY1
            ),
            _ = Math.atan2(Math.sin(h - a), Math.cos(h - a));
          Math.abs(_) > i.minBounceBackAngle && (this._blockedSortIndex = null);
        }
        return (
          (this._sortX1 = this._sortX2),
          (this._sortY1 = this._sortY2),
          (this._sortX2 = t),
          (this._sortY2 = e),
          !0
        );
      }
      return !1;
    }),
    (ye.prototype._resetStartPredicate = function () {
      var t = this._startPredicateData;
      t &&
        (t.delayTimer && (t.delayTimer = window.clearTimeout(t.delayTimer)),
        (this._startPredicateData = null));
    }),
    (ye.prototype._handleSort = function () {
      if (this._isActive) {
        var t = this._getGrid()._settings;
        if (
          !t.dragSort ||
          (!t.dragAutoScroll.sortDuringScroll &&
            ye.autoScroller.isItemScrolling(this._item))
        )
          return (
            (this._sortX1 = this._sortX2 = this._gridX),
            (this._sortY1 = this._sortY2 = this._gridY),
            (this._isSortNeeded = !0),
            void (
              void 0 !== this._sortTimer &&
              (this._sortTimer = window.clearTimeout(this._sortTimer))
            )
          );
        var e = this._checkHeuristics(this._gridX, this._gridY);
        if (this._isSortNeeded || e) {
          var i = t.dragSortHeuristics.sortInterval;
          i <= 0 || this._isSortNeeded
            ? ((this._isSortNeeded = !1),
              void 0 !== this._sortTimer &&
                (this._sortTimer = window.clearTimeout(this._sortTimer)),
              this._checkOverlap())
            : void 0 === this._sortTimer &&
              (this._sortTimer = window.setTimeout(this._handleSortDelayed, i));
        }
      }
    }),
    (ye.prototype._handleSortDelayed = function () {
      (this._isSortNeeded = !0),
        (this._sortTimer = void 0),
        at(this._item._id, this._handleSort);
    }),
    (ye.prototype._cancelSort = function () {
      var t;
      (this._isSortNeeded = !1),
        void 0 !== this._sortTimer &&
          (this._sortTimer = window.clearTimeout(this._sortTimer)),
        (t = this._item._id),
        it.remove(1, U + t);
    }),
    (ye.prototype._finishSort = function () {
      var t =
        this._getGrid()._settings.dragSort &&
        (this._isSortNeeded || void 0 !== this._sortTimer);
      this._cancelSort(), t && this._checkOverlap();
    }),
    (ye.prototype._checkOverlap = function () {
      if (this._isActive) {
        var t,
          e,
          n,
          o,
          r,
          h,
          a,
          _,
          l = this._item,
          m = this._getGrid()._settings;
        (t = dt(m.dragSortPredicate)
          ? m.dragSortPredicate(l, this._dragMoveEvent)
          : ye.defaultSortPredicate(l, m.dragSortPredicate)) &&
          "number" == typeof t.index &&
          ((a = t.action === i ? i : s),
          (_ = (e = l.getGrid()) !== (o = t.grid || e)),
          (n = e._items.indexOf(l)),
          (r = Wt(o._items, t.index, _ && a === s ? 1 : 0)),
          (_ || r !== this._blockedSortIndex) &&
            (_
              ? ((this._blockedSortIndex = null),
                (h = o._items[r]),
                e._hasListeners(c) &&
                  e._emit(c, {
                    item: l,
                    fromGrid: e,
                    fromIndex: n,
                    toGrid: o,
                    toIndex: r,
                  }),
                o._hasListeners(p) &&
                  o._emit(p, {
                    item: l,
                    fromGrid: e,
                    fromIndex: n,
                    toGrid: o,
                    toIndex: r,
                  }),
                (l._gridId = o._id),
                (this._isMigrating = l._gridId !== this._gridId),
                e._items.splice(n, 1),
                Gt(o._items, l, r),
                (l._sortData = null),
                e._hasListeners(u) &&
                  e._emit(u, {
                    item: l,
                    fromGrid: e,
                    fromIndex: n,
                    toGrid: o,
                    toIndex: r,
                  }),
                o._hasListeners(f) &&
                  o._emit(f, {
                    item: l,
                    fromGrid: e,
                    fromIndex: n,
                    toGrid: o,
                    toIndex: r,
                  }),
                a === i &&
                  h &&
                  h.isActive() &&
                  o._items.indexOf(h) > -1 &&
                  o.send(h, e, n, {
                    appendTo: this._container || document.body,
                    layoutSender: !1,
                    layoutReceiver: !1,
                  }),
                e.layout(),
                o.layout())
              : n !== r &&
                ((this._blockedSortIndex = n),
                (a === i ? Nt : Bt)(e._items, n, r),
                e._hasListeners(d) &&
                  e._emit(d, { item: l, fromIndex: n, toIndex: r, action: a }),
                e.layout())));
      }
    }),
    (ye.prototype._finishMigration = function () {
      var t,
        e,
        i = this._item,
        s = i._dragRelease,
        n = i._element,
        o = i._isActive,
        r = i.getGrid(),
        h = r._element,
        a = r._settings,
        _ = a.dragContainer || h,
        l = this._getGrid()._settings,
        d = n.parentNode,
        u = o ? l.itemVisibleClass : l.itemHiddenClass,
        c = o ? a.itemVisibleClass : a.itemHiddenClass;
      (this._isMigrating = !1),
        this.destroy(),
        l.itemClass !== a.itemClass && (ue(n, l.itemClass), Ot(n, a.itemClass)),
        u !== c && (ue(n, u), Ot(n, c)),
        _ !== d &&
          (_.appendChild(n),
          (e = ie(d, _, !0)),
          ((t = de(n)).x -= e.left),
          (t.y -= e.top)),
        i._refreshDimensions(),
        (e = ie(_, h, !0)),
        (s._containerDiffX = e.left),
        (s._containerDiffY = e.top),
        (i._drag = a.dragEnabled ? new ye(i) : null),
        _ !== d && i._setTranslate(t.x, t.y),
        i._visibility.setStyles(o ? a.visibleStyles : a.hiddenStyles),
        s.start();
    }),
    (ye.prototype._preStartCheck = function (t) {
      0 === this._startPredicateState && (this._startPredicateState = 1),
        1 === this._startPredicateState
          ? ((this._startPredicateResult = this._startPredicate(this._item, t)),
            !0 === this._startPredicateResult
              ? ((this._startPredicateState = 2), this._onStart(t))
              : !1 === this._startPredicateResult &&
                (this._resetStartPredicate(t),
                this._dragger._reset(),
                (this._startPredicateState = 0)))
          : 2 === this._startPredicateState &&
            this._isActive &&
            this._onMove(t);
    }),
    (ye.prototype._preEndCheck = function (t) {
      var e = 2 === this._startPredicateState;
      this._startPredicate(this._item, t),
        (this._startPredicateState = 0),
        e && this._isActive && (this._isStarted ? this._onEnd(t) : this.stop());
    }),
    (ye.prototype._onStart = function (t) {
      var e,
        i,
        s,
        n = this._item;
      n._isActive &&
        ((this._isActive = !0),
        (this._dragStartEvent = t),
        ye.autoScroller.addItem(n),
        (e = n._id),
        (i = this._prepareStart),
        (s = this._applyStart),
        it.add(0, N + e, i),
        it.add(2, F + e, s));
    }),
    (ye.prototype._prepareStart = function () {
      if (this._isActive) {
        var t = this._item;
        if (t._isActive) {
          var e = t._element,
            i = this._getGrid(),
            s = i._settings,
            n = i._element,
            o = s.dragContainer || n,
            r = Jt(o),
            h = de(e),
            a = e.getBoundingClientRect(),
            _ = o !== n;
          if (
            ((this._container = o),
            (this._containingBlock = r),
            (this._clientX = a.left),
            (this._clientY = a.top),
            (this._left = this._gridX = h.x),
            (this._top = this._gridY = h.y),
            (this._scrollDiffX = this._scrollDiffY = 0),
            (this._moveDiffX = this._moveDiffY = 0),
            this._resetHeuristics(this._gridX, this._gridY),
            _)
          ) {
            var l = ie(r, n);
            (this._containerDiffX = l.left), (this._containerDiffY = l.top);
          }
        }
      }
    }),
    (ye.prototype._applyStart = function () {
      if (this._isActive) {
        var t = this._item;
        if (t._isActive) {
          var e = this._getGrid(),
            i = t._element,
            s = t._dragRelease,
            n = t._migrate,
            o = this._container !== e._element;
          t.isPositioning() && t._layout.stop(!0, this._left, this._top),
            n._isActive &&
              ((this._left -= n._containerDiffX),
              (this._top -= n._containerDiffY),
              (this._gridX -= n._containerDiffX),
              (this._gridY -= n._containerDiffY),
              n.stop(!0, this._left, this._top)),
            t.isReleasing() && s._reset(),
            e._settings.dragPlaceholder.enabled && t._dragPlaceholder.create(),
            (this._isStarted = !0),
            e._emit("dragInit", t, this._dragStartEvent),
            o &&
              (i.parentNode === this._container
                ? ((this._gridX -= this._containerDiffX),
                  (this._gridY -= this._containerDiffY))
                : ((this._left += this._containerDiffX),
                  (this._top += this._containerDiffY),
                  this._container.appendChild(i),
                  t._setTranslate(this._left, this._top))),
            Ot(i, e._settings.itemDraggingClass),
            this._bindScrollListeners(),
            e._emit("dragStart", t, this._dragStartEvent);
        }
      }
    }),
    (ye.prototype._onMove = function (t) {
      var e,
        i,
        s,
        n = this._item;
      n._isActive
        ? ((this._dragMoveEvent = t),
          (e = n._id),
          (i = this._prepareMove),
          (s = this._applyMove),
          it.add(0, z + e, i),
          it.add(2, V + e, s),
          at(n._id, this._handleSort))
        : this.stop();
    }),
    (ye.prototype._prepareMove = function () {
      if (this._isActive && this._item._isActive) {
        var t = this._getGrid()._settings.dragAxis,
          e = this._dragMoveEvent,
          i = this._dragPrevMoveEvent || this._dragStartEvent || e;
        if ("y" !== t) {
          var s = e.clientX - i.clientX;
          (this._left = this._left - this._moveDiffX + s),
            (this._gridX = this._gridX - this._moveDiffX + s),
            (this._clientX = this._clientX - this._moveDiffX + s),
            (this._moveDiffX = s);
        }
        if ("x" !== t) {
          var n = e.clientY - i.clientY;
          (this._top = this._top - this._moveDiffY + n),
            (this._gridY = this._gridY - this._moveDiffY + n),
            (this._clientY = this._clientY - this._moveDiffY + n),
            (this._moveDiffY = n);
        }
        this._dragPrevMoveEvent = e;
      }
    }),
    (ye.prototype._applyMove = function () {
      if (this._isActive) {
        var t = this._item;
        t._isActive &&
          ((this._moveDiffX = this._moveDiffY = 0),
          t._setTranslate(this._left, this._top),
          this._getGrid()._emit("dragMove", t, this._dragMoveEvent),
          ye.autoScroller.updateItem(t));
      }
    }),
    (ye.prototype._onScroll = function (t) {
      var e,
        i,
        s,
        n = this._item;
      n._isActive
        ? ((this._scrollEvent = t),
          (e = n._id),
          (i = this._prepareScroll),
          (s = this._applyScroll),
          it.add(0, j + e, i),
          it.add(2, Q + e, s),
          at(n._id, this._handleSort))
        : this.stop();
    }),
    (ye.prototype._prepareScroll = function () {
      if (this._isActive) {
        var t = this._item;
        if (t._isActive) {
          var e = t._element,
            i = this._getGrid()._element,
            s = e.getBoundingClientRect();
          if (this._container !== i) {
            var n = ie(this._containingBlock, i);
            (this._containerDiffX = n.left), (this._containerDiffY = n.top);
          }
          var o = this._clientX - this._moveDiffX - s.left;
          (this._left = this._left - this._scrollDiffX + o),
            (this._scrollDiffX = o);
          var r = this._clientY - this._moveDiffY - s.top;
          (this._top = this._top - this._scrollDiffY + r),
            (this._scrollDiffY = r),
            (this._gridX = this._left - this._containerDiffX),
            (this._gridY = this._top - this._containerDiffY);
        }
      }
    }),
    (ye.prototype._applyScroll = function () {
      if (this._isActive) {
        var t = this._item;
        t._isActive &&
          ((this._scrollDiffX = this._scrollDiffY = 0),
          t._setTranslate(this._left, this._top),
          this._getGrid()._emit("dragScroll", t, this._scrollEvent));
      }
    }),
    (ye.prototype._onEnd = function (t) {
      var e = this._item,
        i = e._element,
        s = this._getGrid(),
        n = s._settings,
        o = e._dragRelease;
      e._isActive
        ? (ot(e._id),
          rt(e._id),
          ht(e._id),
          this._finishSort(),
          this._unbindScrollListeners(),
          (o._containerDiffX = this._containerDiffX),
          (o._containerDiffY = this._containerDiffY),
          this._reset(),
          ue(i, n.itemDraggingClass),
          ye.autoScroller.removeItem(e),
          s._emit("dragEnd", e, t),
          this._isMigrating ? this._finishMigration() : o.start())
        : this.stop();
    });
  var we = /^(webkit|moz|ms|o|Webkit|Moz|MS|O)(?=[A-Z])/,
    De = {};
  function be(t) {
    var e = De[t];
    return (
      e ||
      ((e = t.replace(we, "")) !== t && (e = e[0].toLowerCase() + e.slice(1)),
      (De[t] = e),
      e)
    );
  }
  function Ae(t, e) {
    for (var i in e) t.style[i] = e[i];
  }
  var Ee,
    Te,
    xe = !(!Element || !dt(Element.prototype.animate)),
    ke = !!(
      Element &&
      ((Ee = Element.prototype.animate),
      (Te = window.Symbol),
      Ee &&
        dt(Te) &&
        dt(Te.toString) &&
        Te(Ee).toString().indexOf("[native code]") > -1)
    );
  function Le(t) {
    (this._element = t),
      (this._animation = null),
      (this._duration = 0),
      (this._easing = ""),
      (this._callback = null),
      (this._props = []),
      (this._values = []),
      (this._isDestroyed = !1),
      (this._onFinish = this._onFinish.bind(this));
  }
  function Re(t, e) {
    var i = {};
    for (var s in t) i[e ? s : be(s)] = t[s];
    return i;
  }
  function Ie(t, e) {
    return "translateX(" + t + "px) translateY(" + e + "px)";
  }
  function Ce(t) {
    (this._item = t),
      (this._animation = new Le()),
      (this._element = null),
      (this._className = ""),
      (this._didMigrate = !1),
      (this._resetAfterLayout = !1),
      (this._left = 0),
      (this._top = 0),
      (this._transX = 0),
      (this._transY = 0),
      (this._nextTransX = 0),
      (this._nextTransY = 0),
      (this._setupAnimation = this._setupAnimation.bind(this)),
      (this._startAnimation = this._startAnimation.bind(this)),
      (this._updateDimensions = this._updateDimensions.bind(this)),
      (this._onLayoutStart = this._onLayoutStart.bind(this)),
      (this._onLayoutEnd = this._onLayoutEnd.bind(this)),
      (this._onReleaseEnd = this._onReleaseEnd.bind(this)),
      (this._onMigrate = this._onMigrate.bind(this)),
      (this._onHide = this._onHide.bind(this));
  }
  function Me(t) {
    (this._item = t),
      (this._isActive = !1),
      (this._isDestroyed = !1),
      (this._isPositioningStarted = !1),
      (this._containerDiffX = 0),
      (this._containerDiffY = 0);
  }
  (Le.prototype.start = function (t, e, i) {
    if (!this._isDestroyed) {
      var s = this._element,
        n = i || {};
      if (!xe)
        return (
          Ae(s, e),
          (this._callback = dt(n.onFinish) ? n.onFinish : null),
          void this._onFinish()
        );
      var o,
        r,
        h,
        a = this._animation,
        _ = this._props,
        l = this._values,
        d = n.duration || 300,
        u = n.easing || "ease",
        c = !1;
      if (
        a &&
        ((r = 0), (d === this._duration && u === this._easing) || (c = !0), !c)
      ) {
        for (o in e)
          if ((++r, -1 === (h = _.indexOf(o)) || e[o] !== l[h])) {
            c = !0;
            break;
          }
        r !== _.length && (c = !0);
      }
      if (
        (c && a.cancel(),
        (this._callback = dt(n.onFinish) ? n.onFinish : null),
        !a || c)
      ) {
        for (o in ((_.length = l.length = 0), e)) _.push(o), l.push(e[o]);
        (this._duration = d),
          (this._easing = u),
          (this._animation = s.animate([Re(t, ke), Re(e, ke)], {
            duration: d,
            easing: u,
          })),
          (this._animation.onfinish = this._onFinish),
          Ae(s, e);
      }
    }
  }),
    (Le.prototype.stop = function () {
      !this._isDestroyed &&
        this._animation &&
        (this._animation.cancel(),
        (this._animation = this._callback = null),
        (this._props.length = this._values.length = 0));
    }),
    (Le.prototype.getCurrentStyles = function () {
      return Se(element, currentProps);
    }),
    (Le.prototype.isAnimating = function () {
      return !!this._animation;
    }),
    (Le.prototype.destroy = function () {
      this._isDestroyed ||
        (this.stop(), (this._element = null), (this._isDestroyed = !0));
    }),
    (Le.prototype._onFinish = function () {
      var t = this._callback;
      (this._animation = this._callback = null),
        (this._props.length = this._values.length = 0),
        t && t();
    }),
    (Ce.prototype._updateDimensions = function () {
      this.isActive() &&
        Ae(this._element, {
          width: this._item._width + "px",
          height: this._item._height + "px",
        });
    }),
    (Ce.prototype._onLayoutStart = function (t, e) {
      var i = this._item;
      if (-1 !== t.indexOf(i)) {
        var s = i._left,
          n = i._top,
          o = this._left,
          r = this._top;
        if (
          ((this._left = s),
          (this._top = n),
          e || this._didMigrate || o !== s || r !== n)
        ) {
          var h,
            a,
            _,
            l = s + i._marginLeft,
            d = n + i._marginTop,
            u = i.getGrid();
          if (!(!e && u._settings.layoutDuration > 0) || this._didMigrate)
            return (
              _t(i._id),
              (this._element.style[Ft] = Ie(l, d)),
              this._animation.stop(),
              void (
                this._didMigrate &&
                (u.getElement().appendChild(this._element),
                (this._didMigrate = !1))
              )
            );
          (this._nextTransX = l),
            (this._nextTransY = d),
            (h = i._id),
            (a = this._setupAnimation),
            (_ = this._startAnimation),
            it.add(0, Z + h, a),
            it.add(2, J + h, _);
        }
      } else this.reset();
    }),
    (Ce.prototype._setupAnimation = function () {
      if (this.isActive()) {
        var t = de(this._element);
        (this._transX = t.x), (this._transY = t.y);
      }
    }),
    (Ce.prototype._startAnimation = function () {
      if (this.isActive()) {
        var t = this._animation,
          e = this._transX,
          i = this._transY,
          s = this._nextTransX,
          n = this._nextTransY;
        if (e !== s || i !== n) {
          var o = this._item.getGrid()._settings,
            r = {},
            h = {};
          (r[Ft] = Ie(e, i)),
            (h[Ft] = Ie(s, n)),
            t.start(r, h, {
              duration: o.layoutDuration,
              easing: o.layoutEasing,
              onFinish: this._onLayoutEnd,
            });
        } else
          t.isAnimating() && ((this._element.style[Ft] = Ie(s, n)), t.stop());
      }
    }),
    (Ce.prototype._onLayoutEnd = function () {
      this._resetAfterLayout && this.reset();
    }),
    (Ce.prototype._onReleaseEnd = function (t) {
      if (t._id === this._item._id) {
        if (!this._animation.isAnimating()) return void this.reset();
        this._resetAfterLayout = !0;
      }
    }),
    (Ce.prototype._onMigrate = function (t) {
      if (t.item === this._item) {
        var e = this._item.getGrid(),
          i = t.toGrid;
        e.off(m, this._onReleaseEnd),
          e.off(n, this._onLayoutStart),
          e.off(c, this._onMigrate),
          e.off(a, this._onHide),
          i.on(m, this._onReleaseEnd),
          i.on(n, this._onLayoutStart),
          i.on(c, this._onMigrate),
          i.on(a, this._onHide),
          (this._didMigrate = !0);
      }
    }),
    (Ce.prototype._onHide = function (t) {
      t.indexOf(this._item) > -1 && this.reset();
    }),
    (Ce.prototype.create = function () {
      if (this.isActive()) this._resetAfterLayout = !1;
      else {
        var t,
          e = this._item,
          i = e.getGrid(),
          s = i._settings,
          o = this._animation;
        (this._left = e._left),
          (this._top = e._top),
          (t = dt(s.dragPlaceholder.createElement)
            ? s.dragPlaceholder.createElement(e)
            : document.createElement("div")),
          (this._element = t),
          (o._element = t),
          (this._className = s.itemPlaceholderClass || ""),
          this._className && Ot(t, this._className),
          Ae(t, {
            position: "absolute",
            left: "0px",
            top: "0px",
            width: e._width + "px",
            height: e._height + "px",
          }),
          (t.style[Ft] = Ie(e._left + e._marginLeft, e._top + e._marginTop)),
          i.on(n, this._onLayoutStart),
          i.on(m, this._onReleaseEnd),
          i.on(c, this._onMigrate),
          i.on(a, this._onHide),
          dt(s.dragPlaceholder.onCreate) && s.dragPlaceholder.onCreate(e, t),
          i.getElement().appendChild(t);
      }
    }),
    (Ce.prototype.reset = function () {
      if (this.isActive()) {
        var t,
          e = this._element,
          i = this._item,
          s = i.getGrid(),
          o = s._settings,
          r = this._animation;
        (this._resetAfterLayout = !1),
          _t(i._id),
          (t = i._id),
          it.remove(2, $ + t),
          r.stop(),
          (r._element = null),
          s.off(m, this._onReleaseEnd),
          s.off(n, this._onLayoutStart),
          s.off(c, this._onMigrate),
          s.off(a, this._onHide),
          this._className && (ue(e, this._className), (this._className = "")),
          e.parentNode.removeChild(e),
          (this._element = null),
          dt(o.dragPlaceholder.onRemove) && o.dragPlaceholder.onRemove(i, e);
      }
    }),
    (Ce.prototype.isActive = function () {
      return !!this._element;
    }),
    (Ce.prototype.getElement = function () {
      return this._element;
    }),
    (Ce.prototype.updateDimensions = function () {
      var t, e;
      this.isActive() &&
        ((t = this._item._id),
        (e = this._updateDimensions),
        it.add(2, $ + t, e));
    }),
    (Ce.prototype.destroy = function () {
      this.reset(),
        this._animation.destroy(),
        (this._item = this._animation = null);
    }),
    (Me.prototype.start = function () {
      if (!this._isDestroyed && !this._isActive) {
        var t = this._item,
          e = t.getGrid(),
          i = e._settings;
        (this._isActive = !0),
          Ot(t._element, i.itemReleasingClass),
          i.dragRelease.useDragContainer || this._placeToGrid(),
          e._emit("dragReleaseStart", t),
          e._nextLayoutData || t._layout.start(!1);
      }
    }),
    (Me.prototype.stop = function (t, e, i) {
      if (!this._isDestroyed && this._isActive) {
        var s = this._item,
          n = s.getGrid();
        t || (void 0 !== e && void 0 !== i) || ((e = s._left), (i = s._top));
        var o = this._placeToGrid(e, i);
        this._reset(o), t || n._emit(m, s);
      }
    }),
    (Me.prototype.isJustReleased = function () {
      return this._isActive && !1 === this._isPositioningStarted;
    }),
    (Me.prototype.destroy = function () {
      this._isDestroyed ||
        (this.stop(!0), (this._item = null), (this._isDestroyed = !0));
    }),
    (Me.prototype._placeToGrid = function (t, e) {
      if (!this._isDestroyed) {
        var i = this._item,
          s = i._element,
          n = i.getGrid()._element,
          o = !1;
        if (s.parentNode !== n) {
          if (void 0 === t || void 0 === e) {
            var r = de(s);
            (t = r.x - this._containerDiffX), (e = r.y - this._containerDiffY);
          }
          n.appendChild(s), i._setTranslate(t, e), (o = !0);
        }
        return (this._containerDiffX = 0), (this._containerDiffY = 0), o;
      }
    }),
    (Me.prototype._reset = function (t) {
      if (!this._isDestroyed) {
        var e = this._item,
          i = e.getGrid()._settings.itemReleasingClass;
        (this._isActive = !1),
          (this._isPositioningStarted = !1),
          (this._containerDiffX = 0),
          (this._containerDiffY = 0),
          i && (t && e._element.clientWidth, ue(e._element, i));
      }
    });
  function Pe(t) {
    var e = t._element,
      i = e.style;
    (this._item = t),
      (this._isActive = !1),
      (this._isDestroyed = !1),
      (this._isInterrupted = !1),
      (this._currentStyles = {}),
      (this._targetStyles = {}),
      (this._nextLeft = 0),
      (this._nextTop = 0),
      (this._offsetLeft = 0),
      (this._offsetTop = 0),
      (this._skipNextAnimation = !1),
      (this._animOptions = {
        onFinish: this._finish.bind(this),
        duration: 0,
        easing: 0,
      }),
      (i.left = "0px"),
      (i.top = "0px"),
      t._setTranslate(0, 0),
      (this._animation = new Le(e)),
      (this._queue = "layout-" + t._id),
      (this._setupAnimation = this._setupAnimation.bind(this)),
      (this._startAnimation = this._startAnimation.bind(this));
  }
  function Xe(t) {
    (this._item = t),
      (this._isActive = !1),
      (this._isDestroyed = !1),
      (this._container = !1),
      (this._containerDiffX = 0),
      (this._containerDiffY = 0);
  }
  function Ye(t) {
    var e = t._isActive,
      i = t._element,
      s = i.children[0],
      n = t.getGrid()._settings;
    if (!s)
      throw new Error("No valid child element found within item element.");
    (this._item = t),
      (this._isDestroyed = !1),
      (this._isHidden = !e),
      (this._isHiding = !1),
      (this._isShowing = !1),
      (this._childElement = s),
      (this._currentStyleProps = []),
      (this._animation = new Le(s)),
      (this._queue = "visibility-" + t._id),
      (this._finishShow = this._finishShow.bind(this)),
      (this._finishHide = this._finishHide.bind(this)),
      (i.style.display = e ? "" : "none"),
      Ot(i, e ? n.itemVisibleClass : n.itemHiddenClass),
      this.setStyles(e ? n.visibleStyles : n.hiddenStyles);
  }
  (Pe.prototype.start = function (t, e) {
    if (!this._isDestroyed) {
      var i,
        s,
        n,
        o = this._item,
        r = o._dragRelease,
        h = o.getGrid()._settings,
        a = this._isActive,
        _ = r.isJustReleased(),
        l = _ ? h.dragRelease.duration : h.layoutDuration,
        d = _ ? h.dragRelease.easing : h.layoutEasing,
        u = !t && !this._skipNextAnimation && l > 0;
      if (
        (a && (st(o._id), o._emitter.burst(this._queue, !0, o)),
        _ && (r._isPositioningStarted = !0),
        dt(e) && o._emitter.on(this._queue, e),
        (this._skipNextAnimation = !1),
        !u)
      )
        return (
          this._updateOffsets(),
          o._setTranslate(this._nextLeft, this._nextTop),
          this._animation.stop(),
          void this._finish()
        );
      this._animation.isAnimating() &&
        (this._animation._animation.onfinish = null),
        (this._isActive = !0),
        (this._animOptions.easing = d),
        (this._animOptions.duration = l),
        (this._isInterrupted = a),
        (i = o._id),
        (s = this._setupAnimation),
        (n = this._startAnimation),
        it.add(0, H + i, s),
        it.add(2, G + i, n);
    }
  }),
    (Pe.prototype.stop = function (t, e, i) {
      if (!this._isDestroyed && this._isActive) {
        var s = this._item;
        if ((st(s._id), this._animation.isAnimating())) {
          if (void 0 === e || void 0 === i) {
            var n = de(s._element);
            (e = n.x), (i = n.y);
          }
          s._setTranslate(e, i), this._animation.stop();
        }
        ue(s._element, s.getGrid()._settings.itemPositioningClass),
          (this._isActive = !1),
          t && s._emitter.burst(this._queue, !0, s);
      }
    }),
    (Pe.prototype.destroy = function () {
      if (!this._isDestroyed) {
        var t = this._item._element.style;
        this.stop(!0, 0, 0),
          this._item._emitter.clear(this._queue),
          this._animation.destroy(),
          (t[Ft] = ""),
          (t.left = ""),
          (t.top = ""),
          (this._item = null),
          (this._currentStyles = null),
          (this._targetStyles = null),
          (this._animOptions = null),
          (this._isDestroyed = !0);
      }
    }),
    (Pe.prototype._updateOffsets = function () {
      if (!this._isDestroyed) {
        var t = this._item,
          e = t._migrate,
          i = t._dragRelease;
        (this._offsetLeft = i._isActive
          ? i._containerDiffX
          : e._isActive
          ? e._containerDiffX
          : 0),
          (this._offsetTop = i._isActive
            ? i._containerDiffY
            : e._isActive
            ? e._containerDiffY
            : 0),
          (this._nextLeft = this._item._left + this._offsetLeft),
          (this._nextTop = this._item._top + this._offsetTop);
      }
    }),
    (Pe.prototype._finish = function () {
      if (!this._isDestroyed) {
        var t = this._item,
          e = t._migrate,
          i = t._dragRelease;
        (t._tX = this._nextLeft),
          (t._tY = this._nextTop),
          this._isActive &&
            ((this._isActive = !1),
            ue(t._element, t.getGrid()._settings.itemPositioningClass)),
          i._isActive && i.stop(),
          e._isActive && e.stop(),
          t._emitter.burst(this._queue, !1, t);
      }
    }),
    (Pe.prototype._setupAnimation = function () {
      var t = this._item;
      if (void 0 === t._tX || void 0 === t._tY) {
        var e = de(t._element);
        (t._tX = e.x), (t._tY = e.y);
      }
    }),
    (Pe.prototype._startAnimation = function () {
      var t = this._item,
        e = t.getGrid()._settings,
        i = this._animOptions.duration <= 0;
      this._updateOffsets();
      var s = Math.abs(t._left - (t._tX - this._offsetLeft)),
        n = Math.abs(t._top - (t._tY - this._offsetTop));
      if (i || (s < 2 && n < 2))
        return (
          (s || n || this._isInterrupted) &&
            t._setTranslate(this._nextLeft, this._nextTop),
          this._animation.stop(),
          void this._finish()
        );
      this._isInterrupted || Ot(t._element, e.itemPositioningClass),
        (this._currentStyles[Ft] = Ie(t._tX, t._tY)),
        (this._targetStyles[Ft] = Ie(this._nextLeft, this._nextTop)),
        (t._tX = t._tY = void 0),
        this._animation.start(
          this._currentStyles,
          this._targetStyles,
          this._animOptions
        );
    }),
    (Xe.prototype.start = function (t, e, i) {
      if (!this._isDestroyed) {
        var s,
          n,
          o,
          r,
          h,
          a,
          _,
          l,
          d,
          m,
          g = this._item,
          v = g._element,
          y = g.isActive(),
          S = g.isVisible(),
          w = g.getGrid(),
          D = w._settings,
          b = t._settings,
          A = t._element,
          E = t._items,
          T = w._items.indexOf(g),
          x = i || document.body;
        if ("number" == typeof e) s = Wt(E, e, 1);
        else {
          if (!(n = t.getItem(e))) return;
          s = E.indexOf(n);
        }
        (g.isPositioning() || this._isActive || g.isReleasing()) &&
          ((_ = (a = de(v)).x), (l = a.y)),
          g.isPositioning() && g._layout.stop(!0, _, l),
          this._isActive &&
            ((_ -= this._containerDiffX),
            (l -= this._containerDiffY),
            this.stop(!0, _, l)),
          g.isReleasing() &&
            ((_ -= g._dragRelease._containerDiffX),
            (l -= g._dragRelease._containerDiffY),
            g._dragRelease.stop(!0, _, l)),
          g._visibility.stop(!0),
          g._drag && g._drag.destroy(),
          w._hasListeners(c) &&
            w._emit(c, {
              item: g,
              fromGrid: w,
              fromIndex: T,
              toGrid: t,
              toIndex: s,
            }),
          t._hasListeners(p) &&
            t._emit(p, {
              item: g,
              fromGrid: w,
              fromIndex: T,
              toGrid: t,
              toIndex: s,
            }),
          D.itemClass !== b.itemClass &&
            (ue(v, D.itemClass), Ot(v, b.itemClass)),
          (d = S ? D.itemVisibleClass : D.itemHiddenClass) !==
            (m = S ? b.itemVisibleClass : b.itemHiddenClass) &&
            (ue(v, d), Ot(v, m)),
          w._items.splice(T, 1),
          Gt(E, g, s),
          (g._gridId = t._id),
          y
            ? x !== (o = v.parentNode) &&
              (x.appendChild(v),
              (r = ie(x, o, !0)),
              a || ((_ = (a = de(v)).x), (l = a.y)),
              g._setTranslate(_ + r.left, l + r.top))
            : A.appendChild(v),
          g._visibility.setStyles(S ? b.visibleStyles : b.hiddenStyles),
          y && (h = ie(x, A, !0)),
          g._refreshDimensions(),
          (g._sortData = null),
          (g._drag = b.dragEnabled ? new ye(g) : null),
          y
            ? ((this._isActive = !0),
              (this._container = x),
              (this._containerDiffX = h.left),
              (this._containerDiffY = h.top))
            : ((this._isActive = !1),
              (this._container = null),
              (this._containerDiffX = 0),
              (this._containerDiffY = 0)),
          w._hasListeners(u) &&
            w._emit(u, {
              item: g,
              fromGrid: w,
              fromIndex: T,
              toGrid: t,
              toIndex: s,
            }),
          t._hasListeners(f) &&
            t._emit(f, {
              item: g,
              fromGrid: w,
              fromIndex: T,
              toGrid: t,
              toIndex: s,
            });
      }
    }),
    (Xe.prototype.stop = function (t, e, i) {
      if (!this._isDestroyed && this._isActive) {
        var s,
          n = this._item,
          o = n._element,
          r = n.getGrid()._element;
        this._container !== r &&
          ((void 0 !== e && void 0 !== i) ||
            (t
              ? ((e = (s = de(o)).x - this._containerDiffX),
                (i = s.y - this._containerDiffY))
              : ((e = n._left), (i = n._top))),
          r.appendChild(o),
          n._setTranslate(e, i)),
          (this._isActive = !1),
          (this._container = null),
          (this._containerDiffX = 0),
          (this._containerDiffY = 0);
      }
    }),
    (Xe.prototype.destroy = function () {
      this._isDestroyed ||
        (this.stop(!0), (this._item = null), (this._isDestroyed = !0));
    }),
    (Ye.prototype.show = function (t, e) {
      if (!this._isDestroyed) {
        var i = this._item,
          s = i._element,
          n = dt(e) ? e : null,
          o = i.getGrid()._settings;
        this._isShowing || this._isHidden
          ? !this._isShowing || t
            ? (this._isShowing ||
                (i._emitter.burst(this._queue, !0, i),
                ue(s, o.itemHiddenClass),
                Ot(s, o.itemVisibleClass),
                this._isHiding || (s.style.display = "")),
              n && i._emitter.on(this._queue, n),
              (this._isShowing = !0),
              (this._isHiding = this._isHidden = !1),
              this._startAnimation(!0, t, this._finishShow))
            : n && i._emitter.on(this._queue, n)
          : n && n(!1, i);
      }
    }),
    (Ye.prototype.hide = function (t, e) {
      if (!this._isDestroyed) {
        var i = this._item,
          s = i._element,
          n = dt(e) ? e : null,
          o = i.getGrid()._settings;
        this._isHiding || !this._isHidden
          ? !this._isHiding || t
            ? (this._isHiding ||
                (i._emitter.burst(this._queue, !0, i),
                Ot(s, o.itemHiddenClass),
                ue(s, o.itemVisibleClass)),
              n && i._emitter.on(this._queue, n),
              (this._isHidden = this._isHiding = !0),
              (this._isShowing = !1),
              this._startAnimation(!1, t, this._finishHide))
            : n && i._emitter.on(this._queue, n)
          : n && n(!1, i);
      }
    }),
    (Ye.prototype.stop = function (t) {
      if (!this._isDestroyed && (this._isHiding || this._isShowing)) {
        var e = this._item;
        nt(e._id),
          this._animation.stop(),
          t && e._emitter.burst(this._queue, !0, e);
      }
    }),
    (Ye.prototype.setStyles = function (t) {
      var e = this._childElement,
        i = this._currentStyleProps;
      for (var s in (this._removeCurrentStyles(), t))
        i.push(s), (e.style[s] = t[s]);
    }),
    (Ye.prototype.destroy = function () {
      if (!this._isDestroyed) {
        var t = this._item,
          e = t._element,
          i = t.getGrid()._settings;
        this.stop(!0),
          t._emitter.clear(this._queue),
          this._animation.destroy(),
          this._removeCurrentStyles(),
          ue(e, i.itemVisibleClass),
          ue(e, i.itemHiddenClass),
          (e.style.display = ""),
          (this._isHiding = this._isShowing = !1),
          (this._isDestroyed = this._isHidden = !0);
      }
    }),
    (Ye.prototype._startAnimation = function (t, e, i) {
      if (!this._isDestroyed) {
        var s,
          n = this._item,
          o = this._animation,
          r = this._childElement,
          h = n.getGrid()._settings,
          a = t ? h.visibleStyles : h.hiddenStyles,
          _ = t ? h.showDuration : h.hideDuration,
          l = t ? h.showEasing : h.hideEasing,
          d = e || _ <= 0;
        if (a) {
          if ((nt(n._id), d)) return Ae(r, a), o.stop(), void (i && i());
          var u, c, f;
          o.isAnimating() && (o._animation.onfinish = null),
            (u = n._id),
            (c = function () {
              s = Se(r, a);
            }),
            (f = function () {
              o.start(s, a, { duration: _, easing: l, onFinish: i });
            }),
            it.add(0, W + u, c),
            it.add(2, B + u, f);
        } else i && i();
      }
    }),
    (Ye.prototype._finishShow = function () {
      this._isHidden ||
        ((this._isShowing = !1),
        this._item._emitter.burst(this._queue, !1, this._item));
    }),
    (Ye.prototype._finishHide = function () {
      if (this._isHidden) {
        var t = this._item;
        (this._isHiding = !1),
          t._layout.stop(!0, 0, 0),
          (t._element.style.display = "none"),
          t._emitter.burst(this._queue, !1, t);
      }
    }),
    (Ye.prototype._removeCurrentStyles = function () {
      for (
        var t = this._childElement, e = this._currentStyleProps, i = 0;
        i < e.length;
        i++
      )
        t.style[e[i]] = "";
      e.length = 0;
    });
  var qe = 0;
  function Oe() {
    return ++qe;
  }
  function He(t, i, s) {
    var n = t._settings;
    if (e) {
      if (e.has(i))
        throw new Error("You can only create one Muuri Item per element!");
      e.set(i, this);
    }
    (this._id = Oe()),
      (this._gridId = t._id),
      (this._element = i),
      (this._isDestroyed = !1),
      (this._left = 0),
      (this._top = 0),
      (this._width = 0),
      (this._height = 0),
      (this._marginLeft = 0),
      (this._marginRight = 0),
      (this._marginTop = 0),
      (this._marginBottom = 0),
      (this._tX = void 0),
      (this._tY = void 0),
      (this._sortData = null),
      (this._emitter = new S()),
      i.parentNode !== t._element && t._element.appendChild(i),
      Ot(i, n.itemClass),
      "boolean" != typeof s && (s = "none" !== ct(i, "display")),
      (this._isActive = s),
      (this._visibility = new Ye(this)),
      (this._layout = new Pe(this)),
      (this._migrate = new Xe(this)),
      (this._drag = n.dragEnabled ? new ye(this) : null),
      (this._dragRelease = new Me(this)),
      (this._dragPlaceholder = new Ce(this));
  }
  function Ge(t) {
    var e,
      i,
      s,
      n,
      o,
      r = 0.001,
      h = 0.5;
    function a(t) {
      return ((((1e3 * t + 0.5) << 0) / 10) << 0) / 100;
    }
    function _() {
      (this.currentRects = []),
        (this.nextRects = []),
        (this.rectTarget = {}),
        (this.rectStore = []),
        (this.slotSizes = []),
        (this.rectId = 0),
        (this.slotIndex = -1),
        (this.slotData = { left: 0, top: 0, width: 0, height: 0 }),
        (this.sortRectsLeftTop = this.sortRectsLeftTop.bind(this)),
        (this.sortRectsTopLeft = this.sortRectsTopLeft.bind(this));
    }
    if (
      ((_.prototype.computeLayout = function (t, e) {
        var i,
          s,
          n,
          o,
          r,
          h,
          _ = t.items,
          l = t.slots,
          d = !!(1 & e),
          u = !!(2 & e),
          c = !!(4 & e),
          f = !!(8 & e),
          p = !!(16 & e),
          m = "number" == typeof _[0];
        if (!_.length) return t;
        for (s = m ? 2 : 1, i = 0; i < _.length; i += s)
          m
            ? ((o = _[i]), (r = _[i + 1]))
            : ((o = (n = _[i])._width + n._marginLeft + n._marginRight),
              (r = n._height + n._marginTop + n._marginBottom)),
            p && ((o = a(o)), (r = a(r))),
            (h = this.computeNextSlot(t, o, r, d, u)),
            u
              ? h.left + h.width > t.width && (t.width = h.left + h.width)
              : h.top + h.height > t.height && (t.height = h.top + h.height),
            (l[++this.slotIndex] = h.left),
            (l[++this.slotIndex] = h.top),
            (c || f) && this.slotSizes.push(h.width, h.height);
        if (c)
          for (i = 0; i < l.length; i += 2)
            l[i] = t.width - (l[i] + this.slotSizes[i]);
        if (f)
          for (i = 1; i < l.length; i += 2)
            l[i] = t.height - (l[i] + this.slotSizes[i]);
        return (
          (this.slotSizes.length = 0),
          (this.currentRects.length = 0),
          (this.nextRects.length = 0),
          (this.rectStore.length = 0),
          (this.rectId = 0),
          (this.slotIndex = -1),
          t
        );
      }),
      (_.prototype.computeNextSlot = function (t, e, i, s, n) {
        var o,
          a,
          _,
          l,
          d,
          u = this.slotData,
          c = this.currentRects,
          f = this.nextRects,
          p = !1;
        for (
          f.length = 0,
            u.left = null,
            u.top = null,
            u.width = e,
            u.height = i,
            l = 0;
          l < c.length;
          l++
        )
          if (
            (a = c[l]) &&
            ((o = this.getRect(a)),
            u.width <= o.width + r && u.height <= o.height + r)
          ) {
            (u.left = o.left), (u.top = o.top);
            break;
          }
        if (
          (null === u.left &&
            (n
              ? ((u.left = t.width), (u.top = 0))
              : ((u.left = 0), (u.top = t.height)),
            s || (p = !0)),
          !n &&
            u.top + u.height > t.height + r &&
            (u.left > h && f.push(this.addRect(0, t.height, u.left, 1 / 0)),
            u.left + u.width < t.width - h &&
              f.push(
                this.addRect(
                  u.left + u.width,
                  t.height,
                  t.width - u.left - u.width,
                  1 / 0
                )
              ),
            (t.height = u.top + u.height)),
          n &&
            u.left + u.width > t.width + r &&
            (u.top > h && f.push(this.addRect(t.width, 0, 1 / 0, u.top)),
            u.top + u.height < t.height - h &&
              f.push(
                this.addRect(
                  t.width,
                  u.top + u.height,
                  1 / 0,
                  t.height - u.top - u.height
                )
              ),
            (t.width = u.left + u.width)),
          !p)
        )
          for (s && (l = 0); l < c.length; l++)
            if ((a = c[l]))
              for (
                o = this.getRect(a), _ = this.splitRect(o, u), d = 0;
                d < _.length;
                d++
              )
                (a = _[d]),
                  (o = this.getRect(a)),
                  (n ? o.left + r < t.width - r : o.top + r < t.height - r) &&
                    f.push(a);
        return (
          f.length > 1 &&
            this.purgeRects(f).sort(
              n ? this.sortRectsLeftTop : this.sortRectsTopLeft
            ),
          (this.currentRects = f),
          (this.nextRects = c),
          u
        );
      }),
      (_.prototype.addRect = function (t, e, i, s) {
        var n = ++this.rectId;
        return (
          (this.rectStore[n] = t || 0),
          (this.rectStore[++this.rectId] = e || 0),
          (this.rectStore[++this.rectId] = i || 0),
          (this.rectStore[++this.rectId] = s || 0),
          n
        );
      }),
      (_.prototype.getRect = function (t, e) {
        return (
          e || (e = this.rectTarget),
          (e.left = this.rectStore[t] || 0),
          (e.top = this.rectStore[++t] || 0),
          (e.width = this.rectStore[++t] || 0),
          (e.height = this.rectStore[++t] || 0),
          e
        );
      }),
      (_.prototype.splitRect =
        ((e = []),
        (i = 0),
        (s = 0),
        function (t, n) {
          return (
            (e.length = 0),
            t.left + t.width <= n.left + r ||
            n.left + n.width <= t.left + r ||
            t.top + t.height <= n.top + r ||
            n.top + n.height <= t.top + r
              ? (e.push(this.addRect(t.left, t.top, t.width, t.height)), e)
              : ((i = n.left - t.left) >= h &&
                  e.push(this.addRect(t.left, t.top, i, t.height)),
                (i = t.left + t.width - (n.left + n.width)) >= h &&
                  e.push(this.addRect(n.left + n.width, t.top, i, t.height)),
                (s = n.top - t.top) >= h &&
                  e.push(this.addRect(t.left, t.top, t.width, s)),
                (s = t.top + t.height - (n.top + n.height)) >= h &&
                  e.push(this.addRect(t.left, n.top + n.height, t.width, s)),
                e)
          );
        })),
      (_.prototype.isRectAWithinRectB = function (t, e) {
        return (
          t.left + r >= e.left &&
          t.top + r >= e.top &&
          t.left + t.width - r <= e.left + e.width &&
          t.top + t.height - r <= e.top + e.height
        );
      }),
      (_.prototype.purgeRects =
        ((n = {}),
        (o = {}),
        function (t) {
          for (var e, i = t.length; i--; )
            if (((e = t.length), t[i]))
              for (this.getRect(t[i], n); e--; )
                if (
                  t[e] &&
                  i !== e &&
                  (this.getRect(t[e], o), this.isRectAWithinRectB(n, o))
                ) {
                  t[i] = 0;
                  break;
                }
          return t;
        })),
      (_.prototype.sortRectsTopLeft = (function () {
        var t = {},
          e = {};
        return function (i, s) {
          return (
            this.getRect(i, t),
            this.getRect(s, e),
            t.top < e.top && t.top + r < e.top
              ? -1
              : t.top > e.top && t.top - r > e.top
              ? 1
              : t.left < e.left && t.left + r < e.left
              ? -1
              : t.left > e.left && t.left - r > e.left
              ? 1
              : 0
          );
        };
      })()),
      (_.prototype.sortRectsLeftTop = (function () {
        var t = {},
          e = {};
        return function (i, s) {
          return (
            this.getRect(i, t),
            this.getRect(s, e),
            t.left < e.left && t.left + r < e.left
              ? -1
              : t.left > e.left && t.left - r < e.left
              ? 1
              : t.top < e.top && t.top + r < e.top
              ? -1
              : t.top > e.top && t.top - r > e.top
              ? 1
              : 0
          );
        };
      })()),
      t)
    ) {
      var l = new _();
      self.onmessage = function (t) {
        var e = new Float32Array(t.data),
          i = e.subarray(4, e.length),
          s = new Float32Array(i.length),
          n = e[3],
          o = { items: i, slots: s, width: e[1], height: e[2] };
        l.computeLayout(o, n),
          (e[1] = o.width),
          (e[2] = o.height),
          e.set(o.slots, 4),
          postMessage(e.buffer, [e.buffer]);
      };
    }
    return _;
  }
  (He.prototype.getGrid = function () {
    return t[this._gridId];
  }),
    (He.prototype.getElement = function () {
      return this._element;
    }),
    (He.prototype.getWidth = function () {
      return this._width;
    }),
    (He.prototype.getHeight = function () {
      return this._height;
    }),
    (He.prototype.getMargin = function () {
      return {
        left: this._marginLeft,
        right: this._marginRight,
        top: this._marginTop,
        bottom: this._marginBottom,
      };
    }),
    (He.prototype.getPosition = function () {
      return { left: this._left, top: this._top };
    }),
    (He.prototype.isActive = function () {
      return this._isActive;
    }),
    (He.prototype.isVisible = function () {
      return !!this._visibility && !this._visibility._isHidden;
    }),
    (He.prototype.isShowing = function () {
      return !(!this._visibility || !this._visibility._isShowing);
    }),
    (He.prototype.isHiding = function () {
      return !(!this._visibility || !this._visibility._isHiding);
    }),
    (He.prototype.isPositioning = function () {
      return !(!this._layout || !this._layout._isActive);
    }),
    (He.prototype.isDragging = function () {
      return !(!this._drag || !this._drag._isActive);
    }),
    (He.prototype.isReleasing = function () {
      return !(!this._dragRelease || !this._dragRelease._isActive);
    }),
    (He.prototype.isDestroyed = function () {
      return this._isDestroyed;
    }),
    (He.prototype._refreshDimensions = function (t) {
      if (!(this._isDestroyed || (!0 !== t && this._visibility._isHidden))) {
        var e = this._element,
          i = this._dragPlaceholder,
          s = e.getBoundingClientRect();
        (this._width = s.width),
          (this._height = s.height),
          (this._marginLeft = Math.max(0, ft(e, "margin-left"))),
          (this._marginRight = Math.max(0, ft(e, "margin-right"))),
          (this._marginTop = Math.max(0, ft(e, "margin-top"))),
          (this._marginBottom = Math.max(0, ft(e, "margin-bottom"))),
          i && i.updateDimensions();
      }
    }),
    (He.prototype._refreshSortData = function () {
      if (!this._isDestroyed) {
        var t,
          e = (this._sortData = {}),
          i = this.getGrid()._settings.sortData;
        for (t in i) e[t] = i[t](this, this._element);
      }
    }),
    (He.prototype._addToLayout = function (t, e) {
      !0 !== this._isActive &&
        ((this._isActive = !0), (this._left = t || 0), (this._top = e || 0));
    }),
    (He.prototype._removeFromLayout = function () {
      !1 !== this._isActive &&
        ((this._isActive = !1), (this._left = 0), (this._top = 0));
    }),
    (He.prototype._canSkipLayout = function (t, e) {
      return (
        this._left === t &&
        this._top === e &&
        !this._migrate._isActive &&
        !this._layout._skipNextAnimation &&
        !this._dragRelease.isJustReleased()
      );
    }),
    (He.prototype._setTranslate = function (t, e) {
      return (
        (this._tX !== t || this._tY !== e) &&
        ((this._tX = t),
        (this._tY = e),
        (this._element.style[Ft] = Ie(t, e)),
        !0)
      );
    }),
    (He.prototype._destroy = function (t) {
      if (!this._isDestroyed) {
        var i = this._element,
          s = this.getGrid()._settings;
        this._dragPlaceholder.destroy(),
          this._dragRelease.destroy(),
          this._migrate.destroy(),
          this._layout.destroy(),
          this._visibility.destroy(),
          this._drag && this._drag.destroy(),
          this._emitter.destroy(),
          ue(i, s.itemClass),
          t && i.parentNode.removeChild(i),
          e && e.delete(i),
          (this._isActive = !1),
          (this._isDestroyed = !0);
      }
    });
  var We = Ge(),
    Be = null,
    Ne = [];
  function Fe(t, e) {
    if (
      ((this._options = 0),
      (this._processor = null),
      (this._layoutQueue = []),
      (this._layouts = {}),
      (this._layoutCallbacks = {}),
      (this._layoutWorkers = {}),
      (this._layoutWorkerData = {}),
      (this._workers = []),
      (this._onWorkerMessage = this._onWorkerMessage.bind(this)),
      this.setOptions(e),
      (t = "number" == typeof t ? Math.max(0, t) : 0) &&
        window.Worker &&
        window.URL &&
        window.Blob)
    )
      try {
        this._workers = (function (t, e) {
          var i = [];
          if (t > 0) {
            Be ||
              (Be = URL.createObjectURL(
                new Blob(["(" + Ge.toString() + ")(true)"], {
                  type: "application/javascript",
                })
              ));
            for (var s, n = 0; n < t; n++)
              (s = new Worker(Be)),
                e && (s.onmessage = e),
                i.push(s),
                Ne.push(s);
          }
          return i;
        })(t, this._onWorkerMessage);
      } catch (t) {
        this._processor = new We();
      }
    else this._processor = new We();
  }
  (Fe.prototype._sendToWorker = function () {
    if (this._layoutQueue.length && this._workers.length) {
      var t = this._layoutQueue.shift(),
        e = this._workers.pop(),
        i = this._layoutWorkerData[t];
      delete this._layoutWorkerData[t],
        (this._layoutWorkers[t] = e),
        e.postMessage(i.buffer, [i.buffer]);
    }
  }),
    (Fe.prototype._onWorkerMessage = function (t) {
      var e = new Float32Array(t.data),
        i = e[0],
        s = this._layouts[i],
        n = this._layoutCallbacks[i],
        o = this._layoutWorkers[i];
      s && delete this._layouts[i],
        n && delete this._layoutCallbacks[i],
        o && delete this._layoutWorkers[i],
        s &&
          n &&
          ((s.width = e[1]),
          (s.height = e[2]),
          (s.slots = e.subarray(4, e.length)),
          this._finalizeLayout(s),
          n(s)),
        o && (this._workers.push(o), this._sendToWorker());
    }),
    (Fe.prototype._finalizeLayout = function (t) {
      var e = t._grid,
        i = 2 & t._settings,
        s = "border-box" === e._boxSizing;
      return (
        delete t._grid,
        delete t._settings,
        (t.styles = {}),
        i
          ? (t.styles.width =
              (s ? t.width + e._borderLeft + e._borderRight : t.width) + "px")
          : (t.styles.height =
              (s ? t.height + e._borderTop + e._borderBottom : t.height) +
              "px"),
        t
      );
    }),
    (Fe.prototype.setOptions = function (t) {
      var e, i, s, n, o;
      t &&
        ((e =
          "boolean" == typeof t.fillGaps
            ? t.fillGaps
              ? 1
              : 0
            : 1 & this._options),
        (i =
          "boolean" == typeof t.horizontal
            ? t.horizontal
              ? 2
              : 0
            : 2 & this._options),
        (s =
          "boolean" == typeof t.alignRight
            ? t.alignRight
              ? 4
              : 0
            : 4 & this._options),
        (n =
          "boolean" == typeof t.alignBottom
            ? t.alignBottom
              ? 8
              : 0
            : 8 & this._options),
        (o =
          "boolean" == typeof t.rounding
            ? t.rounding
              ? 16
              : 0
            : 16 & this._options),
        (this._options = e | i | s | n | o));
    }),
    (Fe.prototype.createLayout = function (t, e, i, s, n, o) {
      if (this._layouts[e])
        throw new Error(
          "A layout with the provided id is currently being processed."
        );
      var r = 2 & this._options,
        h = {
          id: e,
          items: i,
          slots: null,
          width: r ? 0 : s,
          height: r ? n : 0,
          _grid: t,
          _settings: this._options,
        };
      if (!i.length) return (h.slots = []), this._finalizeLayout(h), void o(h);
      if (this._processor)
        return (
          (h.slots = window.Float32Array
            ? new Float32Array(2 * i.length)
            : new Array(2 * i.length)),
          this._processor.computeLayout(h, h._settings),
          this._finalizeLayout(h),
          void o(h)
        );
      var a,
        _,
        l,
        d = new Float32Array(4 + 2 * i.length);
      for (
        d[0] = e,
          d[1] = h.width,
          d[2] = h.height,
          d[3] = h._settings,
          a = 0,
          _ = 3;
        a < i.length;
        a++
      )
        (l = i[a]),
          (d[++_] = l._width + l._marginLeft + l._marginRight),
          (d[++_] = l._height + l._marginTop + l._marginBottom);
      return (
        this._layoutQueue.push(e),
        (this._layouts[e] = h),
        (this._layoutCallbacks[e] = o),
        (this._layoutWorkerData[e] = d),
        this._sendToWorker(),
        this.cancelLayout.bind(this, e)
      );
    }),
    (Fe.prototype.cancelLayout = function (t) {
      if (
        this._layouts[t] &&
        (delete this._layouts[t],
        delete this._layoutCallbacks[t],
        this._layoutWorkerData[t])
      ) {
        delete this._layoutWorkerData[t];
        var e = this._layoutQueue.indexOf(t);
        e > -1 && this._layoutQueue.splice(e, 1);
      }
    }),
    (Fe.prototype.destroy = function () {
      for (var t in this._layoutWorkers)
        this._workers.push(this._layoutWorkers[t]);
      !(function (t) {
        for (var e, i, s = 0; s < t.length; s++)
          ((e = t[s]).onmessage = null),
            (e.onerror = null),
            (e.onmessageerror = null),
            e.terminate(),
            (i = Ne.indexOf(e)) > -1 && Ne.splice(i, 1);
        Be && !Ne.length && (URL.revokeObjectURL(Be), (Be = null));
      })(this._workers),
        (this._workers.length = 0),
        (this._layoutQueue.length = 0),
        (this._layouts = {}),
        (this._layoutCallbacks = {}),
        (this._layoutWorkers = {}),
        (this._layoutWorkerData = {});
    });
  var ze = 0;
  function Ve(t, e) {
    var i = ++ze,
      s = 0,
      n = 0,
      o = !1,
      r = function (e) {
        o ||
          (n && (s -= e - n),
          (n = e),
          s > 0
            ? (function (t, e) {
                it.add(0, et + t, e);
              })(i, r)
            : ((s = n = 0), t()));
      };
    return function (h) {
      if (!o) {
        if (!(e <= 0))
          return !0 === h
            ? ((o = !0),
              (s = n = 0),
              (r = void 0),
              void (function (t) {
                it.remove(0, et + t);
              })(i))
            : void (s <= 0 ? ((s = e), r(0)) : (s = e));
        !0 !== h && t();
      }
    };
  }
  function je(t) {
    var e = Object.prototype.toString.call(t);
    return "[object HTMLCollection]" === e || "[object NodeList]" === e;
  }
  var Qe = Object.prototype.toString;
  function Ue(t) {
    return "object" == typeof t && "[object Object]" === Qe.call(t);
  }
  function Ze() {}
  var Je,
    $e = "number",
    Ke = "string",
    ti = "instant",
    ei = 0;
  function ii(e, i) {
    if (
      (typeof e === Ke && (e = document.querySelector(e)),
      !(e.getRootNode
        ? e.getRootNode({ composed: !0 }) === document
        : document.body.contains(e)) || e === document.documentElement)
    )
      throw new Error("Container element must be an existing DOM element.");
    var s = (function (t, e) {
      var i = si({}, t);
      e && (i = si(i, e));
      e && e.visibleStyles
        ? (i.visibleStyles = e.visibleStyles)
        : t && t.visibleStyles && (i.visibleStyles = t.visibleStyles);
      e && e.hiddenStyles
        ? (i.hiddenStyles = e.hiddenStyles)
        : t && t.hiddenStyles && (i.hiddenStyles = t.hiddenStyles);
      return i;
    })(ii.defaultOptions, i);
    (s.visibleStyles = ni(s.visibleStyles)),
      (s.hiddenStyles = ni(s.hiddenStyles)),
      dt(s.dragSort) || (s.dragSort = !!s.dragSort),
      (this._id = Oe()),
      (this._element = e),
      (this._settings = s),
      (this._isDestroyed = !1),
      (this._items = []),
      (this._layout = { id: 0, items: [], slots: [] }),
      (this._isLayoutFinished = !0),
      (this._nextLayoutData = null),
      (this._emitter = new S()),
      (this._onLayoutDataReceived = this._onLayoutDataReceived.bind(this)),
      (t[this._id] = this),
      Ot(e, s.containerClass),
      (function (t, e) {
        typeof e !== $e && (e = !0 === e ? 0 : -1);
        e >= 0 &&
          ((t._resizeHandler = Ve(function () {
            t.refreshItems().layout();
          }, e)),
          window.addEventListener("resize", t._resizeHandler));
      })(this, s.layoutOnResize),
      this.add(
        (function (t, e) {
          if ("*" === e) return t.children;
          if (typeof e === Ke) {
            for (var i = [], s = t.children, n = 0; n < s.length; n++)
              qt(s[n], e) && i.push(s[n]);
            return i;
          }
          if (Array.isArray(e) || je(e)) return e;
          return [];
        })(e, s.items),
        { layout: !1 }
      ),
      s.layoutOnInit && this.layout(!0);
  }
  function si(t, e) {
    var i,
      s,
      n,
      o = Object.keys(e),
      r = o.length;
    for (n = 0; n < r; n++)
      (i = Ue(e[(s = o[n])])),
        Ue(t[s]) && i
          ? (t[s] = si(si({}, t[s]), e[s]))
          : i
          ? (t[s] = si({}, e[s]))
          : Array.isArray(e[s])
          ? (t[s] = e[s].slice(0))
          : (t[s] = e[s]);
    return t;
  }
  function ni(t) {
    var e,
      i,
      s = {},
      n = document.documentElement.style;
    for (e in t) t[e] && (i = E(n, e)) && (s[i] = t[e]);
    return s;
  }
  function oi(t) {
    for (var e = {}, i = 0; i < t.length; i++) e[t[i]._id] = i;
    return e;
  }
  function ri(t, e, i) {
    return t[e._id] - t[i._id];
  }
  return (
    (ii.Item = He),
    (ii.ItemLayout = Pe),
    (ii.ItemVisibility = Ye),
    (ii.ItemMigrate = Xe),
    (ii.ItemDrag = ye),
    (ii.ItemDragRelease = Me),
    (ii.ItemDragPlaceholder = Ce),
    (ii.Emitter = S),
    (ii.Animator = Le),
    (ii.Dragger = X),
    (ii.Packer = Fe),
    (ii.AutoScroller = Pt),
    (ii.defaultPacker = new Fe(2)),
    (ii.defaultOptions = {
      items: "*",
      showDuration: 300,
      showEasing: "ease",
      hideDuration: 300,
      hideEasing: "ease",
      visibleStyles: { opacity: "1", transform: "scale(1)" },
      hiddenStyles: { opacity: "0", transform: "scale(0.5)" },
      layout: {
        fillGaps: !1,
        horizontal: !1,
        alignRight: !1,
        alignBottom: !1,
        rounding: !1,
      },
      layoutOnResize: 150,
      layoutOnInit: !0,
      layoutDuration: 300,
      layoutEasing: "ease",
      sortData: null,
      dragEnabled: !1,
      dragContainer: null,
      dragHandle: null,
      dragStartPredicate: { distance: 0, delay: 0 },
      dragAxis: "xy",
      dragSort: !0,
      dragSortHeuristics: {
        sortInterval: 100,
        minDragDistance: 10,
        minBounceBackAngle: 1,
      },
      dragSortPredicate: { threshold: 50, action: s, migrateAction: s },
      dragRelease: { duration: 300, easing: "ease", useDragContainer: !0 },
      dragCssProps: {
        touchAction: "none",
        userSelect: "none",
        userDrag: "none",
        tapHighlightColor: "rgba(0, 0, 0, 0)",
        touchCallout: "none",
        contentZooming: "none",
      },
      dragPlaceholder: {
        enabled: !1,
        createElement: null,
        onCreate: null,
        onRemove: null,
      },
      dragAutoScroll: {
        targets: [],
        handle: null,
        threshold: 50,
        safeZone: 0.2,
        speed: Pt.smoothSpeed(1e3, 2e3, 2500),
        sortDuringScroll: !0,
        smoothStop: !1,
        onStart: null,
        onStop: null,
      },
      containerClass: "muuri",
      itemClass: "muuri-item",
      itemVisibleClass: "muuri-item-shown",
      itemHiddenClass: "muuri-item-hidden",
      itemPositioningClass: "muuri-item-positioning",
      itemDraggingClass: "muuri-item-dragging",
      itemReleasingClass: "muuri-item-releasing",
      itemPlaceholderClass: "muuri-item-placeholder",
    }),
    (ii.prototype.on = function (t, e) {
      return this._emitter.on(t, e), this;
    }),
    (ii.prototype.off = function (t, e) {
      return this._emitter.off(t, e), this;
    }),
    (ii.prototype.getElement = function () {
      return this._element;
    }),
    (ii.prototype.getItem = function (t) {
      if (this._isDestroyed || (!t && 0 !== t)) return null;
      if (typeof t === $e)
        return this._items[t > -1 ? t : this._items.length + t] || null;
      if (t instanceof He) return t._gridId === this._id ? t : null;
      if (e) {
        var i = e.get(t);
        return i && i._gridId === this._id ? i : null;
      }
      for (var s = 0; s < this._items.length; s++)
        if (this._items[s]._element === t) return this._items[s];
      return null;
    }),
    (ii.prototype.getItems = function (t) {
      if (this._isDestroyed || void 0 === t) return this._items.slice(0);
      var e,
        i,
        s = [];
      if (Array.isArray(t) || je(t))
        for (e = 0; e < t.length; e++) (i = this.getItem(t[e])) && s.push(i);
      else (i = this.getItem(t)) && s.push(i);
      return s;
    }),
    (ii.prototype.refreshItems = function (t, e) {
      if (this._isDestroyed) return this;
      var i,
        s,
        n,
        o,
        r = t || this._items;
      if (!0 === e)
        for (o = [], i = 0; i < r.length; i++)
          (s = r[i]).isVisible() ||
            s.isHiding() ||
            (((n = s.getElement().style).visibility = "hidden"),
            (n.display = ""),
            o.push(n));
      for (i = 0; i < r.length; i++) r[i]._refreshDimensions(e);
      if (!0 === e) {
        for (i = 0; i < o.length; i++)
          ((n = o[i]).visibility = ""), (n.display = "none");
        o.length = 0;
      }
      return this;
    }),
    (ii.prototype.refreshSortData = function (t) {
      if (this._isDestroyed) return this;
      for (var e = t || this._items, i = 0; i < e.length; i++)
        e[i]._refreshSortData();
      return this;
    }),
    (ii.prototype.synchronize = function () {
      if (this._isDestroyed) return this;
      var t,
        e,
        i = this._items;
      if (!i.length) return this;
      for (var s = 0; s < i.length; s++)
        (e = i[s]._element).parentNode === this._element &&
          (t = t || document.createDocumentFragment()).appendChild(e);
      return t
        ? (this._element.appendChild(t), this._emit("synchronize"), this)
        : this;
    }),
    (ii.prototype.layout = function (t, e) {
      if (this._isDestroyed) return this;
      var i = this._nextLayoutData;
      i && dt(i.cancel) && i.cancel();
      var s = (ei = (ei % 16777216) + 1);
      this._nextLayoutData = { id: s, instant: t, onFinish: e, cancel: null };
      for (var n = this._items, o = [], r = 0; r < n.length; r++)
        n[r]._isActive && o.push(n[r]);
      this._refreshDimensions();
      var h,
        a = this._width - this._borderLeft - this._borderRight,
        _ = this._height - this._borderTop - this._borderBottom,
        l = this._settings.layout;
      return (
        dt(l)
          ? (h = l(this, s, o, a, _, this._onLayoutDataReceived))
          : (ii.defaultPacker.setOptions(l),
            (h = ii.defaultPacker.createLayout(
              this,
              s,
              o,
              a,
              _,
              this._onLayoutDataReceived
            ))),
        dt(h) &&
          this._nextLayoutData &&
          this._nextLayoutData.id === s &&
          (this._nextLayoutData.cancel = h),
        this
      );
    }),
    (ii.prototype.add = function (t, e) {
      if (this._isDestroyed || !t) return [];
      var i,
        s = je((i = t))
          ? Array.prototype.slice.call(i)
          : Array.prototype.concat(i);
      if (!s.length) return s;
      var n,
        o,
        r,
        h,
        a = e || {},
        _ = a.layout ? a.layout : void 0 === a.layout,
        l = this._items,
        d = !1;
      for (h = 0; h < s.length; h++)
        (o = s[h]).parentNode !== this._element &&
          (n = n || document.createDocumentFragment()).appendChild(o);
      for (n && this._element.appendChild(n), h = 0; h < s.length; h++)
        (o = s[h]),
          (r = s[h] = new He(this, o, a.active))._isActive &&
            ((d = !0), (r._layout._skipNextAnimation = !0));
      for (h = 0; h < s.length; h++)
        (r = s[h])._refreshDimensions(), r._refreshSortData();
      return (
        Gt(l, s, a.index),
        this._hasListeners("add") && this._emit("add", s.slice(0)),
        d && _ && this.layout(_ === ti, dt(_) ? _ : void 0),
        s
      );
    }),
    (ii.prototype.remove = function (t, e) {
      if (this._isDestroyed || !t.length) return [];
      var i,
        s,
        n,
        o = e || {},
        r = o.layout ? o.layout : void 0 === o.layout,
        a = !1,
        _ = this.getItems(),
        l = [],
        d = [];
      for (n = 0; n < t.length; n++)
        (s = t[n])._isDestroyed ||
          (-1 !== (i = this._items.indexOf(s)) &&
            (s._isActive && (a = !0),
            l.push(s),
            d.push(_.indexOf(s)),
            s._destroy(o.removeElements),
            this._items.splice(i, 1)));
      return (
        this._hasListeners(h) && this._emit(h, l.slice(0), d),
        a && r && this.layout(r === ti, dt(r) ? r : void 0),
        l
      );
    }),
    (ii.prototype.show = function (t, e) {
      return (
        !this._isDestroyed && t.length && this._setItemsVisibility(t, !0, e),
        this
      );
    }),
    (ii.prototype.hide = function (t, e) {
      return (
        !this._isDestroyed && t.length && this._setItemsVisibility(t, !1, e),
        this
      );
    }),
    (ii.prototype.filter = function (t, e) {
      if (this._isDestroyed || !this._items.length) return this;
      var i,
        s,
        n = [],
        o = [],
        r = typeof t === Ke,
        h = dt(t),
        a = e || {},
        l = !0 === a.instant,
        d = a.syncWithLayout,
        u = a.layout ? a.layout : void 0 === a.layout,
        c = dt(a.onFinish) ? a.onFinish : null,
        f = -1,
        p = Ze;
      if (
        (c &&
          (p = function () {
            ++f && c(n.slice(0), o.slice(0));
          }),
        h || r)
      )
        for (s = 0; s < this._items.length; s++)
          (i = this._items[s]),
            (h ? t(i) : qt(i._element, t)) ? n.push(i) : o.push(i);
      return (
        n.length
          ? this.show(n, {
              instant: l,
              syncWithLayout: d,
              onFinish: p,
              layout: !1,
            })
          : p(),
        o.length
          ? this.hide(o, {
              instant: l,
              syncWithLayout: d,
              onFinish: p,
              layout: !1,
            })
          : p(),
        (n.length || o.length) &&
          (this._hasListeners(_) && this._emit(_, n.slice(0), o.slice(0)),
          u && this.layout(u === ti, dt(u) ? u : void 0)),
        this
      );
    }),
    (ii.prototype.sort = (function () {
      var t, e, i, s;
      function n(n, o) {
        for (var r, h, a, _, l = 0, d = 0; d < t.length; d++)
          if (
            ((r = t[d][0]),
            (h = t[d][1]),
            (a = (n._sortData ? n : n._refreshSortData())._sortData[r]),
            (_ = (o._sortData ? o : o._refreshSortData())._sortData[r]),
            (l =
              "desc" === h || (!h && e)
                ? _ < a
                  ? -1
                  : _ > a
                  ? 1
                  : 0
                : a < _
                ? -1
                : a > _
                ? 1
                : 0))
          )
            return l;
        return l || (s || (s = oi(i)), (l = e ? ri(s, o, n) : ri(s, n, o))), l;
      }
      function o(n, o) {
        var r = e ? -t(n, o) : t(n, o);
        return r || (s || (s = oi(i)), (r = e ? ri(s, o, n) : ri(s, n, o))), r;
      }
      return function (r, h) {
        if (this._isDestroyed || this._items.length < 2) return this;
        var a = this._items,
          _ = h || {},
          d = _.layout ? _.layout : void 0 === _.layout;
        if (((e = !!_.descending), (i = a.slice(0)), (s = null), dt(r)))
          (t = r), a.sort(o);
        else if (typeof r === Ke)
          (t = r
            .trim()
            .split(" ")
            .filter(function (t) {
              return t;
            })
            .map(function (t) {
              return t.split(":");
            })),
            a.sort(n);
        else {
          if (!Array.isArray(r))
            throw (
              ((t = e = i = s = null),
              new Error("Invalid comparer argument provided."))
            );
          (a.length = 0), a.push.apply(a, r);
        }
        return (
          this._hasListeners(l) && this._emit(l, a.slice(0), i),
          d && this.layout(d === ti, dt(d) ? d : void 0),
          (t = e = i = s = null),
          this
        );
      };
    })()),
    (ii.prototype.move = function (t, e, n) {
      if (this._isDestroyed || this._items.length < 2) return this;
      var o,
        r,
        h = this._items,
        a = n || {},
        _ = a.layout ? a.layout : void 0 === a.layout,
        l = a.action === i,
        u = l ? i : s,
        c = this.getItem(t),
        f = this.getItem(e);
      return (
        c &&
          f &&
          c !== f &&
          ((o = h.indexOf(c)),
          (r = h.indexOf(f)),
          l ? Nt(h, o, r) : Bt(h, o, r),
          this._hasListeners(d) &&
            this._emit(d, { item: c, fromIndex: o, toIndex: r, action: u }),
          _ && this.layout(_ === ti, dt(_) ? _ : void 0)),
        this
      );
    }),
    (ii.prototype.send = function (t, e, i, s) {
      if (this._isDestroyed || e._isDestroyed || this === e) return this;
      if (!(t = this.getItem(t))) return this;
      var n = s || {},
        o = n.appendTo || document.body,
        r = n.layoutSender ? n.layoutSender : void 0 === n.layoutSender,
        h = n.layoutReceiver ? n.layoutReceiver : void 0 === n.layoutReceiver;
      return (
        t._migrate.start(e, i, o),
        t._migrate._isActive &&
          t._isActive &&
          (r && this.layout(r === ti, dt(r) ? r : void 0),
          h && e.layout(h === ti, dt(h) ? h : void 0)),
        this
      );
    }),
    (ii.prototype.destroy = function (e) {
      if (this._isDestroyed) return this;
      var i,
        s,
        n,
        o = this._element,
        r = this._items.slice(0),
        h = (this._layout && this._layout.styles) || {};
      for (
        (n = this)._resizeHandler &&
          (n._resizeHandler(!0),
          window.removeEventListener("resize", n._resizeHandler),
          (n._resizeHandler = null)),
          i = 0;
        i < r.length;
        i++
      )
        r[i]._destroy(e);
      for (s in ((this._items.length = 0),
      ue(o, this._settings.containerClass),
      h))
        o.style[s] = "";
      return (
        this._emit("destroy"),
        this._emitter.destroy(),
        delete t[this._id],
        (this._isDestroyed = !0),
        this
      );
    }),
    (ii.prototype._emit = function () {
      this._isDestroyed || this._emitter.emit.apply(this._emitter, arguments);
    }),
    (ii.prototype._hasListeners = function (t) {
      return !this._isDestroyed && this._emitter.countListeners(t) > 0;
    }),
    (ii.prototype._updateBoundingRect = function () {
      var t = this._element.getBoundingClientRect();
      (this._width = t.width),
        (this._height = t.height),
        (this._left = t.left),
        (this._top = t.top),
        (this._right = t.right),
        (this._bottom = t.bottom);
    }),
    (ii.prototype._updateBorders = function (t, e, i, s) {
      var n = this._element;
      t && (this._borderLeft = ft(n, "border-left-width")),
        e && (this._borderRight = ft(n, "border-right-width")),
        i && (this._borderTop = ft(n, "border-top-width")),
        s && (this._borderBottom = ft(n, "border-bottom-width"));
    }),
    (ii.prototype._refreshDimensions = function () {
      this._updateBoundingRect(),
        this._updateBorders(1, 1, 1, 1),
        (this._boxSizing = ct(this._element, "box-sizing"));
    }),
    (ii.prototype._onLayoutDataReceived =
      ((Je = []),
      function (t) {
        if (
          !this._isDestroyed &&
          this._nextLayoutData &&
          this._nextLayoutData.id === t.id
        ) {
          var e,
            i,
            s,
            h,
            a = this,
            _ = this._nextLayoutData.instant,
            l = this._nextLayoutData.onFinish,
            d = t.items.length,
            u = d;
          for (
            this._nextLayoutData = null,
              !this._isLayoutFinished &&
                this._hasListeners(r) &&
                this._emit(r, this._layout.items.slice(0)),
              this._layout = t,
              Je.length = 0,
              h = 0;
            h < d;
            h++
          )
            (e = t.items[h])
              ? ((i = t.slots[2 * h]),
                (s = t.slots[2 * h + 1]),
                e._canSkipLayout(i, s)
                  ? --u
                  : ((e._left = i),
                    (e._top = s),
                    e.isActive() && !e.isDragging() ? Je.push(e) : --u))
              : --u;
          if (
            (t.styles && Ae(this._element, t.styles),
            !this._hasListeners(n) ||
              (this._emit(n, t.items.slice(0), !0 === _),
              this._layout.id === t.id))
          ) {
            var c = function () {
              if (!(--u > 0)) {
                var e = a._layout.id !== t.id,
                  i = dt(_) ? _ : l;
                e || (a._isLayoutFinished = !0),
                  dt(i) && i(t.items.slice(0), e),
                  !e && a._hasListeners(o) && a._emit(o, t.items.slice(0));
              }
            };
            if (!Je.length) return c(), this;
            for (
              this._isLayoutFinished = !1, h = 0;
              h < Je.length && this._layout.id === t.id;
              h++
            )
              Je[h]._layout.start(!0 === _, c);
            return this._layout.id === t.id && (Je.length = 0), this;
          }
        }
      })),
    (ii.prototype._setItemsVisibility = function (t, e, i) {
      var s,
        o,
        r = this,
        h = t.slice(0),
        _ = i || {},
        l = !0 === _.instant,
        d = _.onFinish,
        u = _.layout ? _.layout : void 0 === _.layout,
        c = h.length,
        f = e ? "showStart" : a,
        p = e ? "showEnd" : "hideEnd",
        m = e ? "show" : "hide",
        g = !1,
        v = [],
        y = [];
      if (c) {
        for (o = 0; o < h.length; o++)
          (s = h[o]),
            ((e && !s._isActive) || (!e && s._isActive)) && (g = !0),
            (s._layout._skipNextAnimation = !(!e || s._isActive)),
            e && s._visibility._isHidden && y.push(s),
            e ? s._addToLayout() : s._removeFromLayout();
        y.length && (this.refreshItems(y, !0), (y.length = 0)),
          g && !1 !== _.syncWithLayout ? this.on(n, S) : S(),
          g && u && this.layout(u === ti, dt(u) ? u : void 0);
      } else dt(d) && d(h);
      function S() {
        for (
          g && !1 !== _.syncWithLayout && r.off(n, S),
            r._hasListeners(f) && r._emit(f, h.slice(0)),
            o = 0;
          o < h.length;
          o++
        )
          h[o]._gridId === r._id
            ? h[o]._visibility[m](l, function (t, e) {
                t || v.push(e),
                  --c < 1 &&
                    (dt(d) && d(v.slice(0)),
                    r._hasListeners(p) && r._emit(p, v.slice(0)));
              })
            : --c < 1 &&
              (dt(d) && d(v.slice(0)),
              r._hasListeners(p) && r._emit(p, v.slice(0)));
      }
    }),
    ii
  );
});
